import React from 'react';
import { globalThisGetValue } from '@propertyfinder/helpers';
import { execSync, spawnSync } from 'child_process';
import { existsSync, rmSync, readFileSync } from 'fs';
import { resolve } from 'path';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$h =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$j = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$i = fails$j;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$i(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString$8 = {}.toString;

var classofRaw$1 = function (it) {
  return toString$8.call(it).slice(8, -1);
};

var fails$h = fails$j;
var classof$7 = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$h(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$7(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$7 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$6 = requireObjectCoercible$7;

var toIndexedObject$4 = function (it) {
  return IndexedObject$2(requireObjectCoercible$6(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$i = function (argument) {
  return typeof argument === 'function';
};

var isCallable$h = isCallable$i;

var isObject$8 = function (it) {
  return typeof it === 'object' ? it !== null : isCallable$h(it);
};

var global$g = global$h;
var isCallable$g = isCallable$i;

var aFunction = function (argument) {
  return isCallable$g(argument) ? argument : undefined;
};

var getBuiltIn$6 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$g[namespace]) : global$g[namespace] && global$g[namespace][method];
};

var getBuiltIn$5 = getBuiltIn$6;

var engineUserAgent = getBuiltIn$5('navigator', 'userAgent') || '';

var global$f = global$h;
var userAgent = engineUserAgent;

var process$1 = global$f.process;
var Deno = global$f.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$g = fails$j;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$g(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var isCallable$f = isCallable$i;
var getBuiltIn$4 = getBuiltIn$6;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$4('Symbol');
  return isCallable$f($Symbol) && Object(it) instanceof $Symbol;
};

var tryToString$2 = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$e = isCallable$i;
var tryToString$1 = tryToString$2;

// `Assert: IsCallable(argument) is true`
var aCallable$3 = function (argument) {
  if (isCallable$e(argument)) return argument;
  throw TypeError(tryToString$1(argument) + ' is not a function');
};

var aCallable$2 = aCallable$3;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$4 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$2(func);
};

var isCallable$d = isCallable$i;
var isObject$7 = isObject$8;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$d(fn = input.toString) && !isObject$7(val = fn.call(input))) return val;
  if (isCallable$d(fn = input.valueOf) && !isObject$7(val = fn.call(input))) return val;
  if (pref !== 'string' && isCallable$d(fn = input.toString) && !isObject$7(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var global$e = global$h;

var setGlobal$3 = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global$e, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$e[key] = value;
  } return value;
};

var global$d = global$h;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$d[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.3',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

var requireObjectCoercible$5 = requireObjectCoercible$7;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$6 = function (argument) {
  return Object(requireObjectCoercible$5(argument));
};

var toObject$5 = toObject$6;

var hasOwnProperty = {}.hasOwnProperty;

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject$5(it), key);
};

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var global$c = global$h;
var shared$3 = shared$4.exports;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$1 = global$c.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$f = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && hasOwn$9(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var isObject$6 = isObject$8;
var isSymbol$1 = isSymbol$2;
var getMethod$3 = getMethod$4;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$e = wellKnownSymbol$f;

var TO_PRIMITIVE = wellKnownSymbol$e('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$6(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$3(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject$6(result) || isSymbol$1(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};

var global$b = global$h;
var isObject$5 = isObject$8;

var document$1 = global$b.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$5(document$1) && isObject$5(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$8 = descriptors;
var fails$f = fails$j;
var createElement = documentCreateElement$2;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$8 && !fails$f(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$7 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$8 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$7 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$8(O, P)) return createPropertyDescriptor$2(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$4 = isObject$8;

// `Assert: Type(argument) is Object`
var anObject$c = function (argument) {
  if (isObject$4(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};

var DESCRIPTORS$6 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$b = anObject$c;
var toPropertyKey = toPropertyKey$2;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$6 ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$b(O);
  P = toPropertyKey(P);
  anObject$b(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$5 = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$7 = DESCRIPTORS$5 ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$6 = {exports: {}};

var isCallable$c = isCallable$i;
var store$1 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$c(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$a = global$h;
var isCallable$b = isCallable$i;
var inspectSource$2 = inspectSource$3;

var WeakMap$1 = global$a.WeakMap;

var nativeWeakMap = isCallable$b(WeakMap$1) && /native code/.test(inspectSource$2(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys$1 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$9 = global$h;
var isObject$3 = isObject$8;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$7;
var hasOwn$7 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global$9.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$3(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$7(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$6(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$7(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$7(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var DESCRIPTORS$4 = descriptors;
var hasOwn$6 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$4 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$6(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$4 || (DESCRIPTORS$4 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$8 = global$h;
var isCallable$a = isCallable$i;
var hasOwn$5 = hasOwnProperty_1;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$7;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule$1 = internalState;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;

var getInternalState$2 = InternalStateModule$1.get;
var enforceInternalState$1 = InternalStateModule$1.enforce;
var TEMPLATE = String(String).split('String');

(redefine$6.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$a(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn$5(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
      createNonEnumerableProperty$5(value, 'name', name);
    }
    state = enforceInternalState$1(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$8) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$5(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$a(this) && getInternalState$2(this).source || inspectSource$1(this);
});

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$5 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor$1 : ceil)(number);
};

var toIntegerOrInfinity$4 = toIntegerOrInfinity$5;

var max$1 = Math.max;
var min$3 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$4(index);
  return integer < 0 ? max$1(integer + length, 0) : min$3(integer, length);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$5;

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$4 = function (argument) {
  return argument > 0 ? min$2(toIntegerOrInfinity$3(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$3 = toLength$4;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$4 = function (obj) {
  return toLength$3(obj.length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$3 = lengthOfArrayLike$4;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = lengthOfArrayLike$3(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var hasOwn$4 = hasOwnProperty_1;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$4(hiddenKeys$2, key) && hasOwn$4(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$4(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$3 = getBuiltIn$6;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$a = anObject$c;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$3('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$a(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$3.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$e = fails$j;
var isCallable$9 = isCallable$i;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$9(detection) ? fails$e(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$7 = global$h;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$7;
var redefine$5 = redefine$6.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$1 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$7;
  } else if (STATIC) {
    target = global$7[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$7[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$4(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$5(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$3 = descriptors;
var fails$d = fails$j;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$4 = toObject$6;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$2 = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$d(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$3 && $assign({ b: 1 }, $assign(defineProperty$2({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$2(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$4(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys$1(S).concat(getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$3 || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$5 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$5({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:873
 */

const Icon360ThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '14',
  viewBox: '0 0 20 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12.578 4.377c0 1.314-1.028 2.25-2.443 2.25-1.516 0-2.646-1.072-2.646-3.26C7.49 1.265 8.491 0 10.14 0c1.23 0 2.18.72 2.356 1.767h-1.31c-.15-.453-.527-.717-1.05-.717-.923 0-1.38.892-1.376 2.281h.027c.246-.589.87-1.02 1.726-1.02 1.227 0 2.066.875 2.066 2.066Zm-5.523.334c0 1.151-.997 1.916-2.47 1.916-1.432 0-2.408-.773-2.465-1.938h1.266c.044.519.5.87 1.2.87.663 0 1.12-.37 1.12-.905.004-.615-.448-.958-1.217-.958h-.725V2.75h.707c.664 0 1.094-.36 1.094-.879 0-.518-.355-.848-.988-.848-.624 0-1.06.334-1.099.883H2.261C2.327.747 3.25.004 4.577.004c1.34 0 2.245.664 2.245 1.68 0 .808-.575 1.33-1.322 1.484v.027c.94.088 1.555.646 1.555 1.516Zm3.062.861c-.65 0-1.16-.51-1.16-1.164 0-.646.5-1.117 1.173-1.117.664 0 1.156.475 1.156 1.143a1.148 1.148 0 0 1-1.169 1.138ZM18.154 3.3c0 2.048-.976 3.327-2.585 3.327-1.608 0-2.588-1.27-2.588-3.322C12.981 1.257 13.97 0 15.57 0c1.6 0 2.585 1.252 2.585 3.3Zm-2.585 2.263c-.782 0-1.239-.804-1.239-2.258 0-1.442.466-2.242 1.24-2.242.777 0 1.234.796 1.234 2.242 0 1.454-.452 2.258-1.234 2.258ZM20 6.726c0-.42-.075-.833-.222-1.233a.75.75 0 0 0-1.408.515c.087.237.13.476.13.718 0 1.523-1.807 3.04-4.708 3.788a.75.75 0 1 0 .375 1.453c3.485-.9 5.833-2.87 5.833-5.241Zm-18.348-.8a.75.75 0 0 0-1.44-.407A3.57 3.57 0 0 0 0 6.726c0 2.375 2.356 4.349 5.851 5.246.05.012.1.02.149.022v1.349a.5.5 0 0 0 .757.428l3.528-2.117a.5.5 0 0 0 0-.857L6.757 8.68A.5.5 0 0 0 6 9.11v1.35c-2.779-.766-4.5-2.247-4.5-3.733 0-.236.042-.47.125-.702l.027-.098Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:860
 */

const Icon360Thick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M14.578 9.456c0 1.314-1.028 2.25-2.443 2.25-1.517 0-2.646-1.073-2.646-3.261 0-2.1 1.002-3.366 2.65-3.366 1.23 0 2.18.72 2.356 1.766h-1.31c-.15-.452-.527-.716-1.05-.716-.923 0-1.38.892-1.376 2.28h.027c.246-.588.87-1.019 1.726-1.019 1.227 0 2.066.875 2.066 2.066Zm-5.523.334c0 1.15-.997 1.916-2.47 1.916-1.432 0-2.408-.774-2.465-1.938h1.266c.044.518.5.87 1.2.87.663 0 1.12-.37 1.12-.906.004-.615-.448-.958-1.217-.958h-.725V7.83h.707c.664 0 1.094-.36 1.094-.88 0-.518-.355-.847-.988-.847-.624 0-1.06.334-1.099.883H4.261c.066-1.16.989-1.903 2.316-1.903 1.34 0 2.245.664 2.245 1.679 0 .808-.575 1.331-1.322 1.485v.026c.94.088 1.555.646 1.555 1.517Zm3.062.86c-.65 0-1.16-.509-1.16-1.164 0-.646.5-1.116 1.173-1.116.664 0 1.156.475 1.156 1.143a1.148 1.148 0 0 1-1.169 1.138Zm8.037-2.271c0 2.048-.976 3.327-2.584 3.327-1.609 0-2.589-1.27-2.589-3.323 0-2.048.989-3.304 2.589-3.304s2.584 1.252 2.584 3.3Zm-2.584 2.263c-.783 0-1.24-.804-1.24-2.259 0-1.441.466-2.24 1.24-2.24.777 0 1.234.795 1.234 2.24 0 1.455-.452 2.26-1.234 2.26ZM22 11.804c0-.419-.075-.832-.222-1.233a.75.75 0 0 0-1.408.515c.087.238.13.477.13.718 0 1.523-1.807 3.04-4.708 3.79a.75.75 0 1 0 .375 1.452c3.485-.9 5.833-2.871 5.833-5.242Zm-18.348-.8a.75.75 0 0 0-1.44-.407A3.57 3.57 0 0 0 2 11.804c0 2.375 2.356 4.35 5.851 5.246.05.013.1.02.149.023v1.348a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.857l-3.528-2.117a.5.5 0 0 0-.757.428v1.35c-2.779-.765-4.5-2.246-4.5-3.733 0-.236.042-.47.125-.702l.027-.098Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1191
 */

const Icon360Shape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '14',
  viewBox: '0 0 20 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6.953 1.823c0 .464-.128.843-.383 1.138-.256.295-.618.492-1.087.592v.04c.573.072.998.258 1.275.556.277.298.415.689.415 1.172 0 .693-.236 1.225-.708 1.598-.472.372-1.143.559-2.012.559-.377 0-.723-.03-1.037-.087a3.508 3.508 0 0 1-.916-.306V6.3c.31.156.639.274.989.355.35.082.68.122.993.122 1.234 0 1.851-.492 1.851-1.475 0-.882-.68-1.322-2.041-1.322h-.703v-.71h.713c.556 0 .997-.126 1.323-.376.326-.25.488-.597.488-1.04 0-.355-.12-.633-.359-.835C5.515.817 5.19.715 4.78.715c-.312 0-.607.044-.884.13-.276.086-.592.245-.947.477L2.54.765c.293-.235.63-.42 1.013-.554A3.625 3.625 0 0 1 4.761.01c.693 0 1.232.161 1.616.484.384.323.576.766.576 1.33Zm.586 2.45c0-1.428.273-2.495.818-3.202C8.902.364 9.709.01 10.777.01c.367 0 .657.031.869.094v.71a2.736 2.736 0 0 0-.86-.123c-.765 0-1.35.242-1.753.728-.403.485-.625 1.247-.664 2.288h.059c.358-.57.924-.855 1.699-.855.641 0 1.147.197 1.516.591.37.394.554.93.554 1.605 0 .755-.202 1.35-.608 1.781-.405.433-.953.649-1.643.649-.739 0-1.325-.283-1.758-.847-.432-.565-.649-1.351-.649-2.358Zm2.398 2.504c.462 0 .82-.148 1.076-.444.256-.297.383-.725.383-1.285 0-.48-.118-.858-.356-1.133s-.592-.412-1.064-.412a1.77 1.77 0 0 0-.806.184 1.498 1.498 0 0 0-.584.507 1.185 1.185 0 0 0-.217.67c0 .341.065.66.195.954.13.295.315.529.555.7.239.173.512.26.818.26Zm7.468-3.04c0 1.255-.194 2.192-.583 2.812-.39.62-.984.929-1.785.929-.768 0-1.352-.317-1.753-.952-.4-.634-.6-1.564-.6-2.79 0-1.265.193-2.204.58-2.817.388-.613.979-.919 1.773-.919.775 0 1.363.32 1.765.959.402.64.603 1.565.603 2.777Zm-3.901 0c0 1.056.122 1.825.366 2.307s.633.723 1.167.723c.54 0 .932-.244 1.174-.733.243-.488.364-1.254.364-2.298 0-1.043-.121-1.807-.364-2.293-.242-.485-.633-.728-1.174-.728-.534 0-.923.24-1.167.718-.244.48-.366 1.247-.366 2.303Zm-7.482 7.328V8.912l4 2.544-4 2.544v-1.917a.492.492 0 0 1-.137-.008C2.084 11.305 0 9.539 0 7.385c0-.855.409-1.662 1.157-2.368a.494.494 0 0 1 .707.027.515.515 0 0 1-.027.72C1.28 6.29 1 6.84 1 7.385c0 1.499 1.67 2.988 5.022 3.679Zm7.575 1.011a.5.5 0 0 1-.587-.4.508.508 0 0 1 .393-.598c3.388-.685 5.563-2.184 5.563-3.692 0-.56-.294-1.126-.883-1.666a.515.515 0 0 1-.037-.718.494.494 0 0 1 .706-.038c.784.719 1.214 1.544 1.214 2.422 0 2.154-2.564 3.921-6.369 4.69Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1187
 */

const Icon360 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.953 6.823c0 .464-.128.843-.383 1.138-.256.295-.618.492-1.087.592v.04c.573.072.998.258 1.275.556.277.298.415.689.415 1.172 0 .693-.236 1.225-.708 1.598-.472.372-1.143.559-2.012.559-.377 0-.723-.03-1.037-.087a3.507 3.507 0 0 1-.916-.306V11.3c.31.156.639.274.989.355.35.082.68.122.993.122 1.234 0 1.851-.492 1.851-1.475 0-.882-.68-1.322-2.041-1.322h-.703v-.71h.713c.556 0 .997-.126 1.323-.376.326-.25.488-.597.488-1.04 0-.355-.12-.633-.359-.835-.239-.202-.564-.304-.974-.304-.312 0-.607.044-.884.13-.276.086-.592.245-.947.477l-.41-.557c.293-.235.63-.42 1.013-.554a3.624 3.624 0 0 1 1.209-.201c.693 0 1.232.161 1.616.484.384.323.576.766.576 1.33Zm.586 2.45c0-1.428.273-2.495.818-3.202.545-.707 1.352-1.061 2.42-1.061.367 0 .657.031.869.094v.71a2.736 2.736 0 0 0-.86-.123c-.765 0-1.35.242-1.753.728-.403.485-.625 1.247-.664 2.288h.059c.358-.57.924-.855 1.699-.855.641 0 1.147.197 1.516.591.37.394.554.93.554 1.605 0 .755-.202 1.35-.608 1.781-.405.433-.953.649-1.643.649-.739 0-1.325-.283-1.758-.847-.432-.565-.649-1.351-.649-2.358Zm2.398 2.504c.462 0 .82-.148 1.076-.444.256-.297.383-.725.383-1.285 0-.48-.118-.858-.356-1.133s-.592-.412-1.064-.412a1.77 1.77 0 0 0-.806.184 1.5 1.5 0 0 0-.584.507 1.186 1.186 0 0 0-.217.67c0 .341.065.66.196.954.13.295.314.529.554.7.239.173.511.26.818.26Zm7.468-3.04c0 1.255-.194 2.192-.583 2.812-.39.62-.984.929-1.785.929-.768 0-1.352-.317-1.753-.952-.4-.634-.6-1.564-.6-2.79 0-1.265.193-2.204.58-2.817.388-.613.979-.919 1.773-.919.775 0 1.363.32 1.765.959.402.64.603 1.565.603 2.777Zm-3.901 0c0 1.056.122 1.825.366 2.307s.633.723 1.167.723c.54 0 .932-.244 1.174-.733.243-.488.364-1.254.364-2.298 0-1.043-.121-1.807-.364-2.293-.242-.485-.633-.728-1.174-.728-.534 0-.923.24-1.167.718-.244.48-.366 1.247-.366 2.303Zm-7.482 7.328v-2.153l4 2.544-4 2.544v-1.917a.492.492 0 0 1-.137-.008C4.084 16.305 2 14.539 2 12.385c0-.855.409-1.662 1.157-2.368a.494.494 0 0 1 .707.027.515.515 0 0 1-.027.72C3.28 11.29 3 11.84 3 12.385c0 1.499 1.67 2.988 5.022 3.679Zm7.575 1.011a.5.5 0 0 1-.587-.4.508.508 0 0 1 .393-.598c3.388-.685 5.563-2.184 5.563-3.692 0-.56-.294-1.126-.883-1.666a.515.515 0 0 1-.037-.718.494.494 0 0 1 .706-.038c.784.719 1.214 1.544 1.214 2.422 0 2.154-2.564 3.921-6.369 4.69Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1539
 */

const IconAppleFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '19',
  viewBox: '0 0 16 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.21 4.59c.53 0 2.475.048 3.756 1.884-.109.085-2.042 1.184-2.042 3.624 0 2.814 2.452 3.817 2.537 3.841-.024.06-.399 1.365-1.305 2.694-.809 1.16-1.667 2.343-2.947 2.343-1.304 0-1.63-.761-3.116-.761-1.462 0-1.981.785-3.153.785-1.183 0-2.005-1.087-2.947-2.416C.893 15.014 0 12.586 0 10.291c0-3.696 2.404-5.653 4.771-5.653 1.244 0 2.295.822 3.092.822.737 0 1.909-.87 3.346-.87ZM11.5 0c.023.109.035.242.035.374 0 .979-.422 1.957-1.002 2.658-.64.773-1.715 1.353-2.573 1.353-.097 0-.193-.012-.254-.025a1.658 1.658 0 0 1-.036-.338c0-.99.495-1.957 1.039-2.573C9.397.64 10.545.036 11.499 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1534
 */

const IconAppleFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.479 7.09c.531 0 2.476.048 3.756 1.884-.108.085-2.041 1.184-2.041 3.624 0 2.814 2.452 3.817 2.536 3.841-.024.06-.398 1.365-1.304 2.694-.81 1.16-1.667 2.343-2.947 2.343-1.305 0-1.631-.761-3.117-.761-1.461 0-1.98.785-3.152.785-1.184 0-2.005-1.087-2.947-2.416-1.1-1.57-1.993-3.998-1.993-6.293 0-3.696 2.403-5.653 4.77-5.653 1.245 0 2.296.822 3.093.822.737 0 1.908-.87 3.346-.87Zm.29-4.59c.024.109.036.242.036.374 0 .979-.423 1.957-1.003 2.658-.64.773-1.715 1.353-2.572 1.353-.097 0-.194-.012-.254-.025a1.657 1.657 0 0 1-.036-.338c0-.99.495-1.957 1.038-2.573.689-.809 1.836-1.413 2.79-1.449Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2394:3443
 */

const IconAreaChartThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '16',
  viewBox: '0 0 17 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M1.5.75a.75.75 0 0 0-1.5 0h1.5ZM15.252 16a.75.75 0 0 0 0-1.5V16ZM2.394 11.809a.75.75 0 1 0 1.213.882l-1.213-.882ZM7 6.75l.53-.53a.75.75 0 0 0-1.136.089L7 6.75Zm3 3-.53.53a.75.75 0 0 0 1.138-.09L10 9.75Zm5.859-6.81a.75.75 0 0 0-1.215-.88l1.215.88ZM0 .75v12.5h1.5V.75H0ZM2.75 16h12.502v-1.5H2.75V16Zm.857-3.309 4-5.5-1.213-.882-4 5.5 1.213.882Zm2.863-5.41 3 3 1.06-1.061-3-3-1.06 1.06Zm4.138 2.909 5.251-7.25-1.215-.88-5.251 7.25 1.215.88ZM0 13.25A2.75 2.75 0 0 0 2.75 16v-1.5c-.69 0-1.25-.56-1.25-1.25H0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2394:3427
 */

const IconAreaChartShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M1 .5a.5.5 0 0 0-1 0h1ZM15.5 16a.5.5 0 0 0 0-1v1ZM2.596 12.206a.5.5 0 0 0 .808.588l-.808-.588ZM7 7l.354-.354a.5.5 0 0 0-.758.06L7 7Zm3 3-.354.354a.5.5 0 0 0 .757-.058L10 10Zm5.903-7.204a.5.5 0 1 0-.806-.592l.806.592ZM0 .5v13h1V.5H0ZM2.5 16h13v-1h-13v1Zm.904-3.206 4-5.5-.808-.588-4 5.5.808.588Zm3.242-5.44 3 3 .708-.708-3-3-.708.708Zm3.757 2.942 5.5-7.5-.806-.592-5.5 7.5.806.592ZM0 13.5A2.5 2.5 0 0 0 2.5 16v-1A1.5 1.5 0 0 1 1 13.5H0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2133:3728
 */

const IconAreaSizeThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '19',
  viewBox: '0 0 19 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.78.22a.75.75 0 0 1 0 1.06L8.06 2h8.38l-.72-.72A.75.75 0 0 1 16.78.22l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l.72-.72H8.06l.72.72a.75.75 0 0 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 0ZM.22 15.47a.75.75 0 0 1 1.06 0l.72.72V7.81l-.72.72A.75.75 0 0 1 .22 7.47l2-2a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1-1.06 1.06l-.72-.72v8.38l.72-.72a.75.75 0 0 1 1.06 1.06l-2 2a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 0-1.06Zm8.03-7.72h8a.5.5 0 0 1 .5.5v1h1.5v-1a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1h-1.5v1a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5Zm10 3.5v2h-1.5v-2h1.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2422:3440
 */

const IconAreaSizeShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm3 16.256 1.148-1.132a.5.5 0 0 1 .704.709l-2 1.975a.5.5 0 0 1-.704 0l-2-1.975a.5.5 0 1 1 .704-.71L2 16.257V6.682L.852 7.815a.5.5 0 0 1-.704-.71l2-1.975a.5.5 0 0 1 .704 0l2 1.975a.5.5 0 1 1-.704.71L3 6.682v9.574ZM6.71 2.998l1.133 1.147a.5.5 0 1 1-.71.704L5.157 2.85a.5.5 0 0 1 0-.704L7.133.148a.5.5 0 0 1 .71.704L6.71 1.999h9.58L15.157.852a.5.5 0 1 1 .71-.704l1.976 1.998a.5.5 0 0 1 0 .704L15.867 4.85a.5.5 0 0 1-.71-.704l1.133-1.147H6.71ZM18 16.001A2 2 0 0 1 16 18H8a2 2 0 0 1-2-1.999V8.006a2 2 0 0 1 2-1.998h8a2 2 0 0 1 2 1.998v2h-1v-2a1 1 0 0 0-1-.999H8a1 1 0 0 0-1 1V16a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1h1Zm0-1.998h-1v-2h1v2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2394:3444
 */

const IconAreaChartThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M5.5 4.75a.75.75 0 0 0-1.5 0h1.5ZM19.25 20a.75.75 0 0 0 0-1.5V20ZM6.393 15.809a.75.75 0 0 0 1.214.882l-1.214-.882ZM11 10.75l.53-.53a.75.75 0 0 0-1.136.089l.606.441Zm3 3-.53.53a.75.75 0 0 0 1.137-.09L14 13.75Zm5.859-6.81a.75.75 0 1 0-1.215-.88l1.215.88ZM3.999 4.75v12.5h1.5V4.75H4ZM6.75 20h12.502v-1.5H6.75V20Zm.858-3.309 4-5.5-1.213-.882-4 5.5 1.213.882Zm2.863-5.41 3 3 1.06-1.061-3-3-1.06 1.06Zm4.137 2.909 5.252-7.25-1.215-.88-5.251 7.25 1.214.88ZM4 17.25A2.75 2.75 0 0 0 6.75 20v-1.5c-.69 0-1.25-.56-1.25-1.25H4Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2394:3439
 */

const IconAreaChart = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M5 4.5a.5.5 0 0 0-1 0h1ZM19.5 20a.5.5 0 0 0 0-1v1ZM6.596 16.206a.5.5 0 0 0 .808.588l-.808-.588ZM11 11l.354-.354a.5.5 0 0 0-.758.06L11 11Zm3 3-.354.354a.5.5 0 0 0 .757-.058L14 14Zm5.903-7.204a.5.5 0 1 0-.806-.592l.806.592ZM4 4.5v13h1v-13H4ZM6.5 20h13v-1h-13v1Zm.904-3.206 4-5.5-.808-.588-4 5.5.808.588Zm3.242-5.44 3 3 .708-.708-3-3-.708.708Zm3.757 2.942 5.5-7.5-.806-.592-5.5 7.5.806.592ZM4 17.5A2.5 2.5 0 0 0 6.5 20v-1A1.5 1.5 0 0 1 5 17.5H4Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=508:1711
 */

const IconAreaSizeThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.03 2.97a.75.75 0 0 1 0 1.06l-.72.72h8.38l-.72-.72a.75.75 0 0 1 1.06-1.06l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l.72-.72h-8.38l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 0ZM2.47 18.22a.75.75 0 0 1 1.06 0l.72.72v-8.38l-.72.72a.75.75 0 0 1-1.06-1.06l2-2a.75.75 0 0 1 1.06 0l2 2a.75.75 0 1 1-1.06 1.06l-.72-.72v8.38l.72-.72a.75.75 0 0 1 1.06 1.06l-2 2a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 0-1.06Zm8.03-7.72h8a.5.5 0 0 1 .5.5v1h1.5v-1a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1H19v1a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5Zm10 3.5v2H19v-2h1.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1062
 */

const IconAreaSize = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm6 19.256 1.148-1.132a.5.5 0 0 1 .704.709l-2 1.975a.5.5 0 0 1-.704 0l-2-1.975a.5.5 0 1 1 .704-.71L5 19.257V9.682l-1.148 1.133a.5.5 0 0 1-.704-.71l2-1.975a.5.5 0 0 1 .704 0l2 1.975a.5.5 0 1 1-.704.71L6 9.682v9.574ZM9.71 5.998l1.133 1.147a.5.5 0 1 1-.71.704L8.157 5.85a.5.5 0 0 1 0-.704l1.976-1.998a.5.5 0 0 1 .71.704L9.71 4.999h9.58l-1.133-1.147a.5.5 0 1 1 .71-.704l1.976 1.998a.5.5 0 0 1 0 .704L18.867 7.85a.5.5 0 0 1-.71-.704l1.133-1.147H9.71ZM21 19.001A2 2 0 0 1 19 21h-8a2 2 0 0 1-2-1.999v-7.995a2 2 0 0 1 2-1.998h8a2 2 0 0 1 2 1.999v1.998h-1v-1.998a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1V19a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1h1Zm0-1.998h-1v-2h1v2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=269:1611
 */

const IconArrowCircleClockwiseShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '15',
  viewBox: '0 0 16 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M8.486 14.895a.58.58 0 0 0 .47-.667.568.568 0 0 0-.658-.482c-3.389.593-6.602-1.758-7.178-5.252-.575-3.493 1.705-6.807 5.093-7.4C9.602.5 12.815 2.852 13.391 6.345c.354 2.149-.374 4.336-1.933 5.807l-.834-2.581a.562.562 0 0 0-.715-.37.587.587 0 0 0-.358.738l1.13 3.497a.567.567 0 0 0 .537.398h3.391c.312 0 .565-.26.565-.582a.574.574 0 0 0-.565-.583h-2.065c2.769-3.002 2.654-7.749-.257-10.603C9.376-.79 4.772-.67 2.003 2.33-.765 5.333-.65 10.08 2.261 12.934c1.66 1.628 3.966 2.355 6.225 1.961Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=800:1817
 */

const IconArrowCircleCounterclockwiseShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.112 7.052a.619.619 0 0 1 .712-.494.6.6 0 0 1 .514.693c-.633 3.572 1.875 6.96 5.601 7.567 3.727.607 7.261-1.797 7.894-5.37.633-3.572-1.875-6.96-5.601-7.567-2.292-.374-4.625.394-6.195 2.038l2.754.88a.59.59 0 0 1 .394.753.628.628 0 0 1-.786.377l-3.73-1.192a.599.599 0 0 1-.426-.565V.596A.61.61 0 0 1 1.865 0a.61.61 0 0 1 .622.596v2.177c3.201-2.92 8.265-2.798 11.31.272 3.045 3.069 2.918 7.924-.284 10.843-3.201 2.919-8.265 2.797-11.31-.272C.467 11.866-.307 9.434.112 7.052Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3106
 */

const IconArrowDownThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '13',
  height: '17',
  viewBox: '0 0 13 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm6.44 16.227.546.547a.773.773 0 0 1-1.093 0l.546-.547Zm5.12-6.213a.773.773 0 0 1 1.092 1.093l-1.092-1.093ZM.226 11.107a.773.773 0 1 1 1.093-1.093L.226 11.107ZM5.666.773a.773.773 0 1 1 1.546 0H5.667Zm.227 14.908 5.667-5.667 1.092 1.093-5.666 5.667-1.093-1.093Zm0 1.093L.226 11.107l1.093-1.093 5.667 5.667-1.093 1.093Zm-.226-.547V.773h1.545v15.454H5.667Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3102
 */

const IconArrowDownShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '12',
  height: '16',
  viewBox: '0 0 12 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm6 15.5-.354.354a.5.5 0 0 0 .708 0L6 15.5ZM.854 9.646a.5.5 0 1 0-.708.708l.708-.708Zm11 .708a.5.5 0 0 0-.708-.708l.708.708ZM6.5.5a.5.5 0 0 0-1 0h1Zm-.146 14.646-5.5-5.5-.708.708 5.5 5.5.708-.708Zm0 .708 5.5-5.5-.708-.708-5.5 5.5.708.708ZM6.5 15.5V.5h-1v15h1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3096
 */

const IconArrowLeftThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '13',
  viewBox: '0 0 17 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm.773 6.44-.547-.547a.773.773 0 0 0 0 1.093l.547-.547Zm6.213-5.12A.773.773 0 1 0 5.893.225L6.986 1.32ZM5.893 12.651a.773.773 0 0 0 1.093-1.092l-1.093 1.092Zm10.334-5.44a.773.773 0 0 0 0-1.545v1.545ZM1.32 6.986l5.667-5.667L5.893.226.226 5.893 1.32 6.986Zm-1.093 0 5.667 5.667 1.093-1.093-5.667-5.667L.226 6.986Zm.547.226h15.454V5.667H.773v1.545Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3076
 */

const IconArrowLeftShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '12',
  viewBox: '0 0 16 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm.5 6-.354-.354a.5.5 0 0 0 0 .708L.5 6ZM6.354.854a.5.5 0 1 0-.708-.708l.708.708Zm-.708 11a.5.5 0 0 0 .708-.708l-.708.708ZM15.5 6.5a.5.5 0 0 0 0-1v1ZM.854 6.354l5.5-5.5-.708-.708-5.5 5.5.708.708Zm-.708 0 5.5 5.5.708-.708-5.5-5.5-.708.708ZM.5 6.5h15v-1H.5v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=704:7
 */

const IconArrowNarrowDownThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '13',
  viewBox: '0 0 9 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M3.504.747v9.703L1.282 8.238a.753.753 0 0 0-1.062 0 .745.745 0 0 0 0 1.057l3.487 3.471a.785.785 0 0 0 .548.234.773.773 0 0 0 .53-.234l3.488-3.471a.745.745 0 0 0 0-1.057.753.753 0 0 0-1.062 0l-2.206 2.195V.747A.75.75 0 0 0 4.255 0a.75.75 0 0 0-.751.747Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=704:17
 */

const IconArrowNarrowUpThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '13',
  viewBox: '0 0 9 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M4.99 12.253V2.55L7.21 4.763a.753.753 0 0 0 1.062 0 .745.745 0 0 0 0-1.058L4.786.234A.785.785 0 0 0 4.238 0a.774.774 0 0 0-.53.234L.22 3.705a.745.745 0 0 0 0 1.058.753.753 0 0 0 1.062 0l2.205-2.196v9.686a.75.75 0 0 0 .751.747.75.75 0 0 0 .751-.747Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3098
 */

const IconArrowRightThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '13',
  viewBox: '0 0 17 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm16.227 6.44.547-.547a.773.773 0 0 1 0 1.093l-.547-.547Zm-6.213-5.12A.773.773 0 0 1 11.107.225L10.014 1.32Zm1.093 11.332a.773.773 0 0 1-1.093-1.092l1.093 1.092ZM.773 7.212a.773.773 0 1 1 0-1.545v1.545Zm14.908-.226-5.667-5.667L11.107.226l5.667 5.667-1.093 1.093Zm1.093 0-5.667 5.667-1.093-1.093 5.667-5.667 1.093 1.093Zm-.547.226H.773V5.667h15.454v1.545Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3085
 */

const IconArrowRightShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '12',
  viewBox: '0 0 16 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm15.5 6 .354-.354a.5.5 0 0 1 0 .708L15.5 6ZM9.646.854a.5.5 0 1 1 .708-.708l-.708.708Zm.708 11a.5.5 0 0 1-.708-.708l.708.708ZM.5 6.5a.5.5 0 0 1 0-1v1Zm14.646-.146-5.5-5.5.708-.708 5.5 5.5-.708.708Zm.708 0-5.5 5.5-.708-.708 5.5-5.5.708.708ZM15.5 6.5H.5v-1h15v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3104
 */

const IconArrowUpThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '13',
  height: '17',
  viewBox: '0 0 13 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M6.44.773 5.892.226a.773.773 0 0 1 1.093 0l-.547.547ZM1.32 6.986A.773.773 0 0 1 .225 5.893L1.32 6.986Zm11.332-1.093a.773.773 0 0 1-1.092 1.093l1.092-1.093Zm-5.44 10.334a.773.773 0 0 1-1.545 0h1.545ZM6.986 1.32 1.319 6.986.226 5.893 5.893.226 6.986 1.32Zm0-1.093 5.667 5.667-1.093 1.093-5.667-5.667L6.986.226Zm.226.547v15.454H5.667V.773h1.545Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3100
 */

const IconArrowUpShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '12',
  height: '16',
  viewBox: '0 0 12 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm6 .5.354-.354a.5.5 0 0 0-.708 0L6 .5Zm5.146 5.854a.5.5 0 0 0 .708-.708l-.708.708Zm-11-.708a.5.5 0 1 0 .708.708l-.708-.708ZM5.5 15.5a.5.5 0 0 0 1 0h-1ZM5.646.854l5.5 5.5.708-.708-5.5-5.5-.708.708Zm0-.708-5.5 5.5.708.708 5.5-5.5-.708-.708ZM5.5.5v15h1V.5h-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3531
 */

const IconArrowZigzagDownThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '10',
  viewBox: '0 0 17 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M16.443 9.537a.748.748 0 0 1-.693.463h-6a.75.75 0 1 1 0-1.5h4.19L8.25 2.81 5.28 5.78a.75.75 0 0 1-1.09-.032l-4-4.5A.75.75 0 0 1 1.31.252l3.472 3.905L7.72 1.22a.75.75 0 0 1 1.06 0L15 7.44V3.25a.75.75 0 0 1 1.5 0v6c0 .102-.02.199-.057.287Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3590
 */

const IconArrowZigzagDownRtlThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '10',
  viewBox: '0 0 17 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.057 9.537A.748.748 0 0 0 .75 10h6a.75.75 0 1 0 0-1.5H2.56l5.69-5.69 2.97 2.97a.75.75 0 0 0 1.09-.032l4-4.5a.75.75 0 1 0-1.12-.996l-3.472 3.905L8.78 1.22a.75.75 0 0 0-1.06 0L1.5 7.44V3.25a.75.75 0 1 0-1.5 0v6c0 .102.02.199.057.287Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3483
 */

const IconArrowZigzagDownRtlShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '10',
  viewBox: '0 0 16 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.038 9.191A.499.499 0 0 0 .5 9.5h6a.5.5 0 1 0 0-1H1.707L8 2.207l3.146 3.147a.5.5 0 0 0 .728-.022l4-4.5a.5.5 0 1 0-.748-.664L11.48 4.27 8.354 1.146a.5.5 0 0 0-.708 0L1 7.793V3a.5.5 0 1 0-1 0v6c0 .068.013.132.038.191Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2369:3329
 */

const IconArrowZigzagDownShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '10',
  viewBox: '0 0 16 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.962 9.191a.5.5 0 0 1-.462.309h-6a.5.5 0 1 1 0-1h4.793L8 2.207 4.854 5.354a.5.5 0 0 1-.728-.022l-4-4.5A.5.5 0 1 1 .874.168L4.52 4.27l3.125-3.125a.5.5 0 0 1 .708 0L15 7.793V3a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.038.191Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3530
 */

const IconArrowZigzagUpThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '10',
  viewBox: '0 0 17 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9.75 0a.75.75 0 1 0 0 1.5h4.19L8.25 7.19 5.28 4.22a.75.75 0 0 0-1.09.032l-4 4.5a.75.75 0 0 0 1.12.996l3.472-3.905L7.72 8.78a.75.75 0 0 0 1.06 0L15 2.56v4.19a.75.75 0 0 0 1.5 0v-6a.747.747 0 0 0-.75-.75h-6Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3604
 */

const IconArrowZigzagUpRtlThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '10',
  viewBox: '0 0 17 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6.75 0a.75.75 0 1 1 0 1.5H2.56l5.69 5.69 2.97-2.97a.75.75 0 0 1 1.09.032l4 4.5a.75.75 0 1 1-1.12.996l-3.472-3.905L8.78 8.78a.75.75 0 0 1-1.06 0L1.5 2.56v4.19a.75.75 0 1 1-1.5 0v-6A.748.748 0 0 1 .75 0h6Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3455
 */

const IconArrowZigzagUpRtlShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '10',
  viewBox: '0 0 16 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.038.309A.498.498 0 0 1 .5 0h6a.5.5 0 1 1 0 1H1.707L8 7.293l3.146-3.147a.5.5 0 0 1 .728.022l4 4.5a.5.5 0 1 1-.748.664L11.48 5.23 8.354 8.354a.5.5 0 0 1-.708 0L1 1.707V6.5a.5.5 0 0 1-1 0v-6C0 .432.013.368.038.309Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2369:3330
 */

const IconArrowZigzagUpShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '10',
  viewBox: '0 0 16 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.962.309A.5.5 0 0 0 15.5 0h-6a.5.5 0 1 0 0 1h4.793L8 7.293 4.854 4.146a.5.5 0 0 0-.728.022l-4 4.5a.5.5 0 1 0 .748.664L4.52 5.23l3.125 3.125a.5.5 0 0 0 .708 0L15 1.707V6.5a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.038-.191Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=270:1582
 */

const IconArrowCircleClockwise = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M12.486 19.895a.58.58 0 0 0 .47-.667.568.568 0 0 0-.648-.484l-.01.002c-3.389.593-6.602-1.758-7.178-5.252-.575-3.493 1.705-6.807 5.093-7.4 3.389-.594 6.602 1.758 7.178 5.251.354 2.149-.374 4.336-1.933 5.807l-.834-2.581a.562.562 0 0 0-.715-.37.587.587 0 0 0-.358.738l1.13 3.497a.567.567 0 0 0 .537.398h3.391c.312 0 .565-.26.565-.582a.574.574 0 0 0-.565-.583h-2.065c2.769-3.002 2.654-7.749-.257-10.603C13.376 4.21 8.772 4.33 6.003 7.33c-2.768 3.002-2.653 7.749.258 10.603 1.66 1.628 3.966 2.355 6.225 1.961Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=800:1818
 */

const IconArrowCircleCounterclockwise = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M4.112 11.052a.619.619 0 0 1 .712-.495.6.6 0 0 1 .514.694c-.633 3.572 1.875 6.96 5.601 7.568 3.727.606 7.261-1.798 7.894-5.37.633-3.573-1.875-6.962-5.601-7.568-2.292-.374-4.625.394-6.195 2.038l2.754.88a.59.59 0 0 1 .394.753.628.628 0 0 1-.786.377l-3.73-1.192a.599.599 0 0 1-.426-.565V4.596A.61.61 0 0 1 5.865 4a.61.61 0 0 1 .622.596v2.177c3.201-2.92 8.265-2.798 11.31.272 3.045 3.069 2.918 7.924-.284 10.843-3.201 2.919-8.265 2.797-11.31-.272-1.736-1.75-2.51-4.182-2.091-6.564Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3119
 */

const IconArrowDownThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm12 19.5.53.53a.75.75 0 0 1-1.06 0l.53-.53Zm4.97-6.03a.75.75 0 1 1 1.06 1.06l-1.06-1.06Zm-11 1.06a.75.75 0 1 1 1.06-1.06l-1.06 1.06ZM11.25 4.5a.75.75 0 0 1 1.5 0h-1.5Zm.22 14.47 5.5-5.5 1.06 1.06-5.5 5.5-1.06-1.06Zm0 1.06-5.5-5.5 1.06-1.06 5.5 5.5-1.06 1.06Zm-.22-.53v-15h1.5v15h-1.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3115
 */

const IconArrowDown = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm12 19.5-.354.354a.5.5 0 0 0 .708 0L12 19.5Zm-5.146-5.854a.5.5 0 0 0-.708.708l.708-.708Zm11 .708a.5.5 0 0 0-.708-.708l.708.708ZM12.5 4.5a.5.5 0 0 0-1 0h1Zm-.146 14.646-5.5-5.5-.708.708 5.5 5.5.708-.708Zm0 .708 5.5-5.5-.708-.708-5.5 5.5.708.708Zm.146-.354v-15h-1v15h1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3116
 */

const IconArrowLeftThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm4.5 12-.53-.53a.75.75 0 0 0 0 1.06L4.5 12Zm6.03-4.97a.75.75 0 1 0-1.06-1.06l1.06 1.06Zm-1.06 11a.75.75 0 1 0 1.06-1.06l-1.06 1.06Zm10.03-5.28a.75.75 0 0 0 0-1.5v1.5Zm-14.47-.22 5.5-5.5-1.06-1.06-5.5 5.5 1.06 1.06Zm-1.06 0 5.5 5.5 1.06-1.06-5.5-5.5-1.06 1.06Zm.53.22h15v-1.5h-15v1.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3112
 */

const IconArrowLeft = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm4.5 12-.354-.354a.5.5 0 0 0 0 .708L4.5 12Zm5.854-5.146a.5.5 0 0 0-.708-.708l.708.708Zm-.708 11a.5.5 0 0 0 .708-.708l-.708.708ZM19.5 12.5a.5.5 0 0 0 0-1v1Zm-14.646-.146 5.5-5.5-.708-.708-5.5 5.5.708.708Zm-.708 0 5.5 5.5.708-.708-5.5-5.5-.708.708Zm.354.146h15v-1h-15v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=704:10
 */

const IconArrowNarrowDownThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M11.254 6.747v9.703l-2.222-2.212a.753.753 0 0 0-1.062 0 .745.745 0 0 0 0 1.056l3.487 3.472a.785.785 0 0 0 .548.234.774.774 0 0 0 .53-.234l3.488-3.471a.745.745 0 0 0 0-1.057.753.753 0 0 0-1.062 0l-2.206 2.195V6.747a.75.75 0 0 0-.75-.747.75.75 0 0 0-.751.747Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=704:19
 */

const IconArrowNarrowUpThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M12.74 18.253V8.55l2.221 2.212a.753.753 0 0 0 1.062 0 .745.745 0 0 0 0-1.057l-3.487-3.471A.785.785 0 0 0 11.988 6a.773.773 0 0 0-.53.234L7.97 9.705a.745.745 0 0 0 0 1.057.753.753 0 0 0 1.062 0l2.205-2.195v9.686a.75.75 0 0 0 .751.747.75.75 0 0 0 .751-.747Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3117
 */

const IconArrowRightThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm19.5 12 .53-.53a.75.75 0 0 1 0 1.06L19.5 12Zm-6.03-4.97a.75.75 0 0 1 1.06-1.06l-1.06 1.06Zm1.06 11a.75.75 0 1 1-1.06-1.06l1.06 1.06ZM4.5 12.75a.75.75 0 0 1 0-1.5v1.5Zm14.47-.22-5.5-5.5 1.06-1.06 5.5 5.5-1.06 1.06Zm1.06 0-5.5 5.5-1.06-1.06 5.5-5.5 1.06 1.06Zm-.53.22h-15v-1.5h15v1.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3113
 */

const IconArrowRight = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm19.5 12 .354-.354a.5.5 0 0 1 0 .708L19.5 12Zm-5.854-5.146a.5.5 0 0 1 .708-.708l-.708.708Zm.708 11a.5.5 0 0 1-.708-.708l.708.708ZM4.5 12.5a.5.5 0 0 1 0-1v1Zm14.646-.146-5.5-5.5.708-.708 5.5 5.5-.708.708Zm.708 0-5.5 5.5-.708-.708 5.5-5.5.708.708Zm-.354.146h-15v-1h15v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3118
 */

const IconArrowUpThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm12 4.5-.53-.53a.75.75 0 0 1 1.06 0L12 4.5Zm-4.97 6.03a.75.75 0 1 1-1.06-1.06l1.06 1.06Zm11-1.06a.75.75 0 1 1-1.06 1.06l1.06-1.06ZM12.75 19.5a.75.75 0 0 1-1.5 0h1.5Zm-.22-14.47-5.5 5.5-1.06-1.06 5.5-5.5 1.06 1.06Zm0-1.06 5.5 5.5-1.06 1.06-5.5-5.5 1.06-1.06Zm.22.53v15h-1.5v-15h1.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3114
 */

const IconArrowUp = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm12 4.5.354-.354a.5.5 0 0 0-.708 0L12 4.5Zm5.146 5.854a.5.5 0 0 0 .708-.708l-.708.708Zm-11-.708a.5.5 0 0 0 .708.708l-.708-.708ZM11.5 19.5a.5.5 0 0 0 1 0h-1Zm.146-14.646 5.5 5.5.708-.708-5.5-5.5-.708.708Zm0-.708-5.5 5.5.708.708 5.5-5.5-.708-.708ZM11.5 4.5v15h1v-15h-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1664:3510
 */

const IconArrowZigzagDownThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M19.693 16.787a.747.747 0 0 1-.693.463h-6a.75.75 0 0 1 0-1.5h4.19l-5.69-5.69-2.97 2.97a.75.75 0 0 1-1.09-.032l-4-4.5a.75.75 0 1 1 1.12-.996l3.472 3.905L10.97 8.47a.75.75 0 0 1 1.06 0l6.22 6.22V10.5a.75.75 0 0 1 1.5 0v6c0 .102-.02.199-.057.287Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1667:4101
 */

const IconArrowZigzagDown = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M19.462 16.691A.5.5 0 0 1 19 17h-6a.5.5 0 0 1 0-1h4.793L11.5 9.707l-3.146 3.147a.5.5 0 0 1-.728-.022l-4-4.5a.5.5 0 0 1 .748-.664L8.02 11.77l3.125-3.125a.5.5 0 0 1 .708 0l6.646 6.647V10.5a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.038.191Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3593
 */

const IconArrowZigzagDownRtlThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3.307 16.787A.747.747 0 0 0 4 17.25h6a.75.75 0 0 0 0-1.5H5.81l5.69-5.69 2.97 2.97a.75.75 0 0 0 1.09-.032l4-4.5a.75.75 0 1 0-1.12-.996l-3.472 3.905L12.03 8.47a.75.75 0 0 0-1.06 0l-6.22 6.22V10.5a.75.75 0 0 0-1.5 0v6c0 .102.02.199.057.287Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3486
 */

const IconArrowZigzagDownRtl = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3.538 16.691A.499.499 0 0 0 4 17h6a.5.5 0 0 0 0-1H5.207L11.5 9.707l3.146 3.147a.5.5 0 0 0 .728-.022l4-4.5a.5.5 0 1 0-.748-.664L14.98 11.77l-3.125-3.125a.5.5 0 0 0-.708 0L4.5 15.293V10.5a.5.5 0 0 0-1 0v6c0 .068.013.132.038.191Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1664:3453
 */

const IconArrowZigzagUpThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13 7.25a.75.75 0 0 0 0 1.5h4.19l-5.69 5.69-2.97-2.97a.75.75 0 0 0-1.09.032l-4 4.5a.75.75 0 0 0 1.12.996l3.472-3.905 2.938 2.937a.75.75 0 0 0 1.06 0l6.22-6.22V14a.75.75 0 0 0 1.5 0V8a.747.747 0 0 0-.75-.75h-6Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1667:4097
 */

const IconArrowZigzagUp = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M19.462 7.809A.5.5 0 0 0 19 7.5h-6a.5.5 0 0 0 0 1h4.793L11.5 14.793l-3.146-3.147a.5.5 0 0 0-.728.022l-4 4.5a.5.5 0 0 0 .748.664l3.647-4.104 3.125 3.126a.5.5 0 0 0 .708 0L18.5 9.207V14a.5.5 0 0 0 1 0V8a.5.5 0 0 0-.038-.191Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3607
 */

const IconArrowZigzagUpRtlThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10 7.25a.75.75 0 0 1 0 1.5H5.81l5.69 5.69 2.97-2.97a.75.75 0 0 1 1.09.032l4 4.5a.75.75 0 1 1-1.12.996l-3.472-3.905-2.938 2.937a.75.75 0 0 1-1.06 0L4.75 9.81V14a.75.75 0 0 1-1.5 0V8A.748.748 0 0 1 4 7.25h6Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3458
 */

const IconArrowZigzagUpRtl = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3.538 7.809A.499.499 0 0 1 4 7.5h6a.5.5 0 0 1 0 1H5.207l6.293 6.293 3.146-3.147a.5.5 0 0 1 .728.022l4 4.5a.5.5 0 1 1-.748.664l-3.647-4.104-3.125 3.126a.5.5 0 0 1-.708 0L4.5 9.207V14a.5.5 0 0 1-1 0V8c0-.068.013-.132.038-.191Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=268:1640
 */

const IconArrowsCircleThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '20',
  viewBox: '0 0 19 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.99 3.148a.301.301 0 0 1-.14.491L11.907 4.77a.301.301 0 0 1-.373-.373l.384-1.337a7.88 7.88 0 0 0-9.69 10.522.815.815 0 1 1-1.506.625A9.51 9.51 0 0 1 12.368 1.493l.365-1.275A.301.301 0 0 1 13.246.1l2.744 3.048ZM7.098 15.831l-.375 1.307a7.536 7.536 0 0 0 9.4-10.017.78.78 0 0 1 1.441-.597A9.095 9.095 0 0 1 6.293 18.639l-.328 1.143a.301.301 0 0 1-.513.118L2.858 17.02a.301.301 0 0 1 .14-.492l3.727-1.069a.301.301 0 0 1 .373.373Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:851
 */

const IconArrowsUpDownThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '14',
  viewBox: '0 0 16 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.011 10.462V.748a.75.75 0 0 1 .75-.748.75.75 0 0 1 .752.748v9.697l2.205-2.198a.753.753 0 0 1 1.062 0 .747.747 0 0 1 0 1.058l-3.487 3.476a.773.773 0 0 1-.531.234.785.785 0 0 1-.548-.234L7.727 9.305a.747.747 0 0 1 0-1.058.753.753 0 0 1 1.062 0l2.222 2.215ZM4.989 2.553v9.714a.75.75 0 0 1-.75.748.75.75 0 0 1-.752-.748V2.57L1.282 4.768a.753.753 0 0 1-1.062 0 .747.747 0 0 1 0-1.058L3.707.234A.773.773 0 0 1 4.238 0a.785.785 0 0 1 .548.234L8.273 3.71a.747.747 0 0 1 0 1.058.753.753 0 0 1-1.062 0L4.99 2.553Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:857
 */

const IconArrowsUpDownShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '14',
  viewBox: '0 0 16 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3.43 12.23V0h.882v12.231l2.805-2.62.624.582-3.87 3.616L0 10.193l.624-.583 2.805 2.62Zm4.829-8.614L12.129 0 16 3.616l-.623.583-2.806-2.62v12.23h-.882V1.58l-2.805 2.62-.624-.583Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=269:1583
 */

const IconArrowsCircleThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M18.923 5.135a.3.3 0 0 1-.14.489L14.856 6.75a.3.3 0 0 1-.371-.371l.381-1.332a7.847 7.847 0 0 0-9.649 10.477.812.812 0 1 1-1.5.622 9.47 9.47 0 0 1 11.596-12.66l.365-1.269a.3.3 0 0 1 .511-.118l2.733 3.036Zm-8.855 12.629-.373 1.302c.773.264 1.59.4 2.426.4a7.504 7.504 0 0 0 6.935-10.375.776.776 0 0 1 1.434-.595A9.056 9.056 0 0 1 9.266 20.559l-.326 1.139a.3.3 0 0 1-.511.118l-2.583-2.87a.3.3 0 0 1 .14-.489l3.71-1.064a.3.3 0 0 1 .372.371Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:847
 */

const IconArrowsUpDownThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.011 15.462V5.748a.75.75 0 0 1 .75-.748.75.75 0 0 1 .752.748v9.697l2.205-2.198a.753.753 0 0 1 1.062 0 .746.746 0 0 1 0 1.058l-3.487 3.476a.773.773 0 0 1-.531.234.785.785 0 0 1-.548-.234l-3.487-3.476a.746.746 0 0 1 0-1.058.753.753 0 0 1 1.062 0l2.222 2.215ZM8.989 7.553v9.714a.75.75 0 0 1-.75.748.75.75 0 0 1-.752-.748V7.57L5.282 9.768a.753.753 0 0 1-1.062 0 .747.747 0 0 1 0-1.058l3.487-3.476A.773.773 0 0 1 8.238 5a.784.784 0 0 1 .548.234l3.487 3.476a.747.747 0 0 1 0 1.058.753.753 0 0 1-1.062 0L8.99 7.553Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:852
 */

const IconArrowsUpDown = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.322 16.848V5h.855v11.848l2.717-2.539.605.565-3.75 3.503L4 14.874l.605-.565 2.717 2.539ZM12 8.503 15.75 5l3.749 3.503-.605.565-2.717-2.54v11.849h-.855V6.529l-2.717 2.539L12 8.503Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:616
 */

const IconBalconyShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '20',
  viewBox: '0 0 19 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M4 11V5.5a5.5 5.5 0 1 1 11 0V11h2.5a.5.5 0 0 0 0-1H17V9h.5a1.5 1.5 0 0 1 .5 2.915V18a1 1 0 0 1-1 1h-2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1H2a1 1 0 0 1-1-1v-6.085A1.5 1.5 0 0 1 1.5 9l.5.02V10h-.5a.5.5 0 0 0 0 1H4Zm10-2.98V5.5a4.5 4.5 0 0 0-3.998-4.472v.041c.07 4.37 1.947 6.659 3.998 6.951ZM9.502 4.538C8.672 7.296 6.914 8.822 5 9.028V11h9V9.028c-1.913-.208-3.669-1.734-4.498-4.49Zm-.5-3.51A4.5 4.5 0 0 0 5 5.5v2.52c2.052-.29 3.932-2.578 4.002-6.95v-.043ZM5 12H2v5.75c0 .138.112.25.25.25h14.5a.25.25 0 0 0 .25-.25V12h-3v6h-1v-6h-3v6H9v-6H6v6H5v-6Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:613
 */

const IconBalcony = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7 13V7.5a5.5 5.5 0 1 1 11 0V13h2.5a.5.5 0 0 0 0-1H20v-1h.5a1.5 1.5 0 0 1 .5 2.915V20a1 1 0 0 1-1 1h-2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1H5a1 1 0 0 1-1-1v-6.085A1.5 1.5 0 0 1 4.5 11l.5.02V12h-.5a.5.5 0 0 0 0 1H7Zm10-2.98V7.5a4.5 4.5 0 0 0-3.998-4.472v.041c.07 4.37 1.947 6.659 3.998 6.951Zm-4.498-3.482c-.83 2.758-2.588 4.284-4.502 4.49V13h9v-1.972c-1.913-.208-3.669-1.734-4.498-4.49Zm-.5-3.51A4.5 4.5 0 0 0 8 7.5v2.52c2.052-.29 3.932-2.578 4.002-6.95v-.043ZM8 14H5v5.75c0 .138.112.25.25.25h14.5a.25.25 0 0 0 .25-.25V14h-3v6h-1v-6h-3v6h-1v-6H9v6H8v-6Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1148
 */

const IconBarbecueShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '18',
  viewBox: '0 0 16 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13.841 14.006a2 2 0 1 1-.946.327L12.36 13H4.31l-1.862 3.724a.5.5 0 1 1-.894-.448l3.5-7a.508.508 0 0 1 .02-.037A6.006 6.006 0 0 1 2.083 5H.5a.5.5 0 0 1 0-1H2a3 3 0 0 1 3-3h2.5V.5A.5.5 0 0 1 8 0h2a.5.5 0 0 1 .5.5V1H13a3 3 0 0 1 3 3l-.083 1a6.009 6.009 0 0 1-3.828 4.626l1.752 4.38ZM10 10H8a5.99 5.99 0 0 1-2.023-.35.504.504 0 0 1-.03.074L4.81 12h7.152l-.841-2.104A6.033 6.033 0 0 1 10 10Zm3-8H5a2 2 0 0 0-2 2h12a2 2 0 0 0-2-2Zm1.9 3H3.1A5.002 5.002 0 0 0 8 9h2a5.002 5.002 0 0 0 4.9-4ZM14 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1144
 */

const IconBarbecue = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17.841 17.006a2 2 0 1 1-.946.327L16.36 16H8.31l-1.862 3.724a.5.5 0 1 1-.894-.448l3.5-7a.508.508 0 0 1 .02-.037A6.006 6.006 0 0 1 6.083 8H4.5a.5.5 0 0 1 0-1H6a3 3 0 0 1 3-3h2.5v-.5A.5.5 0 0 1 12 3h2a.5.5 0 0 1 .5.5V4H17a3 3 0 0 1 3 3l-.083 1a6.008 6.008 0 0 1-3.828 4.626l1.752 4.38ZM14 13h-2a5.99 5.99 0 0 1-2.023-.35.504.504 0 0 1-.03.074L8.81 15h7.152l-.841-2.104A6.031 6.031 0 0 1 14 13Zm3-8H9a2 2 0 0 0-2 2h12a2 2 0 0 0-2-2Zm1.9 3H7.1a5.002 5.002 0 0 0 4.9 4h2a5.002 5.002 0 0 0 4.9-4ZM18 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=178:94
 */

const IconBathtubThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '13',
  viewBox: '0 0 17 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3.5 2.684c0-.491.125-.793.255-.956a.598.598 0 0 1 .5-.228c.23 0 .383.08.494.219.126.156.251.455.251.965v.466a.75.75 0 0 0 1.5 0v-.466c0-.738-.18-1.406-.582-1.905C5.503.262 4.908 0 4.254 0 3.594 0 3 .275 2.586.79 2.186 1.287 2 1.953 2 2.683v2.465c0 .03.002.06.005.09H.75a.75.75 0 0 0-.75.75v2.5c0 1.323.817 2.424 1.96 2.938l-.242.485a.75.75 0 0 0 1.341.67l.422-.843h9.633l.422.844a.75.75 0 0 0 1.341-.671l-.176-.352C16.02 11.125 17 9.94 17 8.49v-2.5a.75.75 0 0 0-.75-.75H13.5v-.754a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75v.753H3.495a.759.759 0 0 0 .005-.09V2.684Zm5 4.055h-7v1.75c0 .922.815 1.75 1.92 1.75h10.163c1.105 0 1.917-.828 1.917-1.75V6.74h-2v1.51a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-1.51ZM10 5.236v2.263h2V5.236h-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=178:96
 */

const IconBathtubThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7 8.185c0-.49.125-.793.255-.955a.598.598 0 0 1 .5-.229c.23 0 .383.081.494.22.126.155.251.454.251.964v.466a.75.75 0 0 0 1.5 0v-.466c0-.738-.18-1.406-.582-1.905-.415-.517-1.01-.779-1.664-.779-.66 0-1.255.275-1.668.79-.4.499-.586 1.164-.586 1.894v2.465c0 .03.002.061.005.09H4.25a.75.75 0 0 0-.75.75v2.5c0 1.324.817 2.425 1.96 2.939l-.242.484a.75.75 0 1 0 1.341.67l.422-.842h9.633l.422.843a.75.75 0 0 0 1.341-.67l-.176-.353c1.318-.435 2.299-1.619 2.299-3.07v-2.5a.75.75 0 0 0-.75-.75H17v-.754a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75v.754H6.995A.759.759 0 0 0 7 10.65V8.184Zm5 4.056H5v1.75c0 .921.815 1.75 1.92 1.75h10.163c1.105 0 1.917-.829 1.917-1.75v-1.75h-2v1.509a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-1.51Zm1.5-1.504V13h2v-2.263h-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1123
 */

const IconBathtubShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '12',
  viewBox: '0 0 17 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M2 3.908V1.475C2 .661 2.66 0 3.495 0 4.33 0 5 .66 5 1.475v.658a.493.493 0 0 1-.498.486.493.493 0 0 1-.499-.486v-.658a.503.503 0 0 0-.508-.502.495.495 0 0 0-.498.502v2.433H9c0-.54.448-.977 1-.977h3c.552 0 1 .438 1 .977h2c.552 0 1 .438 1 .977v2.443c0 1.823-1.46 3.312-3.299 3.414l.434.424a.48.48 0 0 1 0 .69.508.508 0 0 1-.707 0l-1.135-1.108H4.989l-1.135 1.109a.508.508 0 0 1-.708 0 .48.48 0 0 1 0-.691l.428-.418H3.5c-1.933 0-3.5-1.531-3.5-3.42V4.885c0-.54.448-.977 1-.977h1Zm8 0v.977h3v-.977h-3Zm-1 .977H1v2.443c0 1.35 1.12 2.443 2.5 2.443h10c1.38 0 2.5-1.094 2.5-2.443V4.885h-2v2.932c0 .54-.448.977-1 .977h-3c-.552 0-1-.438-1-.977V4.885Zm1 0v2.932h3V6.84h-1.79a.494.494 0 0 1-.5-.489c0-.27.223-.489.5-.489H13v-.977h-3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1119
 */

const IconBathtub = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5.5 9.908V7.475C5.5 6.661 6.16 6 6.995 6 7.83 6 8.5 6.66 8.5 7.475v.658a.493.493 0 0 1-.498.486.493.493 0 0 1-.499-.486v-.658a.503.503 0 0 0-.508-.502.495.495 0 0 0-.498.502v2.433H12.5c0-.54.448-.977 1-.977h3c.552 0 1 .438 1 .977h2c.552 0 1 .438 1 .977v2.443c0 1.823-1.46 3.312-3.299 3.414l.434.424a.48.48 0 0 1 0 .69.508.508 0 0 1-.707 0l-1.135-1.108H8.489l-1.135 1.109a.508.508 0 0 1-.708 0 .48.48 0 0 1 0-.691l.428-.418H7c-1.933 0-3.5-1.531-3.5-3.42v-2.443c0-.54.448-.977 1-.977h1Zm8 0v.977h3v-.977h-3Zm-1 .977h-8v2.443c0 1.35 1.12 2.443 2.5 2.443h10c1.38 0 2.5-1.094 2.5-2.443v-2.443h-2v2.932c0 .54-.448.977-1 .977h-3c-.552 0-1-.438-1-.977v-2.932Zm1 0v2.932h3v-.977h-1.79a.494.494 0 0 1-.5-.489c0-.27.223-.489.5-.489h1.79v-.977h-3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1130
 */

const IconBeachBallShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '15',
  viewBox: '0 0 20 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M19.997 13.168s-.678.299-.965.68C18.403 14.68 18 15 17.189 15c-.811 0-1.214-.32-1.843-1.153-.452-.599-.65-.756-1.04-.756s-.588.157-1.04.756C12.637 14.68 12.234 15 11.423 15c-.81 0-1.214-.32-1.843-1.153-.452-.599-.65-.756-1.04-.756s-.587.157-1.04.756C6.871 14.68 6.468 15 5.657 15c-.81 0-1.214-.32-1.842-1.153-.453-.599-.65-.756-1.04-.756s-.588.157-1.04.756c-.498.66-1.727 1.11-1.727 1.11L0 13.938s.646-.3.932-.677c.629-.833 1.032-1.153 1.843-1.153.81 0 1.214.32 1.842 1.153.453.599.65.756 1.04.756s.588-.157 1.04-.756c.63-.833 1.032-1.153 1.843-1.153.811 0 1.214.32 1.843 1.153.452.599.65.756 1.04.756s.588-.157 1.04-.756c.63-.833 1.032-1.153 1.843-1.153.811 0 1.214.32 1.843 1.153.452.599.65.756 1.04.756s.588-.157 1.04-.756c.5-.663 1.771-1.111 1.771-1.111l-.003 1.018ZM8.11 8.924a8.721 8.721 0 0 1-1.745-1.839 6.888 6.888 0 0 1-2.982-.322A3.997 3.997 0 0 0 8.11 8.924ZM11 5.044c0-.17-.01-.339-.03-.505C9.912 5.747 8.702 6.5 7.452 6.865A8.363 8.363 0 0 0 9.15 8.45 4.042 4.042 0 0 0 11 5.045Zm-7.996 0c0 .17.01.335.03.498a6.068 6.068 0 0 0 2.766.573c-.751-1.57-.802-3.243-.303-4.81a4.037 4.037 0 0 0-2.493 3.74Zm3.664-4.021c-.681 1.592-.702 3.335.188 4.952 1.355-.312 2.675-1.145 3.78-2.617a3.998 3.998 0 0 0-3.968-2.335Zm.334 9.067c-2.76 0-4.998-2.259-4.998-5.045S4.242 0 7.002 0C9.762 0 12 2.259 12 5.045S9.763 10.09 7.002 10.09Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1126
 */

const IconBeachBall = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M21.997 17.668s-.678.299-.965.68C20.403 19.18 20 19.5 19.189 19.5c-.811 0-1.214-.32-1.843-1.153-.452-.599-.65-.756-1.04-.756s-.588.157-1.04.756c-.629.833-1.032 1.153-1.843 1.153-.81 0-1.214-.32-1.843-1.153-.452-.599-.65-.756-1.04-.756s-.587.157-1.04.756c-.629.833-1.032 1.153-1.843 1.153-.81 0-1.214-.32-1.842-1.153-.453-.599-.65-.756-1.04-.756s-.588.157-1.04.756c-.498.66-1.727 1.11-1.727 1.11L2 18.438s.646-.3.932-.677c.629-.833 1.032-1.153 1.843-1.153.81 0 1.214.32 1.842 1.153.453.599.65.756 1.04.756s.588-.157 1.04-.756c.63-.833 1.032-1.153 1.843-1.153.811 0 1.214.32 1.843 1.153.452.599.65.756 1.04.756s.588-.157 1.04-.756c.63-.833 1.032-1.153 1.843-1.153.811 0 1.214.32 1.843 1.153.452.599.65.756 1.04.756s.588-.157 1.04-.756c.5-.663 1.771-1.111 1.771-1.111l-.003 1.018ZM10.11 13.424a8.72 8.72 0 0 1-1.745-1.839 6.887 6.887 0 0 1-2.982-.322 3.997 3.997 0 0 0 3.62 2.318c.383 0 .755-.055 1.107-.157ZM13 9.544c0-.17-.01-.339-.03-.505-1.058 1.208-2.268 1.961-3.518 2.326a8.362 8.362 0 0 0 1.698 1.585A4.042 4.042 0 0 0 13 9.545Zm-7.996 0c0 .17.01.335.03.498a6.067 6.067 0 0 0 2.766.573c-.751-1.57-.802-3.243-.303-4.81a4.037 4.037 0 0 0-2.493 3.74Zm3.664-4.021c-.681 1.592-.702 3.335.188 4.952 1.355-.312 2.675-1.145 3.78-2.617a3.998 3.998 0 0 0-3.968-2.335Zm.334 9.067c-2.76 0-4.998-2.259-4.998-5.045S6.242 4.5 9.002 4.5C11.762 4.5 14 6.759 14 9.545s-2.237 5.045-4.998 5.045Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:802
 */

const IconBedThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '13',
  viewBox: '0 0 15 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13.5 4.756V3A1.5 1.5 0 0 0 12 1.5H3A1.5 1.5 0 0 0 1.5 3v1.756a4.497 4.497 0 0 0-1.5.89V3a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v2.646a4.497 4.497 0 0 0-1.5-.89ZM2.886 7.504A1.5 1.5 0 0 0 1.5 9v1.5h12V9a1.5 1.5 0 0 0-1.386-1.496A1 1 0 0 1 11.25 8h-7.5a1 1 0 0 1-.864-.496ZM15 9v2.5a.5.5 0 0 1-.5.5H14v.5a.5.5 0 0 1-.5.5H13a.5.5 0 0 1-.5-.5V12h-10v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V12H.5a.5.5 0 0 1-.5-.5V9a3 3 0 0 1 2.75-2.99V4a1 1 0 0 1 1-1h7.5a1 1 0 0 1 1 1v2.01A3 3 0 0 1 15 9ZM6.75 6.5v-2h-2.5v2h2.5Zm1.5-2v2h2.5v-2h-2.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:799
 */

const IconBedThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17.5 10.756V9A1.5 1.5 0 0 0 16 7.5H7A1.5 1.5 0 0 0 5.5 9v1.756a4.498 4.498 0 0 0-1.5.89V9a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v2.646a4.498 4.498 0 0 0-1.5-.89ZM6.886 13.504A1.5 1.5 0 0 0 5.5 15v1.5h12V15a1.5 1.5 0 0 0-1.386-1.496 1 1 0 0 1-.864.496h-7.5a1 1 0 0 1-.864-.496ZM19 15v2.5a.5.5 0 0 1-.5.5H18v.5a.5.5 0 0 1-.5.5H17a.5.5 0 0 1-.5-.5V18h-10v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V18h-.5a.5.5 0 0 1-.5-.5V15a3 3 0 0 1 2.75-2.99V10a1 1 0 0 1 1-1h7.5a1 1 0 0 1 1 1v2.01A3 3 0 0 1 19 15Zm-8.25-2.5v-2h-2.5v2h2.5Zm1.5-2v2h2.5v-2h-2.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:766
 */

const IconBedShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '13',
  viewBox: '0 0 17 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13.293 12H3.707l-.853.854a.5.5 0 0 1-.708-.708L2.293 12H2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.268A2 2 0 0 1 5 4h2c.597 0 1.134.262 1.5.677A1.995 1.995 0 0 1 10 4h2a2 2 0 0 1 1.732 3H15a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-.293l.147.146a.5.5 0 0 1-.708.708L13.293 12ZM15 8H2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Zm-3-1a1 1 0 1 0 0-2h-2a1 1 0 0 0 0 2h2ZM5 7h2a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2ZM2 5.5a.5.5 0 0 1-1 0v-3C1 1.138 1.938 0 3.147 0h10.706C15.063 0 16 1.138 16 2.5v3a.5.5 0 0 1-1 0v-3c0-.848-.537-1.5-1.147-1.5H3.147C2.537 1 2 1.652 2 2.5v3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:762
 */

const IconBed = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17.293 18H7.707l-.853.854a.5.5 0 0 1-.708-.708L6.293 18H6a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h1.268A2 2 0 0 1 9 10h2c.597 0 1.133.262 1.5.677A1.995 1.995 0 0 1 14 10h2a2 2 0 0 1 1.732 3H19a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-.293l.147.146a.5.5 0 0 1-.708.708L17.293 18ZM19 14H6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-3-1a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2h2Zm-7 0h2a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2Zm-3-1.5a.5.5 0 0 1-1 0v-3C5 7.138 5.938 6 7.147 6h10.706C19.063 6 20 7.138 20 8.5v3a.5.5 0 0 1-1 0v-3c0-.848-.537-1.5-1.147-1.5H7.147C6.537 7 6 7.652 6 8.5v3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=515:1742
 */

const IconBellShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '20',
  viewBox: '0 0 17 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.5 19a2 2 0 0 0 1.732-1H6.768A2 2 0 0 0 8.5 19Zm-2.83-1c-.11-.313-.17-.65-.17-1h6a2.997 2.997 0 0 1-3 3 3.001 3.001 0 0 1-2.83-2Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M1.5 14.063V9.28c0-2.12.696-3.946 1.94-5.244C4.683 2.736 6.442 2 8.5 2c2.057 0 3.816.737 5.06 2.036C14.805 5.334 15.5 7.16 15.5 9.28v4.783A2 2 0 0 1 15 18H2a2 2 0 0 1-.5-3.937Zm1-4.783c0-1.9.62-3.465 1.661-4.552C5.201 3.643 6.691 3 8.5 3c1.81 0 3.3.643 4.339 1.728C13.879 5.815 14.5 7.38 14.5 9.28v5.22a.5.5 0 0 0 .5.5 1 1 0 1 1 0 2H2a1 1 0 1 1 0-2 .5.5 0 0 0 .5-.5V9.28Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M6.5.5A.5.5 0 0 1 7 0h3a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3777
 */

const IconBellThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '20',
  viewBox: '0 0 18 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.75 0a1 1 0 0 0-1 1v.808c-1.693.202-3.154.92-4.241 2.056C2.215 5.214 1.5 7.104 1.5 9.28v4.598a2.251 2.251 0 0 0 .75 4.372h3.772a3 3 0 0 0 5.456 0h3.772a2.25 2.25 0 0 0 .75-4.372V9.28c0-2.176-.715-4.066-2.008-5.416-1.088-1.136-2.549-1.854-4.242-2.056V1a1 1 0 0 0-1-1ZM3 9.28c0-1.845.602-3.345 1.592-4.379C5.58 3.87 7.002 3.25 8.75 3.25c1.748 0 3.17.62 4.158 1.651.99 1.034 1.592 2.534 1.592 4.379v5.22c0 .414.336.75.75.75a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1 0-1.5.75.75 0 0 0 .75-.75V9.28Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=515:1748
 */

const IconBellThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 2a1 1 0 0 0-1 1v.808c-1.693.202-3.154.92-4.241 2.056-1.294 1.35-2.009 3.24-2.009 5.416v4.598a2.251 2.251 0 0 0 .75 4.372h3.772a3 3 0 0 0 5.456 0H18.5a2.25 2.25 0 0 0 .75-4.372V11.28c0-2.176-.715-4.066-2.009-5.416C16.154 4.728 14.693 4.01 13 3.808V3a1 1 0 0 0-1-1Zm-5.75 9.28c0-1.845.602-3.345 1.592-4.379C8.829 5.87 10.252 5.25 12 5.25c1.748 0 3.17.62 4.158 1.651.99 1.034 1.592 2.534 1.592 4.379v5.22c0 .414.336.75.75.75a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1 0-1.5.75.75 0 0 0 .75-.75v-5.22Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=515:1743
 */

const IconBell = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 21a2 2 0 0 0 1.732-1h-3.464A2 2 0 0 0 12 21Zm-2.83-1c-.11-.313-.17-.65-.17-1h6a2.997 2.997 0 0 1-3 3 3.001 3.001 0 0 1-2.83-2Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5 16.063V11.28c0-2.12.696-3.946 1.94-5.244C8.183 4.736 9.942 4 12 4c2.057 0 3.816.737 5.06 2.036C18.305 7.334 19 9.16 19 11.28v4.783A2 2 0 0 1 18.5 20h-13a2 2 0 0 1-.5-3.937Zm1-4.783c0-1.9.62-3.465 1.661-4.552C8.701 5.643 10.191 5 12 5c1.81 0 3.3.643 4.339 1.728C17.379 7.815 18 9.38 18 11.28v5.22a.5.5 0 0 0 .5.5 1 1 0 1 1 0 2h-13a1 1 0 1 1 0-2 .5.5 0 0 0 .5-.5v-5.22Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M10 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2771:6084
 */

const IconBookOpenThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '15',
  viewBox: '0 0 19 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13 11c-.921 0-2.03.566-2.75 1.002V12.827l.055-.04C11.113 12.199 12.3 11.5 14 11.5h3.5v-8H17V10a1 1 0 0 1-1 1h-3Zm4-9h1a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-4c-1.531 0-2.5.75-3.25 1.332-.178.137-.343.265-.5.371-.264.18-.507.297-.75.297s-.486-.118-.75-.296c-.157-.107-.322-.235-.5-.372C7.5 13.75 6.531 13 5 13H.999A.999.999 0 0 1 0 12V3a1 1 0 0 1 1-1h1V1a1 1 0 0 1 1-1h3c2 0 3.5 1.5 3.5 1.5S11 0 13 0h3a1 1 0 0 1 1 1v1ZM2 3.5h-.5v8H5c1.701 0 2.887.7 3.695 1.287l.055.04V12.002C8.03 11.566 6.921 11 6 11H3a1 1 0 0 1-1-1V3.5Zm11 6c-1.013 0-2.031.418-2.75.785V2.87l.305-.304.025-.024c.027-.024.072-.065.136-.116.127-.105.317-.248.556-.39C11.764 1.74 12.369 1.5 13 1.5h2.5v8H13Zm-4.25.785V2.87l-.305-.304c.002.001.002.002.001 0h-.001a4.742 4.742 0 0 0-.717-.53C7.236 1.74 6.631 1.5 6 1.5H3.5v8H6c1.013 0 2.031.418 2.75.785Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:606
 */

const IconBookOpenShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '15',
  viewBox: '0 0 19 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17 2.018h1c.552 0 1 .451 1 1.008v9.08c0 .556-.448 1.008-1 1.008h-4c-1.78 0-2.768.575-3.992 1.724A.597.597 0 0 1 9.6 15h-.2a.597.597 0 0 1-.409-.162C7.768 13.69 6.78 13.114 5 13.114H1c-.552 0-1-.452-1-1.009V3.026c0-.557.448-1.008 1-1.008h1V1a1 1 0 0 1 1-1h2.97C7.35 0 8.535.577 9.5 1.703 10.466.577 11.65 0 13.03 0H16a1 1 0 0 1 1 1v1.018Zm-1-.76a.25.25 0 0 0-.25-.25h-2.72c-1.196 0-2.195.547-3.03 1.678v8.593c.87-.79 1.885-1.191 3.03-1.191h2.72a.25.25 0 0 0 .25-.25V3.026h1v7.07a1 1 0 0 1-1 1h-2.97c-1.156 0-2.093.538-2.958 1.248l-.072.078v1.11c1.278-.95 2.283-1.427 4-1.427h3.75c.138 0 .25-.113.25-.252V3.278a.251.251 0 0 0-.25-.252L16 3.03V1.259ZM9 11.28V2.686c-.835-1.13-1.834-1.677-3.03-1.677H3.25a.25.25 0 0 0-.25.25v8.579c0 .138.112.25.25.25h2.72c1.145 0 2.16.402 3.03 1.191Zm0 1.143-.072-.078c-.767-.641-1.802-1.248-2.957-1.248H3a1 1 0 0 1-1-1v-7.07h-.75a.251.251 0 0 0-.25.252v8.575c0 .14.112.252.25.252H5c1.717 0 2.722.477 4 1.427v-1.11Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2771:6089
 */

const IconBookOpenThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M16 16c-.921 0-2.03.566-2.75 1.002V17.827l.055-.04C14.113 17.199 15.3 16.5 17 16.5h3.5v-8H20V15a1 1 0 0 1-1 1h-3Zm4-9h1a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-4c-1.531 0-2.5.75-3.25 1.332-.178.137-.343.265-.5.371-.264.18-.507.297-.75.297s-.486-.118-.75-.297c-.157-.106-.322-.234-.5-.37v-.001C10.5 18.75 9.532 18 8 18H3.999A.999.999 0 0 1 3 17V8a1 1 0 0 1 1-1h1V6a1 1 0 0 1 1-1h3c2 0 3.5 1.5 3.5 1.5S14 5 16 5h3a1 1 0 0 1 1 1v1ZM5 8.5h-.5v8H8c1.701 0 2.887.7 3.695 1.287l.055.04V17.002C11.03 16.566 9.921 16 9 16H6a1 1 0 0 1-1-1V8.5Zm11 6c-1.013 0-2.031.418-2.75.785V7.87l.305-.304.025-.024c.027-.024.072-.065.136-.116.127-.105.317-.248.556-.39C14.764 6.74 15.369 6.5 16 6.5h2.5v8H16Zm-4.25.785V7.87l-.305-.304c.002.001.002.002.001 0h-.001a4.744 4.744 0 0 0-.717-.53C10.236 6.74 9.631 6.5 9 6.5H6.5v8H9c1.013 0 2.031.418 2.75.785Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:603
 */

const IconBookOpen = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M20 7.018h1c.552 0 1 .451 1 1.008v9.08c0 .556-.448 1.008-1 1.008h-4c-1.78 0-2.768.575-3.992 1.724A.597.597 0 0 1 12.6 20h-.2a.597.597 0 0 1-.409-.162C10.768 18.689 9.78 18.114 8 18.114H4c-.552 0-1-.452-1-1.009V8.026c0-.557.448-1.008 1-1.008h1V6a1 1 0 0 1 1-1h2.97c1.38 0 2.564.577 3.53 1.703C13.466 5.577 14.65 5 16.03 5H19a1 1 0 0 1 1 1v1.018Zm-1-.76a.25.25 0 0 0-.25-.25h-2.72c-1.196 0-2.195.547-3.03 1.678v8.593c.87-.79 1.885-1.191 3.03-1.191h2.72a.25.25 0 0 0 .25-.25V8.026h1v7.07a1 1 0 0 1-1 1h-2.97c-1.156 0-2.093.538-2.958 1.248l-.072.078v1.11c1.278-.95 2.283-1.427 4-1.427h3.75c.138 0 .25-.113.25-.252V8.278a.251.251 0 0 0-.25-.252L19 8.03V6.259ZM12 16.28V7.686c-.835-1.13-1.834-1.677-3.03-1.677H6.25a.25.25 0 0 0-.25.25v8.579c0 .138.112.25.25.25h2.72c1.145 0 2.16.402 3.03 1.191Zm0 1.143-.072-.078c-.767-.641-1.802-1.248-2.957-1.248H6a1 1 0 0 1-1-1v-7.07h-.75a.251.251 0 0 0-.25.252v8.575c0 .14.112.252.25.252H8c1.717 0 2.722.477 4 1.427v-1.11Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=181:34
 */

const IconBricksThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '16',
  viewBox: '0 0 19 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.284 1.654a.5.5 0 0 0-.354.613L8.966 6.13a.5.5 0 0 0 .612.354l6.11-1.637a.5.5 0 0 0 .353-.613L15.006.371a.5.5 0 0 0-.613-.354l-6.11 1.637Zm1.872 3.122-.518-1.932 4.178-1.12.517 1.933-4.177 1.12ZM0 3.75a.5.5 0 0 1 .5-.5h6.825v3.5h8.26a.5.5 0 0 1 .5.5v3H18.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-4.5h2.917v-2H0v-4.5Zm6.825 4.5H4.417v2H8.75v-2h1.5v2h4.333v-2h.001H6.825Zm-1-3.5v2H1.5v-2h4.325Zm-2.908 7H1.5v2h4.333v-2h1.5v2h4.334v-2h1.5v2H17.5v-2H2.917Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=182:0
 */

const IconBricksThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10.784 6.029a.5.5 0 0 0-.354.612l1.036 3.864a.5.5 0 0 0 .612.354l6.11-1.637a.5.5 0 0 0 .353-.613l-1.035-3.864a.5.5 0 0 0-.613-.353l-6.11 1.637Zm1.872 3.122-.518-1.932 4.178-1.12.517 1.932-4.177 1.12ZM2.5 8.125a.5.5 0 0 1 .5-.5h6.825v3.5h8.26a.5.5 0 0 1 .5.5v3H21a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-4.5h2.917v-2H2.5v-4.5Zm6.825 4.5H6.917v2h4.333v-2h1.5v2h4.333v-2h.001H9.325Zm-1-3.5v2H4v-2h4.325Zm-2.908 7H4v2h4.333v-2h1.5v2h4.334v-2h1.5v2H20v-2H5.417Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1073
 */

const IconBricksShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '13',
  viewBox: '0 0 19 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 11.984V9.967H7v2.017h5Zm4-3.026h2.5c.276 0 .5.226.5.504v3.027a.502.502 0 0 1-.5.504h-6a.491.491 0 0 1-.093-.009H.5a.5.5 0 0 1-.5-.5V8.967h3V6.932H0V3.415a.5.5 0 0 1 .5-.5H7V5.94h9v3.017Zm-3 1.009v2.017h5V9.967h-5Zm-3-1.009h5V6.941h-5v2.017ZM6 9.967H1v2.017h5V9.967ZM9 6.94H4v2.017h5V6.941ZM6 3.915H1v2.017h5V3.915ZM8.478 1.57 14.274.017a.502.502 0 0 1 .614.358l.783 2.923a.502.502 0 0 1-.353.616L9.523 5.467a.502.502 0 0 1-.614-.357l-.783-2.923a.502.502 0 0 1 .352-.617Zm1.267 2.794 4.83-1.295-.523-1.948-4.83 1.294.523 1.949Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1069
 */

const IconBricks = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M14.5 17.488V15.47h-5v2.018h5Zm4-3.026H21c.276 0 .5.226.5.504v3.026a.502.502 0 0 1-.5.505h-6a.5.5 0 0 1-.093-.01H3a.5.5 0 0 1-.5-.5V14.47h3v-2.035h-3V8.918a.5.5 0 0 1 .5-.5h6.5v3.026h9v3.018Zm-3 1.008v2.018h5V15.47h-5Zm-3-1.008h5v-2.018h-5v2.018Zm-4 1.008h-5v2.018h5V15.47Zm3-3.026h-5v2.018h5v-2.018Zm-3-3.026h-5v2.018h5V9.418Zm2.479-2.345 5.795-1.552a.502.502 0 0 1 .613.357l.784 2.923a.502.502 0 0 1-.353.617l-5.795 1.553a.502.502 0 0 1-.614-.358l-.783-2.923a.502.502 0 0 1 .353-.617Zm1.266 2.794 4.83-1.294-.523-1.949-4.83 1.294.523 1.95Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=414:0
 */

const IconBriefcaseThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '15',
  viewBox: '0 0 18 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5.5 3V2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1h4A1.5 1.5 0 0 1 18 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 0 13.5v-9A1.5 1.5 0 0 1 1.5 3h4Zm11 4h-3a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5h-5a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5h-3V4.5h15V7Zm-10 1.5h5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1h3v5h-15v-5h3v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1ZM11 3H7V2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=414:6
 */

const IconBriefcaseThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.5 7V6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1h4A1.5 1.5 0 0 1 21 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 17.5v-9A1.5 1.5 0 0 1 4.5 7h4Zm11 4h-3a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5h-5a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5h-3V8.5h15V11Zm-10 1.5h5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1h3v5h-15v-5h3v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1ZM14 7h-4V6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:599
 */

const IconBroomShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13 19v-1.5a.5.5 0 0 1 1 0V19h3v-1.5a.5.5 0 0 1 1 0V19h.75a.25.25 0 0 0 .25-.25V17.5a2.5 2.5 0 0 0-2.5-2.5h-2a2.5 2.5 0 0 0-2.5 2.5v1.25c0 .137.112.25.25.25H13Zm3-5h.5a3.5 3.5 0 0 1 3.5 3.5V19a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-1.5a3.5 3.5 0 0 1 3.5-3.5h.5V.5a.5.5 0 0 1 1 0V14Zm0 5h-1v-1.5a.5.5 0 0 1 1 0V19Zm-7.335-.081c-.505.947-1.325 1.086-3.865 1.08H.412L.1 19.732a.597.597 0 0 1 .272-.887c.987-.404 1.637-.737 1.926-.974a2.03 2.03 0 0 0 .358-.429c-.022.033.457-.708.63-.942.276-.371.567-.678.916-.943.834-.635 2.32-.707 3.352-.376L11.006.386a.5.5 0 1 1 .974.228l-3.5 15a.504.504 0 0 1-.03.086c.655.713.746 2.222.215 3.219Zm-4.172.08h.31c2.057.005 2.746-.112 2.98-.55.36-.678.264-1.805-.107-2.109-.523-.428-2.173-.518-2.869.011a3.607 3.607 0 0 0-.717.744c-.151.203-.613.917-.607.909-.19.28-.355.477-.549.637a3.866 3.866 0 0 1-.536.359h2.095Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:596
 */

const IconBroom = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15 21v-1.5a.5.5 0 0 1 1 0V21h3v-1.5a.5.5 0 0 1 1 0V21h.75a.25.25 0 0 0 .25-.25V19.5a2.5 2.5 0 0 0-2.5-2.5h-2a2.5 2.5 0 0 0-2.5 2.5v1.25c0 .137.112.25.25.25H15Zm3-5h.5a3.5 3.5 0 0 1 3.5 3.5V21a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-1.5a3.5 3.5 0 0 1 3.5-3.5h.5V2.5a.5.5 0 0 1 1 0V16Zm0 5h-1v-1.5a.5.5 0 0 1 1 0V21Zm-7.335-.081c-.505.947-1.325 1.086-3.865 1.08H2.412l-.312-.268a.597.597 0 0 1 .272-.887c.987-.404 1.637-.737 1.926-.974a2.03 2.03 0 0 0 .358-.429c-.022.033.457-.708.63-.942.276-.371.567-.678.916-.944.834-.634 2.32-.706 3.352-.375l3.452-14.794a.5.5 0 1 1 .974.228l-3.5 15a.502.502 0 0 1-.03.087c.655.712.746 2.221.215 3.218Zm-4.172.08h.31c2.057.005 2.746-.112 2.98-.55.36-.678.264-1.805-.107-2.109-.523-.428-2.173-.518-2.869.011a3.607 3.607 0 0 0-.717.744c-.151.203-.613.917-.607.909-.19.28-.355.477-.549.637a3.866 3.866 0 0 1-.536.359h2.095Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:699
 */

const IconBubblesShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '14',
  viewBox: '0 0 20 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M19.03 1.724c.289-.38.97-.675.97-.675L19.988.043s-1.263.446-1.76 1.1c-.453.593-.65.749-1.04.749s-.588-.156-1.04-.75C15.517.318 15.115 0 14.304 0c-.811 0-1.214.317-1.843 1.143-.452.593-.65.749-1.04.749s-.587-.156-1.04-.75C9.755.318 9.352 0 8.54 0c-.81 0-1.214.317-1.843 1.143-.452.593-.65.749-1.04.749s-.587-.156-1.04-.75C3.99.318 3.588 0 2.776 0 1.965 0 1.561.317.933 1.143.647 1.517 0 1.814 0 1.814L0 2.824s1.235-.444 1.735-1.1c.452-.594.65-.75 1.04-.75s.588.156 1.04.75c.629.825 1.032 1.142 1.843 1.142.81 0 1.213-.317 1.842-1.142.452-.594.65-.75 1.04-.75s.588.156 1.04.75c.629.825 1.031 1.142 1.842 1.142.811 0 1.214-.317 1.843-1.142.452-.594.65-.75 1.04-.75s.588.156 1.04.75c.628.825 1.031 1.142 1.842 1.142.811 0 1.214-.317 1.843-1.142ZM3.504 12a2.5 2.5 0 1 0-.001-4.999 2.5 2.5 0 0 0 0 4.999Zm0-1a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm15.492 1a2 2 0 1 1-3.999.001A2 2 0 0 1 18.996 12Zm-2.998 0a1 1 0 1 0 1.999 0 1 1 0 0 0-2 0Zm-1-4a2 2 0 1 0-.001-3.999A2 2 0 0 0 14.998 8Zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-5.247 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.5 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:693
 */

const IconBubbles = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M21.03 6.724c.289-.38.97-.675.97-.675l-.012-1.006s-1.263.446-1.76 1.1c-.453.593-.65.749-1.04.749s-.588-.156-1.04-.75C17.517 5.318 17.115 5 16.304 5c-.811 0-1.214.317-1.843 1.143-.452.593-.65.749-1.04.749s-.587-.156-1.04-.75C11.755 5.318 11.352 5 10.54 5c-.81 0-1.214.317-1.843 1.143-.452.593-.65.749-1.04.749s-.587-.156-1.04-.75C5.99 5.318 5.588 5 4.776 5c-.81 0-1.214.317-1.842 1.143-.286.374-.932.671-.932.671L2 7.824s1.235-.444 1.735-1.1c.453-.594.65-.75 1.04-.75s.588.156 1.04.75c.629.825 1.032 1.142 1.843 1.142.81 0 1.213-.317 1.842-1.142.452-.594.65-.75 1.04-.75s.588.156 1.04.75c.629.825 1.031 1.142 1.842 1.142.811 0 1.214-.317 1.843-1.142.452-.594.65-.75 1.04-.75s.587.156 1.04.75c.628.825 1.031 1.142 1.842 1.142.811 0 1.214-.317 1.843-1.142ZM5.504 17a2.5 2.5 0 1 0-.001-4.999 2.5 2.5 0 0 0 0 4.999Zm0-1a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm15.492 1a2 2 0 1 1-3.999.001A2 2 0 0 1 20.996 17Zm-2.998 0a1 1 0 1 0 1.999 0 1 1 0 0 0-2 0Zm-1-4a2 2 0 1 0-.001-3.999A2 2 0 0 0 16.998 13Zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-5.247 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-1.25-7.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:785
 */

const IconBuildingsAltThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15',
  viewBox: '0 0 15 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm11 4.92-.69.546a.5.5 0 0 1-.81-.392V3.75c0-1.232-1.081-2.25-2.438-2.25H3.938C2.582 1.5 1.5 2.518 1.5 3.75v11a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25v-11C0 1.668 1.773 0 3.938 0h3.124C9.227 0 11 1.668 11 3.75v1.17ZM3.25 4h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5A.25.25 0 0 1 3 5.75v-1.5A.25.25 0 0 1 3.25 4Zm3 0h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5A.25.25 0 0 1 6 5.75v-1.5A.25.25 0 0 1 6.25 4Zm-3 4h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5A.25.25 0 0 1 3 9.75v-1.5A.25.25 0 0 1 3.25 8Zm0 4h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25Zm7-1h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25ZM11 8.94l-2.5 1.92v3.89a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25v-4.502a.5.5 0 0 1 .197-.398l3.5-2.667a.5.5 0 0 1 .606 0l3.5 2.667a.5.5 0 0 1 .197.398v4.502a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25v-3.89L11 8.94Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1092
 */

const IconBuildingsAltShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '16',
  viewBox: '0 0 15 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.994 0C9.728 0 10.918 1.272 11 2.812v2.185a.5.5 0 0 1-.5.5.507.507 0 0 1-.498-.41L10 4.997V2.984c0-1.041-.721-1.902-1.843-1.979L7.994 1h-5c-.99 0-1.907.738-1.988 1.826L1 2.984V15.5a.5.5 0 0 1-.992.09L0 15.5V2.984C0 1.28 1.337.088 2.827.004L2.994 0h5ZM10.5 12.984a.5.5 0 0 1 0-1h1a.5.5 0 1 1 0 1h-1Zm.714-4.936a.5.5 0 0 0-.506.046l-3.5 2.523-.072.063a.5.5 0 0 0-.136.343V15.5l.008.09A.5.5 0 0 0 7.5 16l.09-.008A.5.5 0 0 0 8 15.5v-4.221l3-2.163 3 2.162V15.5l.008.09A.5.5 0 0 0 15 15.5v-4.477l-.01-.095a.5.5 0 0 0-.198-.31l-3.5-2.524-.078-.046ZM4 5a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1H4Zm-.5 3.5A.5.5 0 0 0 4 9h3a.5.5 0 0 0 0-1H4a.5.5 0 0 0-.5.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1085
 */

const IconBuildingsShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '18',
  viewBox: '0 0 17 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8 10.012V1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v16.5a.5.5 0 0 1-1 0V1H9v9.012h2a1 1 0 0 1 1 1V17.5a.5.5 0 0 1-1 0v-6.488H1V17.5a.5.5 0 0 1-1 0v-6.488a1 1 0 0 1 1-1h7ZM3 17.5a.5.5 0 0 1-1 0v-1.993a2.5 2.5 0 1 1 5 0V17.5a.5.5 0 0 1-1 0v-1.993a1.5 1.5 0 1 0-3 0V17.5ZM11 4a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3Zm0 3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2392:3386
 */

const IconBuildingsStarThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '19',
  viewBox: '0 0 18 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10.25 1.5a.25.25 0 0 0-.25.25V10h1.25c.966 0 1.75.784 1.75 1.75v6a.75.75 0 0 1-1.5 0v-6a.25.25 0 0 0-.25-.25h-9.5a.25.25 0 0 0-.25.25v6a.75.75 0 0 1-1.5 0v-6C0 10.784.784 10 1.75 10H8.5V1.75C8.5.784 9.284 0 10.25 0h6C17.216 0 18 .784 18 1.75v16a.75.75 0 0 1-1.5 0v-16a.25.25 0 0 0-.25-.25h-6ZM3 15.752a2.75 2.75 0 1 1 5.5 0v2a.75.75 0 0 1-1.5 0v-2a1.25 1.25 0 0 0-2.5 0v2a.75.75 0 0 1-1.5 0v-2ZM2.957 3.75c.33-.189.604-.462.793-.793.189.33.463.604.793.793-.33.189-.604.463-.793.793a2.126 2.126 0 0 0-.793-.793ZM3.18.615a.625.625 0 0 1 1.138 0l.708 1.55a.625.625 0 0 0 .309.308l1.549.708a.625.625 0 0 1 0 1.138l-1.55.708a.625.625 0 0 0-.308.309L4.32 6.885a.625.625 0 0 1-1.138 0l-.708-1.55a.625.625 0 0 0-.309-.308L.615 4.32a.625.625 0 0 1 0-1.138l1.55-.708a.625.625 0 0 0 .308-.309L3.18.615ZM11 3.75a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM11.75 6a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2392:3363
 */

const IconBuildingsStarShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.5 10.011V1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v16.5a.5.5 0 0 1-1 0V1h-7v9.011h2a1 1 0 0 1 1 1V17.5a.5.5 0 0 1-1 0v-6.487h-10v6.487a.5.5 0 0 1-1 0v-6.487a1 1 0 0 1 1-1h7Zm-5 7.489a.5.5 0 1 1-1 0v-1.993a2.5 2.5 0 1 1 5 0V17.5a.5.5 0 1 1-1 0v-1.993a1.5 1.5 0 1 0-3 0V17.5Zm7.5-14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Zm.5 3.5a.5.5 0 1 1 0-1h3a.5.5 0 0 1 0 1h-3ZM3.131 2.33l.368-.804.368.804c.162.355.447.64.802.802l.804.368-.804.368c-.355.162-.64.447-.802.802l-.368.804-.368-.804a1.625 1.625 0 0 0-.802-.802L1.526 3.5l.804-.368c.355-.163.64-.447.802-.802Zm-.2-1.965a.625.625 0 0 1 1.136 0l.71 1.549a.625.625 0 0 0 .308.308l1.549.71a.625.625 0 0 1 0 1.136l-1.55.71a.625.625 0 0 0-.308.308l-.709 1.549a.625.625 0 0 1-1.137 0l-.709-1.55a.625.625 0 0 0-.308-.308L.365 4.068a.625.625 0 0 1 0-1.137l1.549-.709a.625.625 0 0 0 .308-.308l.71-1.549Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1081
 */

const IconBuildings = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.5 13.012V4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v16.5a.5.5 0 0 1-1 0V4h-7v9.012h2a1 1 0 0 1 1 1V20.5a.5.5 0 0 1-1 0v-6.488h-10V20.5a.5.5 0 0 1-1 0v-6.488a1 1 0 0 1 1-1h7Zm-5 7.488a.5.5 0 0 1-1 0v-1.993a2.5 2.5 0 1 1 5 0V20.5a.5.5 0 0 1-1 0v-1.993a1.5 1.5 0 1 0-3 0V20.5Zm8-13.5a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3Zm0 3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:782
 */

const IconBuildingsAltThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm16 9.92-.69.546a.5.5 0 0 1-.81-.392V8.75c0-1.232-1.082-2.25-2.438-2.25H8.938C7.58 6.5 6.5 7.518 6.5 8.75v11a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25v-11C5 6.668 6.773 5 8.938 5h3.124C14.227 5 16 6.668 16 8.75v1.17ZM8.25 9h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5A.25.25 0 0 1 8.25 9Zm3 0h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25Zm-3 4h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25Zm0 4h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25Zm7-1h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25Zm.75-2.06-2.5 1.92v3.89a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25v-4.502a.5.5 0 0 1 .197-.397l3.5-2.668a.5.5 0 0 1 .606 0l3.5 2.668a.5.5 0 0 1 .197.397v4.502a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25v-3.89L16 13.94Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1088
 */

const IconBuildingsAlt = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12.994 5C14.728 5 15.918 6.272 16 7.811v2.186a.5.5 0 0 1-.5.5.507.507 0 0 1-.498-.41L15 9.997V7.984c0-1.041-.721-1.902-1.843-1.979L12.994 6h-5c-.99 0-1.907.738-1.988 1.826L6 7.984V20.5a.5.5 0 0 1-.992.09L5 20.5V7.984c0-1.703 1.337-2.896 2.827-2.98L7.994 5h5ZM15.5 17.984a.5.5 0 0 1 0-1h1a.5.5 0 1 1 0 1h-1Zm.714-4.936a.5.5 0 0 0-.506.046l-3.5 2.523-.072.063a.5.5 0 0 0-.136.343V20.5l.008.09a.5.5 0 0 0 .492.41l.09-.008A.5.5 0 0 0 13 20.5v-4.221l3-2.163 3 2.162V20.5l.008.09A.5.5 0 0 0 20 20.5v-4.477l-.01-.095a.5.5 0 0 0-.198-.31l-3.5-2.524-.078-.046ZM9 10a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1H9Zm-.5 3.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1H9a.5.5 0 0 0-.5.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2392:3401
 */

const IconBuildingsStarThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13 4.25a.25.25 0 0 0-.25.25v8.25H14c.966 0 1.75.784 1.75 1.75v6a.75.75 0 0 1-1.5 0v-6a.25.25 0 0 0-.25-.25H4.5a.25.25 0 0 0-.25.25v6a.75.75 0 0 1-1.5 0v-6c0-.966.784-1.75 1.75-1.75h6.75V4.5c0-.966.784-1.75 1.75-1.75h6c.966 0 1.75.784 1.75 1.75v16a.75.75 0 0 1-1.5 0v-16a.25.25 0 0 0-.25-.25h-6ZM5.75 18.502a2.75 2.75 0 1 1 5.5 0v2a.75.75 0 0 1-1.5 0v-2a1.25 1.25 0 0 0-2.5 0v2a.75.75 0 0 1-1.5 0v-2ZM5.707 6.5c.33-.189.604-.463.793-.793.189.33.463.604.793.793-.33.189-.604.463-.793.793a2.126 2.126 0 0 0-.793-.793Zm.224-3.135a.625.625 0 0 1 1.138 0l.708 1.55a.625.625 0 0 0 .309.308l1.549.708a.625.625 0 0 1 0 1.138l-1.55.708a.625.625 0 0 0-.308.309L7.07 9.635a.625.625 0 0 1-1.138 0l-.708-1.55a.625.625 0 0 0-.309-.308L3.365 7.07a.625.625 0 0 1 0-1.138l1.55-.708a.625.625 0 0 0 .308-.309l.708-1.549ZM13.75 6.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2392:3365
 */

const IconBuildingsStar = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.5 13.012V4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v16.5a.5.5 0 0 1-1 0V4h-7v9.012h2a1 1 0 0 1 1 1V20.5a.5.5 0 0 1-1 0v-6.488h-10V20.5a.5.5 0 0 1-1 0v-6.488a1 1 0 0 1 1-1h7Zm-5 7.489a.5.5 0 0 1-1 0v-1.993a2.5 2.5 0 0 1 5 0V20.5a.5.5 0 0 1-1 0v-1.993a1.5 1.5 0 0 0-3 0V20.5ZM14 6.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Zm.5 3.5a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3ZM6.132 5.33l.368-.804.368.804c.163.355.447.64.802.802l.804.368-.804.368c-.355.163-.64.447-.802.802l-.368.804-.368-.804a1.625 1.625 0 0 0-.802-.802L4.526 6.5l.804-.368c.355-.163.64-.447.802-.802Zm-.2-1.965a.625.625 0 0 1 1.137 0l.708 1.55a.625.625 0 0 0 .309.308l1.549.708a.625.625 0 0 1 0 1.138l-1.55.708a.625.625 0 0 0-.308.309L7.07 9.635a.625.625 0 0 1-1.138 0l-.708-1.55a.625.625 0 0 0-.309-.308L3.365 7.07a.625.625 0 0 1 0-1.138l1.55-.708a.625.625 0 0 0 .308-.309l.708-1.549Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1282
 */

const IconBurjKhalifaShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M2 19v-6.75a.25.25 0 0 1 .25-.25H3V7.25A.25.25 0 0 1 3.25 7H4V2.25c0-.731 1-.998 1-.998V.5a.5.5 0 0 1 1 0V1s.557-.058.778.252c.222.31.222.86.222.998V9h.75a.25.25 0 0 1 .25.25V16h.75a.25.25 0 0 1 .25.25V19h7v1H0v-1h2Zm1 0h5v-2H7v-7H6V2.012s-1 .075-1 .546V8H4v5H3v6Zm10.5-3a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0-8a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5Zm4.268 2.354a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707-.707l.707-.707a.5.5 0 0 1 .707 0Zm0 8.414a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 1 1 .707-.707l.707.707a.5.5 0 0 1 0 .707ZM9.354 9.354a.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1-.707.707l-.707-.707a.5.5 0 0 1 0-.707ZM20 13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5ZM4 12h.75a.25.25 0 0 1 .25.25v1.25a.5.5 0 0 1-1 0V12Zm2.25 4H7v1.5a.5.5 0 0 1-1 0v-1.25a.25.25 0 0 1 .25-.25Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1278
 */

const IconBurjKhalifa = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M4 21v-6.75a.25.25 0 0 1 .25-.25H5V9.25A.25.25 0 0 1 5.25 9H6V4.25c0-.731 1-.998 1-.998V2.5a.5.5 0 0 1 1 0V3s.557-.058.778.252c.222.31.222.86.222.998V11h.75a.25.25 0 0 1 .25.25V18h.75a.25.25 0 0 1 .25.25V21h7v1H2v-1h2Zm1 0h5v-2H9v-7H8V4.012s-1 .075-1 .546V10H6v5H5v6Zm10.5-3a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0-8a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5Zm4.268 2.354a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707-.707l.707-.707a.5.5 0 0 1 .707 0Zm0 8.414a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 1 1 .707-.707l.707.707a.5.5 0 0 1 0 .707Zm-8.414-8.414a.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1-.707.707l-.707-.707a.5.5 0 0 1 0-.707ZM22 15.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5ZM6 14h.75a.25.25 0 0 1 .25.25v1.25a.5.5 0 0 1-1 0V14Zm2.25 4H9v1.5a.5.5 0 0 1-1 0v-1.25a.25.25 0 0 1 .25-.25Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1047
 */

const IconCalendarThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '20',
  viewBox: '0 0 18 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M14 0a1 1 0 0 1 1 1v1h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1V1a1 1 0 0 1 2 0v1h8V1a1 1 0 0 1 1-1ZM2 8v10h14V8H2Zm0-2h14V4H2v2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1043
 */

const IconCalendarThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17 2a1 1 0 0 1 1 1v1h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V3a1 1 0 0 1 2 0v1h8V3a1 1 0 0 1 1-1ZM5 10v10h14V10H5Zm0-2h14V6H5v2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1033
 */

const IconCalendarShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '20',
  viewBox: '0 0 18 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3 .5a.5.5 0 0 1 1 0V2h10V.5a.5.5 0 0 1 1 0V2h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1V.5ZM14.5 3H2a1 1 0 0 0-.993.883L1 4v2h16V4a1 1 0 0 0-.883-.993L16 3h-1.5ZM17 7H1v11a1 1 0 0 0 .883.993L2 19h14a1 1 0 0 0 .993-.883L17 18V7Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1027
 */

const IconCalendar = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6 2.5a.5.5 0 0 1 1 0V4h10V2.5a.5.5 0 0 1 1 0V4h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V2.5ZM17.5 5H5a1 1 0 0 0-.993.883L4 6v2h16V6a1 1 0 0 0-.883-.993L19 5h-1.5ZM20 9H4v11a1 1 0 0 0 .883.993L5 21h14a1 1 0 0 0 .993-.883L20 20V9Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=507:1727
 */

const IconCarClockThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '21',
  viewBox: '0 0 20 21',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9.255 6.752c.047.28.118.55.21.812H4.37c-.3 0-.573.165-.714.424l-.042.09L1.9 12.437h4.445a.406.406 0 1 1 0 .812h-5.02a.809.809 0 0 0-.252.488l-.007.105v4.28h15.431v-4.28a.81.81 0 0 0-.258-.594h-3.396a.406.406 0 0 1-.073-.805l.073-.006h2.82l-.674-1.713a4.83 4.83 0 0 0 .786-.222l.772 1.963c.458.287.763.797.763 1.377v5.904c0 .449-.45.812-1.004.812H14.3c-.554 0-1.004-.363-1.004-.812v-.812h-9.03l.001.812c0 .449-.45.812-1.003.812H1.257c-.554 0-1.003-.363-1.003-.812v-5.904c0-.58.304-1.09.763-1.377L2.859 7.78a1.624 1.624 0 0 1 1.511-1.03h4.885Zm-5.8 12.182H1.066v.812h2.389v-.812Zm13.042 0h-2.39l.002.812h2.388v-.812ZM5.533 15.685a.406.406 0 1 1 0 .812H2.284a.406.406 0 1 1 0-.812h3.249Zm9.746 0a.406.406 0 1 1 0 .812h-3.248a.406.406 0 1 1 0-.812h3.248Zm0-15.431a4.467 4.467 0 1 1 0 8.934 4.467 4.467 0 0 1 0-8.934Zm0 .812a3.655 3.655 0 1 0 0 7.31 3.655 3.655 0 0 0 0-7.31Zm0 .812c.2 0 .365.144.4.333l.006.073v2.269l1.506 1.505c.14.141.156.36.047.518l-.047.056a.406.406 0 0 1-.518.047l-.057-.047-1.743-1.743V2.284c0-.224.182-.406.406-.406Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm9.255 6.752.25-.042-.035-.212h-.215v.254Zm.21.812v.254h.36l-.12-.339-.24.085Zm-5.095 0V7.31v.253Zm-.714.424-.223-.12-.004.006-.003.007.23.107Zm-.042.09-.23-.107-.003.007-.003.007.236.093ZM1.9 12.437l-.236-.093-.136.346H1.9v-.253Zm4.445.812v.254-.254Zm-5.02 0v-.255h-.1l-.074.069.173.185Zm-.252.488-.252-.032-.001.008v.008l.253.016Zm-.007.105-.253-.016v.016h.253Zm0 4.28H.812v.254h.254v-.254Zm15.431 0v.254h.254v-.254h-.254Zm-.258-4.874.173-.185-.073-.069h-.1v.254Zm-3.396 0v.255-.254Zm-.073-.805-.023-.253-.011.001-.012.002.046.25Zm.073-.006v-.254h-.023l.023.254Zm2.82 0v.253h.372l-.136-.346-.236.093Zm-.674-1.713-.048-.25-.3.059.112.284.236-.093Zm.786-.222.236-.093-.092-.232-.234.088.09.237Zm.772 1.963-.236.093.03.078.071.044.135-.215Zm-3.25 7.281h.253-.254Zm-.001-.812h.254v-.254h-.254v.254Zm-9.03 0v-.254h-.253v.254h.254Zm.001.812h.254-.254Zm-3.25-7.281.134.215.071-.044.03-.078-.235-.093ZM2.859 7.78l-.237-.093.237.093Zm1.511-1.03v-.254.254Zm-.915 12.183h.253v-.254h-.253v.254Zm-2.389 0v-.254H.812v.254h.254Zm0 .812H.812V20h.254v-.254Zm2.389 0V20h.254v-.254h-.254Zm13.042-.812h.254v-.254h-.254v.254Zm-2.39 0v-.254h-.254v.255h.254Zm.002.812h-.254V20h.254v-.254Zm2.388 0V20h.254v-.254h-.254ZM15.68 2.211l.253-.022-.002-.012-.002-.011-.25.045Zm.006.073h.254v-.022l-.254.022Zm0 2.269h-.254v.105l.075.074.18-.18Zm1.506 1.505.18-.18-.18.18Zm.047.518.195.163.007-.009.006-.01-.208-.144Zm-.047.056.18.18.007-.008.008-.009-.195-.163Zm-.518.047-.163.195.009.007.01.007.144-.209Zm-.057-.047-.179.18.008.008.009.007.162-.195ZM14.873 4.89h-.254v.105l.075.075.18-.18ZM9.005 6.794c.05.294.124.58.221.855l.479-.17a4.584 4.584 0 0 1-.2-.77l-.5.085Zm.46.516H4.37v.507h5.095V7.31Zm-5.095 0c-.394 0-.752.217-.937.558l.446.241a.558.558 0 0 1 .491-.292V7.31Zm-.944.571-.042.09.46.214.042-.09-.46-.214Zm-.048.104-1.714 4.359.472.186L3.851 8.17l-.473-.186ZM1.9 12.69h4.445v-.507H1.9v.507Zm4.445 0c.084 0 .152.069.152.153h.508a.66.66 0 0 0-.66-.66v.507Zm.152.153a.152.152 0 0 1-.152.152v.508a.66.66 0 0 0 .66-.66h-.508Zm-.152.152h-5.02v.507h5.02v-.507Zm-5.194.068c-.18.167-.298.393-.33.642l.503.065a.555.555 0 0 1 .173-.336l-.346-.371Zm-.332.658-.006.105.506.032.007-.104-.507-.033Zm-.007.121v4.28h.508v-4.28H.812Zm.254 4.534h15.431v-.508H1.066v.508Zm15.685-.254v-4.28h-.507v4.28h.507Zm0-4.28c0-.301-.126-.581-.339-.78l-.346.372c.112.104.178.25.178.408h.507Zm-.512-.848-3.396.001v.508l3.396-.001v-.508Zm-3.396.001a.152.152 0 0 1-.153-.152h-.507c0 .364.295.66.66.66v-.508Zm-.153-.152c0-.075.054-.137.125-.15l-.09-.5a.66.66 0 0 0-.542.65h.507Zm.102-.147.073-.007-.045-.505-.073.006.045.506Zm.05-.006h2.82v-.507h-2.82v.507Zm3.057-.346-.674-1.713-.472.186.673 1.713.473-.186Zm-.862-1.37c.285-.056.561-.134.827-.234l-.179-.475c-.239.09-.488.16-.744.21l.096.498Zm.502-.379.772 1.963.472-.186-.772-1.963-.472.186Zm.873 2.085c.387.243.644.673.644 1.162h.508c0-.671-.353-1.26-.882-1.592l-.27.43Zm.644 1.162v5.904h.508v-5.904h-.508Zm0 5.904c0 .261-.283.559-.75.559v.507c.642 0 1.258-.43 1.258-1.066h-.508Zm-.75.559H14.3v.507h2.006v-.507Zm-2.006 0c-.467 0-.75-.298-.75-.559h-.507c0 .636.615 1.066 1.257 1.066v-.507Zm-.75-.559v-.812h-.508v.812h.508Zm-.254-1.066h-9.03v.508h9.03v-.508Zm-9.283.254v.812h.508v-.812h-.508Zm0 .812c0 .261-.283.559-.75.559v.507c.642 0 1.258-.43 1.258-1.066h-.508Zm-.75.559H1.258v.507h2.007v-.507Zm-2.006 0c-.467 0-.75-.298-.75-.559H0c0 .636.616 1.066 1.257 1.066v-.507Zm-.75-.559v-5.904H0v5.904h.508Zm0-5.904c0-.49.257-.92.644-1.162l-.27-.43c-.528.332-.881.92-.881 1.592h.508Zm.746-1.284 1.842-4.684-.473-.186L.78 12.372l.473.186Zm1.842-4.684a1.37 1.37 0 0 1 1.275-.869v-.508c-.772 0-1.465.473-1.748 1.191l.473.186Zm1.275-.869h4.885v-.507H4.37v.507ZM3.455 18.68H1.066v.508h2.389v-.508Zm-2.643.254v.812h.508v-.812H.812ZM1.066 20h2.389v-.507H1.066V20Zm2.643-.254v-.812H3.2v.812h.508Zm12.788-1.066h-2.39v.508h2.39v-.508Zm-2.644.255.002.812.508-.001-.002-.812h-.508ZM14.11 20h2.388v-.508H14.11V20Zm2.642-.254v-.812h-.507v.812h.507ZM5.533 15.94c.084 0 .152.068.152.152h.508a.66.66 0 0 0-.66-.66v.508Zm.152.152a.152.152 0 0 1-.152.153v.507a.66.66 0 0 0 .66-.66h-.508Zm-.152.153H2.284v.507h3.249v-.507Zm-3.249 0a.152.152 0 0 1-.152-.153h-.508c0 .365.296.66.66.66v-.507Zm-.152-.153c0-.084.068-.152.152-.152v-.508a.66.66 0 0 0-.66.66h.508Zm.152-.152h3.249v-.508H2.284v.508Zm12.995 0c.084 0 .152.068.152.152h.508a.66.66 0 0 0-.66-.66v.508Zm.152.152a.152.152 0 0 1-.152.153v.507a.66.66 0 0 0 .66-.66h-.508Zm-.152.153h-3.248v.507h3.248v-.507Zm-3.248 0a.152.152 0 0 1-.153-.153h-.507c0 .365.295.66.66.66v-.507Zm-.153-.153c0-.084.068-.152.152-.152v-.508a.66.66 0 0 0-.66.66h.508Zm.152-.152h3.25v-.508h-3.25v.508ZM15.28.508a4.213 4.213 0 0 1 4.212 4.213H20A4.72 4.72 0 0 0 15.28 0v.508Zm4.212 4.213a4.213 4.213 0 0 1-4.213 4.213v.508A4.72 4.72 0 0 0 20 4.72h-.508ZM15.28 8.934a4.213 4.213 0 0 1-4.213-4.213h-.508a4.72 4.72 0 0 0 4.721 4.72v-.507Zm-4.213-4.213A4.213 4.213 0 0 1 15.279.508V0a4.72 4.72 0 0 0-4.72 4.72h.507ZM15.279.812a3.909 3.909 0 0 0-3.908 3.909h.507A3.401 3.401 0 0 1 15.28 1.32V.812Zm-3.908 3.909a3.909 3.909 0 0 0 3.908 3.908v-.507a3.401 3.401 0 0 1-3.4-3.401h-.508Zm3.908 3.908a3.909 3.909 0 0 0 3.909-3.908h-.508a3.401 3.401 0 0 1-3.4 3.4v.508Zm3.909-3.908A3.909 3.909 0 0 0 15.279.812v.508a3.401 3.401 0 0 1 3.401 3.4h.508Zm-3.909-2.589c.075 0 .137.054.15.125l.5-.091a.66.66 0 0 0-.65-.542v.508Zm.147.102.006.073.506-.045-.006-.073-.506.045Zm.005.05v2.269h.508V2.284h-.508Zm.075 2.448 1.505 1.506.36-.36-1.506-1.505-.36.36Zm1.505 1.506a.153.153 0 0 1 .018.194l.417.289a.66.66 0 0 0-.076-.842l-.359.359Zm.032.175-.047.057.39.325.047-.056-.39-.326Zm-.032.04a.152.152 0 0 1-.194.018l-.289.417a.66.66 0 0 0 .842-.076l-.359-.36Zm-.176.032-.056-.047-.325.39.056.046.325-.39Zm-.04-.032L15.054 4.71l-.36.359 1.744 1.743.359-.36Zm-1.668-1.564V2.284h-.508V4.89h.508Zm0-2.605c0-.084.068-.152.152-.152v-.508a.66.66 0 0 0-.66.66h.508Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4299
 */

const IconCarClockShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '20',
  viewBox: '0 0 19 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.981 5.01A5.01 5.01 0 1 1 19 5.01a5.01 5.01 0 0 1-10.019 0Zm5.01-4.008a4.007 4.007 0 1 0 0 8.015 4.007 4.007 0 0 0 0-8.015Zm-.501 4.007V2.111h1.002v2.69l1.785 1.786-.708.709-1.933-1.933a.501.501 0 0 1-.146-.354Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm15.388 10.857.218.363c.233.389.357.835.357 1.289v5.86a1.57 1.57 0 0 1-1.57 1.57h-1.068a1.57 1.57 0 0 1-1.57-1.57V17.8H4.208v.568a1.57 1.57 0 0 1-1.57 1.57H1.57A1.57 1.57 0 0 1 0 18.369v-5.86c0-.454.124-.9.357-1.29l1.986-3.307a3.707 3.707 0 0 1 3.178-1.8h2.56c.064.346.157.68.278 1.003H5.52c-.95 0-1.83.498-2.319 1.312l-1.986 3.308c-.14.234-.214.501-.214.774v5.86c0 .313.254.568.568.568h1.068a.568.568 0 0 0 .568-.568v-1.57h9.55v1.57c0 .313.255.568.569.568h1.068a.568.568 0 0 0 .568-.568v-5.86c0-.273-.074-.54-.214-.774l-.435-.723c.369-.02.728-.072 1.076-.155Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M2.97 11.453v1.001H12.99v-1.001H2.97ZM1.968 15.664h3.006v-1.002H1.968v1.002ZM13.99 14.662h-3.005v1.002h3.006v-1.002Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3390
 */

const IconCarEntranceShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '19',
  viewBox: '0 0 19 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M9.494 19c1.31 0 2.536-.246 3.679-.737a9.716 9.716 0 0 0 5.084-5.084A9.158 9.158 0 0 0 19 9.5a9.158 9.158 0 0 0-.743-3.679A9.703 9.703 0 0 0 16.2 2.79 9.61 9.61 0 0 0 13.17.737 9.214 9.214 0 0 0 9.491 0 9.218 9.218 0 0 0 5.82.737 9.506 9.506 0 0 0 2.793 2.79a9.768 9.768 0 0 0-2.05 3.031A9.158 9.158 0 0 0 0 9.5c0 1.309.248 2.535.743 3.679a9.756 9.756 0 0 0 2.051 3.031 9.523 9.523 0 0 0 3.028 2.053A9.218 9.218 0 0 0 9.494 19Zm0-.86a8.446 8.446 0 0 1-3.353-.67 8.65 8.65 0 0 1-2.752-1.856 8.747 8.747 0 0 1-1.86-2.758A8.42 8.42 0 0 1 .856 9.5c0-1.192.224-2.31.672-3.356a8.727 8.727 0 0 1 1.858-2.757 8.65 8.65 0 0 1 2.752-1.858A8.447 8.447 0 0 1 9.491.86c1.193 0 2.313.223 3.36.67a8.597 8.597 0 0 1 2.754 1.857 8.794 8.794 0 0 1 1.858 2.757 8.404 8.404 0 0 1 .674 3.356c0 1.192-.223 2.31-.668 3.356a8.682 8.682 0 0 1-4.609 4.615 8.487 8.487 0 0 1-3.366.669ZM4.1 12.92a.57.57 0 0 0 .172.419.569.569 0 0 0 .418.172h.538a.569.569 0 0 0 .418-.172.57.57 0 0 0 .173-.419v-.747c.523.026 1.125.05 1.804.073.68.023 1.306.034 1.88.034.586 0 1.217-.01 1.892-.034.675-.022 1.274-.047 1.798-.073v.747a.57.57 0 0 0 .172.419.57.57 0 0 0 .418.172h.529a.58.58 0 0 0 .427-.172.57.57 0 0 0 .172-.419V10.35c0-.418-.048-.75-.146-.998a2.775 2.775 0 0 0-.429-.719l-.404-.546a13.039 13.039 0 0 0-.343-1.25 11.56 11.56 0 0 0-.31-.856 1.36 1.36 0 0 0-.532-.6 2.05 2.05 0 0 0-.74-.264 14.02 14.02 0 0 0-.966-.045 64.657 64.657 0 0 0-3.076 0c-.478.012-.799.026-.96.045-.266.039-.513.126-.74.262a1.368 1.368 0 0 0-.533.602c-.08.17-.185.456-.314.857-.13.4-.238.817-.326 1.249l-.417.546c-.188.233-.33.472-.428.72-.098.246-.147.579-.147.997v2.571Zm1.84-5.198a6.74 6.74 0 0 1 .243-.883c.096-.27.18-.469.252-.598a.917.917 0 0 1 .264-.3.916.916 0 0 1 .424-.152c.181-.024.475-.041.883-.05.407-.01.906-.014 1.496-.014.595 0 1.096.004 1.504.012.407.008.704.026.892.052a.883.883 0 0 1 .42.152.943.943 0 0 1 .259.3c.074.121.158.318.253.592.094.273.178.57.25.889.035.145-.026.214-.184.206-.41-.031-.867-.055-1.37-.071a65.27 65.27 0 0 0-2.024-.025c-.848 0-1.52.009-2.017.025-.496.016-.95.04-1.36.071-.156.008-.217-.06-.185-.206Zm-.49 2.613a.624.624 0 0 1 .643-.646.632.632 0 0 1 .645.646.6.6 0 0 1-.187.45.634.634 0 0 1-.459.181.627.627 0 0 1-.46-.18.609.609 0 0 1-.182-.45Zm2.426.096c0-.309.149-.463.446-.463h2.358a.44.44 0 0 1 .33.129.458.458 0 0 1 .125.334c0 .303-.151.455-.455.455H8.323c-.297 0-.446-.152-.446-.455Zm4.407-.096c0-.187.061-.342.182-.463a.627.627 0 0 1 .464-.182c.18 0 .33.06.45.182a.628.628 0 0 1 .183.463c0 .18-.06.33-.182.45a.615.615 0 0 1-.451.181.63.63 0 0 1-.464-.18.609.609 0 0 1-.181-.45Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=507:1736
 */

const IconCarClockThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.266 8.4c.046.276.116.543.207.8H6.455a.8.8 0 0 0-.704.419l-.04.088L4.02 14H8.4a.4.4 0 0 1 0 .8H3.454a.797.797 0 0 0-.247.481l-.007.104V19.6h15.2v-4.215a.798.798 0 0 0-.254-.586L14.8 14.8a.4.4 0 0 1-.072-.794L14.8 14h2.777l-.663-1.687c.266-.051.525-.125.774-.218l.76 1.933c.452.283.752.785.752 1.357V21.2c0 .442-.442.8-.988.8h-1.977c-.546 0-.988-.358-.988-.8v-.8H6.352v.8c0 .442-.443.8-.988.8H3.388c-.546 0-.988-.358-.988-.8v-5.815c0-.572.3-1.074.751-1.357l1.815-4.614A1.6 1.6 0 0 1 6.455 8.4h4.811Zm-5.713 12H3.2v.8h2.353v-.8Zm12.847 0h-2.354l.001.8H18.4v-.8ZM7.6 17.2a.4.4 0 0 1 0 .8H4.4a.4.4 0 0 1 0-.8h3.2Zm9.6 0a.4.4 0 0 1 0 .8H14a.4.4 0 0 1 0-.8h3.2Zm0-15.2a4.4 4.4 0 1 1 0 8.8 4.4 4.4 0 0 1 0-8.8Zm0 .8a3.6 3.6 0 1 0 0 7.2 3.6 3.6 0 0 0 0-7.2Zm0 .8a.4.4 0 0 1 .393.328L17.6 4v2.234l1.483 1.483a.4.4 0 0 1 .046.51l-.046.056a.4.4 0 0 1-.51.046l-.056-.046L16.8 6.566V4c0-.22.179-.4.4-.4Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm11.266 8.4.247-.041-.035-.209h-.212v.25Zm.207.8v.25h.354l-.118-.333-.236.084Zm-5.018 0v-.25.25Zm-.704.419-.22-.12-.003.007-.003.007.226.106Zm-.04.088-.228-.105-.003.007-.002.007.232.091ZM4.02 14l-.232-.091-.134.341h.366V14Zm4.379.8v.25-.25Zm-4.946 0v-.25h-.098l-.072.066.17.183Zm-.247.481-.248-.032-.001.008-.001.008.25.016Zm-.007.104-.25-.016v.016h.25Zm0 4.215h-.25v.25h.25v-.25Zm15.2 0v.25h.25v-.25h-.25Zm-.254-4.8.17-.184-.072-.067h-.099v.25Zm-3.346 0v.25-.25Zm-.072-.794-.022-.249-.011.001-.012.003.045.245ZM14.8 14v-.25h-.011l-.011.001.022.249Zm2.777 0v.25h.367l-.134-.341-.232.091Zm-.663-1.687-.047-.245-.296.057.11.28.233-.092Zm.774-.218.233-.092-.09-.229-.231.087.088.234Zm.76 1.933-.232.091.03.077.07.044.133-.212ZM15.247 21.2h.25-.25Zm0-.8h.25v-.25h-.25v.25Zm-8.894 0v-.25h-.25v.25h.25Zm0 .8h.25-.25ZM3.15 14.028l.133.212.07-.044.03-.077-.233-.091Zm1.815-4.614-.233-.091.233.091ZM6.455 8.4v-.25.25Zm-.902 12h.25v-.25h-.25v.25Zm-2.353 0v-.25h-.25v.25h.25Zm0 .8h-.25v.25h.25v-.25Zm2.353 0v.25h.25v-.25h-.25Zm12.847-.8h.25v-.25h-.25v.25Zm-2.354 0v-.25h-.251v.25h.25Zm.001.8h-.25v.25h.25v-.25Zm2.353 0v.25h.25v-.25h-.25Zm-.806-17.272.248-.022v-.011l-.003-.012-.245.045ZM17.6 4h.25v-.011l-.001-.011-.25.022Zm0 2.234h-.25v.104l.073.073.177-.177Zm1.483 1.483.177-.177-.177.177Zm.046.51.192.16.007-.008.006-.01-.205-.142Zm-.046.056.177.177.007-.008.008-.009-.192-.16Zm-.51.046-.16.192.008.007.01.007.142-.206Zm-.056-.046-.177.177.008.008.009.007.16-.192ZM16.8 6.566h-.25v.103l.073.073.177-.176Zm-5.78 1.876c.048.29.122.571.218.842l.47-.167a4.518 4.518 0 0 1-.195-.758l-.493.083Zm.453.509L6.455 8.95v.5h5.018v-.5ZM6.455 8.95a1.05 1.05 0 0 0-.923.55l.44.238a.55.55 0 0 1 .483-.288v-.5Zm-.93.563-.042.089.454.21.041-.088-.453-.21Zm-.047.103-1.69 4.293.466.182L5.943 9.8l-.465-.183ZM4.02 14.25H8.4v-.5H4.02v.5Zm4.379 0a.15.15 0 0 1 .15.15h.5a.65.65 0 0 0-.65-.65v.5Zm.15.15a.15.15 0 0 1-.15.15v.5a.65.65 0 0 0 .65-.65h-.5Zm-.15.15H3.454v.5H8.4v-.5Zm-5.116.066a1.047 1.047 0 0 0-.325.633l.495.064a.547.547 0 0 1 .17-.33l-.34-.367Zm-.327.65-.007.103.5.032.006-.104-.499-.032Zm-.007.119V19.6h.5v-4.215h-.5Zm.25 4.465h15.2v-.5H3.2v.5Zm15.45-.25v-4.215h-.5V19.6h.5Zm0-4.215c0-.297-.124-.573-.334-.768l-.34.365c.11.103.174.247.174.403h.5Zm-.505-.836-3.345.001v.5h3.346v-.5Zm-3.345.001a.15.15 0 0 1-.15-.15h-.5c0 .359.29.65.65.65v-.5Zm-.15-.15a.15.15 0 0 1 .123-.148l-.09-.492a.65.65 0 0 0-.533.64h.5Zm.1-.145.072-.006-.044-.498-.072.006.044.498Zm.05-.005h2.777v-.5H14.8v.5Zm3.01-.341-.663-1.687-.466.183.664 1.687.465-.184Zm-.849-1.35a5.02 5.02 0 0 0 .815-.23l-.176-.468c-.236.088-.48.158-.733.207l.094.49Zm.494-.373.76 1.933.466-.183-.76-1.933-.466.183Zm.86 2.054c.382.239.635.662.635 1.145h.5c0-.662-.348-1.242-.869-1.569l-.265.424Zm.635 1.145V21.2h.5v-5.815h-.5Zm0 5.815c0 .257-.279.55-.738.55v.5c.632 0 1.238-.423 1.238-1.05h-.5Zm-.738.55h-1.977v.5h1.977v-.5Zm-1.977 0c-.46 0-.738-.293-.738-.55h-.5c0 .627.606 1.05 1.238 1.05v-.5Zm-.738-.55v-.8h-.5v.8h.5Zm-.25-1.05H6.352v.5h8.893v-.5Zm-9.144.25v.8h.5v-.8h-.5Zm0 .8c0 .257-.279.55-.738.55v.5c.632 0 1.238-.423 1.238-1.05h-.5Zm-.738.55H3.388v.5h1.977v-.5Zm-1.977 0c-.46 0-.738-.293-.738-.55h-.5c0 .627.606 1.05 1.238 1.05v-.5Zm-.738-.55v-5.815h-.5V21.2h.5Zm0-5.815c0-.483.253-.906.634-1.145l-.265-.424a1.849 1.849 0 0 0-.87 1.569h.5Zm.734-1.266 1.814-4.613-.465-.183-1.814 4.613.465.183Zm1.814-4.613a1.35 1.35 0 0 1 1.257-.856v-.5a1.85 1.85 0 0 0-1.722 1.173l.465.183Zm1.257-.856h4.811v-.5H6.455v.5Zm-.902 11.5H3.2v.5h2.353v-.5Zm-2.603.25v.8h.5v-.8h-.5Zm.25 1.05h2.353v-.5H3.2v.5Zm2.603-.25v-.8h-.5v.8h.5ZM18.4 20.15h-2.354v.5H18.4v-.5Zm-2.604.25.001.8h.5l-.002-.8h-.5Zm.251 1.05H18.4v-.5h-2.353v.5Zm2.603-.25v-.8h-.5v.8h.5ZM7.6 17.45a.15.15 0 0 1 .15.15h.5a.65.65 0 0 0-.65-.65v.5Zm.15.15a.15.15 0 0 1-.15.15v.5a.65.65 0 0 0 .65-.65h-.5Zm-.15.15H4.4v.5h3.2v-.5Zm-3.2 0a.15.15 0 0 1-.15-.15h-.5c0 .359.29.65.65.65v-.5Zm-.15-.15a.15.15 0 0 1 .15-.15v-.5a.65.65 0 0 0-.65.65h.5Zm.15-.15h3.2v-.5H4.4v.5Zm12.8 0a.15.15 0 0 1 .15.15h.5a.65.65 0 0 0-.65-.65v.5Zm.15.15a.15.15 0 0 1-.15.15v.5a.65.65 0 0 0 .65-.65h-.5Zm-.15.15H14v.5h3.2v-.5Zm-3.2 0a.15.15 0 0 1-.15-.15h-.5c0 .359.29.65.65.65v-.5Zm-.15-.15a.15.15 0 0 1 .15-.15v-.5a.65.65 0 0 0-.65.65h.5Zm.15-.15h3.2v-.5H14v.5Zm3.2-15.2a4.15 4.15 0 0 1 4.15 4.15h.5a4.65 4.65 0 0 0-4.65-4.65v.5Zm4.15 4.15a4.15 4.15 0 0 1-4.15 4.15v.5a4.65 4.65 0 0 0 4.65-4.65h-.5Zm-4.15 4.15a4.15 4.15 0 0 1-4.15-4.15h-.5a4.65 4.65 0 0 0 4.65 4.65v-.5ZM13.05 6.4a4.15 4.15 0 0 1 4.15-4.15v-.5a4.65 4.65 0 0 0-4.65 4.65h.5Zm4.15-3.85a3.85 3.85 0 0 0-3.85 3.85h.5c0-1.85 1.5-3.35 3.35-3.35v-.5ZM13.35 6.4a3.85 3.85 0 0 0 3.85 3.85v-.5a3.35 3.35 0 0 1-3.35-3.35h-.5Zm3.85 3.85a3.85 3.85 0 0 0 3.85-3.85h-.5c0 1.85-1.5 3.35-3.35 3.35v.5Zm3.85-3.85a3.85 3.85 0 0 0-3.85-3.85v.5c1.85 0 3.35 1.5 3.35 3.35h.5ZM17.2 3.85a.15.15 0 0 1 .148.123l.491-.09a.65.65 0 0 0-.64-.533v.5Zm.145.1.006.072.498-.044-.006-.072-.498.044Zm.005.05v2.234h.5V4h-.5Zm.073 2.411 1.483 1.483.354-.354-1.483-1.482-.354.353Zm1.483 1.483a.15.15 0 0 1 .018.191l.41.285a.65.65 0 0 0-.075-.83l-.353.354Zm.031.173-.046.056.384.32.046-.055-.384-.32Zm-.031.04a.15.15 0 0 1-.191.017l-.285.41a.65.65 0 0 0 .83-.074l-.354-.354Zm-.173.03-.056-.046-.32.384.055.046.32-.384Zm-.04-.03-1.716-1.718-.354.353L18.34 8.46l.354-.354ZM17.05 6.565V4h-.5v2.566h.5Zm0-2.566a.15.15 0 0 1 .15-.15v-.5a.65.65 0 0 0-.65.65h.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3374
 */

const IconCarClock = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.965 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-.5 4V4.107h1v2.686l1.782 1.782-.707.707-1.929-1.928A.5.5 0 0 1 16.465 7Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm18.36 12.837.217.362a2.5 2.5 0 0 1 .356 1.287v5.849c0 .865-.701 1.567-1.566 1.567H16.3a1.567 1.567 0 0 1-1.567-1.567v-.567H7.2v.567c0 .865-.701 1.567-1.567 1.567H4.567A1.567 1.567 0 0 1 3 20.335v-5.85a2.5 2.5 0 0 1 .357-1.286l1.982-3.302a3.7 3.7 0 0 1 3.172-1.795h2.555c.064.344.157.678.277 1H8.511a2.7 2.7 0 0 0-2.315 1.31l-1.982 3.301a1.5 1.5 0 0 0-.214.773v5.849c0 .313.254.567.567.567h1.066a.567.567 0 0 0 .567-.567v-1.567h9.533v1.567c0 .313.254.567.567.567h1.067a.567.567 0 0 0 .566-.567v-5.85a1.5 1.5 0 0 0-.214-.771l-.433-.722c.367-.02.726-.072 1.073-.155Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M5.965 13.431v1h10v-1h-10ZM4.965 17.635h3v-1h-3v1ZM16.965 16.635h-3v1h3v-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3391
 */

const IconCarEntrance = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M12.494 22c1.31 0 2.536-.246 3.679-.737a9.716 9.716 0 0 0 5.084-5.084A9.158 9.158 0 0 0 22 12.5a9.158 9.158 0 0 0-.743-3.679A9.703 9.703 0 0 0 19.2 5.79a9.61 9.61 0 0 0-3.029-2.053A9.214 9.214 0 0 0 12.491 3a9.218 9.218 0 0 0-3.671.737A9.506 9.506 0 0 0 5.793 5.79a9.768 9.768 0 0 0-2.05 3.031A9.158 9.158 0 0 0 3 12.5c0 1.309.248 2.535.743 3.679a9.756 9.756 0 0 0 2.051 3.031 9.523 9.523 0 0 0 3.028 2.053 9.219 9.219 0 0 0 3.672.737Zm0-.86a8.446 8.446 0 0 1-3.353-.67 8.65 8.65 0 0 1-2.752-1.857 8.747 8.747 0 0 1-1.86-2.757 8.42 8.42 0 0 1-.673-3.356c0-1.192.224-2.31.672-3.356a8.727 8.727 0 0 1 1.858-2.757 8.65 8.65 0 0 1 2.752-1.858 8.447 8.447 0 0 1 3.353-.669c1.193 0 2.313.223 3.36.67a8.597 8.597 0 0 1 2.754 1.857 8.794 8.794 0 0 1 1.858 2.757 8.404 8.404 0 0 1 .674 3.356c0 1.192-.223 2.31-.668 3.356a8.682 8.682 0 0 1-4.609 4.615 8.487 8.487 0 0 1-3.366.669ZM7.1 15.92a.57.57 0 0 0 .172.419.569.569 0 0 0 .418.172h.538a.569.569 0 0 0 .418-.172.57.57 0 0 0 .173-.419v-.747c.523.026 1.125.05 1.804.073.68.023 1.306.034 1.88.034.586 0 1.217-.01 1.892-.034.675-.022 1.274-.047 1.798-.073v.747a.57.57 0 0 0 .172.419.57.57 0 0 0 .418.172h.529a.58.58 0 0 0 .427-.172.57.57 0 0 0 .173-.419V13.35c0-.418-.05-.75-.147-.998a2.775 2.775 0 0 0-.429-.719l-.404-.546a13.036 13.036 0 0 0-.343-1.25 11.56 11.56 0 0 0-.31-.856 1.36 1.36 0 0 0-.532-.6 2.05 2.05 0 0 0-.74-.264 14.02 14.02 0 0 0-.966-.045 64.656 64.656 0 0 0-3.075 0c-.48.012-.8.026-.962.045-.265.039-.512.126-.74.262a1.368 1.368 0 0 0-.532.602c-.08.17-.185.456-.314.857-.13.4-.238.817-.326 1.248l-.417.547c-.188.233-.33.472-.428.72-.098.246-.147.579-.147.997v2.571Zm1.84-5.198c.067-.32.148-.614.243-.883.096-.27.18-.469.252-.598a.917.917 0 0 1 .264-.3.916.916 0 0 1 .424-.152c.181-.024.475-.041.883-.05.407-.01.906-.014 1.496-.014.595 0 1.096.004 1.504.012.407.008.704.026.892.052a.883.883 0 0 1 .42.152.943.943 0 0 1 .259.3c.074.121.158.318.253.592.094.273.178.57.25.889.035.145-.026.214-.184.206-.41-.031-.867-.055-1.37-.071a65.306 65.306 0 0 0-2.024-.025c-.848 0-1.52.008-2.017.025-.496.016-.95.04-1.36.071-.156.008-.217-.06-.185-.206Zm-.49 2.613a.624.624 0 0 1 .643-.646.632.632 0 0 1 .645.646.6.6 0 0 1-.187.45.634.634 0 0 1-.459.181.627.627 0 0 1-.46-.18.609.609 0 0 1-.182-.45Zm2.426.096c0-.309.149-.463.446-.463h2.358a.44.44 0 0 1 .33.129.458.458 0 0 1 .125.334c0 .303-.151.455-.455.455h-2.358c-.297 0-.446-.152-.446-.455Zm4.407-.096c0-.187.061-.342.182-.463a.628.628 0 0 1 .464-.182c.18 0 .33.06.45.182a.628.628 0 0 1 .183.463c0 .18-.06.33-.182.45a.615.615 0 0 1-.451.181.63.63 0 0 1-.464-.18.609.609 0 0 1-.181-.45Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2302:5121
 */

const IconCheckmarkThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '11',
  viewBox: '0 0 15 11',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm.75 5.25 4.5 4.5 9-9',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=703:1707
 */

const IconCheckmarkThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm5.5 12 4.5 4.5 9-9',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2302:5120
 */

const IconCheckmarkShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '10',
  viewBox: '0 0 15 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.5 5 5 9.5l9-9',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=703:1715
 */

const IconCheckmark = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm5.5 12 4.5 4.5 9-9',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1319
 */

const IconChevronDownThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '9',
  viewBox: '0 0 16 9',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.597 1.79A1.048 1.048 0 0 0 14.119.303l-6.19 6.115L1.784.306A1.047 1.047 0 0 0 .306 1.788l6.905 6.905c.41.41 1.073.41 1.482 0l6.904-6.903Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:668
 */

const IconChevronDownShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '8',
  viewBox: '0 0 15 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.146.146A.5.5 0 0 0 .09.784l.057.07 7 7a.5.5 0 0 0 .638.057l.07-.057 7-7a.5.5 0 0 0-.638-.765l-.07.057L7.5 6.793.854.146A.5.5 0 0 0 .216.09l-.07.057Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3375
 */

const IconChevronDownSmallFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '5',
  viewBox: '0 0 9 5',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.523 0a.522.522 0 0 0-.37.89l3.958 3.957a.522.522 0 0 0 .737 0L8.805.89A.522.522 0 0 0 8.436 0H.523Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3335
 */

const IconChevronDownSmallThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '8',
  height: '5',
  viewBox: '0 0 8 5',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.8.8 4 4 7.2.8',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4243
 */

const IconChevronDownSmallShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '7',
  height: '4',
  viewBox: '0 0 7 4',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm.5.5 3 3 3-3',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1316
 */

const IconChevronLeftThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '16',
  viewBox: '0 0 9 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.21 15.597a1.048 1.048 0 0 0 1.487-1.478l-6.115-6.19 6.112-6.145A1.047 1.047 0 0 0 7.212.306L.307 7.211c-.41.41-.41 1.073 0 1.482l6.903 6.904Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:641
 */

const IconChevronLeftShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '8',
  height: '15',
  viewBox: '0 0 8 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.854.146A.5.5 0 0 0 7.216.09l-.07.057-7 7a.5.5 0 0 0-.057.638l.057.07 7 7a.5.5 0 0 0 .765-.638l-.057-.07L1.207 7.5 7.854.854A.5.5 0 0 0 7.91.216l-.057-.07Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3381
 */

const IconChevronLeftSmallFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '5',
  height: '9',
  viewBox: '0 0 5 9',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M5 .523a.522.522 0 0 0-.89-.37L.153 4.112a.522.522 0 0 0 0 .737L4.11 8.805c.328.329.89.096.89-.369V.523Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3359
 */

const IconChevronLeftSmallThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '5',
  height: '8',
  viewBox: '0 0 5 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M4 .8.8 4 4 7.2',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4249
 */

const IconChevronLeftSmallShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '4',
  height: '7',
  viewBox: '0 0 4 7',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm3.5.5-3 3 3 3',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1322
 */

const IconChevronRightThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '16',
  viewBox: '0 0 9 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M1.79.307A1.048 1.048 0 0 0 .303 1.785l6.115 6.19-6.112 6.144a1.047 1.047 0 0 0 1.482 1.478l6.905-6.904c.41-.41.41-1.073 0-1.483L1.79.307Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:647
 */

const IconChevronRightShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '8',
  height: '15',
  viewBox: '0 0 8 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.146.146A.5.5 0 0 1 .784.09l.07.057 7 7a.5.5 0 0 1 .057.638l-.057.07-7 7a.5.5 0 0 1-.765-.638l.057-.07L6.793 7.5.146.854A.5.5 0 0 1 .09.216l.057-.07Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3386
 */

const IconChevronRightSmallFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '5',
  height: '9',
  viewBox: '0 0 5 9',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M0 8.436c0 .465.562.698.89.37l3.957-3.958a.522.522 0 0 0 0-.737L.89.154A.522.522 0 0 0 0 .523v7.913Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3353
 */

const IconChevronRightSmallThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '5',
  height: '8',
  viewBox: '0 0 5 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.8 7.2 4 4 .8.8',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4257
 */

const IconChevronRightSmallShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '4',
  height: '7',
  viewBox: '0 0 4 7',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm.5 6.5 3-3-3-3',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1325
 */

const IconChevronUpThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '9',
  viewBox: '0 0 16 9',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.307 7.21a1.048 1.048 0 0 0 1.478 1.487l6.19-6.115 6.144 6.112a1.047 1.047 0 0 0 1.478-1.482L8.693.307a1.048 1.048 0 0 0-1.483 0L.307 7.21Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:644
 */

const IconChevronUpShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '8',
  viewBox: '0 0 15 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.146 7.854a.5.5 0 0 1-.057-.638l.057-.07 7-7A.5.5 0 0 1 7.784.09l.07.057 7 7a.5.5 0 0 1-.638.765l-.07-.057L7.5 1.207.854 7.854a.5.5 0 0 1-.638.057l-.07-.057Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3367
 */

const IconChevronUpSmallFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '5',
  viewBox: '0 0 9 5',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.523 5a.522.522 0 0 1-.37-.89L4.112.153a.522.522 0 0 1 .737 0L8.805 4.11a.522.522 0 0 1-.369.89H.523Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3346
 */

const IconChevronUpSmallThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '8',
  height: '5',
  viewBox: '0 0 8 5',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M7.2 4 4 .8.8 4',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4265
 */

const IconChevronUpSmallShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '7',
  height: '4',
  viewBox: '0 0 7 4',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm6.5 3.5-3-3-3 3',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1317
 */

const IconChevronDownThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M19.293 10.412a1 1 0 0 0-1.41-1.418l-5.905 5.833-5.862-5.83a.998.998 0 0 0-1.41 1.414l6.587 6.587a1 1 0 0 0 1.414 0l6.586-6.586Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:666
 */

const IconChevronDown = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M4.646 8.146a.5.5 0 0 0-.057.638l.057.07 7 7a.5.5 0 0 0 .638.057l.07-.057 7-7a.5.5 0 0 0-.638-.765l-.07.057L12 14.793 5.354 8.146a.5.5 0 0 0-.638-.057l-.07.057Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3376
 */

const IconChevronDownSmallFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M8.207 10a.5.5 0 0 0-.353.854l3.792 3.792a.5.5 0 0 0 .708 0l3.792-3.792a.5.5 0 0 0-.353-.854H8.207Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3336
 */

const IconChevronDownSmallThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm9 11 3 3 3-3',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3249
 */

const IconChevronDownSmall = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm9 11 3 3 3-3',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1314
 */

const IconChevronLeftThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13.588 19.293a1 1 0 0 0 1.419-1.41l-5.834-5.905 5.83-5.862a.998.998 0 0 0-1.414-1.41l-6.587 6.587a1 1 0 0 0 0 1.414l6.586 6.586Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:639
 */

const IconChevronLeft = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.854 4.646a.5.5 0 0 0-.638-.057l-.07.057-7 7a.5.5 0 0 0-.057.638l.057.07 7 7a.5.5 0 0 0 .765-.638l-.057-.07L9.207 12l6.647-6.646a.5.5 0 0 0 .057-.638l-.057-.07Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3382
 */

const IconChevronLeftSmallFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M13.5 8.207a.5.5 0 0 0-.854-.353l-3.792 3.792a.5.5 0 0 0 0 .708l3.792 3.792a.5.5 0 0 0 .854-.353V8.207Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3360
 */

const IconChevronLeftSmallThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm13 9-3 3 3 3',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3250
 */

const IconChevronLeftSmall = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm13 9-3 3 3 3',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1320
 */

const IconChevronRightThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10.412 4.707a1 1 0 0 0-1.418 1.41l5.833 5.905-5.83 5.862a.998.998 0 0 0 1.414 1.41l6.587-6.587a1 1 0 0 0 0-1.414l-6.586-6.586Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:645
 */

const IconChevronRight = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.146 4.646a.5.5 0 0 1 .638-.057l.07.057 7 7a.5.5 0 0 1 .057.638l-.057.07-7 7a.5.5 0 0 1-.765-.638l.057-.07L14.793 12 8.146 5.354a.5.5 0 0 1-.057-.638l.057-.07Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3388
 */

const IconChevronRightSmallFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M10 15.793a.5.5 0 0 0 .854.353l3.792-3.792a.5.5 0 0 0 0-.708l-3.792-3.792a.5.5 0 0 0-.854.353v7.586Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3354
 */

const IconChevronRightSmallThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm10.5 15 3-3-3-3',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3251
 */

const IconChevronRightSmall = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm10.5 15 3-3-3-3',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1323
 */

const IconChevronUpThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M4.707 13.588a1 1 0 0 0 1.41 1.419l5.905-5.834 5.862 5.83a.998.998 0 0 0 1.41-1.414l-6.587-6.587a1 1 0 0 0-1.414 0l-6.586 6.586Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:642
 */

const IconChevronUp = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M4.646 15.854a.5.5 0 0 1-.057-.638l.057-.07 7-7a.5.5 0 0 1 .638-.057l.07.057 7 7a.5.5 0 0 1-.638.765l-.07-.057L12 9.207l-6.646 6.647a.5.5 0 0 1-.638.057l-.07-.057Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3370
 */

const IconChevronUpSmallFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M8.207 14a.5.5 0 0 1-.353-.854l3.792-3.792a.5.5 0 0 1 .708 0l3.792 3.792a.5.5 0 0 1-.353.854H8.207Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3348
 */

const IconChevronUpSmallThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm15 13-3-3-3 3',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3252
 */

const IconChevronUpSmall = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm15 13-3-3-3 3',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:825
 */

const IconClockHistoryThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '15',
  viewBox: '0 0 14 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm4.251 3.079.57 1.409a.414.414 0 0 1-.491.556l-3.545-.94a.518.518 0 0 1-.31-.769L2.37.2a.416.416 0 0 1 .74.06l.553 1.366a6.98 6.98 0 0 1 3.331-.84C10.864.786 14 3.918 14 7.782c0 3.864-3.137 6.996-7.006 6.996a6.99 6.99 0 0 1-4.954-2.05.776.776 0 0 1 0-1.098.78.78 0 0 1 1.1 0 5.433 5.433 0 0 0 3.854 1.593c3.01 0 5.45-2.436 5.45-5.441a5.445 5.445 0 0 0-5.45-5.441 5.437 5.437 0 0 0-2.743.738Zm-4.25 5.14a.778.778 0 0 1 1.554-.095c.028.439.107.869.237 1.282a.777.777 0 1 1-1.486.464 6.965 6.965 0 0 1-.304-1.65Zm7.778-.925 2.18 1.7a.776.776 0 0 1 .134 1.091A.78.78 0 0 1 9 10.22L6.955 8.624c-.132-.103-.733-.521-.733-1.101V4.932a.778.778 0 0 1 1.557 0v2.362Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4336
 */

const IconClockHistoryShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm2.993 2.93-.356-.354.356.355ZM1.51 4.423h-.503v.503h.503v-.503ZM.524 8.393l.502.017-1.004-.052.502.035ZM8.8 9h-.503c0 .128.049.252.137.345L8.8 9Zm0 7.994c-4.294 0-7.795-3.568-7.795-7.994H0c0 4.96 3.929 9 8.8 9v-1.006ZM16.595 9c0 4.426-3.5 7.994-7.794 7.994V18c4.871 0 8.8-4.04 8.8-9h-1.006Zm1.006 0c0-4.96-3.929-9-8.8-9v1.006c4.293 0 7.794 3.568 7.794 7.994h1.006ZM3.35 3.286a7.67 7.67 0 0 1 5.45-2.28V0a8.675 8.675 0 0 0-6.163 2.576l.713.71Zm-.713-.71L1.152 4.067l.713.71L3.35 3.285l-.713-.71ZM1.006 9c0-.193.006-.383.02-.572l-1.004-.07A9.33 9.33 0 0 0 0 9h1.006Zm0 .017.02-.607-1.005-.034-.02.607 1.004.034Zm7.292-5.099V9h1.005V3.918H8.298Zm.137 5.427 3.268 3.467.732-.69-3.268-3.467-.732.69ZM1.005.398v4.024h1.007V.398H1.006Zm.504 4.527h3.52V3.92h-3.52v1.006Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:638
 */

const IconClockShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M18 9A9 9 0 1 0 0 9a9 9 0 0 0 18 0ZM1 9a8 8 0 1 1 16 0A8 8 0 0 1 1 9Zm7.566.186a.449.449 0 0 0 .132.318l1.92 1.921a.45.45 0 1 0 .637-.636l-1.789-1.79V4.694a.45.45 0 0 0-.9 0v4.493Zm.034.172.002.003-.003-.006.001.003Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:633
 */

const IconClock = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0ZM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm7.566.186a.449.449 0 0 0 .132.318l1.92 1.921a.45.45 0 1 0 .637-.636l-1.789-1.79V7.693a.45.45 0 0 0-.9 0v4.493Zm.034.172.002.003-.003-.006.001.003Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:822
 */

const IconClockHistoryThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm9.1 7.969.55 1.358a.4.4 0 0 1-.475.536l-3.418-.906a.5.5 0 0 1-.3-.741l1.829-3.023a.4.4 0 0 1 .713.057l.534 1.318a6.731 6.731 0 0 1 3.211-.81c3.731 0 6.756 3.02 6.756 6.746 0 3.726-3.025 6.746-6.756 6.746a6.74 6.74 0 0 1-4.777-1.976.749.749 0 0 1 0-1.06.751.751 0 0 1 1.062 0 5.239 5.239 0 0 0 3.715 1.537A5.25 5.25 0 0 0 17 12.504a5.25 5.25 0 0 0-5.255-5.247A5.243 5.243 0 0 0 9.1 7.97ZM5 12.926a.75.75 0 0 1 1.499-.092c.026.423.103.838.228 1.236a.75.75 0 1 1-1.433.447A6.717 6.717 0 0 1 5 12.927Zm7.5-.892 2.102 1.64a.749.749 0 1 1-.925 1.18l-1.971-1.538c-.128-.099-.707-.503-.707-1.062V9.756a.75.75 0 0 1 1.501 0v2.278Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3477
 */

const IconClockHistory = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm5.976 6.018-.354-.353.354.353ZM4.5 7.501H4v.5h.5v-.5Zm-.98 3.949.5.017-.998-.052.499.035Zm8.23.603h-.5a.5.5 0 0 0 .136.343l.364-.343Zm0 7.948c-4.27 0-7.75-3.547-7.75-7.948H3C3 16.983 6.906 21 11.75 21v-1Zm7.75-7.948c0 4.4-3.48 7.948-7.75 7.948v1c4.844 0 8.75-4.017 8.75-8.948h-1Zm1 0c0-4.93-3.906-8.948-8.75-8.948v1c4.27 0 7.75 3.547 7.75 7.948h1ZM6.33 6.37a7.625 7.625 0 0 1 5.42-2.266v-1a8.625 8.625 0 0 0-6.128 2.56l.708.706Zm-.708-.705L4.146 7.149l.708.705 1.477-1.483-.71-.705ZM4 12.053c0-.192.007-.381.02-.57l-.998-.068c-.015.21-.022.424-.022.638h1Zm0 .017.02-.603-.999-.035-.02.604.999.034ZM11.25 7v5.053h1V7h-1Zm.136 5.396 3.25 3.447.727-.685-3.25-3.448-.727.686ZM4 3.5v4.001h1V3.5H4Zm.5 4.501H8v-1H4.5v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1248
 */

const IconClosetShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '16',
  viewBox: '0 0 19 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10 1v8H9V1H1.25a.25.25 0 0 0-.25.25V9h17V1.25a.25.25 0 0 0-.25-.25H10Zm8 9H1v4.75c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V10ZM1 0h17a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1Zm7.5 12h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1ZM6.005 5.54v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0Zm5.995 0v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1244
 */

const IconCloset = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12.5 5v8h-1V5H3.75a.25.25 0 0 0-.25.25V13h17V5.25a.25.25 0 0 0-.25-.25H12.5Zm8 9h-17v4.75c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V14ZM3.5 4h17a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1ZM11 16h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1ZM8.505 9.54v-2a.5.5 0 0 1 1 0v2a.5.5 0 1 1-1 0Zm5.995 0v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4472
 */

const IconCogFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M6.428 8c0-.882.704-1.6 1.57-1.6.868 0 1.572.718 1.572 1.6 0 .883-.704 1.6-1.571 1.6s-1.57-.717-1.57-1.6Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5.94 0h4.117l.175.892v.004l.287 1.424c.41.184.789.412 1.14.67l1.434-.49.85-.268.444.776 1.16 1.978.453.793-.676.6-1.075.932c.034.21.065.446.065.689 0 .243-.031.48-.065.689l1.08.936.671.596-.457.798-1.156 1.973-.444.778-.861-.274-1.423-.485c-.351.258-.73.485-1.14.669l-.287 1.424v.004l-.175.892H5.94l-.173-.895-.288-1.425a6.27 6.27 0 0 1-1.14-.67l-1.433.49-.852.27-.442-.778-1.16-1.979L0 10.223l.674-.6 1.076-.934A4.347 4.347 0 0 1 1.684 8c0-.242.032-.48.066-.688L.668 6.374 0 5.78l.455-.798 1.157-1.973.442-.776.862.272 1.423.485c.351-.258.73-.485 1.14-.67L5.767.895 5.94 0Zm2.059 5.333C6.554 5.333 5.38 6.527 5.38 8c0 1.473 1.173 2.667 2.618 2.667 1.445 0 2.618-1.194 2.618-2.667 0-1.473-1.173-2.667-2.618-2.667Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3572
 */

const IconCogFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M10.428 12c0-.882.704-1.6 1.57-1.6.868 0 1.572.718 1.572 1.6 0 .883-.704 1.6-1.571 1.6s-1.57-.717-1.57-1.6Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9.94 4h4.117l.175.892v.004l.287 1.424c.41.184.789.412 1.14.67l1.434-.49.85-.268.444.776 1.16 1.978.453.793-.676.6-1.075.933c.034.209.065.445.065.688 0 .243-.031.48-.065.688l1.08.937.671.596-.456.798-1.157 1.973-.444.778-.861-.274-1.423-.485c-.351.258-.73.485-1.14.669l-.287 1.424v.004l-.175.892H9.94l-.173-.895-.288-1.425a6.27 6.27 0 0 1-1.14-.67l-1.433.49-.852.27-.442-.778-1.16-1.979L4 14.223l.674-.6 1.076-.934A4.347 4.347 0 0 1 5.684 12c0-.242.032-.48.066-.688l-1.082-.938L4 9.78l.455-.798 1.157-1.973.442-.776.862.272 1.423.485c.351-.258.73-.485 1.14-.67l.288-1.425L9.94 4Zm2.059 5.333c-1.445 0-2.618 1.194-2.618 2.667 0 1.473 1.173 2.667 2.618 2.667 1.445 0 2.618-1.194 2.618-2.667 0-1.473-1.173-2.667-2.618-2.667Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4316
 */

const IconCogShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  clipRule: 'evenodd',
  d: 'M6.333.5 6.24.968l-.353 1.713a5.914 5.914 0 0 0-1.536.883l-1.723-.576-.463-.144-.24.414L.74 5.242l-.24.414.351.307 1.333 1.135c-.048.297-.11.59-.11.902 0 .312.062.605.11.902L.851 10.037l-.351.307.24.414 1.186 1.984.24.415.463-.145 1.723-.576c.462.362.973.667 1.536.883l.353 1.713.092.468h3.333l.093-.468.352-1.713a5.911 5.911 0 0 0 1.536-.883l1.723.576.463.145.24-.415 1.186-1.984.241-.414-.352-.307-1.333-1.135c.049-.297.11-.59.11-.902 0-.312-.061-.605-.11-.902l1.333-1.135.352-.307-.241-.414-1.185-1.984-.241-.414-.463.144-1.723.576a5.912 5.912 0 0 0-1.536-.883L9.759.968 9.666.5H6.333Z',
  stroke: 'currentColor',
  strokeLinecap: 'square',
  strokeLinejoin: 'round'
}), /*#__PURE__*/React.createElement("path", {
  clipRule: 'evenodd',
  d: 'M10.143 8a2.144 2.144 0 1 1-4.288-.002A2.144 2.144 0 0 1 10.142 8Z',
  stroke: 'currentColor',
  strokeLinecap: 'square',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3448
 */

const IconCog = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  clipRule: 'evenodd',
  d: 'm10.333 4.5-.092.468-.353 1.713a5.914 5.914 0 0 0-1.536.883l-1.723-.576-.463-.144-.24.414L4.74 9.242l-.24.414.351.307 1.333 1.135c-.048.297-.11.59-.11.902 0 .312.062.605.11.902l-1.333 1.135-.351.307.24.414 1.186 1.984.24.415.463-.145 1.723-.576c.462.362.973.667 1.536.883l.353 1.713.092.468h3.333l.093-.468.352-1.713a5.911 5.911 0 0 0 1.536-.883l1.723.576.463.145.24-.415 1.186-1.984.241-.414-.352-.307-1.333-1.135c.049-.297.11-.59.11-.902 0-.312-.061-.605-.11-.902l1.332-1.135.353-.307-.241-.414-1.185-1.984-.241-.414-.463.144-1.723.576a5.912 5.912 0 0 0-1.536-.883l-.352-1.713-.093-.468h-3.333Z',
  stroke: 'currentColor',
  strokeLinecap: 'square',
  strokeLinejoin: 'round'
}), /*#__PURE__*/React.createElement("path", {
  clipRule: 'evenodd',
  d: 'M14.143 12a2.144 2.144 0 1 1-4.288-.002 2.144 2.144 0 0 1 4.287.002Z',
  stroke: 'currentColor',
  strokeLinecap: 'square',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3536
 */

const IconCompassThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M16.5 9a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0ZM18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0Zm-4.804-3.221a.75.75 0 0 0-.974-.975l-5 2a.75.75 0 0 0-.418.417l-2 5a.75.75 0 0 0 .975.975l5-2a.75.75 0 0 0 .417-.418l2-5Zm-6.35 5.375 1.231-3.077 3.077-1.23-1.231 3.076-3.077 1.23Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3506
 */

const IconCompassThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M19.5 12a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Zm1.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-4.804-3.221a.75.75 0 0 0-.975-.975l-5 2a.75.75 0 0 0-.417.418l-2 5a.75.75 0 0 0 .975.974l5-2a.75.75 0 0 0 .417-.418l2-5Zm-6.35 5.375 1.231-3.077 3.077-1.23-1.231 3.076-3.077 1.23Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3533
 */

const IconCompassShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0Zm1 0A9 9 0 1 1 0 9a9 9 0 0 1 18 0Zm-4.545-3.793a.5.5 0 0 0-.662-.662l-5.5 2.5a.5.5 0 0 0-.248.248l-2.5 5.5a.5.5 0 0 0 .662.662l5.5-2.5a.5.5 0 0 0 .248-.248l2.5-5.5Zm-7.448 6.786 1.87-4.115 4.116-1.871-1.87 4.115-4.116 1.871Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3440
 */

const IconCompass = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm1 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-4.545-3.793a.5.5 0 0 0-.662-.662l-5.5 2.5a.5.5 0 0 0-.248.248l-2.5 5.5a.5.5 0 0 0 .662.662l5.5-2.5a.5.5 0 0 0 .248-.248l2.5-5.5Zm-7.448 6.786 1.87-4.115 4.116-1.871-1.87 4.115-4.116 1.871Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:729
 */

const IconConciergeShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '19',
  viewBox: '0 0 15 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 5c0-.953-.375-1.827-1-2.514V1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1.486C3.375 3.173 3 4.047 3 5c0 2.21 2.015 4 4.5 4S12 7.21 12 5Zm-2-4v1a.5.5 0 0 0 0 1h.109c.554.53.891 1.232.891 2 0 1.657-1.567 3-3.5 3S4 6.657 4 5c0-.768.337-1.47.891-2H7.5a.5.5 0 0 0 0-1H5V1h5ZM1 18.5a.5.5 0 0 1-1 0v-3C0 12.462 1.462 10 4.5 10c1.231.667 2.231 1 3 1 .769 0 1.769-.333 3-1 3.038 0 4.5 2.462 4.5 5.5v3a.5.5 0 0 1-1 0v-3c0-2.485-1-4.5-3.23-4.5-1.346.667-2.436 1-3.27 1-.834 0-1.925-.333-3.273-1C2 11 1 13.015 1 15.5v3ZM3.5 14a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:722
 */

const IconConcierge = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M16.5 7.5c0-.953-.375-1.827-1-2.514V3.5a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v1.486c-.625.687-1 1.561-1 2.514 0 2.21 2.015 4 4.5 4s4.5-1.79 4.5-4Zm-2-4v1a.5.5 0 0 0 0 1h.109c.554.53.891 1.232.891 2 0 1.657-1.567 3-3.5 3s-3.5-1.343-3.5-3c0-.768.337-1.47.891-2H12a.5.5 0 0 0 0-1H9.5v-1h5ZM5.5 21a.5.5 0 0 1-1 0v-3c0-3.038 1.462-5.5 4.5-5.5 1.231.667 2.231 1 3 1 .769 0 1.769-.333 3-1 3.038 0 4.5 2.462 4.5 5.5v3a.5.5 0 0 1-1 0v-3c0-2.485-1-4.5-3.23-4.5-1.346.667-2.436 1-3.27 1-.834 0-1.925-.333-3.273-1C6.5 13.5 5.5 15.515 5.5 18v3ZM8 16.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H8Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3363
 */

const IconCraneShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '21',
  height: '17',
  viewBox: '0 0 21 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M1 1h5.62L4.217 5H1V1Zm4.384 4 2.402-4h3.432l2.402 4H5.384Zm9.403 0H19.13l-2.666-4h-4.08l2.402 4ZM12 6H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h15.465a1 1 0 0 1 .832.445l2.666 4A1 1 0 0 1 19.131 6H18v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V6Zm5 0h-4v2.761l4-1.6V6Zm0 6.761-4-1.6V9.84l4-1.6v4.522Zm-4-.522V16h4v-2.162l-4-1.6ZM4 9.55V7h1v3.5h-.5A1.5 1.5 0 1 0 6 12a.5.5 0 0 1 1 0 2.5 2.5 0 1 1-3-2.45Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=86:37
 */

const IconCrane = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3 5h5.62L6.217 9H3V5Zm4.384 4 2.402-4h3.432l2.402 4H7.384Zm9.403 0H21.13l-2.666-4h-4.08l2.402 4ZM14 10H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h15.465a1 1 0 0 1 .832.445l2.666 4A1 1 0 0 1 21.131 10H20v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V10Zm5 0h-4v2.761l4-1.6V10Zm0 6.762-4-1.6v-1.324l4-1.6v4.524Zm-4-.524V20h4v-2.162l-4-1.6ZM6 13.55V11h1v3.5h-.5A1.5 1.5 0 1 0 8 16a.5.5 0 0 1 1 0 2.5 2.5 0 1 1-3-2.45Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2732:3337
 */

const IconCrownFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '16',
  viewBox: '0 0 19 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M9.545 3.052a1.541 1.541 0 1 0-.63-.006l-.146.348-.003.007-.012.027-.048.108a12.397 12.397 0 0 1-.91 1.647c-.307.464-.666.927-1.061 1.298-.399.374-.805.627-1.203.719-.815.188-1.621.078-2.241-.091a5.818 5.818 0 0 1-.934-.344 2.44 2.44 0 0 1-.048-.024l-.01-.006h-.002l-.26-.141a1.541 1.541 0 1 0-.565.08l.642 5.137h14.487l.963-5.139a1.54 1.54 0 1 0-.587-.073l-.258.127h-.002l-.01.005-.048.022a6.477 6.477 0 0 1-.936.319c-.623.16-1.442.273-2.281.123-.44-.08-.896-.329-1.348-.702-.45-.37-.867-.84-1.227-1.31A13.39 13.39 0 0 1 9.72 3.396l-.014-.027-.003-.007H9.7l-.156-.31ZM2.242 12.838h14.166l-.577 3.078H2.627l-.385-3.078Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2726:3386
 */

const IconCrownFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M12.294 6.471a1.5 1.5 0 1 0-.614-.005l-.142.338v.001l-.003.006-.011.027-.047.105a12.077 12.077 0 0 1-.886 1.603 7.182 7.182 0 0 1-1.034 1.265c-.388.364-.783.61-1.17.7-.794.183-1.58.075-2.183-.09a5.653 5.653 0 0 1-.91-.335l-.046-.023-.01-.005h-.002l-.252-.138a1.5 1.5 0 1 0-.55.079L5.057 15h14.106l.938-5.003a1.5 1.5 0 1 0-.572-.072l-.251.124h-.001l-.01.005a4.55 4.55 0 0 1-.24.102 6.32 6.32 0 0 1-.719.23c-.606.155-1.404.266-2.221.12-.428-.077-.872-.32-1.313-.684-.437-.36-.844-.817-1.194-1.275a13.043 13.043 0 0 1-1.118-1.74l-.014-.028-.003-.006v-.001l-.152-.3ZM5.183 16h13.794l-.563 2.997H5.559L5.183 16Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3412
 */

const IconCrownShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '16',
  viewBox: '0 0 19 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9.243 2.054a.514.514 0 1 0 0-1.027.514.514 0 0 0 0 1.027Zm1.54-.513c0 .747-.532 1.37-1.239 1.51l.157.312.001.001.003.006.015.028.06.111a13.39 13.39 0 0 0 1.088 1.677c.36.47.777.939 1.226 1.31.453.373.909.622 1.348.701.84.15 1.659.037 2.281-.122a6.47 6.47 0 0 0 .937-.32l.048-.021.01-.005h.001l.261-.13a1.541 1.541 0 1 1 .585.073l-.114.612-1.54 8.216-.08.419H2.629l-.056-.45-1.027-8.216-.073-.579a1.54 1.54 0 1 1 .563-.08l.262.143h.001l.011.006.048.024a5.818 5.818 0 0 0 .934.344c.62.17 1.427.28 2.242.091.398-.092.804-.344 1.202-.718.395-.371.755-.835 1.061-1.299a12.402 12.402 0 0 0 .959-1.755l.012-.027.002-.006.147-.35a1.541 1.541 0 1 1 1.868-1.506Zm5.49 6.446a7.648 7.648 0 0 1-.295.082c-.706.182-1.684.325-2.717.14-.678-.122-1.293-.487-1.82-.921-.53-.437-1-.97-1.389-1.478-.307-.4-.567-.792-.77-1.118-.167.312-.379.68-.629 1.06-.332.503-.742 1.036-1.215 1.48-.47.442-1.033.823-1.674.971-1.038.24-2.029.094-2.743-.1a6.947 6.947 0 0 1-.348-.106l.54 4.327h12.192a.52.52 0 0 1 .055.003l.814-4.34Zm-1.005 5.364H3.342l.192 1.54H14.98l.29-1.54Zm2.705-8.216a.514.514 0 1 1-1.027 0 .514.514 0 0 1 1.027 0ZM1.541 5.65a.514.514 0 1 0 0-1.027.514.514 0 0 0 0 1.027Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3413
 */

const IconCrown = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5-.5a1.5 1.5 0 0 1-1.207 1.471l.153.303v.001l.004.007.014.027a9.037 9.037 0 0 0 .285.505c.198.333.483.78.833 1.236.35.457.756.914 1.194 1.275.44.363.885.606 1.312.683.817.147 1.615.036 2.222-.12a6.295 6.295 0 0 0 .958-.331l.01-.005h.001l.254-.126a1.5 1.5 0 1 1 .57.07l-.112.596-1.5 8-.076.408H5.559l-.055-.438-1-8-.07-.563a1.5 1.5 0 1 1 .547-.078l.256.139h.001l.01.006.047.023c.043.02.109.051.194.088.17.072.417.166.716.247.603.165 1.389.272 2.182.089.388-.09.783-.336 1.17-.7a7.181 7.181 0 0 0 1.034-1.264 12.079 12.079 0 0 0 .934-1.709l.01-.026.003-.006v-.001l.143-.34A1.5 1.5 0 1 1 13.5 5Zm5.346 6.277c-.09.027-.187.054-.288.08-.688.177-1.64.316-2.646.135-.66-.118-1.26-.473-1.772-.896-.517-.426-.975-.945-1.352-1.438-.3-.39-.553-.772-.75-1.09-.163.304-.369.663-.613 1.032-.323.49-.722 1.01-1.183 1.442-.458.43-1.006.8-1.63.945-1.01.234-1.975.092-2.67-.098a6.791 6.791 0 0 1-.34-.102L6.13 15.5H18c.018 0 .036.001.053.003l.793-4.226Zm-.98 5.223H6.254L6.44 18h11.144l.281-1.5Zm2.634-8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM4.5 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1209
 */

const IconCutleryAndDishShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '17',
  viewBox: '0 0 20 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5 4.101a6.998 6.998 0 0 0-1.666 2.757c-.108.038-.22.069-.334.092v9.55a.5.5 0 0 1-1 0V6.95A2.5 2.5 0 0 1 0 4.5v-4a.5.5 0 0 1 1 0V5c0 .502 1 1.027 1 .502V.499A.5.5 0 1 1 3 .5v5.003C3 6.012 4.003 5.5 4.003 5V.499a.499.499 0 0 1 .998 0V4.1ZM18.5 0c1.105 0 1.5.895 1.5 2v5.788a2 2 0 0 1-1.087 1.78l-.913.468V16c0 .552 0 1-.499 1C17 17 17 16.552 17 16V2c0-1.105.395-2 1.5-2Zm0 1c.552 0 .5.448.5 1v5.788a1 1 0 0 1-.544.89L18 8.979V16 2c0-.552-.052-1 .5-1ZM10 13a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-1a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 3a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-1a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1259
 */

const IconCutleryShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '17',
  viewBox: '0 0 17 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3 6.95v9.55a.5.5 0 0 1-1 0V6.95A2.5 2.5 0 0 1 0 4.5V0h1v5c0 .502 1 1.027 1 .502V0h1v5.502C3 6.012 4.002 5.5 4.002 5V0H5v4.5a2.5 2.5 0 0 1-2 2.45ZM10 2c0-1.105-.395-2-1.5-2S7 .895 7 2v14c0 .552 0 1 .501 1C8 17 8 16.552 8 16v-5.964l.913-.468A2 2 0 0 0 10 7.788V2Zm-2-.132C7.994 1.378 7.992 1 8.5 1s.505.378.5.868v5.92a1 1 0 0 1-.544.89L8 8.979V1.868ZM12 1h1v9h-1a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-1V1h1V0h-3v1Zm1 10h1v5h-1v-5Zm-2 1a1 1 0 0 1 1-1v5a1 1 0 0 1-1-1v-3Zm5 3a1 1 0 0 1-1 1v-5a1 1 0 0 1 1 1v3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1253
 */

const IconCutlery = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6.5 10.45V20a.5.5 0 0 1-1 0v-9.55A2.5 2.5 0 0 1 3.5 8V3.5h1v5c0 .502 1 1.027 1 .502V3.5h1v5.502c0 .51 1.002-.002 1.002-.502v-5H8.5V8a2.5 2.5 0 0 1-2 2.45Zm7-4.95c0-1.105-.395-2-1.5-2s-1.5.895-1.5 2v14c0 .552 0 1 .501 1 .499 0 .499-.448.499-1v-5.964l.913-.468a2 2 0 0 0 1.087-1.78V5.5Zm-2-.132c-.005-.49-.008-.868.5-.868s.505.378.5.868v5.92a1 1 0 0 1-.544.89l-.456.301V5.368Zm4-.868h1v9h-1a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-1v-9h1v-1h-3v1Zm1 10h1v5h-1v-5Zm-2 1a1 1 0 0 1 1-1v5a1 1 0 0 1-1-1v-3Zm5 3a1 1 0 0 1-1 1v-5a1 1 0 0 1 1 1v3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1205
 */

const IconCutleryAndDish = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7 7.601a6.998 6.998 0 0 0-1.666 2.756c-.108.039-.22.07-.334.093V20a.5.5 0 0 1-1 0v-9.55A2.5 2.5 0 0 1 2 8V4a.5.5 0 0 1 1 0v4.5c0 .502 1 1.027 1 .502V3.999A.5.5 0 1 1 5 4v5.003C5 9.512 6.003 9 6.003 8.5V3.999a.499.499 0 0 1 .998 0V7.6ZM20.5 3.5c1.105 0 1.5.895 1.5 2v5.788a2 2 0 0 1-1.087 1.78l-.913.468V19.5c0 .552 0 1-.499 1-.501 0-.501-.448-.501-1v-14c0-1.105.395-2 1.5-2Zm0 1c.552 0 .5.448.5 1v5.788a1 1 0 0 1-.544.89l-.456.301V19.5v-14c0-.552-.052-1 .5-1Zm-8.5 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-1a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 3a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-1a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:821
 */

const IconDiamondThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '13',
  viewBox: '0 0 16 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.957 4.5h-1.712l-1.974-3h-.622l-1.904 3H4.04a1.25 1.25 0 0 1 .153-.354L5.877 1.5h-2.21L1.545 4.989l4.761 4.697L4.451 6H6.13l1.834 3.647L9.852 6h1.686L9.552 9.826l4.904-4.839L12.352 1.5H10.05L11.8 4.14c.072.113.124.235.156.36ZM3.386 0h9.248a1 1 0 0 1 .857.483l2.437 4.04a.5.5 0 0 1 .072.259v.58a.5.5 0 0 1-.149.356l-7.088 6.994A1 1 0 0 1 8.06 13h-.12a1 1 0 0 1-.703-.288L.15 5.718A.5.5 0 0 1 0 5.362v-.579a.5.5 0 0 1 .073-.26L2.532.48A1 1 0 0 1 3.386 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:818
 */

const IconDiamondThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.957 10.5h-1.712l-1.974-3h-.622l-1.904 3H8.04a1.25 1.25 0 0 1 .153-.354L9.877 7.5h-2.21l-2.122 3.489 4.761 4.697L8.451 12h1.678l1.834 3.647L13.852 12h1.686l-1.986 3.826 4.904-4.838L16.352 7.5H14.05l1.752 2.64c.072.113.124.234.156.36ZM7.386 6h9.248a1 1 0 0 1 .857.483l2.437 4.04a.5.5 0 0 1 .072.259v.58a.5.5 0 0 1-.149.356l-7.088 6.994a1 1 0 0 1-.703.288h-.12a1 1 0 0 1-.703-.288L4.15 11.718A.5.5 0 0 1 4 11.362v-.579a.5.5 0 0 1 .073-.26L6.532 6.48A1 1 0 0 1 7.386 6Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:753
 */

const IconDogFootprintShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5.435 7.154c.426-1.356 1.907-2.12 3.308-1.71a2.618 2.618 0 0 1 1.71 1.546l.884 2.258c.185.473.453.908.791 1.287l1.093 1.223a2.507 2.507 0 0 1-.272 3.617c-.589.493-1.372.71-2.142.595l-2.274-.984a3.19 3.19 0 0 0-1.066 0l-2.296.963c-1.45.206-2.797-.763-3.01-2.165-.12-.79.147-1.588.722-2.16l.925-.92A4.267 4.267 0 0 0 4.87 8.956l.566-1.803Zm4.024.23a1.564 1.564 0 0 0-1.025-.918c-.84-.244-1.727.21-1.982 1.016l-.636 2.01a4.266 4.266 0 0 1-1.07 1.749l-1.097 1.082c-.344.34-.504.815-.432 1.284.127.833.935 1.41 1.803 1.287 0 0 1.762-.924 2.158-.98a8.536 8.536 0 0 1 1.69 0c.395.056 2.099 1.001 2.099 1.001.46.069.93-.06 1.283-.353.664-.55.737-1.513.163-2.15l-1.162-1.29a4.267 4.267 0 0 1-.784-1.251L9.46 7.385ZM13.867 9.6c-1.217 0-2.134-1.222-2.134-2.667 0-1.445.917-2.666 2.134-2.666C15.084 4.267 16 5.488 16 6.933c0 1.445-.916 2.667-2.133 2.667Zm0-1.067c.55 0 1.066-.688 1.066-1.6 0-.911-.516-1.6-1.066-1.6s-1.067.689-1.067 1.6c0 .912.516 1.6 1.067 1.6ZM2.133 9.6C.916 9.6 0 8.378 0 6.933c0-1.445.916-2.666 2.133-2.666s2.134 1.221 2.134 2.666c0 1.445-.917 2.667-2.134 2.667Zm0-1.067c.55 0 1.067-.688 1.067-1.6 0-.911-.516-1.6-1.067-1.6-.55 0-1.066.689-1.066 1.6 0 .912.516 1.6 1.066 1.6Zm3.2-3.2C4.116 5.333 3.2 4.112 3.2 2.667 3.2 1.222 4.116 0 5.333 0s2.134 1.222 2.134 2.667c0 1.445-.917 2.666-2.134 2.666Zm0-1.066c.55 0 1.067-.689 1.067-1.6 0-.912-.516-1.6-1.067-1.6-.55 0-1.066.688-1.066 1.6 0 .911.516 1.6 1.066 1.6Zm5.334 1.066c-1.217 0-2.134-1.221-2.134-2.666C8.533 1.222 9.45 0 10.667 0 11.884 0 12.8 1.222 12.8 2.667c0 1.445-.916 2.666-2.133 2.666Zm0-1.066c.55 0 1.066-.689 1.066-1.6 0-.912-.516-1.6-1.066-1.6S9.6 1.755 9.6 2.667c0 .911.516 1.6 1.067 1.6Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:749
 */

const IconDogFootprint = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9.435 11.154c.426-1.356 1.907-2.121 3.308-1.71a2.618 2.618 0 0 1 1.71 1.546l.884 2.258c.185.473.453.908.791 1.287l1.093 1.223a2.507 2.507 0 0 1-.272 3.617c-.589.493-1.372.71-2.142.595l-2.274-.984a3.19 3.19 0 0 0-1.066 0l-2.296.963c-1.45.206-2.797-.763-3.01-2.165-.12-.79.147-1.588.722-2.16l.925-.92a4.267 4.267 0 0 0 1.061-1.747l.566-1.803Zm4.024.23a1.564 1.564 0 0 0-1.024-.918c-.84-.244-1.728.21-1.983 1.016l-.636 2.01a4.266 4.266 0 0 1-1.07 1.749l-1.097 1.082c-.344.34-.504.815-.432 1.284.127.833.935 1.41 1.803 1.287 0 0 1.761-.924 2.158-.98a8.535 8.535 0 0 1 1.69 0c.395.056 2.099 1.001 2.099 1.001.46.069.93-.06 1.283-.353.664-.55.737-1.513.163-2.15l-1.162-1.29a4.267 4.267 0 0 1-.784-1.251l-1.008-2.486Zm4.408 2.216c-1.217 0-2.134-1.222-2.134-2.667 0-1.445.917-2.666 2.134-2.666 1.217 0 2.133 1.221 2.133 2.666 0 1.445-.916 2.667-2.133 2.667Zm0-1.067c.55 0 1.066-.688 1.066-1.6 0-.911-.516-1.6-1.066-1.6s-1.067.689-1.067 1.6c0 .912.516 1.6 1.067 1.6ZM6.133 13.6C4.916 13.6 4 12.378 4 10.933c0-1.445.916-2.666 2.133-2.666s2.134 1.221 2.134 2.666c0 1.445-.917 2.667-2.134 2.667Zm0-1.067c.55 0 1.067-.688 1.067-1.6 0-.911-.516-1.6-1.067-1.6-.55 0-1.066.689-1.066 1.6 0 .912.516 1.6 1.066 1.6Zm3.2-3.2C8.116 9.333 7.2 8.112 7.2 6.667 7.2 5.222 8.116 4 9.333 4s2.134 1.222 2.134 2.667c0 1.445-.917 2.666-2.134 2.666Zm0-1.066c.55 0 1.067-.689 1.067-1.6 0-.912-.516-1.6-1.067-1.6-.55 0-1.066.688-1.066 1.6 0 .911.516 1.6 1.066 1.6Zm5.334 1.066c-1.217 0-2.134-1.221-2.134-2.666 0-1.445.917-2.667 2.134-2.667C15.884 4 16.8 5.222 16.8 6.667c0 1.445-.916 2.666-2.133 2.666Zm0-1.066c.55 0 1.066-.689 1.066-1.6 0-.912-.516-1.6-1.066-1.6s-1.067.688-1.067 1.6c0 .911.516 1.6 1.067 1.6Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2298:4953
 */

const IconDownloadThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '19',
  viewBox: '0 0 19 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10.272.77V0h-1.54v11.75L6.45 9.468a.77.77 0 0 0-1.09 1.09l3.597 3.594c.301.3.789.3 1.09 0l3.594-3.595a.77.77 0 0 0-1.09-1.09l-2.279 2.28V.77Zm-8.731 9.5V9.5H0V15.919a2.824 2.824 0 0 0 2.824 2.824h13.352A2.824 2.824 0 0 0 19 15.92V9.5h-1.54V15.919c0 .709-.575 1.284-1.284 1.284H2.824a1.284 1.284 0 0 1-1.283-1.284V10.27Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2298:4956
 */

const IconDownloadThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12.752 4.5v-.75h-1.5v11.44L9.03 12.97a.75.75 0 1 0-1.06 1.06l3.502 3.5a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22V4.5ZM4.25 13.75V13h-1.5v6.25A2.75 2.75 0 0 0 5.5 22h13a2.75 2.75 0 0 0 2.75-2.75V13h-1.5v6.25c0 .69-.56 1.25-1.25 1.25h-13c-.69 0-1.25-.56-1.25-1.25v-5.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2298:4930
 */

const IconDownloadShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9.5.5V0h-1v11.793L5.852 9.146a.5.5 0 0 0-.707.708l3.502 3.5a.5.5 0 0 0 .707 0l3.5-3.5a.5.5 0 0 0-.708-.708L9.5 11.793V.5ZM1 9.5V9H0v6.5A2.5 2.5 0 0 0 2.5 18h13a2.5 2.5 0 0 0 2.5-2.5V9h-1v6.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 1 15.5v-6Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1433:1799
 */

const IconDownload = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12.5 4.5V4h-1v11.793l-2.648-2.647a.5.5 0 1 0-.707.708l3.502 3.5a.5.5 0 0 0 .707 0l3.5-3.5a.5.5 0 0 0-.708-.708L12.5 15.793V4.5Zm-8.5 9V13H3v6.5A2.5 2.5 0 0 0 5.5 22h13a2.5 2.5 0 0 0 2.5-2.5V13h-1v6.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19.5v-6Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:688
 */

const IconDumbbellShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '13',
  viewBox: '0 0 20 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6 8v3a2 2 0 1 1-4 0v-.085A1.5 1.5 0 0 1 0 9.5v-6a1.5 1.5 0 0 1 2-1.415V2a2 2 0 1 1 4 0v3h8V2a2 2 0 1 1 4 0v.085A1.5 1.5 0 0 1 20 3.5v6a1.5 1.5 0 0 1-2 1.415V11a2 2 0 1 1-4 0V8H6Zm0-1h8V6H6v1Zm-1 4V2a1 1 0 0 0-2 0v9a1 1 0 1 0 2 0Zm10-9v9a1 1 0 1 0 2 0V2a1 1 0 1 0-2 0ZM2 9.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0Zm16-6v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-1 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:684
 */

const IconDumbbell = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8 14v3a2 2 0 1 1-4 0v-.085A1.5 1.5 0 0 1 2 15.5v-6a1.5 1.5 0 0 1 2-1.415V8a2 2 0 1 1 4 0v3h8V8a2 2 0 1 1 4 0v.085A1.5 1.5 0 0 1 22 9.5v6a1.5 1.5 0 0 1-2 1.415V17a2 2 0 1 1-4 0v-3H8Zm0-1h8v-1H8v1Zm-1 4V8a1 1 0 0 0-2 0v9a1 1 0 1 0 2 0Zm10-9v9a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0ZM4 15.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0Zm16-6v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-1 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2272:3515
 */

const IconEditSquareThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '18',
  viewBox: '0 0 17 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm7.46 12.37 5.32-6.574-1.9-1.595-5.248 6.173v1.995h1.827Zm7.312-9.034-1.025 1.266-1.873-1.572 1.087-1.279 1.811 1.585Zm-7.069 10.57H5.12a1.024 1.024 0 0 1-1.024-1.025v-2.695c0-.243.086-.478.244-.663L12.127.36a1.024 1.024 0 0 1 1.455-.108l2.572 2.251c.415.363.468.988.122 1.415l-7.777 9.607c-.194.24-.487.38-.796.38ZM2.048 1.615h5.12v1.536h-5.12a.512.512 0 0 0-.512.512v12.288c0 .283.23.512.512.512h12.288c.283 0 .512-.23.512-.512v-5.12h1.536v5.12A2.048 2.048 0 0 1 14.336 18H2.048A2.048 2.048 0 0 1 0 15.952V3.664c0-1.131.917-2.048 2.048-2.048Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=702:37
 */

const IconEditSquareShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '18',
  viewBox: '0 0 17 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5.12 12.88h2.583l6.376-7.876-2.659-2.231-6.3 7.412v2.695Zm6.963-10.887 2.64 2.215.756-.933-2.572-2.251-.824.969Zm-4.38 11.911H5.12a1.024 1.024 0 0 1-1.024-1.024v-2.695c0-.243.086-.478.243-.663L12.126.36a1.024 1.024 0 0 1 1.455-.108l2.572 2.251c.414.363.468.987.122 1.415l-7.776 9.606c-.195.24-.487.38-.796.38ZM5.645 1.617a.512.512 0 0 1 .092 1.016l-.092.008H4.352c-1.77 0-3.228 1.493-3.323 3.387l-.005.197v7.167c0 1.92 1.4 3.477 3.146 3.579l.182.005h7.68c1.768 0 3.227-1.493 3.322-3.386l.005-.198v-.914a.512.512 0 0 1 1.016-.092l.008.092v.914c0 2.463-1.828 4.486-4.14 4.603L12.03 18h-7.68c-2.34 0-4.236-1.95-4.346-4.385L0 13.392V6.225c0-2.463 1.828-4.486 4.14-4.602l.212-.006h1.293Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=700:1736
 */

const IconEditSquareThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm11.284 14.501 5.197-6.42-1.857-1.557L9.5 12.553V14.5h1.784Zm7.142-8.821-1.001 1.236-1.83-1.535 1.062-1.249 1.769 1.548ZM11.523 16H9a1 1 0 0 1-1-1V12.37a1 1 0 0 1 .238-.648l7.605-8.947a1 1 0 0 1 1.42-.105l2.513 2.199a1 1 0 0 1 .119 1.381L12.3 15.631a1 1 0 0 1-.777.37ZM6 4h5v1.5H6a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-5H20v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=700:1757
 */

const IconEditSquare = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9 15h2.523l6.227-7.692-2.597-2.18L9 12.369V15Zm6.8-10.633 2.58 2.163.737-.911-2.512-2.198-.804.946ZM11.524 16H9a1 1 0 0 1-1-1v-2.632a1 1 0 0 1 .238-.648l7.605-8.947a1 1 0 0 1 1.42-.105l2.513 2.198a1 1 0 0 1 .119 1.382L12.3 15.629a1 1 0 0 1-.777.371ZM9.513 4a.5.5 0 0 1 .09.992L9.513 5H8.25C6.522 5 5.098 6.458 5.005 8.307L5 8.5v7c0 1.875 1.367 3.396 3.072 3.495L8.25 19h7.5c1.728 0 3.152-1.458 3.245-3.307L19 15.5v-.893a.5.5 0 0 1 .992-.09l.008.09v.893c0 2.405-1.785 4.38-4.043 4.495L15.75 20h-7.5c-2.285 0-4.138-1.904-4.245-4.283L4 15.5v-7c0-2.405 1.785-4.38 4.043-4.495L8.25 4h1.264Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=88:1442
 */

const IconElectricPlugThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15',
  viewBox: '0 0 15 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M0 7.5C0 3.365 3.365 0 7.5 0 11.636 0 15 3.365 15 7.501c0 2.012-.784 3.9-2.21 5.318l-.023.022c-.176.16-1.767 1.572-3.165 1.572-.744 0-1.39-.282-1.868-.815-.865-.966-1.001-2.553-.994-3.52a2.372 2.372 0 0 1-2.177-2.363V5.467h5.875v2.248a2.37 2.37 0 0 1-2.252 2.366c-.005.812.109 1.978.626 2.554.204.226.455.332.79.332.654 0 1.743-.792 2.182-1.186a6.015 6.015 0 0 0 1.772-4.28 6.062 6.062 0 0 0-6.055-6.056A6.062 6.062 0 0 0 1.445 7.5c0 1.612.626 3.13 1.763 4.272a6.08 6.08 0 0 0 2.41 1.486.722.722 0 1 1-.45 1.373 7.522 7.522 0 0 1-2.984-1.84A7.454 7.454 0 0 1 0 7.501Zm6.174-4.405h-.203c-.238 0-.431.176-.431.395v1.674h1.065V3.49c0-.218-.193-.395-.431-.395Zm2.855 0h-.203c-.238 0-.43.176-.43.395v1.674H9.46V3.49c0-.218-.193-.395-.432-.395Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=89:12
 */

const IconElectricPlugDisabledThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15',
  viewBox: '0 0 15 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("g", {
  clipPath: 'url(#a)',
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  fill: 'currentColor'
}, /*#__PURE__*/React.createElement("path", {
  d: 'M5.96 3.09h.204-.001c.237 0 .43.176.43.394v1.671H5.53v-1.67c0-.219.192-.395.43-.395Zm2.85 0h.204c.238 0 .43.176.43.394v1.671H8.382v-1.67c0-.219.193-.395.43-.395Zm-.638 7.14c-.004.811.757 2.695 1.273 3.27.203.226-.803 1.274-1.28.742-.863-.965-1.444-3.049-1.436-4.015a2.368 2.368 0 0 1-2.174-2.359V5.624h5.865v2.244a2.366 2.366 0 0 1-2.248 2.362Z'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M1.5 7.5a6 6 0 0 1 10.697-3.734l-10.113 6.32A5.976 5.976 0 0 1 1.5 7.5Zm1.738 4.224a6 6 0 0 0 9.927-6.203l-9.927 6.203ZM7.5 0a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z'
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: 'a'
}, /*#__PURE__*/React.createElement("path", {
  fill: 'currentColor',
  d: 'M0 0h15v15H0z'
}))));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=89:5
 */

const IconElectricPlugThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M4.5 11.988c0-4.13 3.359-7.488 7.488-7.488 4.128 0 7.487 3.359 7.487 7.489a7.435 7.435 0 0 1-2.207 5.308l-.023.022c-.176.16-1.764 1.57-3.159 1.57-.743 0-1.389-.281-1.865-.814-.864-.965-1-2.548-.992-3.515a2.368 2.368 0 0 1-2.174-2.358V9.957h5.865v2.245a2.367 2.367 0 0 1-2.248 2.362c-.005.81.109 1.975.625 2.55.204.226.454.331.79.331.652 0 1.739-.79 2.177-1.184a6.005 6.005 0 0 0 1.77-4.273 6.052 6.052 0 0 0-6.046-6.046 6.052 6.052 0 0 0-6.045 6.046c0 1.609.625 3.123 1.76 4.264a6.07 6.07 0 0 0 2.405 1.483.72.72 0 1 1-.448 1.371 7.51 7.51 0 0 1-2.98-1.836 7.441 7.441 0 0 1-2.18-5.282Zm6.164-4.399h-.203c-.238 0-.43.177-.43.395v1.671h1.063V7.984c0-.218-.193-.395-.43-.395Zm2.85 0h-.203c-.237 0-.43.177-.43.395v1.671h1.064V7.984c0-.218-.193-.395-.43-.395Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=89:31
 */

const IconElectricPlugDisabledThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("g", {
  clipPath: 'url(#a)',
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  fill: 'currentColor'
}, /*#__PURE__*/React.createElement("path", {
  d: 'M10.46 7.59h.204-.001c.237 0 .43.176.43.394v1.671H10.03v-1.67c0-.219.192-.395.43-.395Zm2.85 0h.204c.238 0 .43.176.43.394v1.671h-1.063v-1.67c0-.219.193-.395.43-.395Zm-.638 7.14c-.004.811.757 2.695 1.273 3.27.203.226-.803 1.274-1.28.742-.863-.965-1.444-3.049-1.436-4.015a2.368 2.368 0 0 1-2.174-2.359v-2.244h5.865v2.244a2.366 2.366 0 0 1-2.248 2.362Z'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M6 12a6 6 0 0 1 10.697-3.734l-10.113 6.32A5.976 5.976 0 0 1 6 12Zm1.738 4.224a6 6 0 0 0 9.927-6.203l-9.927 6.203ZM12 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z'
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: 'a'
}, /*#__PURE__*/React.createElement("path", {
  fill: 'currentColor',
  transform: 'translate(4.5 4.5)',
  d: 'M0 0h15v15H0z'
}))));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2093:3948
 */

const IconEnvelopeFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '14',
  viewBox: '0 0 16 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M0 1.615C0 .723.716 0 1.6 0h12.8c.884 0 1.6.723 1.6 1.615v1.3L8 7.46 0 2.916v-1.3Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M0 4.151v8.234C0 13.277.716 14 1.6 14h12.8c.884 0 1.6-.723 1.6-1.615V4.15L8 8.695 0 4.15Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1350
 */

const IconEnvelopeFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M4 6.615C4 5.723 4.716 5 5.6 5h12.8c.884 0 1.6.723 1.6 1.615v1.3l-8 4.544-8-4.543v-1.3Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M4 9.151v8.234C4 18.277 4.716 19 5.6 19h12.8c.884 0 1.6-.723 1.6-1.615V9.15l-8 4.544L4 9.15Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4369
 */

const IconEnvelopeShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '14',
  viewBox: '0 0 16 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.5 3.75 8 8.083l7.5-4.333M1.571.5H14.43C15.02.5 15.5.985 15.5 1.583v10.834c0 .598-.48 1.083-1.071 1.083H1.57A1.077 1.077 0 0 1 .5 12.417V1.583C.5.985.98.5 1.571.5Z',
  stroke: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3506
 */

const IconEnvelope = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm4.5 8.75 7.5 4.333 7.5-4.333M5.571 5.5H18.43c.591 0 1.071.485 1.071 1.083v10.834c0 .598-.48 1.083-1.071 1.083H5.57A1.077 1.077 0 0 1 4.5 17.417V6.583c0-.598.48-1.083 1.071-1.083Z',
  stroke: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3361
 */

const IconExtensionShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '19',
  viewBox: '0 0 19 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M11.52 18.153h6.253c.402 0 .707-.107.915-.322.208-.215.312-.53.312-.943V6.43c0-.414-.104-.729-.312-.944-.208-.214-.513-.322-.915-.322h-5.596v.755h5.448c.226 0 .386.047.48.14.094.095.14.252.14.472v10.254c0 .22-.046.38-.14.476-.094.097-.254.145-.48.145h-6.104v.746Zm3.17-8.814h1.605c.144 0 .216-.077.216-.231V7.53c0-.155-.072-.232-.216-.232H14.69c-.15 0-.224.077-.224.232v1.577c0 .154.075.231.224.231Zm0 3.34h1.605c.144 0 .216-.077.216-.232v-1.576c0-.155-.072-.232-.216-.232H14.69c-.15 0-.224.077-.224.232v1.576c0 .155.075.232.224.232Zm0 3.34h1.605c.144 0 .216-.077.216-.231V14.21c0-.155-.072-.232-.216-.232H14.69c-.15 0-.224.077-.224.232v1.576c0 .155.075.232.224.232ZM0 16.888c0 .414.103.728.308.943.205.215.509.322.91.322h10.303c.394 0 .696-.107.905-.322.209-.215.313-.53.313-.943V1.265c0-.414-.104-.728-.313-.943-.21-.215-.51-.322-.905-.322H1.219C.817 0 .513.107.308.322.103.537 0 .852 0 1.265v15.623Zm.754-.102V1.366c0-.22.047-.377.141-.47C.99.8 1.146.753 1.367.753H11.37c.22 0 .377.047.471.141.094.094.141.251.141.472v15.42c0 .22-.047.378-.14.475-.095.097-.252.145-.472.145H1.367c-.22 0-.378-.048-.472-.145-.094-.097-.14-.255-.14-.476Zm2.64.977h.666v-2.697c0-.26.133-.39.398-.39H8.29c.26 0 .39.13.39.39v2.697h.67v-2.798c0-.33-.076-.571-.229-.725-.153-.154-.391-.23-.715-.23H4.338c-.321 0-.559.076-.713.23-.154.154-.232.395-.232.725v2.799ZM3.5 4.947h1.924c.183 0 .275-.095.275-.285V2.769c0-.184-.092-.275-.275-.275H3.501c-.18 0-.271.091-.271.275V4.66c0 .19.09.285.271.285Zm3.81 0h1.924c.183 0 .275-.095.275-.285V2.769c0-.184-.092-.275-.275-.275H7.311c-.183 0-.274.091-.274.275V4.66c0 .19.091.285.274.285Zm-3.81 3.756h1.924c.183 0 .275-.094.275-.283V6.527c0-.183-.092-.274-.275-.274H3.501c-.18 0-.271.091-.271.274V8.42c0 .189.09.283.271.283Zm3.81 0h1.924c.183 0 .275-.094.275-.283V6.527c0-.183-.092-.274-.275-.274H7.311c-.183 0-.274.091-.274.274V8.42c0 .189.091.283.274.283Zm-3.81 3.758h1.924c.183 0 .275-.094.275-.282v-1.892c0-.185-.092-.278-.275-.278H3.501c-.18 0-.271.093-.271.278v1.892c0 .188.09.282.271.282Zm3.81 0h1.924c.183 0 .275-.094.275-.282v-1.892c0-.185-.092-.278-.275-.278H7.311c-.183 0-.274.093-.274.278v1.892c0 .188.091.282.274.282Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3371
 */

const IconExtension = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M14.52 21.153h6.253c.402 0 .707-.107.915-.322.208-.215.312-.53.312-.943V9.43c0-.414-.104-.729-.312-.944-.208-.214-.513-.322-.915-.322h-5.596v.755h5.448c.226 0 .386.047.48.14.094.095.14.252.14.472v10.254c0 .22-.046.38-.14.476-.094.097-.254.145-.48.145h-6.104v.746Zm3.17-8.814h1.605c.144 0 .216-.077.216-.231V10.53c0-.155-.072-.232-.216-.232H17.69c-.15 0-.224.077-.224.232v1.577c0 .154.075.231.224.231Zm0 3.34h1.605c.144 0 .216-.077.216-.232v-1.576c0-.155-.072-.232-.216-.232H17.69c-.15 0-.224.077-.224.232v1.576c0 .155.075.232.224.232Zm0 3.34h1.605c.144 0 .216-.077.216-.231V17.21c0-.155-.072-.232-.216-.232H17.69c-.15 0-.224.077-.224.232v1.577c0 .154.075.231.224.231ZM3 19.888c0 .414.103.728.308.943.205.215.509.322.91.322h10.303c.394 0 .696-.107.905-.322.209-.215.313-.53.313-.943V4.265c0-.414-.104-.728-.313-.943-.21-.215-.51-.322-.905-.322H4.219c-.402 0-.706.107-.911.322-.205.215-.308.53-.308.943v15.623Zm.754-.102V4.366c0-.22.047-.377.141-.47.094-.095.251-.142.472-.142H14.37c.22 0 .377.047.471.141.094.094.141.251.141.472v15.42c0 .22-.047.378-.14.475-.095.097-.252.145-.472.145H4.367c-.22 0-.378-.048-.472-.145-.094-.097-.14-.255-.14-.476Zm2.64.977h.666v-2.697c0-.26.133-.39.398-.39h3.832c.26 0 .39.13.39.39v2.698h.67v-2.8c0-.329-.076-.57-.229-.724-.153-.154-.391-.23-.715-.23H7.338c-.321 0-.559.076-.713.23-.154.154-.232.395-.232.725v2.799ZM6.5 7.947h1.924c.183 0 .275-.095.275-.285V5.769c0-.184-.092-.275-.275-.275H6.501c-.18 0-.271.091-.271.275V7.66c0 .19.09.285.271.285Zm3.81 0h1.924c.183 0 .275-.095.275-.285V5.769c0-.184-.092-.275-.275-.275h-1.924c-.183 0-.274.091-.274.275V7.66c0 .19.091.285.274.285Zm-3.81 3.756h1.924c.183 0 .275-.094.275-.283V9.527c0-.183-.092-.274-.275-.274H6.501c-.18 0-.271.091-.271.274v1.892c0 .189.09.283.271.283Zm3.81 0h1.924c.183 0 .275-.094.275-.283V9.527c0-.183-.092-.274-.275-.274h-1.924c-.183 0-.274.091-.274.274v1.892c0 .189.091.283.274.283Zm-3.81 3.758h1.924c.183 0 .275-.094.275-.282v-1.892c0-.185-.092-.278-.275-.278H6.501c-.18 0-.271.093-.271.278v1.892c0 .188.09.282.271.282Zm3.81 0h1.924c.183 0 .275-.094.275-.282v-1.892c0-.185-.092-.278-.275-.278h-1.924c-.183 0-.274.093-.274.278v1.892c0 .188.091.282.274.282Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2255:3468
 */

const IconExternalLinkThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M2 0h4v1.5H2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-4H16v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2Zm7.5.75c0 .414.336.75.75.75h3.19L6.22 8.72a.75.75 0 0 0 1.06 1.06l7.22-7.22v3.19a.75.75 0 0 0 1.5 0v-5a.75.75 0 0 0-.75-.75h-5a.75.75 0 0 0-.75.75Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3562
 */

const IconExternalLinkRtlThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M14 0h-4v1.5h4a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4H0v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2ZM6.5.75a.75.75 0 0 1-.75.75H2.56l7.22 7.22a.75.75 0 0 1-1.06 1.06L1.5 2.56v3.19a.75.75 0 0 1-1.5 0v-5A.75.75 0 0 1 .75 0h5a.75.75 0 0 1 .75.75Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3439
 */

const IconExternalLinkRtlShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.5 9.166c.277 0 .5.218.5.486v4.306c0 .59.493 1.07 1.1 1.07h11.8c.608 0 1.1-.48 1.1-1.07V2.042c0-.591-.492-1.07-1.1-1.07H9.5A.493.493 0 0 1 9 .486C9 .218 9.224 0 9.5 0h4.4c1.16 0 2.1.914 2.1 2.042v11.916c0 1.127-.94 2.041-2.1 2.041H2.1C.94 16 0 15.085 0 13.958V9.652c0-.268.224-.486.5-.486Zm8.218-.002L1 1.66v3.678a.493.493 0 0 1-.5.486.493.493 0 0 1-.5-.486V.486C0 .218.224 0 .5 0h4.984c.276 0 .5.218.5.486a.493.493 0 0 1-.5.486H1.707l7.718 7.504a.477.477 0 0 1 0 .688.51.51 0 0 1-.707 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2255:3484
 */

const IconExternalLinkShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.5 9.166c-.277 0-.5.218-.5.486v4.306c0 .59-.493 1.07-1.1 1.07H2.1c-.608 0-1.1-.48-1.1-1.07V2.042c0-.591.492-1.07 1.1-1.07h4.4c.276 0 .5-.217.5-.486A.493.493 0 0 0 6.5 0H2.1C.94 0 0 .914 0 2.042v11.916c0 1.127.94 2.041 2.1 2.041h11.8c1.16 0 2.1-.914 2.1-2.041V9.652a.493.493 0 0 0-.5-.486Zm-8.218-.002L15 1.66v3.678c0 .268.224.486.5.486s.5-.218.5-.486V.486A.493.493 0 0 0 15.5 0h-4.984c-.276 0-.5.218-.5.486 0 .269.224.486.5.486h3.777L6.575 8.476a.477.477 0 0 0 0 .688.51.51 0 0 0 .707 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2255:3483
 */

const IconExternalLinkThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6 4h4v1.5H6a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-4H20v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm7.5.75c0 .414.336.75.75.75h3.19l-7.22 7.22a.75.75 0 1 0 1.06 1.06l7.22-7.22v3.19a.75.75 0 0 0 1.5 0v-5a.75.75 0 0 0-.75-.75h-5a.75.75 0 0 0-.75.75Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=270:1583
 */

const IconExternalLink = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M19.5 13.167c-.276 0-.5.217-.5.486v4.305c0 .591-.492 1.07-1.1 1.07H6.1c-.608 0-1.1-.479-1.1-1.07V6.042c0-.591.492-1.07 1.1-1.07h4.4c.276 0 .5-.217.5-.486A.493.493 0 0 0 10.5 4H6.1C4.94 4 4 4.914 4 6.042v11.916C4 19.086 4.94 20 6.1 20h11.8c1.16 0 2.1-.914 2.1-2.042v-4.305a.493.493 0 0 0-.5-.486Zm-8.218-.003L19 5.66v3.678c0 .268.224.486.5.486.277 0 .5-.218.5-.486V4.486A.493.493 0 0 0 19.5 4h-4.983c-.277 0-.5.218-.5.486 0 .269.223.486.5.486h3.776l-7.718 7.504a.477.477 0 0 0 0 .688.51.51 0 0 0 .707 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3567
 */

const IconExternalLinkRtlThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M18 4h-4v1.5h4a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-4H4v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm-7.5.75a.75.75 0 0 1-.75.75H6.56l7.22 7.22a.75.75 0 1 1-1.06 1.06L5.5 6.56v3.19a.75.75 0 0 1-1.5 0v-5A.75.75 0 0 1 4.75 4h5a.75.75 0 0 1 .75.75Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3442
 */

const IconExternalLinkRtl = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M4.5 13.167c.277 0 .5.217.5.486v4.305c0 .591.493 1.07 1.1 1.07h11.8c.608 0 1.1-.479 1.1-1.07V6.042c0-.591-.492-1.07-1.1-1.07h-4.4a.493.493 0 0 1-.5-.486c0-.268.224-.486.5-.486h4.4c1.16 0 2.1.914 2.1 2.042v11.916C20 19.086 19.06 20 17.9 20H6.1C4.94 20 4 19.086 4 17.958v-4.305c0-.269.224-.486.5-.486Zm8.219-.003L5 5.66v3.678a.493.493 0 0 1-.5.486.493.493 0 0 1-.5-.486V4.486C4 4.218 4.224 4 4.5 4h4.984c.276 0 .5.218.5.486a.493.493 0 0 1-.5.486H5.707l7.719 7.504a.477.477 0 0 1 0 .688.51.51 0 0 1-.707 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3630
 */

const IconEyeThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '17',
  viewBox: '0 0 20 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm.75 9.75-.697-.276a.75.75 0 0 0 0 .552L.75 9.75Zm18 0 .697.276a.75.75 0 0 0 0-.552l-.697.276Zm-8.25-9a.75.75 0 0 0-1.5 0h1.5Zm-6.353 4.5.47.584-.47-.584ZM2.794 2.734a.75.75 0 0 0-1.088 1.032l1.088-1.032Zm15 1.032a.75.75 0 0 0-1.088-1.032l1.088 1.032ZM9.75 15.5c-2.932 0-4.994-1.474-6.35-2.999a12.078 12.078 0 0 1-1.847-2.789 6.523 6.523 0 0 1-.106-.238v-.001L.75 9.75l-.697.277.001.002.002.006.008.02a5.135 5.135 0 0 0 .13.291c.09.193.223.463.404.786.36.644.913 1.504 1.681 2.367C3.815 15.224 6.253 17 9.75 17v-1.5Zm9-5.75a101.55 101.55 0 0 1-.697-.276v-.001.001l-.004.01-.019.044a10.456 10.456 0 0 1-.437.871c-.322.575-.814 1.34-1.492 2.102-1.357 1.525-3.419 2.999-6.351 2.999V17c3.496 0 5.935-1.776 7.47-3.501a13.577 13.577 0 0 0 2.087-3.153 7.841 7.841 0 0 0 .129-.292l.008-.019a.126.126 0 0 0 .002-.006v-.002h.001l-.697-.277Zm-9 1.85c-.998 0-1.821-.82-1.821-1.85h-1.5c0 1.842 1.479 3.35 3.321 3.35v-1.5Zm1.821-1.85c0 1.03-.823 1.85-1.821 1.85v1.5c1.842 0 3.321-1.508 3.321-3.35h-1.5ZM9.75 7.9c.998 0 1.821.82 1.821 1.85h1.5c0-1.842-1.479-3.35-3.321-3.35v1.5Zm0-1.5c-1.842 0-3.321 1.508-3.321 3.35h1.5c0-1.03.823-1.85 1.821-1.85V6.4ZM9 .75v2.5h1.5V.75H9Zm-8.25 9 .697.276v.001l.001-.003a1.068 1.068 0 0 1 .038-.088c.028-.066.073-.165.135-.291.124-.253.314-.614.574-1.032.524-.84 1.32-1.892 2.422-2.779l-.94-1.168C2.406 5.689 1.504 6.886.922 7.819c-.292.469-.506.875-.649 1.167a9.329 9.329 0 0 0-.218.483l-.002.003v.001l.697.277Zm3.867-3.916C5.897 4.804 7.581 4 9.75 4V2.5c-2.573 0-4.58.964-6.073 2.166l.94 1.168Zm.074-1.1-1.897-2-1.088 1.032 1.897 2L4.69 4.734ZM9.75 4c2.169 0 3.854.804 5.133 1.834l.94-1.168C14.33 3.464 12.323 2.5 9.75 2.5V4Zm5.133 1.834c1.101.887 1.898 1.94 2.422 2.78a11.54 11.54 0 0 1 .71 1.322 3.738 3.738 0 0 1 .038.091l.697-.277.697-.276v-.002l-.002-.003-.003-.008a2.794 2.794 0 0 0-.054-.127 9.334 9.334 0 0 0-.161-.348 13.007 13.007 0 0 0-.65-1.167c-.581-.932-1.483-2.13-2.754-3.153l-.94 1.168Zm1.014-.068 1.897-2-1.088-1.032-1.897 2 1.088 1.032Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=256:27
 */

const IconEyeThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm3 12-.697-.276a.75.75 0 0 0 0 .552L3 12Zm18 0 .697.276a.75.75 0 0 0 0-.552L21 12Zm-8.25-9a.75.75 0 0 0-1.5 0h1.5ZM6.397 7.5l.47.584-.47-.584ZM5.044 4.984a.75.75 0 0 0-1.088 1.032l1.088-1.032Zm15 1.032a.75.75 0 0 0-1.088-1.032l1.088 1.032ZM12 17.75c-2.932 0-4.994-1.474-6.35-2.999a12.078 12.078 0 0 1-1.847-2.789 6.565 6.565 0 0 1-.102-.229l-.004-.009v-.001L3 12l-.697.277.001.002a.371.371 0 0 0 .01.025 5.042 5.042 0 0 0 .13.292c.09.193.223.463.404.786.36.644.913 1.504 1.681 2.367C6.065 17.474 8.503 19.25 12 19.25v-1.5ZM21 12l-.697-.276v-.001.001l-.004.01-.019.044a10.47 10.47 0 0 1-.437.871c-.322.575-.814 1.34-1.492 2.102-1.357 1.525-3.419 2.999-6.351 2.999v1.5c3.496 0 5.935-1.776 7.47-3.501a13.577 13.577 0 0 0 2.087-3.153 7.841 7.841 0 0 0 .129-.292l.008-.019a.126.126 0 0 0 .002-.006v-.002h.001L21 12Zm-9 1.85c-.998 0-1.821-.82-1.821-1.85h-1.5c0 1.842 1.479 3.35 3.321 3.35v-1.5ZM13.821 12c0 1.03-.823 1.85-1.821 1.85v1.5c1.842 0 3.321-1.508 3.321-3.35h-1.5ZM12 10.15c.998 0 1.821.82 1.821 1.85h1.5c0-1.842-1.479-3.35-3.321-3.35v1.5Zm0-1.5c-1.842 0-3.321 1.508-3.321 3.35h1.5c0-1.03.823-1.85 1.821-1.85v-1.5ZM11.25 3v2.5h1.5V3h-1.5ZM3 12l.697.276v.001l.001-.003a1.068 1.068 0 0 1 .038-.088c.028-.066.073-.165.135-.291.124-.253.314-.614.574-1.032.524-.84 1.32-1.892 2.422-2.779l-.94-1.168c-1.271 1.023-2.173 2.22-2.755 3.153-.292.469-.506.875-.649 1.167a9.374 9.374 0 0 0-.203.446l-.012.029a.992.992 0 0 0-.003.008l-.002.003v.001L3 12Zm3.867-3.916C8.147 7.054 9.831 6.25 12 6.25v-1.5c-2.573 0-4.58.964-6.073 2.166l.94 1.168Zm.074-1.1-1.897-2-1.088 1.032 1.897 2L6.94 6.984ZM12 6.25c2.169 0 3.854.804 5.133 1.834l.94-1.168C16.58 5.714 14.573 4.75 12 4.75v1.5Zm5.133 1.834c1.101.887 1.898 1.94 2.422 2.78a11.528 11.528 0 0 1 .71 1.322 3.623 3.623 0 0 1 .038.091L21 12l.697-.276v-.002l-.002-.003-.003-.008a3.903 3.903 0 0 0-.054-.127 9.394 9.394 0 0 0-.161-.348 13.025 13.025 0 0 0-.65-1.167c-.581-.932-1.483-2.13-2.754-3.153l-.94 1.168Zm1.014-.068 1.897-2-1.088-1.032-1.897 2 1.088 1.032Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3631
 */

const IconEyeClosedThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '11',
  viewBox: '0 0 18 11',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M9 6.943C3.123 6.943.772.772.772.772M9 6.942c5.877 0 8.228-6.17 8.228-6.17M9 6.942v3.086M1.36 7.56l2.35-2.468m10.58 0 2.35 2.468',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3609
 */

const IconEyeClosedShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '10',
  viewBox: '0 0 17 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M8.5 6.5c-5.714 0-8-6-8-6m8 6c5.714 0 8-6 8-6m-8 6v3M1.072 7.1l2.285-2.4m10.286 0 2.285 2.4',
  stroke: 'currentColor',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3608
 */

const IconEyeShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '17',
  viewBox: '0 0 19 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm.5 9.5-.465-.184a.5.5 0 0 0 0 .368L.5 9.5Zm18 0 .465.184a.5.5 0 0 0 0-.368L18.5 9.5ZM10 .5a.5.5 0 0 0-1 0h1ZM3.897 5l.314.39L3.897 5ZM2.363 2.656a.5.5 0 1 0-.726.688l.726-.688Zm15 .688a.5.5 0 0 0-.726-.688l.726.688ZM9.5 15.5c-3.026 0-5.15-1.525-6.537-3.082a12.328 12.328 0 0 1-1.887-2.85 6.78 6.78 0 0 1-.11-.25l-.001-.002L.5 9.5l-.465.184v.001l.001.002a1.634 1.634 0 0 0 .035.083 11.728 11.728 0 0 0 .495.99c.355.633.897 1.477 1.65 2.322C3.722 14.775 6.098 16.5 9.5 16.5v-1Zm9-6a71.391 71.391 0 0 1-.465-.184v.002l-.005.01a4.801 4.801 0 0 1-.106.24 12.33 12.33 0 0 1-1.887 2.85C14.65 13.975 12.527 15.5 9.5 15.5v1c3.402 0 5.778-1.725 7.284-3.418a13.32 13.32 0 0 0 2.046-3.091 7.525 7.525 0 0 0 .125-.282l.007-.017.002-.005v-.002L18.5 9.5Zm-9 2.1c-1.139 0-2.071-.935-2.071-2.1h-1c0 1.707 1.37 3.1 3.071 3.1v-1Zm2.071-2.1c0 1.165-.932 2.1-2.071 2.1v1c1.701 0 3.071-1.393 3.071-3.1h-1ZM9.5 7.4c1.139 0 2.071.935 2.071 2.1h1c0-1.707-1.37-3.1-3.071-3.1v1Zm0-1c-1.702 0-3.071 1.393-3.071 3.1h1c0-1.165.932-2.1 2.071-2.1v-1ZM9 .5V3h1V.5H9Zm-8.5 9 .465.184a.96.96 0 0 1 .009-.022l.033-.076a11.777 11.777 0 0 1 .726-1.355c.533-.855 1.348-1.932 2.478-2.842l-.628-.778C2.341 5.61 1.457 6.784.885 7.7c-.287.46-.498.86-.637 1.145a9.073 9.073 0 0 0-.212.469L.5 9.5Zm3.71-4.11C5.526 4.33 7.265 3.5 9.5 3.5v-1c-2.505 0-4.46.937-5.917 2.11l.628.78Zm.05-.734-1.897-2-.726.688 1.897 2 .726-.688ZM9.5 3.5c2.236 0 3.975.83 5.29 1.89l.627-.78C13.959 3.438 12.005 2.5 9.5 2.5v1Zm5.29 1.89c1.13.91 1.944 1.986 2.477 2.84a11.77 11.77 0 0 1 .726 1.356l.033.076.008.018a.056.056 0 0 1 .001.004 122.64 122.64 0 0 1 .93-.368v-.001l-.002-.003-.003-.007a2.004 2.004 0 0 0-.05-.12 9.046 9.046 0 0 0-.158-.339 12.77 12.77 0 0 0-.637-1.144c-.572-.918-1.456-2.09-2.698-3.091l-.628.778Zm.676-.046 1.897-2-.726-.688-1.897 2 .726.688Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=750:1797
 */

const IconEye = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm3 12-.465-.184a.5.5 0 0 0 0 .368L3 12Zm18 0 .465.184a.5.5 0 0 0 0-.368L21 12Zm-8.5-9a.5.5 0 0 0-1 0h1ZM6.397 7.5l.314.39-.314-.39ZM4.863 5.156a.5.5 0 1 0-.726.688l.726-.688Zm15 .688a.5.5 0 0 0-.726-.688l.726.688ZM12 18c-3.026 0-5.15-1.525-6.537-3.082a12.328 12.328 0 0 1-1.887-2.85 6.778 6.778 0 0 1-.11-.25l-.001-.002L3 12l-.465.184v.001l.001.002a.925.925 0 0 1 .01.022 4.488 4.488 0 0 0 .124.282c.087.187.219.452.396.77.355.632.897 1.476 1.65 2.321C6.222 17.275 8.598 19 12 19v-1Zm9-6a81.802 81.802 0 0 1-.465-.184v.002l-.005.01a5.02 5.02 0 0 1-.106.24 12.33 12.33 0 0 1-1.887 2.85C17.15 16.475 15.027 18 12 18v1c3.402 0 5.778-1.725 7.284-3.418a13.32 13.32 0 0 0 2.046-3.091 7.628 7.628 0 0 0 .125-.282l.007-.017.002-.005v-.002L21 12Zm-9 2.1c-1.139 0-2.071-.935-2.071-2.1h-1c0 1.707 1.37 3.1 3.071 3.1v-1Zm2.071-2.1c0 1.165-.932 2.1-2.071 2.1v1c1.701 0 3.071-1.393 3.071-3.1h-1ZM12 9.9c1.139 0 2.071.935 2.071 2.1h1c0-1.707-1.37-3.1-3.071-3.1v1Zm0-1c-1.701 0-3.071 1.393-3.071 3.1h1c0-1.165.932-2.1 2.071-2.1v-1ZM11.5 3v2.5h1V3h-1ZM3 12a110.301 110.301 0 0 1 .465.184l.001-.004a1.867 1.867 0 0 1 .04-.094 11.777 11.777 0 0 1 .726-1.355c.534-.855 1.349-1.932 2.479-2.842l-.628-.778c-1.242 1-2.126 2.173-2.698 3.09-.287.46-.498.86-.637 1.145a9.12 9.12 0 0 0-.208.459l-.003.007a.118.118 0 0 1-.002.004L3 12Zm3.71-4.11C8.026 6.83 9.765 6 12 6V5c-2.505 0-4.46.937-5.917 2.11l.628.78Zm.05-.734-1.897-2-.726.688 1.897 2 .726-.688ZM12 6c2.236 0 3.975.83 5.29 1.89l.627-.78C16.459 5.938 14.505 5 12 5v1Zm5.29 1.89c1.13.909 1.944 1.986 2.477 2.84a11.768 11.768 0 0 1 .726 1.356l.033.076.008.018a.051.051 0 0 1 .001.004L21 12l.465-.184v-.001l-.002-.003-.003-.007a2.025 2.025 0 0 0-.05-.12 9.09 9.09 0 0 0-.158-.339 12.78 12.78 0 0 0-.637-1.144c-.572-.918-1.456-2.09-2.698-3.091l-.628.778Zm.676-.046 1.897-2-.726-.688-1.897 2 .726.688Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=256:10
 */

const IconEyeClosedThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M12 16c-5.714 0-8-6-8-6m8 6c5.714 0 8-6 8-6m-8 6v3m-7.429-2.4 2.286-2.4m10.286 0 2.286 2.4',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=750:1798
 */

const IconEyeClosed = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M12 16c-5.714 0-8-6-8-6m8 6c5.714 0 8-6 8-6m-8 6v3m-7.429-2.4 2.286-2.4m10.286 0 2.286 2.4',
  stroke: 'currentColor',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1543
 */

const IconFacebookFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M20 10.061C20 4.505 15.523 0 10 0S0 4.505 0 10.061C0 15.083 3.657 19.245 8.438 20v-7.03h-2.54V10.06h2.54V7.845c0-2.522 1.492-3.915 3.777-3.915 1.094 0 2.238.197 2.238.197v2.476h-1.26c-1.243 0-1.63.775-1.63 1.57v1.888h2.773l-.443 2.908h-2.33V20c4.78-.755 8.437-4.917 8.437-9.939',
  fill: '#4267B2'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1542
 */

const IconFacebookFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M22 12.061C22 6.505 17.523 2 12 2S2 6.505 2 12.061c0 5.022 3.657 9.184 8.438 9.939v-7.03h-2.54V12.06h2.54V9.845c0-2.522 1.492-3.915 3.777-3.915 1.094 0 2.238.197 2.238.197v2.476h-1.26c-1.243 0-1.63.775-1.63 1.57v1.888h2.773l-.443 2.908h-2.33V22c4.78-.755 8.437-4.917 8.437-9.939Z',
  fill: '#4267B2'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3670
 */

const IconFilterThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '14',
  viewBox: '0 0 18 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M17.229 2.829H7.457m0 0a2.057 2.057 0 1 0-4.114 0m4.114 0a2.057 2.057 0 1 1-4.114 0m0 0H.77m16.458 8.228h-2.572m0 0a2.057 2.057 0 0 0-4.114 0m4.114 0a2.057 2.057 0 1 1-4.114 0m0 0H.77',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=501:1737
 */

const IconFilterThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M20 8h-9.5m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 8h-2.5m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:883
 */

const IconFilterClearThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '9',
  viewBox: '0 0 14 9',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6.21 3.488a2.233 2.233 0 0 0 .365 1.495H.751A.75.75 0 0 1 0 4.235a.75.75 0 0 1 .751-.747h5.46Zm-.013 4.983H.75A.75.75 0 0 1 0 7.723a.75.75 0 0 1 .751-.747H6.81c-.399.42-.603.956-.613 1.495ZM.75 1.495A.75.75 0 0 1 0 .747.75.75 0 0 1 .751 0h9.504a.75.75 0 0 1 .75.747.75.75 0 0 1-.75.748H.75Zm10.098 3.312 1.869-1.86a.754.754 0 0 1 1.062 0 .745.745 0 0 1 0 1.057l-1.869 1.86 1.869 1.86a.745.745 0 0 1 0 1.057.754.754 0 0 1-1.062 0l-1.869-1.86-1.869 1.86a.754.754 0 0 1-1.062 0 .745.745 0 0 1 0-1.057l1.869-1.86-1.869-1.86a.745.745 0 0 1 0-1.057.754.754 0 0 1 1.062 0l1.87 1.86Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:5064
 */

const IconFilterShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '13',
  viewBox: '0 0 17 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M16.5 2.5H7m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H.5m16 8H14m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H.5',
  stroke: 'currentColor',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=501:1717
 */

const IconFilter = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M20 8h-9.5m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 8h-2.5m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4',
  stroke: 'currentColor',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:880
 */

const IconFilterClearThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.225 10.988a2.233 2.233 0 0 0 .365 1.495H5.766a.75.75 0 0 1-.751-.748.75.75 0 0 1 .75-.747h5.46Zm-.014 4.983H5.766a.75.75 0 0 1-.751-.748.75.75 0 0 1 .75-.747h6.06a2.23 2.23 0 0 0-.614 1.495ZM5.766 8.995a.75.75 0 0 1-.751-.748.75.75 0 0 1 .75-.747h9.504a.75.75 0 0 1 .751.747.75.75 0 0 1-.75.748H5.765Zm10.098 3.312 1.869-1.86a.754.754 0 0 1 1.062 0 .745.745 0 0 1 0 1.057l-1.869 1.86 1.869 1.86a.745.745 0 0 1 0 1.057.754.754 0 0 1-1.062 0l-1.87-1.86-1.868 1.86a.754.754 0 0 1-1.062 0 .745.745 0 0 1 0-1.057l1.869-1.86-1.869-1.86a.745.745 0 0 1 0-1.057.754.754 0 0 1 1.062 0l1.869 1.86Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2291:4398
 */

const IconFlagFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '18',
  viewBox: '0 0 17 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.5 1.5a1 1 0 0 1 1-1h13.316a1 1 0 0 1 .877 1.479L13.761 5.52a1 1 0 0 0 0 .958l1.932 3.542a1 1 0 0 1-.877 1.479H.5v-10Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.5 11.5v-10a1 1 0 0 1 1-1h13.316a1 1 0 0 1 .877 1.479L13.761 5.52a1 1 0 0 0 0 .958l1.932 3.542a1 1 0 0 1-.877 1.479H.5Zm0 0V18',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2291:4409
 */

const IconFlagFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M4.5 5.5a1 1 0 0 1 1-1h13.316a1 1 0 0 1 .877 1.479L17.761 9.52a1 1 0 0 0 0 .958l1.932 3.542a1 1 0 0 1-.878 1.479H4.5v-10Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M4.5 15.5v-10a1 1 0 0 1 1-1h13.316a1 1 0 0 1 .877 1.479L17.761 9.52a1 1 0 0 0 0 .958l1.932 3.542a1 1 0 0 1-.878 1.479H4.5Zm0 0V22',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2291:4401
 */

const IconFlagThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '19',
  viewBox: '0 0 17 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.758 11.877V1.77c0-.558.453-1.01 1.011-1.01h13.46c.767 0 1.254.82.887 1.494l-1.953 3.58a1.011 1.011 0 0 0 0 .969l1.953 3.58a1.01 1.01 0 0 1-.887 1.495H.759Zm0 0v6.57',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2291:4408
 */

const IconFlagThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M4.5 15.5v-10a1 1 0 0 1 1-1h13.316a1 1 0 0 1 .877 1.479L17.761 9.52a1 1 0 0 0 0 .958l1.932 3.542a1 1 0 0 1-.878 1.479H4.5Zm0 0V22',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:5219
 */

const IconFlagShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '18',
  viewBox: '0 0 17 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.5 11.5v-10a1 1 0 0 1 1-1h13.316a1 1 0 0 1 .877 1.479L13.761 5.52a1 1 0 0 0 0 .958l1.932 3.542a1 1 0 0 1-.877 1.479H.5Zm0 0V18',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1000
 */

const IconFlag = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M4.5 15.5v-10a1 1 0 0 1 1-1h13.316a1 1 0 0 1 .877 1.479L17.761 9.52a1 1 0 0 0 0 .958l1.932 3.542a1 1 0 0 1-.878 1.479H4.5Zm0 0V22',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:810
 */

const IconFloorplanThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.001 6.43V2.955c0-.73-.59-1.324-1.322-1.33l-3.735-.03A1.332 1.332 0 0 0 1.6 2.916v.012l.005 3.501h1.316a.799.799 0 1 1 0 1.596H1.608l.007 5.05a1.332 1.332 0 0 0 1.333 1.329h5.055v-1.32a.8.8 0 1 1 1.6 0v1.32h3.464c.736 0 1.333-.596 1.333-1.33V9.355c0-.734-.597-1.33-1.333-1.33H9.603v1.327a.8.8 0 1 1-1.6 0V8.025H6.67a.799.799 0 1 1 0-1.596H8Zm-7.997.797.002-.06L0 2.93v-.028A2.93 2.93 0 0 1 2.956 0l3.736.03a2.93 2.93 0 0 1 2.91 2.926V6.43h3.465A2.93 2.93 0 0 1 16 9.355v3.719A2.93 2.93 0 0 1 13.067 16H2.948a2.93 2.93 0 0 1-2.933-2.922L.007 7.29a.808.808 0 0 1-.003-.063Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:806
 */

const IconFloorplanThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12.002 10.43V6.955c0-.73-.59-1.324-1.323-1.33l-3.735-.03A1.332 1.332 0 0 0 5.6 6.916v.012l.005 3.501h1.316a.799.799 0 1 1 0 1.596H5.608l.007 5.05a1.332 1.332 0 0 0 1.333 1.329h5.055v-1.32a.8.8 0 1 1 1.6 0v1.32h3.464c.736 0 1.333-.596 1.333-1.33v-3.719c0-.734-.597-1.33-1.333-1.33h-3.464v1.327a.8.8 0 1 1-1.6 0v-1.327H10.67a.799.799 0 1 1 0-1.596h1.332Zm-7.998.797.002-.06L4 6.93v-.028A2.93 2.93 0 0 1 6.956 4l3.736.03a2.93 2.93 0 0 1 2.91 2.926v3.473h3.465A2.93 2.93 0 0 1 20 13.355v3.719A2.93 2.93 0 0 1 17.067 20H6.948a2.93 2.93 0 0 1-2.933-2.922l-.008-5.788a.804.804 0 0 1-.003-.063Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1556
 */

const IconFloorplanShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M14 7.001H9.001V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9.001a2 2 0 0 0-2-2ZM9 15v-1.5a.5.5 0 0 0-1 0V15H2a1 1 0 0 1-1-1V8h1.5a.5.5 0 0 0 0-1H1V2a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8.013h5a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H9Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:770
 */

const IconFloorplan = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M18 11.001h-4.999V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4.999a2 2 0 0 0-2-2ZM13 19v-1.5a.5.5 0 0 0-1 0V19H6a1 1 0 0 1-1-1v-6h1.5a.5.5 0 0 0 0-1H5V6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5h-1.5a.5.5 0 0 0 0 1H12v1.5a.5.5 0 0 0 1 0v-1.487h5a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1h-5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2299:5055
 */

const IconFullscreenThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M16 5h-1.5V1.503H11V0h5v5ZM0 11h1.5v3.503H5V16H0v-5Zm11 3.5V16h5v-5h-1.5v3.5H11ZM5 0v1.5H1.501V5H0V0h5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2299:5068
 */

const IconFullscreenThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M20 9h-1.5V5.503H15V4h5v5ZM4 15h1.5v3.503H9V20H4v-5Zm11 3.5V20h5v-5h-1.5v3.5H15ZM9 4v1.5H5.501V9H4V4h5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=195:15
 */

const IconFullscreenShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M16 5h-1V1h-4V0h5v5ZM0 11h1v4h4v1H0v-5Zm11 4v1h5v-5h-1v4h-4ZM5 0v1H1v4H0V0h5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=195:28
 */

const IconFullscreen = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M20 9h-1V5h-4V4h5v5ZM4 15h1v4h4v1H4v-5Zm11 4v1h5v-5h-1v4h-4ZM9 4v1H5v4H4V4h5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:814
 */

const IconFurnitureThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '11',
  viewBox: '0 0 15 11',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12.5 2.5V2a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v.5H1V2a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v.5h-1.5ZM4 8.5v1h7v-1H4ZM4 7h7V6a2 2 0 1 1 4 0v4.75a.25.25 0 0 1-.25.25H.25a.25.25 0 0 1-.25-.25V6a2 2 0 1 1 4 0v1ZM1.5 9.5h1V6a.5.5 0 0 0-1 0v3.5Zm11 0h1V6a.5.5 0 0 0-1 0v3.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:811
 */

const IconFurnitureThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17.5 9.5V9a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v.5H6V9a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v.5h-1.5Zm-8.5 6v1h7v-1H9ZM9 14h7v-1a2 2 0 1 1 4 0v4.75a.25.25 0 0 1-.25.25H5.25a.25.25 0 0 1-.25-.25V13a2 2 0 1 1 4 0v1Zm-2.5 2.5h1V13a.5.5 0 0 0-1 0v3.5Zm11 0h1V13a.5.5 0 0 0-1 0v3.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:531
 */

const IconFurnitureShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '19',
  viewBox: '0 0 18 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12.393 5h4.227l-1.334-4h-1.559l-1.334 4Zm2.614 1v13h-1V6h-2.308a.5.5 0 0 1-.474-.658l1.667-5A.5.5 0 0 1 13.367 0h2.28a.5.5 0 0 1 .474.342l1.853 5A.5.5 0 0 1 17.5 6h-2.493ZM3 17h6.003v-1H3.001v1Zm0 1v1h-2.5L0 13.5a1.5 1.5 0 0 1 2-1.415V9.5A1.5 1.5 0 0 1 3.503 8h5.002a1.5 1.5 0 0 1 1.5 1.5v2.585a1.5 1.5 0 0 1 2 1.415l-.499 5.5h-2.5v-1H3Zm7.004 0h.5l.5-4.5a.5.5 0 0 0-1 0V18ZM2 18v-4.5a.5.5 0 0 0-1 0l.5 4.5H2Zm7.003-3V9.5a.5.5 0 0 0-.5-.5H3.502a.5.5 0 0 0-.5.5V15h6.002Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:527
 */

const IconFurniture = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.393 7.5h4.227l-1.334-4h-1.559l-1.334 4Zm2.614 1v13h-1v-13h-2.308a.5.5 0 0 1-.474-.658l1.667-5a.5.5 0 0 1 .474-.342h2.28a.5.5 0 0 1 .475.342l1.853 5a.5.5 0 0 1-.474.658h-2.493ZM6 19.5h6.003v-1H6.001v1Zm0 1v1h-2.5L3 16a1.5 1.5 0 0 1 2-1.415V12a1.5 1.5 0 0 1 1.502-1.5h5.002a1.5 1.5 0 0 1 1.5 1.5v2.585a1.5 1.5 0 0 1 2 1.415l-.499 5.5h-2.5v-1H6Zm7.004 0h.5l.5-4.5a.5.5 0 0 0-1 0v4.5ZM5 20.5V16a.5.5 0 0 0-1 0l.5 4.5H5Zm7.003-3V12a.5.5 0 0 0-.5-.5H6.502a.5.5 0 0 0-.5.5v5.5h6.002Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1528
 */

const IconGoogleFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48Z',
  fill: '#EA4335'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62Z',
  fill: '#4285F4'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26Z',
  fill: '#FBBC05'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18Z',
  fill: '#34A853'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1526
 */

const IconGoogleFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 6.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C16.46 3.89 14.43 3 12 3 8.48 3 5.44 5.02 3.96 7.96l2.91 2.26C7.6 8.05 9.62 6.48 12 6.48Z',
  fill: '#EA4335'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M20.64 12.2c0-.74-.06-1.28-.19-1.84H12v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62Z',
  fill: '#4285F4'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6.88 13.78a5.54 5.54 0 0 1-.3-1.78c0-.62.11-1.22.29-1.78L3.96 7.96A9.008 9.008 0 0 0 3 12c0 1.45.35 2.82.96 4.04l2.92-2.26Z',
  fill: '#FBBC05'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 21c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74l-2.91 2.26C5.45 18.98 8.48 21 12 21Z',
  fill: '#34A853'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=7:1477
 */

const IconGroupPeopleShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '16',
  viewBox: '0 0 20 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6.667 12.985c.758 0 1.333.69 1.333 1.499V15.5a.5.5 0 0 1-1 0v-1.017c0-.294-.171-.5-.333-.5H1.333c-.162 0-.333.206-.333.5V15.5a.5.5 0 0 1-1 0v-1.017c0-.81.575-1.499 1.333-1.499h5.334Zm12 0c.758 0 1.333.69 1.333 1.499V15.5a.5.5 0 0 1-1 0v-1.017c0-.294-.172-.5-.333-.5h-5.334c-.162 0-.333.206-.333.5V15.5a.5.5 0 0 1-1 0v-1.017c0-.81.575-1.499 1.333-1.499h5.334ZM4 8.99a1.999 1.999 0 1 1-2 1.998c0-1.104.895-1.998 2-1.998Zm12 0a1.999 1.999 0 1 1-2 1.998c0-1.104.895-1.998 2-1.998ZM4 9.989a1 1 0 1 0-.001 1.999 1 1 0 0 0 .001-2Zm12 0a1 1 0 1 0-.001 1.999 1 1 0 0 0 .001-2Zm-3.333-5.994c.758 0 1.333.69 1.333 1.499V6.51a.5.5 0 0 1-1 0V5.494c0-.294-.171-.5-.333-.5H7.333c-.162 0-.333.206-.333.5V6.51a.5.5 0 0 1-1 0V5.494c0-.81.575-1.499 1.333-1.499h5.334ZM10 0a1.999 1.999 0 1 1-2 1.998C8 .894 8.895 0 10 0Zm0 .999a1 1 0 1 0-.001 1.999 1 1 0 0 0 .001-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1170
 */

const IconGroupPeople = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.667 16.985c.758 0 1.333.69 1.333 1.499V19.5a.5.5 0 0 1-1 0v-1.017c0-.294-.171-.5-.333-.5H3.333c-.162 0-.333.206-.333.5V19.5a.5.5 0 0 1-1 0v-1.017c0-.81.575-1.499 1.333-1.499h5.334Zm12 0c.758 0 1.333.69 1.333 1.499V19.5a.5.5 0 0 1-1 0v-1.017c0-.294-.172-.5-.333-.5h-5.334c-.162 0-.333.206-.333.5V19.5a.5.5 0 0 1-1 0v-1.017c0-.81.575-1.499 1.333-1.499h5.334ZM6 12.99a1.999 1.999 0 1 1-2 1.998c0-1.104.895-1.998 2-1.998Zm12 0a1.999 1.999 0 1 1-2 1.998c0-1.104.895-1.998 2-1.998Zm-12 .999a1 1 0 1 0-.001 1.999 1 1 0 0 0 .001-2Zm12 0a1 1 0 1 0-.001 1.999 1 1 0 0 0 .001-2Zm-3.333-5.994c.758 0 1.333.69 1.333 1.499v1.017a.5.5 0 0 1-1 0V9.494c0-.294-.171-.5-.333-.5H9.333c-.162 0-.333.206-.333.5v1.017a.5.5 0 0 1-1 0V9.494c0-.81.575-1.499 1.333-1.499h5.334ZM12 4a1.999 1.999 0 1 1-2 1.998C10 4.894 10.895 4 12 4Zm0 .999a1 1 0 1 0-.001 1.999 1 1 0 0 0 .001-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1243
 */

const IconHangerShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '13',
  viewBox: '0 0 19 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.982 7.159c0 .312-.184.407-.482.502L1.697 9.51a1 1 0 0 0-.697.953V11a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-.538a1 1 0 0 0-.697-.953C12.268 7.881 9.667 7.044 9.5 6.997A.822.822 0 0 1 9 6.24V5a.5.5 0 0 1 .5-.5 1.75 1.75 0 1 0-1.392-2.81.5.5 0 1 1-.796-.607A2.75 2.75 0 1 1 10 5.454v.497c0 .11.07.206.174.239l7.433 2.366A2 2 0 0 1 19 10.462V11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-.538a2 2 0 0 1 1.393-1.906L7.5 6.612a.384.384 0 0 1 .482.249c.012.038 0 .258 0 .298Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1241
 */

const IconHanger = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10.482 12.659c0 .312-.184.407-.482.502L4.197 15.01a1 1 0 0 0-.697.953v.538a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-.538a1 1 0 0 0-.697-.953c-5.035-1.628-7.636-2.465-7.803-2.512a.822.822 0 0 1-.5-.756V10.5a.5.5 0 0 1 .5-.5 1.75 1.75 0 1 0-1.393-2.81.5.5 0 1 1-.795-.607 2.75 2.75 0 1 1 2.688 4.371v.497c0 .11.07.206.174.239l7.433 2.366a2 2 0 0 1 1.393 1.906v.538a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2v-.538a2 2 0 0 1 1.393-1.906L10 12.112a.384.384 0 0 1 .482.249c.012.037 0 .258 0 .298Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1372
 */

const IconHeartFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '16',
  viewBox: '0 0 18 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm1.428 8.899 6.232 6.526a1.85 1.85 0 0 0 2.688-.008l6.224-6.518c1.931-2.022 1.931-5.488-.168-7.492-2.1-2.004-4.949-1.796-6.825.169L9 2.183l-.58-.607C6.546-.39 3.697-.551 1.597 1.407c-2.1 1.959-2.1 5.47-.168 7.492Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1370
 */

const IconHeartFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm4.428 12.899 6.232 6.526a1.85 1.85 0 0 0 2.688-.008l6.224-6.518c1.931-2.022 1.931-5.488-.168-7.492-2.1-2.004-4.949-1.796-6.825.169L12 6.183l-.58-.607C9.546 3.61 6.697 3.449 4.597 5.407c-2.1 1.959-2.1 5.47-.168 7.492Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2272:3487
 */

const IconHeartThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '17',
  viewBox: '0 0 19 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm2.095 9.045 6.394 6.696a1.392 1.392 0 0 0 2.027-.006l6.389-6.69c1.793-1.878 1.79-5.113-.157-6.971-1.94-1.853-4.544-1.668-6.286.156l-.955 1h-.014l-.955-1C6.8.411 4.195.26 2.248 2.078.307 3.887.3 7.164 2.094 9.045Z',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1338
 */

const IconHeartThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm4.79 12.557 6.226 6.52c.552.567 1.43.563 1.974-.006l6.22-6.514c1.746-1.829 1.743-4.979-.152-6.788-1.89-1.804-4.425-1.624-6.121.153l-.93.974h-.014l-.93-.974c-1.69-1.771-4.228-1.918-6.125-.149-1.887 1.761-1.896 4.953-.148 6.784Z',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1361
 */

const IconHeartShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '16',
  viewBox: '0 0 18 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm9 2.131.578-.609c1.927-2.03 5.05-2.03 6.977 0 1.927 2.03 1.927 5.32 0 7.35l-.578.61-5.632 5.932a1.837 1.837 0 0 1-2.69 0L2.023 9.481l-.578-.609c-1.927-2.03-1.927-5.32 0-7.35 1.927-2.03 5.05-2.03 6.977 0l.578.61Zm-1.25.089C6.192.58 3.673.58 2.117 2.22c-1.56 1.643-1.56 4.311 0 5.955l6.21 6.542.005.006a.919.919 0 0 0 1.34-.006l6.21-6.542c1.56-1.644 1.56-4.312 0-5.955-1.557-1.64-4.076-1.64-5.632 0L9 3.537 7.75 2.22Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1357
 */

const IconHeart = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm12 6.131.578-.609c1.927-2.03 5.05-2.03 6.977 0 1.927 2.03 1.927 5.32 0 7.35l-.578.61-5.632 5.932a1.837 1.837 0 0 1-2.69 0l-5.632-5.933-.578-.609c-1.927-2.03-1.927-5.32 0-7.35 1.927-2.03 5.05-2.03 6.977 0l.578.61Zm-1.25.089c-1.557-1.64-4.076-1.64-5.632 0-1.56 1.643-1.56 4.311 0 5.955l6.21 6.542.005.006a.919.919 0 0 0 1.34-.006l6.21-6.542c1.56-1.644 1.56-4.312 0-5.955-1.557-1.64-4.076-1.64-5.632 0L12 7.537 10.75 6.22Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3474
 */

const IconHouseFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M0 15.595V8a3 3 0 0 1 1.08-2.305l6-5a3 3 0 0 1 3.84 0l6 5A3 3 0 0 1 18 8v7.595a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-2.5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2.5a1 1 0 0 1-1 1H2a2 2 0 0 1-2-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3475
 */

const IconHouseFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M3 19.5v-7.595A3 3 0 0 1 4.08 9.6l6-5a3 3 0 0 1 3.84 0l6 5A3 3 0 0 1 21 11.905V19.5a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1V18a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2.5a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3462
 */

const IconHouseThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("mask", {
  id: 'a',
  fill: 'currentColor'
}, /*#__PURE__*/React.createElement("path", {
  d: 'M0 15.595V8a3 3 0 0 1 1.08-2.305l6-5a3 3 0 0 1 3.84 0l6 5A3 3 0 0 1 18 8v7.595a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-2.5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2.5a1 1 0 0 1-1 1H2a2 2 0 0 1-2-2Z'
})), /*#__PURE__*/React.createElement("path", {
  d: 'm16.92 5.695.96-1.152-.96 1.152Zm-6-5 .96-1.152-.96 1.152Zm-3.84 0L6.12-.457 7.08.695Zm-6 5L.12 4.543l.96 1.152ZM-1.5 8v7.595h3V8h-3Zm21 7.595V8h-3v7.595h3ZM17.88 4.543l-6-5-1.92 2.305 6 5 1.92-2.305Zm-11.76-5-6 5 1.92 2.305 6-5L6.12-.457Zm4.38 14.552v2.5h3v-2.5h-3Zm2.5 5h3v-3h-3v3Zm-11 0h3v-3H2v3Zm5.5-2.5v-2.5h-3v2.5h3Zm.5-3h2v-3H8v3Zm-.5.5a.5.5 0 0 1 .5-.5v-3a3.5 3.5 0 0 0-3.5 3.5h3Zm-2.5 5a2.5 2.5 0 0 0 2.5-2.5h-3a.5.5 0 0 1 .5-.5v3Zm5.5-2.5a2.5 2.5 0 0 0 2.5 2.5v-3a.5.5 0 0 1 .5.5h-3Zm3-2.5a3.5 3.5 0 0 0-3.5-3.5v3a.5.5 0 0 1 .5.5h3ZM11.88-.457a4.5 4.5 0 0 0-5.76 0l1.92 2.305a1.5 1.5 0 0 1 1.92 0l1.92-2.305ZM19.5 8a4.5 4.5 0 0 0-1.62-3.457l-1.92 2.305A1.5 1.5 0 0 1 16.5 8h3Zm-3 7.595a.5.5 0 0 1-.5.5v3a3.5 3.5 0 0 0 3.5-3.5h-3Zm-18 0a3.5 3.5 0 0 0 3.5 3.5v-3a.5.5 0 0 1-.5-.5h-3ZM1.5 8a1.5 1.5 0 0 1 .54-1.152L.12 4.543A4.5 4.5 0 0 0-1.5 8h3Z',
  fill: 'currentColor',
  mask: 'url(#a)'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3463
 */

const IconHouseThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("mask", {
  id: 'a',
  fill: 'currentColor'
}, /*#__PURE__*/React.createElement("path", {
  d: 'M3 19.5v-7.595A3 3 0 0 1 4.08 9.6l6-5a3 3 0 0 1 3.84 0l6 5A3 3 0 0 1 21 11.905V19.5a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1V18a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2.5a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2Z'
})), /*#__PURE__*/React.createElement("path", {
  d: 'm19.92 9.6.96-1.152-.96 1.152Zm-6-5 .96-1.152-.96 1.152Zm-3.84 0-.96-1.152.96 1.152Zm-6 5-.96-1.152.96 1.152ZM1.5 11.905V19.5h3v-7.595h-3Zm21 7.595v-7.595h-3V19.5h3ZM20.88 8.448l-6-5-1.92 2.305 6 5 1.92-2.305Zm-11.76-5-6 5 1.92 2.305 6-5-1.92-2.305ZM13.5 18v2.5h3V18h-3Zm2.5 5h3v-3h-3v3ZM5 23h3v-3H5v3Zm5.5-2.5V18h-3v2.5h3Zm.5-3h2v-3h-2v3Zm-.5.5a.5.5 0 0 1 .5-.5v-3A3.5 3.5 0 0 0 7.5 18h3ZM8 23a2.5 2.5 0 0 0 2.5-2.5h-3A.5.5 0 0 1 8 20v3Zm5.5-2.5A2.5 2.5 0 0 0 16 23v-3a.5.5 0 0 1 .5.5h-3Zm3-2.5a3.5 3.5 0 0 0-3.5-3.5v3a.5.5 0 0 1 .5.5h3ZM14.88 3.448a4.5 4.5 0 0 0-5.76 0l1.92 2.305a1.5 1.5 0 0 1 1.92 0l1.92-2.305Zm7.62 8.457a4.5 4.5 0 0 0-1.62-3.457l-1.92 2.305a1.5 1.5 0 0 1 .54 1.152h3Zm-3 7.595a.5.5 0 0 1-.5.5v3a3.5 3.5 0 0 0 3.5-3.5h-3Zm-18 0A3.5 3.5 0 0 0 5 23v-3a.5.5 0 0 1-.5-.5h-3Zm3-7.595a1.5 1.5 0 0 1 .54-1.152L3.12 8.448a4.5 4.5 0 0 0-1.62 3.457h3Z',
  fill: 'currentColor',
  mask: 'url(#a)'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3410
 */

const IconHouseArrowShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '16',
  viewBox: '0 0 20 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M1 13.034V6.892a2 2 0 0 1 .692-1.513l4.5-3.892a2 2 0 0 1 2.616 0l4.5 3.892A2 2 0 0 1 14 6.892v6.142a1 1 0 0 1-1 1h-2v-1.757a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v1.757H2a1 1 0 0 1-1-1Zm-1 0V6.892a3 3 0 0 1 1.038-2.27l4.5-3.891a3 3 0 0 1 3.924 0l4.5 3.892A3 3 0 0 1 15 6.892v6.142a2 2 0 0 1-2 2h-2a1 1 0 0 1-1-1v-1.757a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1.757a1 1 0 0 1-1 1H2a2 2 0 0 1-2-2Zm18.5-1.75h1.232l-.77 1-.331.43-.631.82-.631-.82-.331-.43-.77-1H17.5v-7.5h-1.232l.77-1 .331-.43.631-.82.631.82.331.43.77 1H18.5v7.5ZM16 .534a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm.5 13.5a.5.5 0 1 0 0 1h3a.5.5 0 0 0 0-1h-3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3408
 */

const IconHousePercentageShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '23',
  height: '16',
  viewBox: '0 0 23 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M0 7.046a3.08 3.08 0 0 1 1.052-2.318L5.585.762a3.08 3.08 0 0 1 4.056 0l4.533 3.966a3.08 3.08 0 0 1 1.052 2.318v6.317c0 1.134-.92 2.054-2.054 2.054h-1.994c-.568 0-1.027-.46-1.027-1.027v-1.804c0-1.134-.92-2.054-2.054-2.054H7.13c-1.134 0-2.054.92-2.054 2.054v1.804c0 .567-.46 1.027-1.026 1.027H2.054A2.054 2.054 0 0 1 0 13.363V7.046Zm1.027 6.317V7.046c0-.592.256-1.156.701-1.546l4.533-3.965a2.054 2.054 0 0 1 2.704 0L13.498 5.5c.446.39.701.954.701 1.546v6.317c0 .567-.46 1.027-1.027 1.027h-1.994v-1.804a3.08 3.08 0 0 0-3.08-3.08h-.969a3.08 3.08 0 0 0-3.08 3.08v1.804H2.054c-.567 0-1.027-.46-1.027-1.027Zm15.431-6.845a.52.52 0 0 0-.03.73c.191.209.514.222.721.029l5.196-4.838a.52.52 0 0 0 .03-.73.506.506 0 0 0-.72-.03l-5.197 4.839Zm1.26-3.954a.512.512 0 0 0 .028-.717.498.498 0 0 0-.709-.03.512.512 0 0 0-.028.717c.188.207.506.219.709.03Zm.69.76c.62-.577.66-1.551.09-2.177a1.51 1.51 0 0 0-2.152-.09 1.553 1.553 0 0 0-.089 2.176 1.51 1.51 0 0 0 2.152.09Zm3.438 3.071a.512.512 0 0 1-.029.718.498.498 0 0 1-.709-.03.512.512 0 0 1 .03-.718.498.498 0 0 1 .708.03Zm.752-.7c.57.627.53 1.601-.09 2.177a1.51 1.51 0 0 1-2.151-.09c-.57-.626-.53-1.6.09-2.176a1.51 1.51 0 0 1 2.15.09Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3452
 */

const IconHouseShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("mask", {
  id: 'a',
  fill: 'currentColor'
}, /*#__PURE__*/React.createElement("path", {
  d: 'M0 15.595V8a3 3 0 0 1 1.08-2.305l6-5a3 3 0 0 1 3.84 0l6 5A3 3 0 0 1 18 8v7.595a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-2.5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2.5a1 1 0 0 1-1 1H2a2 2 0 0 1-2-2Z'
})), /*#__PURE__*/React.createElement("path", {
  d: 'm16.92 5.695.64-.768-.64.768Zm-6-5 .64-.768-.64.768Zm-3.84 0-.64-.768.64.768Zm-6 5-.64-.768.64.768ZM-1 8v7.595h2V8h-2Zm20 7.595V8h-2v7.595h2ZM17.56 4.927l-6-5-1.28 1.537 6 5 1.28-1.537Zm-11.12-5-6 5 1.28 1.537 6-5L6.44-.073ZM11 14.095v2.5h2v-2.5h-2Zm2 4.5h3v-2h-3v2Zm-11 0h3v-2H2v2Zm5-2v-2.5H5v2.5h2Zm1-3.5h2v-2H8v2Zm-1 1a1 1 0 0 1 1-1v-2a3 3 0 0 0-3 3h2Zm-2 4.5a2 2 0 0 0 2-2H5v2Zm6-2a2 2 0 0 0 2 2v-2h-2Zm2-2.5a3 3 0 0 0-3-3v2a1 1 0 0 1 1 1h2ZM11.56-.073a4 4 0 0 0-5.12 0l1.28 1.537a2 2 0 0 1 2.56 0l1.28-1.537ZM19 8a4 4 0 0 0-1.44-3.073l-1.28 1.537A2 2 0 0 1 17 8h2Zm-2 7.595a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2Zm-18 0a3 3 0 0 0 3 3v-2a1 1 0 0 1-1-1h-2ZM1 8a2 2 0 0 1 .72-1.536L.44 4.927A4 4 0 0 0-1 8h2Z',
  fill: 'currentColor',
  mask: 'url(#a)'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3453
 */

const IconHouse = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("mask", {
  id: 'a',
  fill: 'currentColor'
}, /*#__PURE__*/React.createElement("path", {
  d: 'M3 19v-7.595A3 3 0 0 1 4.08 9.1l6-5a3 3 0 0 1 3.84 0l6 5A3 3 0 0 1 21 11.405V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-2.5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2V20a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2Z'
})), /*#__PURE__*/React.createElement("path", {
  d: 'm19.92 9.1.64-.768-.64.768Zm-6-5 .64-.768-.64.768Zm-3.84 0-.64-.768.64.768Zm-6 5-.64-.768.64.768ZM2 11.405V19h2v-7.595H2ZM22 19v-7.595h-2V19h2ZM20.56 8.332l-6-5-1.28 1.537 6 5 1.28-1.537Zm-11.12-5-6 5L4.72 9.87l6-5-1.28-1.537ZM14 17.5V20h2v-2.5h-2Zm2 4.5h3v-2h-3v2ZM5 22h3v-2H5v2Zm5-2v-2.5H8V20h2Zm1-3.5h2v-2h-2v2Zm-1 1a1 1 0 0 1 1-1v-2a3 3 0 0 0-3 3h2ZM8 22a2 2 0 0 0 2-2H8v2Zm6-2a2 2 0 0 0 2 2v-2h-2Zm2-2.5a3 3 0 0 0-3-3v2a1 1 0 0 1 1 1h2ZM14.56 3.332a4 4 0 0 0-5.12 0l1.28 1.537a2 2 0 0 1 2.56 0l1.28-1.537ZM22 11.405a4 4 0 0 0-1.44-3.073L19.28 9.87a2 2 0 0 1 .72 1.536h2ZM20 19a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2ZM2 19a3 3 0 0 0 3 3v-2a1 1 0 0 1-1-1H2Zm2-7.595a2 2 0 0 1 .72-1.536L3.44 8.332A4 4 0 0 0 2 11.405h2Z',
  fill: 'currentColor',
  mask: 'url(#a)'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3411
 */

const IconHouseArrow = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M2 18v-6.142a2 2 0 0 1 .692-1.513l4.5-3.891a2 2 0 0 1 2.616 0l4.5 3.891A2 2 0 0 1 15 11.858V18a1 1 0 0 1-1 1h-2v-1.757a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3V19H3a1 1 0 0 1-1-1Zm-1 0v-6.142A3 3 0 0 1 2.038 9.59l4.5-3.892a3 3 0 0 1 3.925 0l4.5 3.892A3 3 0 0 1 16 11.86V18a2 2 0 0 1-2 2h-2a1 1 0 0 1-1-1v-1.757a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2V19a1 1 0 0 1-1 1H3a2 2 0 0 1-2-2Zm18.5-1.75h1.232l-.77 1-.331.43-.631.82-.631-.82-.331-.43-.77-1H18.5v-7.5h-1.232l.77-1 .331-.43L19 6.5l.631.82.331.43.77 1H19.5v7.5ZM17 5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm.5 13.5a.5.5 0 1 0 0 1h3a.5.5 0 0 0 0-1h-3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3409
 */

const IconHousePercentage = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.989 11.848A3 3 0 0 1 2.013 9.59l4.415-3.862a3 3 0 0 1 3.95 0l4.414 3.862a3 3 0 0 1 1.025 2.258V18a2 2 0 0 1-2 2h-1.943a1 1 0 0 1-1-1v-1.757a2 2 0 0 0-2-2h-.943a2 2 0 0 0-2 2V19a1 1 0 0 1-1 1H2.99a2 2 0 0 1-2-2v-6.152Zm1 6.152v-6.152a2 2 0 0 1 .683-1.505L7.086 6.48a2 2 0 0 1 2.634 0l4.414 3.862a2 2 0 0 1 .683 1.505V18a1 1 0 0 1-1 1h-1.943v-1.757a3 3 0 0 0-3-3h-.943a3 3 0 0 0-3 3V19H2.99a1 1 0 0 1-1-1Zm15.028-6.667a.507.507 0 0 0-.03.71c.186.205.5.218.703.03l5.06-4.712a.507.507 0 0 0 .03-.71.493.493 0 0 0-.703-.03l-5.06 4.712Zm1.226-3.85a.498.498 0 0 0 .028-.698.485.485 0 0 0-.69-.03.498.498 0 0 0-.028.698.485.485 0 0 0 .69.03Zm.673.74c.603-.561.642-1.51.087-2.12a1.47 1.47 0 0 0-2.095-.088 1.512 1.512 0 0 0-.087 2.12 1.47 1.47 0 0 0 2.095.088Zm3.348 2.991a.498.498 0 0 1-.028.699.485.485 0 0 1-.69-.03.498.498 0 0 1 .028-.698.485.485 0 0 1 .69.03Zm.732-.681c.554.61.516 1.558-.087 2.12a1.47 1.47 0 0 1-2.095-.088 1.512 1.512 0 0 1 .087-2.12 1.47 1.47 0 0 1 2.095.088Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2113:3090
 */

const IconInfoCircleFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10s4.477 10 10 10 10-4.477 10-10ZM8.982 6.051a.25.25 0 0 1 .25-.25h1.01c.137 0 .249.11.25.248l.006.91a.25.25 0 0 1-.249.251l-1.016.007a.25.25 0 0 1-.251-.25V6.05Zm1.475 7.253h2.038c.165 0 .286.035.365.105.078.07.117.18.117.333 0 .174-.037.293-.111.359-.074.065-.21.098-.41.098H7.532c-.17 0-.296-.038-.381-.114-.085-.076-.127-.19-.127-.343 0-.148.044-.258.133-.33.09-.072.222-.108.4-.108h1.936V9.235H8.254c-.173 0-.305-.039-.396-.117-.091-.078-.137-.192-.137-.34 0-.148.043-.259.127-.333.085-.074.212-.111.381-.111h1.86c.114 0 .204.023.27.07.065.046.098.11.098.19v4.71Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:999
 */

const IconInfoCircleShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10s4.477 10 10 10 10-4.477 10-10ZM1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm7.982-3.949a.25.25 0 0 1 .25-.25h1.01c.137 0 .249.11.25.248l.006.91a.25.25 0 0 1-.249.251l-1.016.007a.25.25 0 0 1-.251-.25V6.05Zm1.475 7.253h2.038c.165 0 .286.035.365.105.078.07.117.18.117.333 0 .173-.037.293-.111.359-.074.065-.21.098-.41.098H7.532c-.17 0-.296-.038-.381-.114-.085-.076-.127-.19-.127-.343 0-.148.044-.258.133-.33.09-.072.222-.108.4-.108h1.936V9.235H8.254c-.173 0-.305-.039-.396-.117-.091-.079-.137-.192-.137-.34 0-.148.043-.259.127-.333.085-.074.212-.111.381-.111h1.86c.114 0 .204.023.27.07.065.046.098.11.098.19v4.71Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2113:3106
 */

const IconInfoCircleFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10ZM10.982 8.051a.25.25 0 0 1 .25-.25h1.01c.137 0 .249.11.25.248l.006.91a.25.25 0 0 1-.249.251l-1.016.007a.25.25 0 0 1-.251-.25V8.05Zm1.475 7.253h2.038c.165 0 .286.035.365.105.078.07.117.18.117.333 0 .174-.037.293-.111.359-.074.065-.21.098-.41.098H9.532c-.17 0-.296-.038-.381-.114-.085-.076-.127-.19-.127-.343 0-.148.044-.258.133-.33.09-.072.222-.108.4-.108h1.936v-4.069h-1.238c-.173 0-.305-.039-.396-.117-.091-.079-.137-.192-.137-.34 0-.148.043-.259.127-.333.085-.074.212-.111.381-.111h1.86a.46.46 0 0 1 .27.07c.065.046.098.11.098.19v4.71Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:991
 */

const IconInfoCircle = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10ZM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm7.982-3.949a.25.25 0 0 1 .25-.25h1.01c.137 0 .249.11.25.248l.006.91a.25.25 0 0 1-.249.251l-1.016.007a.25.25 0 0 1-.251-.25V8.05Zm1.475 7.253h2.038c.165 0 .286.035.365.105.078.07.117.18.117.333 0 .173-.037.293-.111.359-.074.065-.21.098-.41.098H9.532c-.17 0-.296-.038-.381-.114-.085-.076-.127-.19-.127-.343 0-.148.044-.258.133-.33.09-.072.222-.108.4-.108h1.936v-4.069h-1.238c-.173 0-.305-.039-.396-.117-.091-.079-.137-.192-.137-.34 0-.148.043-.259.127-.333.085-.074.212-.111.381-.111h1.86a.46.46 0 0 1 .27.07c.065.046.098.11.098.19v4.71Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1305
 */

const IconInternetSocketShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '16',
  viewBox: '0 0 17 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.5 2h3.518V1a1 1 0 0 1 1-1h6.985a1 1 0 0 1 1 1v1H16.5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-13A.5.5 0 0 1 .5 2ZM1 15h15V3h-3.747a.25.25 0 0 1-.25-.25V1H5.018v1.75a.25.25 0 0 1-.25.25H1v12Zm2-8.01h1.007c0-.549.445-.994.993-.994H6V5a1 1 0 0 1 1-1h3.005a1 1 0 0 1 1 1v.996h1c.549 0 .994.445.994.993H14a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1Zm2.007.75a.25.25 0 0 1-.25.25H3v5h11v-5h-1.752a.25.25 0 0 1-.25-.25v-.743h-1.744a.25.25 0 0 1-.25-.25V5H7v1.747a.25.25 0 0 1-.25.25H5.007v.742ZM6 10H5v2h1v-2Zm1 0h1v2H7v-2Zm3 0H9v2h1v-2Zm1 0h1v2h-1v-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1292
 */

const IconInternetSocket = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M4 6h3.518V5a1 1 0 0 1 1-1h6.985a1 1 0 0 1 1 1v1H20a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-13A.5.5 0 0 1 4 6Zm.5 13h15V7h-3.747a.25.25 0 0 1-.25-.25V5H8.518v1.75a.25.25 0 0 1-.25.25H4.5v12Zm2-8.01h1.007c0-.549.445-.994.993-.994H9.5V9a1 1 0 0 1 1-1h3.005a1 1 0 0 1 1 1v.996h1c.549 0 .994.445.994.993H17.5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1Zm2.007.75a.25.25 0 0 1-.25.25H6.5v5h11v-5h-1.752a.25.25 0 0 1-.25-.25v-.744h-1.744a.25.25 0 0 1-.25-.25V9H10.5v1.746a.25.25 0 0 1-.25.25H8.507v.743ZM9.5 14h-1v2h1v-2Zm1 0h1v2h-1v-2Zm3 0h-1v2h1v-2Zm1 0h1v2h-1v-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=36:0
 */

const IconLayersShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '15',
  viewBox: '0 0 16 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.14 4.582 7.733.074a.515.515 0 0 1 .532 0l7.592 4.508a.284.284 0 0 1 0 .49l-7.592 4.47a.515.515 0 0 1-.532 0L.14 5.071a.284.284 0 0 1 0-.49Zm7.988 3.905 6.254-3.66L8.13 1.13a.258.258 0 0 0-.26 0L1.614 4.828 7.87 8.487c.08.046.18.046.26 0ZM.246 8.03a.473.473 0 0 1-.165-.664.51.51 0 0 1 .688-.159l6.962 4.125a.515.515 0 0 0 .527-.003l6.976-4.234a.51.51 0 0 1 .69.152.473.473 0 0 1-.158.665l-6.975 4.234a1.545 1.545 0 0 1-1.583.008L.246 8.03Zm0 2.632a.473.473 0 0 1-.165-.664.51.51 0 0 1 .688-.16l6.962 4.126a.515.515 0 0 0 .527-.003l6.976-4.234a.51.51 0 0 1 .69.151.473.473 0 0 1-.158.666l-6.975 4.234a1.545 1.545 0 0 1-1.583.008L.246 10.662Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:775
 */

const IconLayers = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm4.14 9.082 7.593-4.508a.515.515 0 0 1 .532 0l7.592 4.508a.284.284 0 0 1 0 .49l-7.592 4.47a.515.515 0 0 1-.532 0L4.14 9.571a.284.284 0 0 1 0-.49Zm7.988 3.905 6.254-3.66L12.13 5.63a.258.258 0 0 0-.26 0L5.614 9.328l6.254 3.659c.08.046.18.046.26 0Zm-7.882-.457a.473.473 0 0 1-.165-.664.51.51 0 0 1 .688-.159l6.962 4.125a.515.515 0 0 0 .527-.003l6.976-4.234a.51.51 0 0 1 .69.152.473.473 0 0 1-.158.665l-6.975 4.234a1.546 1.546 0 0 1-1.583.008L4.246 12.53Zm0 2.632a.473.473 0 0 1-.165-.664.51.51 0 0 1 .688-.16l6.962 4.126a.515.515 0 0 0 .527-.003l6.976-4.234a.51.51 0 0 1 .69.152.473.473 0 0 1-.158.665l-6.975 4.234a1.546 1.546 0 0 1-1.583.008l-6.962-4.124Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3349
 */

const IconLiftShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '17',
  viewBox: '0 0 19 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.124 7.006A.46.46 0 0 0 0 7.315c0 .109.037.2.108.274.071.074.17.111.296.111h1.503v3.671a.327.327 0 0 0 .332.338.328.328 0 0 0 .245-.095.334.334 0 0 0 .093-.243v-3.67h1.498c.13 0 .23-.038.3-.113a.388.388 0 0 0 .105-.276.462.462 0 0 0-.123-.306L2.584 4.86a.444.444 0 0 0-.341-.168.436.436 0 0 0-.349.168L.124 7.006Zm6.208 7.364c0 .706.18 1.241.54 1.605.359.364.892.546 1.6.546h8.385c.707 0 1.241-.182 1.602-.546.36-.364.541-.899.541-1.605V2.15c0-.703-.18-1.238-.541-1.603C18.099.182 17.564 0 16.857 0H8.471c-.707 0-1.24.182-1.6.547-.36.365-.54.9-.54 1.604v12.22Zm.673-.02V2.17c0-.487.126-.858.378-1.113C7.635.8 8.01.674 8.508.674h8.316c.495 0 .87.127 1.121.383.253.255.378.626.378 1.114v12.18c0 .486-.125.858-.378 1.113-.252.256-.626.383-1.121.383H8.508c-.498 0-.873-.127-1.125-.383-.252-.255-.378-.627-.378-1.114Zm1.98-2.084h7.369c.105 0 .18-.03.225-.09a.397.397 0 0 0 .067-.242c0-.217-.08-.503-.24-.857a4.083 4.083 0 0 0-.734-1.068 4.174 4.174 0 0 0-1.241-.904c-.498-.246-1.087-.369-1.765-.369-.68 0-1.27.123-1.767.369-.496.245-.91.547-1.24.904-.33.358-.576.714-.736 1.068-.16.354-.24.64-.24.857 0 .101.022.182.068.242.046.06.124.09.234.09Zm3.68-4.16c.549.002 1.016-.203 1.402-.614.387-.412.58-.926.58-1.542 0-.579-.193-1.077-.58-1.495-.386-.417-.854-.626-1.401-.626-.548 0-1.015.209-1.402.626-.387.418-.58.916-.58 1.495 0 .616.193 1.129.58 1.539.387.41.854.616 1.402.617Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3350
 */

const IconLift = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M3.124 11.006a.46.46 0 0 0-.124.309c0 .109.037.2.108.274.071.074.17.111.296.111h1.503v3.671a.327.327 0 0 0 .332.338.328.328 0 0 0 .245-.095.334.334 0 0 0 .093-.243v-3.67h1.498c.13 0 .23-.038.3-.113a.389.389 0 0 0 .105-.276.462.462 0 0 0-.123-.306L5.585 8.86a.444.444 0 0 0-.342-.168.436.436 0 0 0-.349.168l-1.77 2.145Zm6.208 7.364c0 .706.18 1.241.54 1.605.359.364.892.546 1.6.546h8.385c.707 0 1.241-.182 1.602-.546.36-.364.541-.899.541-1.605V6.15c0-.703-.18-1.238-.541-1.603-.36-.365-.895-.547-1.602-.547h-8.386c-.707 0-1.24.182-1.6.547-.36.365-.54.9-.54 1.604v12.22Zm.673-.02V6.17c0-.487.126-.858.378-1.113.252-.256.627-.383 1.125-.383h8.316c.495 0 .87.127 1.121.383.253.255.378.626.378 1.114v12.18c0 .486-.125.858-.378 1.113-.252.256-.626.383-1.121.383h-8.316c-.498 0-.873-.127-1.125-.383-.252-.255-.378-.627-.378-1.114Zm1.98-2.084h7.369c.105 0 .18-.03.225-.09a.397.397 0 0 0 .067-.242c0-.218-.08-.503-.24-.857a4.083 4.083 0 0 0-.734-1.068 4.174 4.174 0 0 0-1.241-.904c-.498-.246-1.087-.369-1.765-.369-.68 0-1.27.123-1.767.369-.496.245-.91.547-1.24.904-.33.358-.576.714-.736 1.068-.16.354-.24.64-.24.857 0 .101.022.182.068.242.046.06.124.09.234.09Zm3.68-4.16a1.844 1.844 0 0 0 1.402-.614c.387-.412.58-.926.58-1.542 0-.579-.193-1.077-.58-1.495-.386-.417-.854-.626-1.401-.626-.548 0-1.015.209-1.402.626-.387.418-.58.916-.58 1.495 0 .616.193 1.129.58 1.539.387.41.854.616 1.402.617Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3352
 */

const IconLighningFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M14.664 3.5h-4.286L7 12.581h3.977L8.93 20.5 17 10.355h-4.73L14.664 3.5Z',
  fill: 'currentColor',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3358
 */

const IconLighningThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M14.664 3.5h-4.286L7 12.581h3.977L8.93 20.5 17 10.355h-4.73L14.664 3.5Z',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3364
 */

const IconLighning = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M14.664 3.5h-4.286L7 12.581h3.977L8.93 20.5 17 10.355h-4.73L14.664 3.5Z',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3351
 */

const IconLightningFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '11',
  height: '18',
  viewBox: '0 0 11 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M8.164.5H3.878L.5 9.581h3.977L2.43 17.5 10.5 7.355H5.77L8.164.5Z',
  fill: 'currentColor',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3348
 */

const IconLightningThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '12',
  height: '19',
  viewBox: '0 0 12 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M8.642.77H4.24L.77 10.097h4.085L2.753 18.23 11.04 7.81H6.183L8.642.77Z',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3345
 */

const IconLightningShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '11',
  height: '18',
  viewBox: '0 0 11 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M8.164.5H3.878L.5 9.581h3.977L2.43 17.5 10.5 7.355H5.77L8.164.5Z',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2296:4451
 */

const IconListFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '14',
  viewBox: '0 0 17 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M3.889.778H1.815c-.573 0-1.037.464-1.037 1.037v2.074c0 .573.464 1.037 1.037 1.037h2.074c.573 0 1.037-.464 1.037-1.037V1.815c0-.573-.464-1.037-1.037-1.037ZM3.889 9.074H1.815c-.573 0-1.037.464-1.037 1.037v2.074c0 .573.464 1.037 1.037 1.037h2.074c.573 0 1.037-.464 1.037-1.037v-2.074c0-.573-.464-1.037-1.037-1.037Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M8.037 2.852h8.815m-8.815 8.296h8.815M1.815.778h2.074c.573 0 1.037.464 1.037 1.037v2.074c0 .573-.464 1.037-1.037 1.037H1.815A1.037 1.037 0 0 1 .778 3.889V1.815c0-.573.464-1.037 1.037-1.037Zm0 8.296h2.074c.573 0 1.037.464 1.037 1.037v2.074c0 .573-.464 1.037-1.037 1.037H1.815a1.037 1.037 0 0 1-1.037-1.037v-2.074c0-.573.464-1.037 1.037-1.037Z',
  stroke: 'currentColor',
  strokeWidth: '1.5'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2296:4452
 */

const IconListFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M7.5 6h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1ZM7.5 14h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z',
  fill: 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M11.5 8H20m-8.5 8H20M5.5 6h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Z',
  stroke: 'currentColor',
  strokeWidth: '1.5'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2295:4431
 */

const IconListThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '14',
  viewBox: '0 0 17 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M8.037 2.852h8.815m-8.815 8.296h8.815M1.815.778h2.074c.573 0 1.037.464 1.037 1.037v2.074c0 .573-.464 1.037-1.037 1.037H1.815A1.037 1.037 0 0 1 .778 3.889V1.815c0-.573.464-1.037 1.037-1.037Zm0 8.296h2.074c.573 0 1.037.464 1.037 1.037v2.074c0 .573-.464 1.037-1.037 1.037H1.815a1.037 1.037 0 0 1-1.037-1.037v-2.074c0-.573.464-1.037 1.037-1.037Z',
  stroke: 'currentColor',
  strokeWidth: '1.5'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=189:1508
 */

const IconListThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M11.5 8H20m-8.5 8H20M5.5 6h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Z',
  stroke: 'currentColor',
  strokeWidth: '1.5'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2295:4446
 */

const IconListShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '13',
  viewBox: '0 0 16 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M7 2.5h9m-9 8h9M1.5.5h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Z',
  stroke: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2295:4447
 */

const IconList = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M11 8h9m-9 8h9M5.5 6h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Z',
  stroke: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:843
 */

const IconLiveThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '14',
  viewBox: '0 0 20 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M4.108.235a1 1 0 0 0-1.41.12C.915 2.476 0 4.644 0 6.846c0 2.187.902 4.442 2.668 6.76a1 1 0 0 0 1.591-1.21C2.74 10.398 2 8.55 2 6.844c0-1.692.729-3.42 2.229-5.2a1 1 0 0 0-.121-1.41ZM17.3.355a1 1 0 1 0-1.53 1.29c1.5 1.78 2.229 3.508 2.229 5.2 0 1.705-.74 3.554-2.26 5.55a1 1 0 0 0 1.592 1.21C19.097 11.288 20 9.033 20 6.846c0-2.202-.914-4.37-2.699-6.49ZM7.26 2.726a1 1 0 0 0-1.407.143C4.741 4.233 4.164 5.613 4.164 7c0 1.387.577 2.767 1.688 4.132a1 1 0 1 0 1.55-1.264C6.563 8.837 6.165 7.884 6.165 7c0-.884.398-1.837 1.239-2.868a1 1 0 0 0-.144-1.407Zm5.48 0a1 1 0 0 1 1.406.143C15.257 4.233 15.834 5.613 15.834 7c0 1.387-.577 2.767-1.689 4.132a1 1 0 1 1-1.55-1.264c.84-1.031 1.239-1.984 1.239-2.868 0-.884-.399-1.837-1.24-2.868a1 1 0 0 1 .145-1.407Zm-3.967 5.69a2 2 0 1 0 2.828-2.83 2 2 0 0 0-2.828 2.83Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:839
 */

const IconLiveThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6.108 5.235a1 1 0 0 0-1.41.12C2.915 7.476 2 9.644 2 11.846c0 2.187.902 4.442 2.668 6.76a1 1 0 0 0 1.591-1.21C4.74 15.398 4 13.55 4 11.844c0-1.692.729-3.42 2.229-5.2a1 1 0 0 0-.121-1.41Zm13.193.12a1 1 0 1 0-1.53 1.29c1.5 1.78 2.229 3.508 2.229 5.2 0 1.705-.74 3.554-2.26 5.55a1 1 0 0 0 1.592 1.21C21.097 16.288 22 14.033 22 11.846c0-2.202-.914-4.37-2.699-6.49ZM9.26 7.726a1 1 0 0 0-1.407.143C6.741 9.233 6.164 10.613 6.164 12c0 1.387.577 2.767 1.688 4.132a1 1 0 1 0 1.55-1.264c-.84-1.031-1.238-1.984-1.238-2.868 0-.883.398-1.837 1.239-2.868a1 1 0 0 0-.144-1.407Zm5.48 0a1 1 0 0 1 1.406.143c1.112 1.365 1.689 2.745 1.689 4.132 0 1.387-.577 2.767-1.689 4.132a1 1 0 0 1-1.55-1.264c.84-1.031 1.239-1.984 1.239-2.868 0-.883-.399-1.837-1.24-2.868a1 1 0 0 1 .145-1.407Zm-3.967 5.69a2 2 0 1 0 2.829-2.83 2 2 0 0 0-2.829 2.83Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4461
 */

const IconLocationArrowFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M15.257.043a.533.533 0 0 1 .7.7l-6.4 14.934a.533.533 0 0 1-.996-.042L6.51 9.488.366 7.44a.533.533 0 0 1-.042-.996l14.934-6.4Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:838
 */

const IconLocationArrowThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15',
  viewBox: '0 0 15 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M1 7.561A1.266 1.266 0 0 1 .79 5.15L13.259.093a1.266 1.266 0 0 1 1.655 1.633L10.05 14.193a1.266 1.266 0 0 1-2.414-.179l-1.212-5.43L1.001 7.56Zm6.004-.54c.479.102.855.471.967.947l.002.01.996 4.464 4.094-10.496L2.6 6.19l4.405.83Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4285
 */

const IconLocationArrowShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M15.498.502 9.07 15.498 6.93 9.07.502 6.93 15.498.502Z',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:890
 */

const IconLocationGpsThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '17',
  viewBox: '0 0 17 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9.25 16.25a.75.75 0 1 1-1.5 0v-1.544A6.254 6.254 0 0 1 2.294 9.25H.75a.75.75 0 0 1 0-1.5h1.544A6.254 6.254 0 0 1 7.75 2.294V.75a.75.75 0 0 1 1.5 0v1.544a6.254 6.254 0 0 1 5.456 5.456h1.544a.75.75 0 1 1 0 1.5h-1.544a6.254 6.254 0 0 1-5.456 5.456v1.544Zm-1.5-3.058v-.439a.75.75 0 1 1 1.5 0v.439a4.754 4.754 0 0 0 3.942-3.942h-.452a.75.75 0 1 1 0-1.5h.452A4.754 4.754 0 0 0 9.25 3.808v.452a.75.75 0 0 1-1.5 0v-.452A4.754 4.754 0 0 0 3.808 7.75h.439a.75.75 0 1 1 0 1.5h-.439a4.754 4.754 0 0 0 3.942 3.942ZM8.5 10.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3571
 */

const IconLocationArrowFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M19.257 4.043a.533.533 0 0 1 .7.7l-6.4 14.934a.534.534 0 0 1-.996-.042l-2.05-6.147-6.146-2.049a.533.533 0 0 1-.042-.996l14.934-6.4Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:834
 */

const IconLocationArrowThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5.674 12.06a1.232 1.232 0 0 1-.205-2.347L17.604 4.79a1.232 1.232 0 0 1 1.611 1.59l-4.732 12.135a1.233 1.233 0 0 1-2.35-.174l-1.18-5.286-5.28-.995Zm5.843-.527c.466.1.832.46.941.923l.002.009.97 4.345 3.985-10.216L7.23 10.725l4.287.808Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3345
 */

const IconLocationArrow = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm19.5 4.5-6.4 14.933-2.133-6.4-6.4-2.133L19.5 4.5Z',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:886
 */

const IconLocationGpsThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13.249 20.248a.75.75 0 0 1-1.5 0v-1.544a6.253 6.253 0 0 1-5.456-5.455H4.75a.75.75 0 0 1 0-1.5h1.543a6.253 6.253 0 0 1 5.456-5.455V4.75a.75.75 0 1 1 1.5 0v1.544a6.253 6.253 0 0 1 5.455 5.455h1.544a.75.75 0 1 1 0 1.5h-1.544a6.253 6.253 0 0 1-5.455 5.455v1.544Zm-1.5-3.058v-.438a.75.75 0 1 1 1.5 0v.438a4.754 4.754 0 0 0 3.941-3.941h-.451a.75.75 0 0 1 0-1.5h.451a4.754 4.754 0 0 0-3.941-3.941v.451a.75.75 0 0 1-1.5 0v-.451a4.754 4.754 0 0 0-3.941 3.941h.438a.75.75 0 1 1 0 1.5h-.438a4.754 4.754 0 0 0 3.941 3.941Zm.75-2.691a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:712
 */

const IconLotusPlantShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '18',
  viewBox: '0 0 19 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm8.157.917.566-.566a1.2 1.2 0 0 1 1.697 0l.565.566a7.998 7.998 0 0 1 1.928 8.206A7.964 7.964 0 0 1 17 8.002h1.5a.5.5 0 0 1 .5.5v1.5A8 8 0 0 1 11 18H8a8 8 0 0 1-8-7.999v-1.5a.5.5 0 0 1 .5-.5H2c1.569 0 3.032.452 4.267 1.232A7.998 7.998 0 0 1 8.157.917ZM10 17h1a7 7 0 0 0 7-6.999v-1h-1a7 7 0 0 0-7 7v1Zm-1-1a7 7 0 0 0-7-6.999H1v1a7 7 0 0 0 7 7h1v-1Zm.394-14.906-.53.53a6.998 6.998 0 0 0 0 9.898l.53.53a.25.25 0 0 0 .354 0l.53-.53a6.998 6.998 0 0 0 0-9.898l-.53-.53a.25.25 0 0 0-.354 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:708
 */

const IconLotusPlant = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm10.657 3.917.566-.566a1.2 1.2 0 0 1 1.697 0l.565.566a7.998 7.998 0 0 1 1.928 8.206 7.964 7.964 0 0 1 4.087-1.121H21a.5.5 0 0 1 .5.5v1.5a8 8 0 0 1-8 7.998h-3a8 8 0 0 1-8-7.999v-1.5a.5.5 0 0 1 .5-.5h1.5c1.569 0 3.032.452 4.267 1.232a7.998 7.998 0 0 1 1.89-8.316ZM12.5 20h1a7 7 0 0 0 7-6.999v-1h-1a7 7 0 0 0-7 7v1Zm-1-1a7 7 0 0 0-7-6.998h-1v1a7 7 0 0 0 7 6.998h1v-1Zm.394-14.906-.53.53a6.998 6.998 0 0 0 0 9.898l.53.53a.25.25 0 0 0 .354 0l.53-.53a6.998 6.998 0 0 0 0-9.898l-.53-.53a.25.25 0 0 0-.354 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2093:3947
 */

const IconMagnifierFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M10.688 11.465a6.498 6.498 0 1 1 .778-.778l4.373 4.374a.55.55 0 0 1-.778.778l-4.373-4.374Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=724:1759
 */

const IconMagnifierFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M14.688 15.465a6.498 6.498 0 1 1 .778-.778l4.373 4.374a.55.55 0 0 1-.778.778l-4.373-4.374Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:895
 */

const IconMagnifierThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15',
  viewBox: '0 0 15 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm10.74 9.68 4.04 4.04a.75.75 0 1 1-1.06 1.06l-4.04-4.04a6 6 0 1 1 1.06-1.06ZM6 10.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:892
 */

const IconMagnifierThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm15.74 14.68 4.04 4.04a.75.75 0 0 1-1.06 1.06l-4.04-4.04a6 6 0 1 1 1.06-1.06ZM11 15.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1106
 */

const IconMagnifierMinusShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6.998 5.998h2.5a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1h3.5Zm-.5 6.998a6.498 6.498 0 1 1 4.967-2.308l4.374 4.373a.55.55 0 0 1-.778.778l-4.373-4.374a6.472 6.472 0 0 1-4.19 1.531Zm0-1A5.498 5.498 0 1 0 6.498 1a5.498 5.498 0 0 0 0 10.996Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1100
 */

const IconMagnifierPlusShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6.998 5.998h2.5a.5.5 0 1 1 0 1h-2.5v2.5a.5.5 0 1 1-1 0v-2.5h-2.5a.5.5 0 1 1 0-1h2.5v-2.5a.5.5 0 1 1 1 0v2.5Zm3.69 5.467a6.498 6.498 0 1 1 .778-.778l4.373 4.374a.55.55 0 0 1-.778.778l-4.373-4.374Zm-4.19.531A5.498 5.498 0 1 0 6.498 1a5.498 5.498 0 0 0 0 10.996Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1112
 */

const IconMagnifierShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10.688 11.465a6.498 6.498 0 1 1 .778-.778l4.373 4.374a.55.55 0 0 1-.778.778l-4.373-4.374Zm-4.19.531A5.498 5.498 0 1 0 6.498 1a5.498 5.498 0 0 0 0 10.996Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1108
 */

const IconMagnifier = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M14.688 15.465a6.498 6.498 0 1 1 .778-.778l4.373 4.374a.55.55 0 0 1-.778.778l-4.373-4.374Zm-4.19.531a5.498 5.498 0 1 0 0-10.996 5.498 5.498 0 0 0 0 10.996Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1102
 */

const IconMagnifierMinus = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10.998 9.998h2.5a.5.5 0 1 1 0 1h-6a.5.5 0 0 1 0-1h3.5Zm-.5 6.998a6.498 6.498 0 1 1 4.967-2.308l4.374 4.373a.55.55 0 0 1-.778.778l-4.373-4.374a6.472 6.472 0 0 1-4.19 1.531Zm0-1a5.498 5.498 0 1 0 0-10.996 5.498 5.498 0 0 0 0 10.996Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1096
 */

const IconMagnifierPlus = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10.998 9.998h2.5a.5.5 0 1 1 0 1h-2.5v2.5a.5.5 0 1 1-1 0v-2.5h-2.5a.5.5 0 0 1 0-1h2.5v-2.5a.5.5 0 0 1 1 0v2.5Zm3.69 5.467a6.498 6.498 0 1 1 .778-.778l4.373 4.374a.55.55 0 0 1-.778.778l-4.373-4.374Zm-4.19.531a5.498 5.498 0 1 0 0-10.996 5.498 5.498 0 0 0 0 10.996Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=275:510
 */

const IconMapPinFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '20',
  viewBox: '0 0 16 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13.652 2.422c-3.123-3.23-8.18-3.23-11.304 0-3.13 3.238-3.13 8.495 0 11.733L8 20l5.652-5.845c3.13-3.238 3.13-8.495 0-11.733ZM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4110
 */

const IconMapPinThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '19',
  viewBox: '0 0 16 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M14.5 8c0 1.691-.742 3.1-2.124 4.664-.697.789-1.525 1.581-2.461 2.454l-.518.481c-.45.418-.92.853-1.397 1.307-.477-.454-.946-.89-1.397-1.307l-.518-.481c-.936-.873-1.764-1.665-2.46-2.454C2.241 11.099 1.5 9.69 1.5 8a6.5 6.5 0 0 1 13 0Zm-4.09 8.706C9.628 17.43 8.813 18.186 8 19a87.859 87.859 0 0 0-2.41-2.294C2.538 13.873 0 11.519 0 8a8 8 0 1 1 16 0c0 3.519-2.537 5.873-5.59 8.706ZM9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=271:1582
 */

const IconMapPinPlusThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '18',
  viewBox: '0 0 20 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12.586 2.125a7.224 7.224 0 0 1 1.525 2.238 3.131 3.131 0 0 0-1.812 1.154 5.157 5.157 0 0 0-1.207-1.897c-2.04-2.04-5.367-2.022-7.43.041-2.064 2.064-2.083 5.39-.042 7.43l3.694 3.695.963-.963c.494.548 1.176.92 1.943 1.013l-2.922 2.922-5.173-5.172C-.73 9.73-.705 5.072 2.184 2.184 5.072-.705 9.73-.731 12.586 2.125ZM9.551 7.462a2.118 2.118 0 0 1-.858 1.708 2.065 2.065 0 0 1-1.232.405 2.102 2.102 0 0 1-2.09-2.113c0-1.167.936-2.113 2.09-2.113s2.09.946 2.09 2.113Zm6.27-.012v3.135h3.134a1.045 1.045 0 0 1 0 2.09H15.82v3.135a1.045 1.045 0 1 1-2.09 0v-3.135h-3.134a1.045 1.045 0 0 1 0-2.09h3.134V7.45a1.045 1.045 0 0 1 2.09 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1024
 */

const IconMapPinShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '19',
  viewBox: '0 0 16 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm5.657-7.695a7.78 7.78 0 0 1 0 11.13L8 19l-5.657-5.565a7.78 7.78 0 0 1 0-11.13c3.124-3.073 8.19-3.073 11.314 0Zm-.701 10.417a6.78 6.78 0 0 0 0-9.704c-2.736-2.69-7.177-2.69-9.912 0a6.78 6.78 0 0 0 0 9.704L8 17.597l4.956-4.875Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=275:516
 */

const IconMapPinFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17.652 4.422c-3.123-3.23-8.18-3.23-11.304 0-3.13 3.238-3.13 8.495 0 11.733L12 22l5.652-5.845c3.13-3.238 3.13-8.495 0-11.733ZM15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=170:1670
 */

const IconMapPinThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M18.5 10.5c0 1.691-.742 3.1-2.124 4.664-.697.789-1.525 1.581-2.461 2.454l-.518.481c-.45.418-.92.853-1.397 1.307-.477-.454-.946-.89-1.397-1.307l-.518-.481c-.936-.873-1.764-1.665-2.46-2.454C6.241 13.599 5.5 12.19 5.5 10.5a6.5 6.5 0 0 1 13 0Zm-4.09 8.706c-.781.724-1.596 1.48-2.41 2.294a87.801 87.801 0 0 0-2.41-2.294C6.538 16.373 4 14.019 4 10.5a8 8 0 1 1 16 0c0 3.519-2.537 5.873-5.59 8.706ZM13.5 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm1.5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1020
 */

const IconMapPin = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 13.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm5.657-7.695a7.78 7.78 0 0 1 0 11.13L12 21.5l-5.657-5.565a7.78 7.78 0 0 1 0-11.13c3.124-3.073 8.19-3.073 11.314 0Zm-.701 10.417a6.78 6.78 0 0 0 0-9.704c-2.736-2.69-7.177-2.69-9.912 0a6.78 6.78 0 0 0 0 9.704L12 20.097l4.956-4.875Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=271:1606
 */

const IconMapPinPlusThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M14.586 5.246a7.224 7.224 0 0 1 1.525 2.238 3.131 3.131 0 0 0-1.812 1.154 5.157 5.157 0 0 0-1.207-1.897c-2.04-2.04-5.367-2.022-7.43.041-2.064 2.064-2.083 5.39-.042 7.43l3.694 3.695.963-.963c.494.548 1.176.92 1.943 1.013L9.298 20.88l-5.173-5.172c-2.856-2.856-2.83-7.514.059-10.402 2.888-2.89 7.546-2.915 10.402-.059Zm-3.035 5.337a2.118 2.118 0 0 1-.858 1.707 2.065 2.065 0 0 1-1.232.406 2.102 2.102 0 0 1-2.09-2.113c0-1.167.936-2.114 2.09-2.114s2.09.947 2.09 2.114Zm6.27-.012v3.135h3.134a1.045 1.045 0 1 1 0 2.09H17.82v3.135a1.045 1.045 0 1 1-2.09 0v-3.135h-3.134a1.045 1.045 0 0 1 0-2.09h3.134v-3.135a1.045 1.045 0 0 1 2.09 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2996:3343
 */

const IconMenuThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '12',
  viewBox: '0 0 18 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.771.771H17.23M.77 11.057H17.23M.77 5.914H17.23',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2996:3344
 */

const IconMenuThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M4 7h16M4 17h16M4 12h16',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2995:3331
 */

const IconMenuShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '11',
  viewBox: '0 0 17 11',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M.5.5h16m-16 10h16m-16-5h16',
  stroke: 'currentColor',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2995:3339
 */

const IconMenu = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M4 7.5h16m-16 10h16m-16-5h16',
  stroke: 'currentColor',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1156
 */

const IconMezzanineShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '13',
  viewBox: '0 0 20 13',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15 12V4.63l-7.012 7.047V12H15Zm1 0h1V4h-1v8Zm2 0h1.5a.5.5 0 1 1 0 1H7v-.404a.503.503 0 0 1-.012-.106v-1.228L15.212 3H19.5a.5.5 0 0 1 0 1H18v8ZM7.002 9.994h-3v2.996H.5a.5.5 0 0 1 0-1h2.502V8.994h3V5.992h3.006V3.004h2.994V0H19.5a.5.5 0 0 1 0 1h-6.498v3.004h-2.994v2.988H7.002v3.002Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1152
 */

const IconMezzanine = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17 17.5v-7.37l-7.012 7.046v.324H17Zm1 0h1v-8h-1v8Zm2 0h1.5a.5.5 0 1 1 0 1H9v-.404a.503.503 0 0 1-.012-.106v-1.228L17.212 8.5H21.5a.5.5 0 0 1 0 1H20v8ZM9.002 15.494h-3v2.996H2.5a.5.5 0 0 1 0-1h2.502v-2.996h3v-3.002h3.006V8.504h2.994V5.5H21.5a.5.5 0 0 1 0 1h-6.498v3.004h-2.994v2.988H9.002v3.002Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1674:3437
 */

const IconMicrophoneFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '11',
  height: '19',
  viewBox: '0 0 11 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5.5 0a3 3 0 0 0-3 3v7a3 3 0 1 0 6 0V3a3 3 0 0 0-3-3ZM1 9a.5.5 0 0 0-1 0c0 2.078.52 3.71 1.499 4.83.883 1.01 2.097 1.55 3.501 1.652V18H2.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H6v-2.522a5.038 5.038 0 0 0 3.511-1.848C10.474 12.461 11 10.842 11 9a.5.5 0 0 0-1 0c0 1.658-.474 3.039-1.261 3.995-.78.948-1.89 1.505-3.239 1.505-1.384 0-2.486-.457-3.249-1.33C1.481 12.29 1 10.923 1 9Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1674:3440
 */

const IconMicrophoneFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 3a3 3 0 0 0-3 3v7a3 3 0 1 0 6 0V6a3 3 0 0 0-3-3Zm-4.5 9a.5.5 0 0 0-1 0c0 2.078.52 3.71 1.499 4.83.883 1.01 2.097 1.55 3.501 1.652V21H9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-2.5v-2.522a5.039 5.039 0 0 0 3.511-1.848c.963-1.169 1.489-2.788 1.489-4.63a.5.5 0 0 0-1 0c0 1.658-.474 3.039-1.261 3.995-.78.948-1.89 1.505-3.239 1.505-1.384 0-2.486-.457-3.249-1.33C7.981 15.29 7.5 13.923 7.5 12Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1674:3421
 */

const IconMicrophoneShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '11',
  height: '20',
  viewBox: '0 0 11 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M10.5 9.5c0 3.5-2 6-5 6m0 0c-3 0-5-2-5-6m5 6V19m-3 0h6m-3-5.5a3 3 0 0 1-3-3v-7a3 3 0 0 1 6 0v7a3 3 0 0 1-3 3Z',
  stroke: 'currentColor',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1674:3422
 */

const IconMicrophone = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M17 12c0 3.5-2 6-5 6m0 0c-3 0-5-2-5-6m5 6v3.5m-3 0h6M12 16a3 3 0 0 1-3-3V6a3 3 0 1 1 6 0v7a3 3 0 0 1-3 3Z',
  stroke: 'currentColor',
  strokeLinecap: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1334
 */

const IconMinusThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '2',
  viewBox: '0 0 18 2',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17 0a1 1 0 0 1 1 1c0 .513-.343 1-1 .993L1 2a1 1 0 0 1-1-1c0-.513.477-1 1-.993L17 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1332
 */

const IconMinusThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M20 11a1 1 0 0 1 1 1c0 .513-.343 1-1 .993L4 13a1 1 0 0 1-1-1c0-.513.477-1 1-.993L20 11Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:656
 */

const IconMinusShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '1',
  viewBox: '0 0 16 1',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.5 0a.5.5 0 0 1 .5.5.514.514 0 0 1-.5.492L.5 1a.496.496 0 1 1 0-.992L15.5 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:654
 */

const IconMinus = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M19.5 11.5a.5.5 0 0 1 .5.5.514.514 0 0 1-.5.492l-15 .008a.496.496 0 1 1 0-.992l15-.008Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:794
 */

const IconMoneyBillsThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '12',
  viewBox: '0 0 18 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M4.114 9.771v.515h12.343V4.114h-.514V2.571h1.028c.569 0 1.029.46 1.029 1.029v7.2c0 .568-.46 1.029-1.029 1.029H3.6c-.568 0-1.029-.46-1.029-1.029V9.771h1.543Zm3.6-3.6a1.543 1.543 0 1 1 0-3.085 1.543 1.543 0 0 1 0 3.085ZM3.6 5.4a.771.771 0 1 1 0-1.543.771.771 0 0 1 0 1.543Zm8.229 0a.771.771 0 1 1 0-1.543.771.771 0 0 1 0 1.543ZM1.543 1.543v6.171h12.343V1.543H1.543ZM1.029 0H14.4c.568 0 1.029.46 1.029 1.029v7.2c0 .568-.46 1.028-1.029 1.028H1.029C.46 9.257 0 8.797 0 8.23v-7.2C0 .46.46 0 1.029 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3403
 */

const IconMoneyBillsShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '16',
  viewBox: '0 0 18 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M0 1.5A1.5 1.5 0 0 1 1.5 0h15A1.5 1.5 0 0 1 18 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 0 10.5v-9ZM1.5 1a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-15ZM3 3h2v1H4v1H3V3Zm11 1h-1V3h2v2h-1V4ZM6.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM9 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-6 4V7h1v1h1v1H3v-.5ZM15 7v2h-2V8h1V7h1ZM0 13.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5ZM.5 15a.5.5 0 0 0 0 1h17a.5.5 0 0 0 0-1H.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:791
 */

const IconMoneyBillsThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7 15.5v.5h12v-6h-.5V8.5h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-1H7Zm3.5-3.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-4-.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm8 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM4.5 7.5v6h12v-6h-12ZM4 6h13a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=86:155
 */

const IconMoneyBills = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3 5.5A1.5 1.5 0 0 1 4.5 4h15A1.5 1.5 0 0 1 21 5.5v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 14.5v-9ZM4.5 5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-15ZM6 7h2v1H7v1H6V7Zm11 1h-1V7h2v2h-1V8Zm-7.5 2a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM12 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-6 4V11h1v1h1v1H6v-.5ZM18 11v2h-2v-1h1v-1h1ZM3 17.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 0 1h-17a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h17a.5.5 0 0 0 0-1h-17Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:738
 */

const IconMopShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.665 18.919c-.505.947-1.325 1.086-3.865 1.08H.412L.1 19.732a.597.597 0 0 1 .272-.887c.987-.404 1.637-.737 1.926-.974a2.03 2.03 0 0 0 .358-.429c-.022.033.457-.708.63-.942.276-.371.567-.678.916-.943.834-.635 2.32-.707 3.352-.376L11.006.386a.5.5 0 1 1 .974.228l-3.5 15a.504.504 0 0 1-.03.086c.655.713.746 2.222.215 3.219Zm-4.172.08h.309c2.058.005 2.747-.112 2.98-.55.362-.678.265-1.805-.106-2.109-.523-.428-2.173-.518-2.869.011a3.607 3.607 0 0 0-.717.744c-.151.203-.613.917-.607.909-.19.28-.355.477-.549.637a3.866 3.866 0 0 1-.536.359h2.095ZM13 10.51c0-.685.504-1.489 1.5-1.489h2c.996 0 1.5.804 1.5 1.49a.5.5 0 1 0 1 .003c0-1.345-1.016-2.492-2.5-2.492h-2c-1.484 0-2.5 1.147-2.5 2.488a.5.5 0 0 0 1 0ZM20 12h-9l1.02 7.142a1 1 0 0 0 .99.858h4.98a1 1 0 0 0 .99-.858L20 12Zm-6.773 7a.25.25 0 0 1-.248-.214L12.153 13h6.694l-.827 5.785a.25.25 0 0 1-.247.215h-4.546Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:730
 */

const IconMop = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10.665 20.919c-.505.947-1.325 1.086-3.865 1.08H2.412l-.312-.268a.597.597 0 0 1 .272-.887c.987-.404 1.637-.737 1.926-.974a2.03 2.03 0 0 0 .358-.429c-.022.033.457-.708.63-.942.276-.371.567-.678.916-.944.834-.634 2.32-.706 3.352-.375l3.452-14.794a.5.5 0 1 1 .974.228l-3.5 15a.502.502 0 0 1-.03.087c.655.712.746 2.221.215 3.218Zm-4.172.08h.309c2.058.005 2.747-.112 2.98-.55.362-.678.265-1.805-.106-2.109-.523-.428-2.173-.518-2.869.011a3.607 3.607 0 0 0-.717.744c-.151.203-.613.917-.607.909-.19.28-.355.477-.549.637a3.866 3.866 0 0 1-.536.359h2.095ZM15 12.51c0-.685.504-1.489 1.5-1.489h2c.996 0 1.5.804 1.5 1.49a.5.5 0 1 0 1 .003c0-1.345-1.016-2.492-2.5-2.492h-2c-1.484 0-2.5 1.147-2.5 2.488a.5.5 0 0 0 1 0ZM22 14h-9l1.02 7.142a1 1 0 0 0 .99.858h4.98a1 1 0 0 0 .99-.858L22 14Zm-6.773 7a.25.25 0 0 1-.248-.214L14.153 15h6.694l-.827 5.785a.25.25 0 0 1-.247.215h-4.546Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4210
 */

const IconMoreHorizontalThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '4',
  viewBox: '0 0 16 4',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3.613 1.806a1.806 1.806 0 1 1-3.613 0 1.806 1.806 0 0 1 3.613 0Zm6.193 0a1.806 1.806 0 1 1-3.612 0 1.806 1.806 0 0 1 3.612 0Zm4.388 1.807a1.806 1.806 0 1 0 0-3.613 1.806 1.806 0 0 0 0 3.613Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4216
 */

const IconMoreVerticalThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '4',
  height: '16',
  viewBox: '0 0 4 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M1.806 3.613a1.806 1.806 0 1 1 0-3.613 1.806 1.806 0 0 1 0 3.613Zm0 6.193a1.806 1.806 0 1 1 0-3.612 1.806 1.806 0 0 1 0 3.612ZM0 14.194a1.806 1.806 0 1 0 3.613 0 1.806 1.806 0 0 0-3.613 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4214
 */

const IconMoreHorizontalThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.75 12a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm6 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM18 13.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4220
 */

const IconMoreVerticalThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 7.75a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Zm0 6a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5ZM10.25 18a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:623
 */

const IconPalmTreeShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '20',
  viewBox: '0 0 18 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.144 6H12c.79 0 2.066.448 3.951 1.356a4.553 4.553 0 0 0-4.05-3.861l-.025-.002c-.117-.012-.767 0-.966.036a3.5 3.5 0 0 0-1.824.926A3.524 3.524 0 0 0 8.144 6ZM11 7v2.5c0 .818-.393 1.544-1 2V20H9v-7.99h-.983V20h-1v-8.487A2.497 2.497 0 0 1 6 9.5V7c-1.344 0-3.344 1-6 3V7.5a5.5 5.5 0 0 1 5.196-5.492C5.674.838 6.972 0 8.5 0c1.732 0 3.17 1.079 3.45 2.495.009 0 .017.002.025.003L12 2.5c2.838.284 5 2.672 5 5.525V9c-2.575-1.333-4.242-2-5-2h-1Zm-1 0H7v2.5a1.5 1.5 0 0 0 3 0V9H8V8h2V7ZM7.11 6a4.518 4.518 0 0 1 1.248-2.232A3.982 3.982 0 0 0 6 3h-.5A4.5 4.5 0 0 0 1 7.5v.56C3.053 6.694 4.697 6 6 6h1.11Zm3.814-3.485C10.654 1.665 9.692 1 8.5 1c-.943 0-1.742.416-2.168 1.01 1.074.071 2.056.481 2.84 1.124a4.496 4.496 0 0 1 1.752-.62ZM15 17h1v3h-1v-3Zm2 1h1v2h-1v-2Zm-4 0h1v2h-1v-2Zm-2 1h1v1h-1v-1Zm-6 0h1v1H5v-1Zm-2-1h1v2H3v-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:620
 */

const IconPalmTree = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.144 8H15c.79 0 2.066.448 3.951 1.356a4.553 4.553 0 0 0-4.05-3.861l-.025-.002c-.117-.012-.767 0-.966.036a3.5 3.5 0 0 0-1.824.926A3.524 3.524 0 0 0 11.144 8ZM14 9v2.5c0 .818-.393 1.544-1 2V22h-1v-7.99h-.983V22h-1v-8.487A2.497 2.497 0 0 1 9 11.5V9c-1.344 0-3.344 1-6 3V9.5a5.5 5.5 0 0 1 5.196-5.492C8.674 2.838 9.972 2 11.5 2c1.732 0 3.17 1.079 3.45 2.495.009 0 .017.002.025.003L15 4.5c2.838.284 5 2.672 5 5.525V11c-2.575-1.333-4.242-2-5-2h-1Zm-1 0h-3v2.5a1.5 1.5 0 0 0 3 0V11h-2v-1h2V9Zm-2.89-1a4.518 4.518 0 0 1 1.248-2.232A3.982 3.982 0 0 0 9 5h-.5A4.5 4.5 0 0 0 4 9.5v.56C6.053 8.694 7.697 8 9 8h1.11Zm3.814-3.485C13.654 3.665 12.692 3 11.5 3c-.943 0-1.742.416-2.168 1.01 1.074.071 2.056.481 2.84 1.124a4.496 4.496 0 0 1 1.752-.62ZM18 19h1v3h-1v-3Zm2 1h1v2h-1v-2Zm-4 0h1v2h-1v-2Zm-2 1h1v1h-1v-1Zm-6 0h1v1H8v-1Zm-2-1h1v2H6v-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:833
 */

const IconPaperplaneThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '17',
  viewBox: '0 0 17 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.13 8.5 1.797 15.167l2.23-5.376h4.055a.775.775 0 1 0 0-1.55H3.509a.775.775 0 0 0-.715.478l-2.7 6.507a1.292 1.292 0 0 0 1.776 1.637l14.416-7.208a1.292 1.292 0 0 0 0-2.31L1.869.136A1.292 1.292 0 0 0 .086 1.755l1.906 4.956a.775.775 0 1 0 1.446-.556L1.772 1.82 15.13 8.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:832
 */

const IconPaperplaneThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M18.644 12.227 5.738 18.68l2.16-5.203h3.923a.75.75 0 0 0 0-1.5H7.396a.75.75 0 0 0-.692.462L4.09 18.736a1.25 1.25 0 0 0 1.718 1.585l13.953-6.976a1.25 1.25 0 0 0 0-2.236L5.809 4.132A1.25 1.25 0 0 0 4.083 5.7l1.844 4.797a.75.75 0 0 0 1.4-.539L5.716 5.762l12.929 6.465Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:744
 */

const IconParkingSignShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M2 0h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2Zm0 1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2Zm.5 1h13a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5ZM3 3v12h12V3H3Zm3 2h3.018c1.587 0 2.973 1.02 2.973 2.62 0 1.605-1.397 2.388-2.985 2.388h-2v3.447H6V5Zm1.007 1.007V9h1.735c1.207 0 2.26-.255 2.26-1.38 0-1.12-1.047-1.613-2.26-1.613H7.007Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:740
 */

const IconParkingSign = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm0 1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Zm.5 1h13a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5ZM6 6v12h12V6H6Zm3 2h3.018c1.587 0 2.973 1.02 2.973 2.62 0 1.605-1.397 2.388-2.985 2.388h-2v3.447H9V8Zm1.007 1.007V12h1.735c1.207 0 2.26-.255 2.26-1.38 0-1.12-1.047-1.613-2.26-1.613h-1.735Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2100:3968
 */

const IconPhoneFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M16 12.636c0 .205-.038.472-.114.802-.075.329-.155.588-.238.778-.16.379-.621.78-1.387 1.205-.712.386-1.416.579-2.113.579-.205 0-.404-.013-.597-.04a4.91 4.91 0 0 1-.653-.142 9.24 9.24 0 0 1-.54-.165c-.117-.041-.328-.119-.63-.232a23.847 23.847 0 0 0-.558-.205 10.285 10.285 0 0 1-1.988-.943c-.97-.599-1.972-1.415-3.006-2.45-1.034-1.033-1.85-2.035-2.449-3.005A10.292 10.292 0 0 1 .784 6.83a24.19 24.19 0 0 0-.204-.557 44.778 44.778 0 0 1-.233-.63 9.264 9.264 0 0 1-.165-.54 4.911 4.911 0 0 1-.142-.654A4.384 4.384 0 0 1 0 3.852c0-.697.193-1.401.58-2.113C1.004.973 1.405.51 1.784.352c.19-.083.449-.163.778-.238A3.75 3.75 0 0 1 3.365 0c.106 0 .185.011.238.034.137.046.337.333.603.864.083.144.197.348.34.613.144.266.277.506.398.722.121.216.239.419.352.608.023.03.09.125.2.284.11.16.19.294.244.403.053.11.08.218.08.324 0 .152-.109.341-.325.568-.216.228-.45.436-.704.625-.254.19-.489.39-.705.603-.216.212-.324.386-.324.522 0 .069.02.154.057.256.038.102.07.18.097.233.026.053.08.144.159.273.08.129.123.2.13.216.576 1.038 1.235 1.928 1.978 2.67.742.743 1.632 1.402 2.67 1.978.015.007.087.05.216.13s.22.133.273.16c.053.026.13.058.233.096a.767.767 0 0 0 .256.057c.136 0 .31-.108.522-.324.212-.216.413-.451.602-.705.19-.254.398-.488.625-.704.228-.216.417-.324.569-.324a.74.74 0 0 1 .324.08c.11.052.244.134.403.244.16.11.254.176.284.198.19.114.392.232.608.353.216.121.457.254.722.397.265.144.47.258.613.341.53.266.819.466.864.603a.637.637 0 0 1 .034.238Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:657
 */

const IconPhoneFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M20 16.636c0 .205-.038.472-.114.802-.075.329-.155.588-.238.778-.16.379-.622.78-1.387 1.204-.712.387-1.416.58-2.113.58-.205 0-.404-.013-.597-.04a4.91 4.91 0 0 1-.653-.142 9.24 9.24 0 0 1-.54-.165c-.117-.041-.328-.119-.63-.232a24.16 24.16 0 0 0-.557-.205 10.286 10.286 0 0 1-1.99-.943c-.969-.599-1.97-1.415-3.005-2.45-1.034-1.033-1.85-2.035-2.449-3.005a10.293 10.293 0 0 1-.943-1.989c-.023-.068-.09-.253-.204-.556a44.683 44.683 0 0 1-.233-.631 9.26 9.26 0 0 1-.165-.54 4.912 4.912 0 0 1-.142-.653A4.384 4.384 0 0 1 4 7.852c0-.697.193-1.401.58-2.113.424-.766.825-1.228 1.204-1.387.19-.083.449-.163.779-.238a3.75 3.75 0 0 1 .8-.114c.107 0 .186.011.24.034.136.046.336.333.602.864.083.144.197.348.34.613.144.266.277.506.398.722.121.216.239.419.352.608.023.03.09.125.2.284.11.16.19.294.244.403.053.11.08.218.08.324 0 .152-.109.341-.325.568-.216.228-.45.436-.704.625-.254.19-.489.39-.705.603-.216.212-.324.386-.324.523 0 .068.02.153.057.255.038.102.07.18.097.233.026.053.08.144.159.273.08.129.123.2.13.216.576 1.038 1.235 1.928 1.978 2.67.742.743 1.632 1.402 2.67 1.978.015.007.087.05.216.13s.22.133.273.16c.053.026.13.058.233.096a.767.767 0 0 0 .255.057c.137 0 .311-.108.523-.324.212-.216.413-.451.602-.705.19-.254.398-.488.625-.704.228-.216.417-.324.569-.324a.74.74 0 0 1 .324.08c.11.052.244.134.403.244.16.11.254.176.284.198.19.114.392.232.608.353.216.121.457.254.722.397.265.144.47.258.613.341.53.266.819.466.864.603a.637.637 0 0 1 .034.238Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2100:3964
 */

const IconPhoneShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '17',
  viewBox: '0 0 17 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3.04.078A1.52 1.52 0 0 1 3.522 0h.223a1.56 1.56 0 0 1 1.363.817 96.04 96.04 0 0 0 1.441 2.5c.264.446.285.996.053 1.46l-.107.214c-.148.295-.38.52-.636.674-.257.155-.606.397-.84.665-.248.284-.244.439-.195.536.213.425.757 1.373 1.528 2.353.776.986 1.748 1.958 2.805 2.487.234.117.443.234.62.334l.074.04c.202.114.348.192.47.242.122.048.174.048.189.046.002 0 .028 0 .089-.06.19-.19.285-.376.411-.63l.007-.013c.126-.25.283-.566.595-.878.443-.443 1.055-.399 1.407-.328a3.034 3.034 0 0 1 .677.223l.013.007.005.002h.001l.001.001-.226.454.226-.454.018.01 2.337 1.401c.221.133.4.327.516.558l.078.154c.263.528.307 1.14.12 1.7a2.913 2.913 0 0 1-1.264 1.576l-.066.039a6.104 6.104 0 0 1-4.004.809l-.32-.046a7.014 7.014 0 0 1-2.541-.885l-1.217-.71a15.133 15.133 0 0 1-5.91-6.303L.738 7.548a5.573 5.573 0 0 1-.532-1.704L.044 4.713a4.413 4.413 0 0 1 .839-3.272C1.302.882 1.882.464 2.545.243L3.04.078Zm10.21 11.514-.013-.005a2.017 2.017 0 0 0-.417-.135c-.28-.056-.43-.011-.493.052-.189.19-.285.375-.411.628l-.007.013c-.126.252-.283.567-.595.879-.19.19-.418.319-.687.35a1.395 1.395 0 0 1-.682-.112 5.259 5.259 0 0 1-.59-.297l-.075-.042c-.18-.101-.367-.206-.577-.311-1.253-.627-2.335-1.734-3.148-2.766C4.738 8.807 4.157 7.8 3.917 7.319c-.335-.67.011-1.281.337-1.655.34-.388.796-.694 1.08-.866a.657.657 0 0 0 .254-.26l.107-.214a.51.51 0 0 0-.018-.49 96.911 96.911 0 0 1-1.459-2.53.546.546 0 0 0-.474-.29H3.52a.507.507 0 0 0-.16.025l-.496.165c-.467.156-.876.451-1.172.845a3.4 3.4 0 0 0-.646 2.52L1.21 5.7c.07.486.216.956.435 1.395l.724 1.447a14.12 14.12 0 0 0 5.514 5.881l1.217.71c.67.39 1.408.648 2.175.757l.319.046a5.091 5.091 0 0 0 3.34-.675l.065-.039a1.9 1.9 0 0 0 .825-1.028 1.212 1.212 0 0 0-.066-.926l-.077-.154a.347.347 0 0 0-.132-.142l-2.299-1.38Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3478
 */

const IconPhone = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6.688 3.577a1.5 1.5 0 0 1 .474-.077h.22c.57 0 1.08.32 1.345.806.426.779 1.06 1.856 1.423 2.468.26.44.28.982.052 1.44l-.106.211a1.645 1.645 0 0 1-.627.666c-.255.154-.598.392-.83.657-.244.28-.24.432-.192.528.21.42.747 1.356 1.508 2.322.766.973 1.725 1.933 2.769 2.455.23.115.436.23.612.33l.072.04c.2.112.344.19.465.238.12.048.17.047.186.046.002 0 .028 0 .087-.06.187-.188.282-.37.407-.62l.006-.014c.124-.248.28-.559.587-.867.438-.437 1.041-.393 1.39-.324a2.995 2.995 0 0 1 .667.22l.013.007.005.002.001.001h.001L17 14.5l.223-.447.018.008 2.306 1.384c.219.131.396.322.51.55l.076.153c.26.52.303 1.124.12 1.677a2.875 2.875 0 0 1-1.25 1.556l-.064.038a6.026 6.026 0 0 1-3.952.799l-.315-.046a6.92 6.92 0 0 1-2.508-.873l-1.201-.7a14.935 14.935 0 0 1-5.833-6.222l-.714-1.428a5.5 5.5 0 0 1-.526-1.682l-.16-1.116a4.355 4.355 0 0 1 .828-3.228 3.391 3.391 0 0 1 1.64-1.183l.49-.163Zm10.075 11.364a1.993 1.993 0 0 0-.424-.138c-.277-.056-.423-.012-.486.05-.186.188-.28.37-.406.62l-.006.014c-.124.248-.28.559-.588.867a1.137 1.137 0 0 1-.677.346c-.251.03-.482-.034-.674-.11a5.173 5.173 0 0 1-.657-.336c-.177-.1-.36-.203-.569-.307-1.236-.618-2.304-1.711-3.106-2.73a15.892 15.892 0 0 1-1.617-2.493c-.33-.661.01-1.265.333-1.634.334-.383.785-.685 1.065-.855a.648.648 0 0 0 .25-.257l.106-.21a.504.504 0 0 0-.018-.484 95.658 95.658 0 0 1-1.44-2.498.54.54 0 0 0-.467-.286h-.22a.5.5 0 0 0-.158.026l-.49.163a2.391 2.391 0 0 0-1.156.834 3.355 3.355 0 0 0-.637 2.487l.16 1.116a4.5 4.5 0 0 0 .429 1.376l.714 1.428a13.935 13.935 0 0 0 5.442 5.805l1.201.7c.66.386 1.39.64 2.147.748l.315.045a5.025 5.025 0 0 0 3.296-.666l.064-.039c.384-.23.673-.59.814-1.014.1-.302.077-.63-.065-.914l-.075-.152a.343.343 0 0 0-.13-.14l-2.27-1.362Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1201
 */

const IconPhotoCameraShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '15',
  viewBox: '0 0 18 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M2 2.997a1 1 0 0 0-1 1v9.002a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3.997a1 1 0 0 0-1-1h-1.586A2 2 0 0 1 13 2.412L11.588 1H8.414L7.002 2.412a2 2 0 0 1-1.414.585H2Zm0-1h3.588a1 1 0 0 0 .707-.293L7.708.293A1 1 0 0 1 8.414 0h3.174a1 1 0 0 1 .706.292l1.413 1.412a1 1 0 0 0 .707.292H16a2 2 0 0 1 2 2V13A2 2 0 0 1 16 15H2a2 2 0 0 1-2-2V3.996a2 2 0 0 1 2-2Zm8 9.006a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 1a4 4 0 1 1 .001-8 4 4 0 0 1-.001 8ZM2.5 5.001h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1197
 */

const IconPhotoCamera = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5 7.497a1 1 0 0 0-1 1v9.002a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8.497a1 1 0 0 0-1-1h-1.586A2 2 0 0 1 16 6.912L14.588 5.5h-3.173l-1.413 1.412a2 2 0 0 1-1.414.585H5Zm0-1h3.588a1 1 0 0 0 .707-.293l1.413-1.411a1 1 0 0 1 .707-.293h3.173a1 1 0 0 1 .706.292l1.413 1.412a1 1 0 0 0 .707.292H19a2 2 0 0 1 2 2V17.5a2 2 0 0 1-2 2.001H5a2 2 0 0 1-2-2V8.496a2 2 0 0 1 2-2Zm8 9.006a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 1a4 4 0 1 1 .001-8 4 4 0 0 1-.001 8ZM5.5 9.501h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:988
 */

const IconPinterestFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M12.008 2C6.481 2 2 6.474 2 11.992c0 4.235 2.636 7.853 6.36 9.309-.091-.79-.166-2.007.032-2.87.181-.781 1.17-4.967 1.17-4.967s-.297-.6-.297-1.48c0-1.39.807-2.426 1.812-2.426.857 0 1.269.641 1.269 1.406 0 .855-.544 2.138-.832 3.33-.239.995.503 1.81 1.483 1.81 1.779 0 3.146-1.875 3.146-4.573 0-2.393-1.721-4.062-4.184-4.062-2.85 0-4.522 2.13-4.522 4.334 0 .855.329 1.776.74 2.278.083.098.092.189.067.287-.074.313-.247.995-.28 1.135-.041.181-.149.222-.338.132-1.252-.584-2.035-2.401-2.035-3.873 0-3.15 2.29-6.045 6.615-6.045 3.468 0 6.17 2.467 6.17 5.773 0 3.446-2.175 6.217-5.19 6.217-1.013 0-1.969-.526-2.29-1.151l-.626 2.377c-.222.871-.832 1.957-1.244 2.623.94.288 1.928.444 2.966.444C17.519 22 22 17.526 22 12.008 22.016 6.474 17.535 2 12.008 2Z',
  fill: '#E60019'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1055
 */

const IconPlayThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm4 8L8 5.5v9l6-4.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1049
 */

const IconPlayThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm4 8-6-4.5v9l6-4.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2347:3574
 */

const IconPlayShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm1 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10Zm-6.804-.638L14 10l-.804.638L9 13.97l-1 .794V5.237l1 .794 4.196 3.33ZM9 7.308 12.392 10 9 12.693V7.308Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1036
 */

const IconPlay = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm1 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-6.804-.638L16 12l-.804.638L11 15.97l-1 .794V7.237l1 .794 4.196 3.33ZM11 9.308 14.392 12 11 14.693V9.308Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1331
 */

const IconPlusThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9 0c.513 0 1 .507.993 1L10 8h7a1 1 0 0 1 1 1c0 .513-.343 1-1 .993L10 10v7a1 1 0 0 1-1 1c-.513 0-1-.448-.993-1L8 10H1a1 1 0 0 1-1-1c0-.513.503-.936 1-.993L8 8V1a1 1 0 0 1 1-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1329
 */

const IconPlusThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 3c.513 0 1 .507.993 1L13 11h7a1 1 0 0 1 1 1c0 .513-.343 1-1 .993L13 13v7a1 1 0 0 1-1 1c-.513 0-1-.448-.993-1L11 13H4a1 1 0 0 1-1-1c0-.513.503-.935 1-.993L11 11V4a1 1 0 0 1 1-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:653
 */

const IconPlusShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8 0c.245 0 .5.203.5.5v7h7a.5.5 0 0 1 .5.5.514.514 0 0 1-.5.492l-7 .008v7a.5.5 0 0 1-.5.5c-.245 0-.5-.224-.492-.5l-.008-7h-7a.496.496 0 1 1 0-.992l7-.008v-7A.5.5 0 0 1 8 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:651
 */

const IconPlus = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 4c.245 0 .5.203.5.5v7h7a.5.5 0 0 1 .5.5.514.514 0 0 1-.5.492l-7 .008v7a.5.5 0 0 1-.5.5c-.245 0-.5-.224-.492-.5l-.008-7h-7a.496.496 0 1 1 0-.992l7-.008v-7A.5.5 0 0 1 12 4Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:680
 */

const IconPoolLadderShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '18',
  viewBox: '0 0 20 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.013 9.035h5.991V7.038h-5.99v1.997Zm0 .974v4.021c.2-.093.387-.294.68-.678.628-.825 1.031-1.143 1.842-1.143.81 0 1.214.318 1.843 1.143.452.593.65.75 1.04.75a.789.789 0 0 0 .586-.226v-3.867h-5.99Zm0-3.946h5.991v-2.06h-5.99v2.06Zm-1.009 7.755V2.924h.028C6.22 1.494 7.372.516 9.372.016a.507.507 0 0 1 .616.346.483.483 0 0 1-.361.59c-1.563.39-2.387 1.144-2.573 2.076h5.978c.188-1.43 1.34-2.512 3.34-3.012a.507.507 0 0 1 .616.346.483.483 0 0 1-.36.59c-1.793.448-2.615 1.236-2.615 2.402v9.355c.373-.353.736-.5 1.287-.5.811 0 1.214.318 1.843 1.143.452.593.65.75 1.04.75s.588-.157 1.04-.75c.232-.304.413-.28.64-.11.225.17.07.691 0 .788-.072.098-.869 1.046-1.68 1.046-.81 0-1.214-.318-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.587.156-1.04.75c-.089.117-.174.224-.256.321l-.355.372c-.354.316-.707.449-1.231.449-.811 0-1.214-.318-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.588.156-1.04.75c-.629.825-1.032 1.142-1.843 1.142-.81 0-1.214-.318-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.587.156-1.04.75c-.628.825-1.413 1.13-2.224 1.13a.494.494 0 0 1-.5-.487c0-.27.224-.488.5-.488.39 0 .97-.144 1.422-.737.629-.825 1.031-1.143 1.842-1.143.811 0 1.214.318 1.843 1.143.155.203.28.354.392.466Zm13.824 3.106c-.116.326-.834 1.076-1.645 1.076-.81 0-1.214-.317-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.587.156-1.04.75C13.632 17.682 13.23 18 12.418 18c-.811 0-1.214-.317-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.588.156-1.04.75C7.866 17.682 7.463 18 6.652 18c-.81 0-1.214-.317-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.587.156-1.04.75C2.102 17.682 1.312 18 .5 18a.494.494 0 0 1-.5-.487c0-.27.224-.488.5-.488.39 0 .974-.155 1.427-.749.629-.825 1.031-1.142 1.842-1.142.811 0 1.214.317 1.843 1.142.452.594.65.75 1.04.75s.588-.156 1.04-.75c.629-.825 1.032-1.142 1.843-1.142.81 0 1.214.317 1.843 1.142.452.594.65.75 1.04.75s.587-.156 1.04-.75c.628-.825 1.031-1.142 1.842-1.142.811 0 1.214.317 1.843 1.142.452.594.65.75 1.04.75s.588-.156 1.04-.75c.234-.307.37-.326.64-.194.268.133.08.516-.035.842Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:676
 */

const IconPoolLadder = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9.013 12.035h5.991v-1.997h-5.99v1.997Zm0 .974v4.021c.2-.093.387-.294.68-.678.628-.825 1.03-1.143 1.842-1.143.81 0 1.214.318 1.843 1.143.452.593.65.75 1.04.75a.789.789 0 0 0 .586-.226v-3.867h-5.99Zm0-3.946h5.991v-2.06h-5.99v2.06Zm-1.009 7.755V5.924h.028c.188-1.43 1.34-2.408 3.34-2.908a.507.507 0 0 1 .616.346.483.483 0 0 1-.361.59c-1.563.39-2.387 1.144-2.573 2.076h5.978c.188-1.43 1.34-2.512 3.34-3.012a.507.507 0 0 1 .616.346.483.483 0 0 1-.36.59c-1.793.448-2.615 1.236-2.615 2.402v9.355c.373-.353.736-.5 1.287-.5.811 0 1.214.318 1.843 1.143.452.593.65.75 1.04.75s.588-.157 1.04-.75c.232-.304.413-.28.64-.11.225.17.07.691 0 .788-.072.098-.869 1.046-1.68 1.046-.81 0-1.214-.317-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.587.156-1.04.75c-.089.116-.174.224-.256.321l-.355.372c-.354.316-.707.449-1.231.449-.811 0-1.214-.317-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.588.156-1.04.75c-.629.825-1.032 1.142-1.843 1.142-.81 0-1.214-.317-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.587.156-1.04.75c-.628.825-1.413 1.13-2.224 1.13a.494.494 0 0 1-.5-.487c0-.27.224-.488.5-.488.39 0 .97-.143 1.422-.737.629-.825 1.031-1.143 1.842-1.143.811 0 1.214.318 1.843 1.143.155.203.28.354.392.466Zm13.824 3.106c-.116.326-.834 1.076-1.645 1.076-.81 0-1.214-.317-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.587.156-1.04.75C15.632 20.682 15.23 21 14.418 21c-.811 0-1.214-.317-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.588.156-1.04.75C9.866 20.682 9.463 21 8.652 21c-.81 0-1.214-.317-1.843-1.143-.452-.593-.65-.749-1.04-.749s-.587.156-1.04.75C4.102 20.682 3.312 21 2.5 21a.494.494 0 0 1-.5-.487c0-.27.224-.488.5-.488.39 0 .974-.155 1.427-.749.629-.825 1.031-1.142 1.842-1.142.811 0 1.214.317 1.843 1.142.452.594.65.75 1.04.75s.588-.156 1.04-.75c.629-.825 1.032-1.142 1.843-1.142.81 0 1.214.317 1.843 1.142.452.594.65.75 1.04.75s.587-.156 1.04-.75c.628-.825 1.031-1.142 1.842-1.142.811 0 1.214.317 1.843 1.142.452.594.65.75 1.04.75s.588-.156 1.04-.75c.234-.307.37-.326.64-.194.268.133.08.516-.035.842Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1219
 */

const IconReceptionistShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M.947 11.37h16.106v-.945H.947v.944Zm16.106.955V18H.947v-5.675H0V9.474h18v2.85h-.947Zm-15.158 0v4.702h14.21v-4.702H1.895Zm9.473 1.783h.948v.973h-.948v-.973Zm-5.684 0h.948v.973h-.948v-.973ZM9 13.135c.785 0 1.421.654 1.421 1.46 0 .806-.636 1.46-1.421 1.46s-1.421-.654-1.421-1.46c0-.806.636-1.46 1.421-1.46Zm-.474 1.46A.48.48 0 0 0 9 15.08a.48.48 0 0 0 .474-.486.48.48 0 0 0-.474-.487.48.48 0 0 0-.474.487ZM9 4.865c-1.308 0-2.368-1.09-2.368-2.433C6.632 1.09 7.692 0 9 0c1.308 0 2.368 1.089 2.368 2.432 0 1.344-1.06 2.433-2.368 2.433Zm0-.973c.785 0 1.421-.654 1.421-1.46 0-.806-.636-1.459-1.421-1.459s-1.421.653-1.421 1.46c0 .805.636 1.459 1.421 1.459Zm3.628 4.711c-.39-1.134-1.443-1.946-2.68-1.946H8.052c-1.238 0-2.29.812-2.68 1.946h-.99c.42-1.678 1.904-2.919 3.67-2.919h1.894c1.766 0 3.25 1.24 3.67 2.92h-.99Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1215
 */

const IconReceptionist = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M3.947 14.37h16.106v-.945H3.947v.944Zm16.106.955V21H3.947v-5.675H3v-2.851h18v2.85h-.947Zm-15.158 0v4.702h14.21v-4.702H4.895Zm9.473 1.783h.948v.973h-.948v-.973Zm-5.684 0h.948v.973h-.948v-.973ZM12 16.135c.785 0 1.421.654 1.421 1.46 0 .806-.636 1.46-1.421 1.46s-1.421-.654-1.421-1.46c0-.806.636-1.46 1.421-1.46Zm-.474 1.46a.48.48 0 0 0 .474.486.48.48 0 0 0 .474-.486.48.48 0 0 0-.474-.487.48.48 0 0 0-.474.487ZM12 7.865c-1.308 0-2.368-1.09-2.368-2.433C9.632 4.09 10.692 3 12 3c1.308 0 2.368 1.089 2.368 2.432 0 1.344-1.06 2.433-2.368 2.433Zm0-.973c.785 0 1.421-.654 1.421-1.46 0-.806-.636-1.459-1.421-1.459s-1.421.653-1.421 1.46c0 .805.636 1.459 1.421 1.459Zm3.628 4.711c-.39-1.134-1.443-1.946-2.68-1.946h-1.895c-1.238 0-2.29.812-2.68 1.946h-.99c.42-1.678 1.904-2.919 3.67-2.919h1.894c1.766 0 3.25 1.24 3.67 2.92h-.99Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3484
 */

const IconRoadSizeThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '19',
  viewBox: '0 0 16 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5.206.03a.75.75 0 0 1 .515.926l-3 10.5a.75.75 0 0 1-1.442-.412l3-10.5A.75.75 0 0 1 5.206.03Zm5.588 0a.75.75 0 0 1 .927.514l3 10.5a.75.75 0 1 1-1.442.412l-3-10.5a.75.75 0 0 1 .515-.927Zm-7.94 13.367a.5.5 0 0 1 0 .707L1.707 15.25h12.586l-1.147-1.146a.5.5 0 0 1 .708-.707l2 2a.5.5 0 0 1 0 .707l-2 2a.5.5 0 0 1-.708-.707l1.147-1.147H1.707l1.147 1.147a.5.5 0 1 1-.708.707l-2-2a.5.5 0 0 1 0-.707l2-2a.5.5 0 0 1 .708 0ZM8.75 1.25a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Zm0 4a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Zm0 4a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3462
 */

const IconRoadSizeShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '18',
  viewBox: '0 0 16 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5.137.02a.5.5 0 0 1 .344.617l-3 10.5a.5.5 0 1 1-.962-.274l3-10.5a.5.5 0 0 1 .618-.344Zm5.726 0a.5.5 0 0 1 .618.343l3 10.5a.5.5 0 0 1-.962.274l-3-10.5a.5.5 0 0 1 .344-.618Zm-8.01 13.127a.5.5 0 0 1 0 .707L1.708 15h12.586l-1.147-1.146a.5.5 0 1 1 .707-.707l2 2a.5.5 0 0 1 0 .707l-2 2a.5.5 0 0 1-.707-.707L14.293 16H1.707l1.147 1.146a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.707l2-2a.5.5 0 0 1 .708 0ZM8.5 1a.5.5 0 1 0-1 0v1.5a.5.5 0 0 0 1 0V1Zm0 4a.5.5 0 1 0-1 0v1.5a.5.5 0 0 0 1 0V5Zm0 4a.5.5 0 1 0-1 0v1.5a.5.5 0 0 0 1 0V9Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3488
 */

const IconRoadSizeThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9.206 2.779a.75.75 0 0 1 .515.927l-3 10.5a.75.75 0 1 1-1.442-.412l3-10.5a.75.75 0 0 1 .927-.515Zm5.588 0a.75.75 0 0 1 .927.515l3 10.5a.75.75 0 1 1-1.442.412l-3-10.5a.75.75 0 0 1 .515-.927Zm-7.94 13.367a.5.5 0 0 1 0 .707L5.707 18h12.586l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .707l-2 2a.5.5 0 0 1-.708-.707L18.293 19H5.707l1.147 1.146a.5.5 0 1 1-.708.707l-2-2a.5.5 0 0 1 0-.707l2-2a.5.5 0 0 1 .708 0ZM12.75 4a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0V4Zm0 4a.75.75 0 0 0-1.5 0v1.5a.75.75 0 1 0 1.5 0V8Zm0 4a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0V12Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3466
 */

const IconRoadSize = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9.137 3.02a.5.5 0 0 1 .344.617l-3 10.5a.5.5 0 0 1-.962-.274l3-10.5a.5.5 0 0 1 .618-.344Zm5.726 0a.5.5 0 0 1 .618.343l3 10.5a.5.5 0 0 1-.962.274l-3-10.5a.5.5 0 0 1 .344-.618Zm-8.01 13.127a.5.5 0 0 1 0 .707L5.708 18h12.586l-1.147-1.146a.5.5 0 0 1 .708-.707l2 2a.5.5 0 0 1 0 .707l-2 2a.5.5 0 0 1-.708-.707L18.293 19H5.707l1.147 1.146a.5.5 0 1 1-.708.708l-2-2a.5.5 0 0 1 0-.707l2-2a.5.5 0 0 1 .708 0ZM12.5 4a.5.5 0 0 0-1 0v1.5a.5.5 0 0 0 1 0V4Zm0 4a.5.5 0 0 0-1 0v1.5a.5.5 0 0 0 1 0V8Zm0 4a.5.5 0 0 0-1 0v1.5a.5.5 0 1 0 1 0V12Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:594
 */

const IconRoomShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '18',
  viewBox: '0 0 20 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5 15.01h6V9c0-1.642 1.349-2.974 3.012-2.974A2.971 2.971 0 0 1 17 9v6.01H19V4.237a.25.25 0 0 0-.25-.25H5V15.01ZM20 4v11.997h-3.998V9a1.98 1.98 0 0 0-1.99-1.987C12.901 7.013 12 7.903 12 9v6.997H5L.757 17.93a.504.504 0 0 1-.686-.17.489.489 0 0 1-.071-.254V.494C0 .22.224 0 .5 0c.09 0 .18.024.257.07L5 3h14a1 1 0 0 1 1 1ZM4 3.559 1 1.365v15.27l3-1.197V3.558Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:591
 */

const IconRoom = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7 18.01h6V12c0-1.642 1.349-2.974 3.012-2.974A2.971 2.971 0 0 1 19 12v6.01H21V7.237a.25.25 0 0 0-.25-.25H7V18.01ZM22 7v11.997h-3.998V12a1.98 1.98 0 0 0-1.99-1.987c-1.111 0-2.012.89-2.012 1.987v6.997H7L2.757 20.93a.504.504 0 0 1-.686-.17.489.489 0 0 1-.071-.254V3.494C2 3.22 2.224 3 2.5 3c.09 0 .18.024.257.07L7 6h14a1 1 0 0 1 1 1ZM6 6.559 3 4.365v15.27l3-1.197V6.558Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3892
 */

const IconShareThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '18',
  viewBox: '0 0 14 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.509.199a.75.75 0 0 0-1.04.02l-3 3A.75.75 0 0 0 4.53 4.28l1.72-1.72v7.69a.75.75 0 0 0 1.5 0V2.463l1.991 1.838A.75.75 0 1 0 10.76 3.2l-3.25-3ZM2 5.75h2v1.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2v-1.5h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1306
 */

const IconShareThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12.509 2.449a.75.75 0 0 0-1.04.02l-3 3A.75.75 0 0 0 9.53 6.53l1.72-1.72v7.69a.75.75 0 0 0 1.5 0V4.713l1.991 1.838A.75.75 0 1 0 15.76 5.45l-3.25-3ZM7 8h2v1.5H7a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2V8h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3891
 */

const IconShareAltThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '15',
  viewBox: '0 0 19 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M11.398 10.413c-3.796 0-7.591.742-10.628 3.709 0-5.934 6.832-9.643 10.628-9.643V.77l6.832 6.676-6.832 6.676v-3.71Z',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3543
 */

const IconShareAltRtlThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '15',
  viewBox: '0 0 19 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M7.602 10.413c3.796 0 7.591.742 10.628 3.709 0-5.934-6.832-9.643-10.628-9.643V.77L.77 7.446l6.832 6.676v-3.71Z',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3497
 */

const IconShareAltRtlShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '14',
  viewBox: '0 0 18 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M7.152 9.889c3.696 0 7.391.722 10.348 3.611 0-5.778-6.652-9.389-10.348-9.389V.5L.5 7l6.652 6.5V9.889Z',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3745
 */

const IconShareAltShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '14',
  viewBox: '0 0 18 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M10.848 9.889C7.152 9.889 3.457 10.61.5 13.5c0-5.778 6.652-9.389 10.348-9.389V.5L17.5 7l-6.652 6.5V9.889Z',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3752
 */

const IconShareShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '18',
  viewBox: '0 0 14 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.34.133a.5.5 0 0 0-.694.013l-3 3a.5.5 0 1 0 .708.708L6.5 1.707V10a.5.5 0 0 0 1 0V1.642l2.41 2.225a.5.5 0 1 0 .68-.734l-3.25-3ZM2 6h2v1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-2V6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1343
 */

const IconShare = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12.34 2.133a.5.5 0 0 0-.694.013l-3 3a.5.5 0 1 0 .708.708L11.5 3.707V12a.5.5 0 0 0 1 0V3.642l2.41 2.225a.5.5 0 1 0 .68-.734l-3.25-3ZM7 8h2v1H7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-2V8h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3947
 */

const IconShareAltThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M13.848 13.889c-3.696 0-7.391.722-10.348 3.611 0-5.778 6.652-9.389 10.348-9.389V4.5L20.5 11l-6.652 6.5v-3.611Z',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3849
 */

const IconShareAlt = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M13.848 13.889c-3.696 0-7.391.722-10.348 3.611 0-5.778 6.652-9.389 10.348-9.389V4.5L20.5 11l-6.652 6.5v-3.611Z',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3544
 */

const IconShareAltRtlThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M10.152 13.889c3.696 0 7.392.722 10.348 3.611 0-5.778-6.652-9.389-10.348-9.389V4.5L3.5 11l6.652 6.5v-3.611Z',
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3498
 */

const IconShareAltRtl = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M10.152 13.889c3.696 0 7.392.722 10.348 3.611 0-5.778-6.652-9.389-10.348-9.389V4.5L3.5 11l6.652 6.5v-3.611Z',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2097:3909
 */

const IconShieldCheckmarkFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.735.07a.533.533 0 0 1 .53 0l7.466 4.267A.533.533 0 0 1 16 4.8v.768c0 4.835-3.205 9.083-7.853 10.412a.534.534 0 0 1-.294 0A10.828 10.828 0 0 1 0 5.567V4.8c0-.191.103-.368.269-.463L7.735.07Zm-.192 11.355 4.607-5.759L11.317 5 7.39 9.91 4.608 7.59l-.683.82 3.618 3.015Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2097:3931
 */

const IconShieldCheckmarkShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm4.251 8 3.213 2.678 4.285-5.356M8 .502.502 4.787v.77c0 4.616 3.06 8.673 7.498 9.94a10.338 10.338 0 0 0 7.498-9.94v-.77L8 .502Z',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:719
 */

const IconShieldShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '18',
  viewBox: '0 0 15 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.468 4c1.656 0 3.825.756 6.532 2.258V3.546C11.457 1.932 8.909 1 7.5 1 6.069 1 3.456 1.95 1 3.54v2.683C3.677 4.745 5.825 4 7.468 4Zm0 1c-1.53 0-3.691.784-6.456 2.363.18 2.64 2.316 5.773 6.489 9.333 4.154-3.538 6.29-6.659 6.484-9.298C11.191 5.795 9.01 5 7.468 5ZM0 3.004C3.042.922 6.016 0 7.5 0s4.362.91 7.5 3.004v4C15 10.225 12.5 13.89 7.5 18 2.5 13.883 0 10.218 0 7.004v-4Zm4.658 6.962a.5.5 0 0 1-.316-.949C5.395 8.667 6.451 8 7.508 8s2.113.667 3.166 1.017a.5.5 0 0 1-.316.95C9.406 9.65 8.456 9 7.508 9c-.948 0-1.898.65-2.85.966Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:715
 */

const IconShield = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.968 7c1.656 0 3.825.756 6.532 2.258V6.546C15.957 4.932 13.409 4 12 4c-1.431 0-4.044.95-6.5 2.54v2.683C8.177 7.745 10.325 7 11.968 7Zm0 1c-1.53 0-3.691.784-6.456 2.363.18 2.64 2.316 5.773 6.489 9.333 4.154-3.538 6.29-6.659 6.484-9.298C15.691 8.795 13.51 8 11.968 8ZM4.5 6.004C7.542 3.922 10.516 3 12 3s4.362.91 7.5 3.004v4C19.5 13.225 17 16.89 12 21c-5-4.117-7.5-7.782-7.5-10.996v-4Zm4.658 6.962a.5.5 0 0 1-.316-.949C9.895 11.667 10.951 11 12.008 11s2.113.667 3.166 1.017a.5.5 0 0 1-.316.95c-.952-.317-1.902-.967-2.85-.967-.948 0-1.898.65-2.85.966Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2097:3908
 */

const IconShieldCheckmarkFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.735 4.07a.533.533 0 0 1 .53 0l7.466 4.267A.533.533 0 0 1 20 8.8v.768c0 4.835-3.205 9.083-7.854 10.412a.534.534 0 0 1-.293 0A10.828 10.828 0 0 1 4 9.568V8.8c0-.191.103-.368.269-.463l7.466-4.267Zm-.192 11.355 4.607-5.759L15.317 9 11.39 13.91 8.608 11.59l-.683.82 3.618 3.015Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2097:3932
 */

const IconShieldCheckmark = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm8.267 12 3.2 2.667 4.266-5.334M12 4.533 4.533 8.8v.768c0 4.596 3.047 8.636 7.467 9.899a10.295 10.295 0 0 0 7.467-9.9V8.8L12 4.533Z',
  stroke: 'currentColor',
  strokeLinejoin: 'round'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:612
 */

const IconSnowFlakeShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '19',
  viewBox: '0 0 19 19',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.05 10H4l-2.293 2.336L1 11.63 2.629 10H0V9h2.629L.943 7.34l.707-.708L4 9h3.05c.07-.343.21-.661.405-.938L5.554 6.02H2.25v-1h2.304l-1.86-1.859.708-.707 1.621 1.621V2.247L6 2.192V5.02l2.177 2.358c.249-.155.526-.268.823-.328V3.707L6.871 1.578l.707-.707L9 2.293V0h1v2.371l1.5-1.5.707.707L10 3.785V7.05c.317.064.612.189.873.36l2.14-2.152V2.247h1v2.01l1.621-1.62.707.707-1.676 1.676h2.121v1h-3.121l-2.083 2.096c.176.264.303.563.368.884h3.343l2.336-2.313.707.707L16.707 9H19v1h-2.293l1.63 1.629-.708.707L15.293 10H11.95c-.06.295-.172.571-.326.819l2.334 2.17h2.828v1h-1.828l1.383 1.384-.707.707-1.621-1.62v2.303h-1v-3.304l-2.07-1.917a2.486 2.486 0 0 1-.943.408v3.343l2.207 2.207-.707.707-1.5-1.5V19H9v-2.215l-1.422 1.422-.707-.707L9 15.371V11.95a2.487 2.487 0 0 1-.89-.371l-2.088 2.063v3.12h-1v-2.12L3.4 16.262l-.708-.706L4.26 13.99H2.25v-1h3.01l2.148-2.122A2.485 2.485 0 0 1 7.05 10Zm2.45 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:609
 */

const IconSnowFlake = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10.05 13H7l-2.293 2.336L4 14.63 5.629 13H3v-1h2.629l-1.686-1.66.707-.708L7 12h3.05c.07-.343.21-.661.405-.938L8.554 9.02H5.25v-1h2.304l-1.86-1.859.708-.707 1.621 1.621V5.247L9 5.192V8.02l2.177 2.358c.248-.155.526-.268.823-.328V6.707L9.871 4.578l.707-.707L12 5.293V3h1v2.371l1.5-1.5.707.707L13 6.785v3.265c.317.064.612.189.873.36l2.14-2.152V5.247h1v2.01l1.621-1.62.707.707-1.676 1.676h2.121v1h-3.121l-2.083 2.096c.176.264.303.563.368.884h3.343l2.336-2.313.707.708L19.707 12H22v1h-2.293l1.63 1.629-.708.707L18.293 13H14.95c-.06.295-.172.571-.326.819l2.334 2.17h2.828v1h-1.828l1.383 1.384-.707.707-1.621-1.62v2.303h-1v-3.304l-2.07-1.917a2.486 2.486 0 0 1-.943.408v3.343l2.207 2.207-.707.707-1.5-1.5V22h-1v-2.215l-1.422 1.422-.707-.707L12 18.371V14.95a2.487 2.487 0 0 1-.89-.371l-2.088 2.063v3.12h-1v-2.12L6.4 19.262l-.708-.706L7.26 16.99H5.25v-1h3.01l2.148-2.122A2.485 2.485 0 0 1 10.05 13Zm2.45 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:877
 */

const IconSortDownThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '10',
  viewBox: '0 0 14 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm6.73 7.015 1.13 1.503H.751a.752.752 0 1 1 0-1.503H6.73ZM5.564 5.01H.752a.752.752 0 0 1 0-1.504h5.137c-.286.448-.4.984-.325 1.504ZM.752 0h9.52a.752.752 0 1 1 0 1.503H.752A.752.752 0 1 1 .752 0Zm9.123 8.712-2.69-3.58a.701.701 0 0 1 .56-1.124H13.3a.701.701 0 0 1 .56 1.125l-2.703 3.58a.802.802 0 0 1-1.28-.001Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:5080
 */

const IconSortDownShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15',
  viewBox: '0 0 15 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M3.354 14.5 3 14.854a.5.5 0 0 0 .707 0l-.353-.354Zm.353.354 3-3L6 11.146l-3 3 .707.708Zm0-.708-3-3-.707.708 3 3 .707-.708ZM2.854 0v14.5h1V0h-1Zm6 4h6V3h-6v1Zm0 4h4V7h-4v1Zm0 4h2v-1h-2v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:5147
 */

const IconSortUpShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15',
  viewBox: '0 0 15 15',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm3.354.5.353-.354a.5.5 0 0 0-.707 0L3.354.5ZM3 .146l-3 3 .707.708 3-3L3 .146Zm0 .708 3 3 .707-.708-3-3L3 .854ZM2.854.5V15h1V.5h-1Zm6 3.5h6V3h-6v1Zm0 4h4V7h-4v1Zm0 4h2v-1h-2v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:874
 */

const IconSortDownThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm11.73 14.494 1.127 1.5H5.766a.75.75 0 0 1 0-1.5h5.966Zm-1.164-2H5.765a.75.75 0 0 1 0-1.5h5.127c-.286.446-.4.98-.325 1.5Zm-4.801-5h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 1 1 0-1.5Zm9.104 8.693-2.684-3.573a.7.7 0 0 1 .56-1.12h5.54a.7.7 0 0 1 .559 1.121l-2.697 3.573a.8.8 0 0 1-1.278-.001Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1006
 */

const IconSortDown = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm8 19.5-.354.354a.5.5 0 0 0 .708 0L8 19.5Zm.354.354 3-3-.708-.708-3 3 .708.708Zm0-.708-3-3-.708.708 3 3 .708-.708ZM7.5 5v14.5h1V5h-1Zm6 4h6V8h-6v1Zm0 4h4v-1h-4v1Zm0 4h2v-1h-2v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1013
 */

const IconSortUp = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm8 5.5.354-.354a.5.5 0 0 0-.708 0L8 5.5Zm-.354-.354-3 3 .708.708 3-3-.708-.708Zm0 .708 3 3 .708-.708-3-3-.708.708ZM7.5 5.5V20h1V5.5h-1Zm6 3.5h6V8h-6v1Zm0 4h4v-1h-4v1Zm0 4h2v-1h-2v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1232
 */

const IconSpiceShakersShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18',
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M16.895 15.053A1.5 1.5 0 0 1 18 16.5V18h-8v-1.5a1.5 1.5 0 0 1 1.105-1.447 1.498 1.498 0 0 1 .425-1.697A1.993 1.993 0 0 1 11 12V6c0-.468.16-.899.43-1.24A2.5 2.5 0 0 1 12.5 0h3a2.5 2.5 0 0 1 1.07 4.76c.27.341.43.772.43 1.24v6c0 .523-.2 1-.53 1.356a1.497 1.497 0 0 1 .425 1.697ZM16.5 16h-5a.5.5 0 0 0-.5.5v.5h6v-.5a.5.5 0 0 0-.5-.5Zm-1-1a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1h3ZM13 13h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1Zm-.5-9h3a1.5 1.5 0 0 0 0-3h-3a1.5 1.5 0 0 0 0 3ZM6.895 15.053A1.5 1.5 0 0 1 8 16.5V18H0v-1.5a1.5 1.5 0 0 1 1.105-1.447 1.497 1.497 0 0 1 .425-1.697A1.993 1.993 0 0 1 1 12V8c0-.468.16-.899.43-1.24A2.5 2.5 0 0 1 2.5 2h3a2.5 2.5 0 0 1 1.07 4.76c.27.341.43.772.43 1.24v4c0 .523-.2 1-.53 1.356a1.497 1.497 0 0 1 .425 1.697ZM6.5 16h-5a.5.5 0 0 0-.5.5v.5h6v-.5a.5.5 0 0 0-.5-.5Zm-1-1a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1h3ZM3 13h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1Zm2.5-7a1.5 1.5 0 1 0 0-3h-3a1.5 1.5 0 1 0 0 3h3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1228
 */

const IconSpiceShakers = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M19.895 18.052A1.5 1.5 0 0 1 21 19.5V21h-8v-1.5a1.5 1.5 0 0 1 1.105-1.448 1.498 1.498 0 0 1 .425-1.696A1.993 1.993 0 0 1 14 15V9c0-.468.16-.899.43-1.24A2.5 2.5 0 0 1 15.5 3h3a2.5 2.5 0 0 1 1.07 4.76c.27.341.43.772.43 1.24v6c0 .523-.2 1-.53 1.356a1.497 1.497 0 0 1 .425 1.696ZM19.5 19h-5a.5.5 0 0 0-.5.5v.5h6v-.5a.5.5 0 0 0-.5-.5Zm-1-1a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1h3ZM16 16h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1Zm-.5-9h3a1.5 1.5 0 0 0 0-3h-3a1.5 1.5 0 0 0 0 3ZM9.895 18.052A1.5 1.5 0 0 1 11 19.5V21H3v-1.5a1.5 1.5 0 0 1 1.105-1.448 1.497 1.497 0 0 1 .425-1.696A1.993 1.993 0 0 1 4 15v-4c0-.468.16-.899.43-1.24A2.5 2.5 0 0 1 5.5 5h3a2.5 2.5 0 0 1 1.07 4.76c.27.341.43.772.43 1.24v4c0 .523-.2 1-.53 1.356a1.497 1.497 0 0 1 .425 1.696ZM9.5 19h-5a.5.5 0 0 0-.5.5v.5h6v-.5a.5.5 0 0 0-.5-.5Zm-1-1a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1h3ZM6 16h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1Zm2.5-7a1.5 1.5 0 1 0 0-3h-3a1.5 1.5 0 1 0 0 3h3Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=705:5
 */

const IconStarFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '18',
  viewBox: '0 0 19 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm9.638.899 2.125 4.306c.258.522.755.884 1.331.967l4.753.691c.207.03.29.285.14.43l-3.44 3.353a1.768 1.768 0 0 0-.508 1.565l.812 4.734a.253.253 0 0 1-.366.266l-4.251-2.235a1.768 1.768 0 0 0-1.646 0l-4.25 2.235a.253.253 0 0 1-.367-.266l.812-4.734a1.768 1.768 0 0 0-.509-1.565L.835 7.294a.253.253 0 0 1 .14-.43l4.753-.692a1.768 1.768 0 0 0 1.331-.967L9.184.9a.253.253 0 0 1 .454 0Z',
  fill: 'currentColor',
  stroke: 'currentColor',
  strokeWidth: '1.5'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=705:6
 */

const IconStarFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M11.776 3.149a.25.25 0 0 1 .448 0l2.104 4.262a1.75 1.75 0 0 0 1.317.957l4.704.684a.25.25 0 0 1 .138.426l-3.403 3.318a1.75 1.75 0 0 0-.503 1.549l.803 4.684a.25.25 0 0 1-.363.264l-4.207-2.212a1.75 1.75 0 0 0-1.628 0l-4.207 2.212a.25.25 0 0 1-.363-.264l.804-4.684a1.75 1.75 0 0 0-.504-1.55L3.513 9.479a.25.25 0 0 1 .138-.426l4.704-.684a1.75 1.75 0 0 0 1.317-.957l2.104-4.262Z',
  fill: 'currentColor',
  stroke: 'currentColor',
  strokeWidth: '1.5'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=702:34
 */

const IconStarThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '18',
  viewBox: '0 0 19 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm9.638.899 2.125 4.306c.258.522.755.884 1.331.967l4.753.691c.207.03.29.285.14.43l-3.44 3.353a1.768 1.768 0 0 0-.508 1.565l.812 4.734a.253.253 0 0 1-.366.266l-4.251-2.235a1.768 1.768 0 0 0-1.646 0l-4.25 2.235a.253.253 0 0 1-.367-.266l.812-4.734a1.768 1.768 0 0 0-.509-1.565L.835 7.294a.253.253 0 0 1 .14-.43l4.753-.692a1.768 1.768 0 0 0 1.331-.967L9.184.9a.253.253 0 0 1 .454 0Z',
  stroke: 'currentColor',
  strokeWidth: '1.5'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=702:35
 */

const IconStarThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M11.776 3.149a.25.25 0 0 1 .448 0l2.104 4.262a1.75 1.75 0 0 0 1.317.957l4.704.684a.25.25 0 0 1 .138.426l-3.403 3.318a1.75 1.75 0 0 0-.503 1.549l.803 4.684a.25.25 0 0 1-.363.264l-4.207-2.212a1.75 1.75 0 0 0-1.628 0l-4.207 2.212a.25.25 0 0 1-.363-.264l.804-4.684a1.75 1.75 0 0 0-.504-1.55L3.513 9.479a.25.25 0 0 1 .138-.426l4.704-.684a1.75 1.75 0 0 0 1.317-.957l2.104-4.262Z',
  stroke: 'currentColor',
  strokeWidth: '1.5'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=702:27
 */

const IconStarShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '18',
  viewBox: '0 0 19 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm9.864.787 2.125 4.306c.221.448.648.758 1.142.83l4.752.69c.415.06.58.57.28.862l-3.439 3.352c-.357.348-.52.85-.436 1.342l.812 4.733a.505.505 0 0 1-.733.532l-4.25-2.234a1.515 1.515 0 0 0-1.411 0l-4.251 2.235a.505.505 0 0 1-.733-.533l.812-4.733a1.516 1.516 0 0 0-.436-1.342L.658 7.475a.505.505 0 0 1 .28-.862l4.753-.69c.494-.072.92-.382 1.142-.83L8.958.787a.505.505 0 0 1 .906 0Z',
  stroke: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2764:6040
 */

const IconStarTrophyFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '12',
  height: '18',
  viewBox: '0 0 12 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.91 3.456 6.405.265h.002a.443.443 0 0 0-.811 0L4.09 3.455a.452.452 0 0 1-.34.26l-3.363.512c-.37.057-.518.534-.25.808L2.57 7.519a.49.49 0 0 1 .13.42l-.575 3.507c-.064.386.324.681.656.498l3.009-1.656a.435.435 0 0 1 .42 0l3.008 1.656c.332.183.72-.112.656-.498L9.3 7.939a.49.49 0 0 1 .13-.42l2.433-2.484c.269-.274.12-.751-.25-.808L8.25 3.714a.452.452 0 0 1-.34-.258Zm1.694 12.543v-1.067c0-.394-.402-.711-.898-.711H7.36v-2.135H4.666v2.135H3.32c-.496 0-.898.317-.898.71V16h7.182Zm.487.001H1.909c-.502 0-.909.298-.909.666V18h10v-1.334c0-.368-.407-.666-.91-.666Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=702:28
 */

const IconStar = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'M11.552 3.038a.5.5 0 0 1 .896 0L14.552 7.3a1.5 1.5 0 0 0 1.13.82l4.703.684a.5.5 0 0 1 .277.853l-3.404 3.318a1.5 1.5 0 0 0-.431 1.327l.803 4.685a.5.5 0 0 1-.725.527l-4.207-2.212a1.5 1.5 0 0 0-1.396 0l-4.207 2.212a.5.5 0 0 1-.725-.527l.803-4.685a1.5 1.5 0 0 0-.431-1.327L3.338 9.657a.5.5 0 0 1 .277-.853l4.704-.683a1.5 1.5 0 0 0 1.13-.82l2.103-4.263Z',
  stroke: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2764:6045
 */

const IconStarTrophyFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm13.91 6.456-1.505-3.191h.002a.443.443 0 0 0-.812 0l-1.505 3.19a.452.452 0 0 1-.34.26l-3.363.512c-.37.057-.518.534-.25.808l2.433 2.484a.49.49 0 0 1 .13.42l-.575 3.507c-.064.386.324.681.656.498l3.009-1.656a.434.434 0 0 1 .42 0l3.008 1.656c.332.183.72-.112.656-.498l-.574-3.507a.489.489 0 0 1 .13-.42l2.433-2.484c.269-.274.12-.751-.25-.808l-3.364-.513a.452.452 0 0 1-.34-.258Zm1.694 12.543v-1.067c0-.394-.402-.711-.898-.711H13.36v-2.135h-2.694v2.135H9.32c-.496 0-.898.317-.898.71V19h7.182Zm.487.001H7.909c-.502 0-.909.298-.909.666V21h10v-1.334c0-.368-.407-.666-.91-.666Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1271
 */

const IconSunAndWaterShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '17',
  viewBox: '0 0 20 17',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M7.493 0a.5.5 0 0 0-.5.5V2.51a.5.5 0 0 0 1 0V.5a.5.5 0 0 0-.5-.5Zm-.5 10.035a3.004 3.004 0 0 0 2.997-3.01 3.004 3.004 0 0 0-2.997-3.011 3.004 3.004 0 0 0-2.997 3.01 3.004 3.004 0 0 0 2.997 3.011Zm0-1.004a2.003 2.003 0 0 1-1.998-2.007c0-1.108.895-2.006 1.998-2.006 1.104 0 1.998.898 1.998 2.006a2.003 2.003 0 0 1-1.998 2.007Zm12.033 3.782c.288-.39.969-.695.969-.695l.002-1.038s-1.272.457-1.773 1.135c-.452.61-.65.771-1.04.771-.389 0-.586-.16-1.038-.771-.628-.85-1.03-1.176-1.84-1.176-.811 0-1.214.326-1.842 1.176-.452.61-.649.771-1.039.771-.39 0-.587-.16-1.039-.771-.628-.85-1.03-1.176-1.84-1.176s-1.213.326-1.842 1.176c-.451.61-.649.771-1.039.771-.39 0-.587-.16-1.038-.771-.629-.85-1.031-1.176-1.841-1.176s-1.213.326-1.841 1.176c-.285.385-.93.69-.93.69l-.009 1.043s1.24-.457 1.74-1.135c.452-.61.65-.771 1.04-.771s.587.16 1.038.771c.629.85 1.031 1.176 1.841 1.176s1.213-.326 1.841-1.176c.452-.61.65-.771 1.04-.771s.587.16 1.038.771c.629.85 1.031 1.176 1.841 1.176s1.213-.326 1.841-1.176c.452-.61.65-.771 1.04-.771.389 0 .586.16 1.038.771.628.85 1.03 1.176 1.84 1.176.811 0 1.214-.326 1.842-1.176ZM20 15.127s-.684.304-.974.697c-.628.85-1.03 1.176-1.841 1.176-.81 0-1.213-.327-1.841-1.176-.452-.611-.65-.771-1.039-.771-.39 0-.587.16-1.039.77-.628.85-1.03 1.177-1.84 1.177-.811 0-1.213-.327-1.842-1.176-.451-.611-.649-.771-1.039-.771-.39 0-.587.16-1.039.77-.628.85-1.03 1.177-1.84 1.177s-1.213-.327-1.842-1.176c-.451-.611-.649-.771-1.038-.771-.39 0-.588.16-1.04.77-.5.677-1.736 1.135-1.736 1.135L0 15.92s.655-.304.945-.696c.628-.85 1.03-1.176 1.84-1.176s1.213.327 1.842 1.176c.451.611.649.771 1.038.771.39 0 .588-.16 1.04-.77.628-.85 1.03-1.177 1.84-1.177s1.213.327 1.841 1.176c.452.611.65.771 1.04.771.389 0 .586-.16 1.038-.77.628-.85 1.03-1.177 1.841-1.177.81 0 1.213.327 1.841 1.176.452.611.65.771 1.039.771.39 0 .587-.16 1.039-.77.5-.677 1.77-1.135 1.77-1.135L20 15.128ZM2.497 7.024a.501.501 0 0 1 0 1.004H.5a.501.501 0 0 1 0-1.004h1.997Zm1.476-3.037a.5.5 0 0 0 0-.706L2.56 1.861a.5.5 0 0 0-.71.707l1.415 1.42a.5.5 0 0 0 .709 0Zm6.369-.204a.5.5 0 0 0 .71.706l1.413-1.42a.5.5 0 0 0-.71-.706l-1.413 1.42Zm3.645 3.743a.502.502 0 0 0-.5-.502h-1.998a.502.502 0 0 0 0 1.004h1.998c.276 0 .5-.226.5-.502Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1265
 */

const IconSunAndWater = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M9.493 3.5a.5.5 0 0 0-.5.5V6.01a.5.5 0 0 0 1 0V4a.5.5 0 0 0-.5-.5Zm-.5 10.035a3.004 3.004 0 0 0 2.997-3.01 3.004 3.004 0 0 0-2.997-3.011 3.004 3.004 0 0 0-2.997 3.01 3.004 3.004 0 0 0 2.997 3.011Zm0-1.004a2.003 2.003 0 0 1-1.998-2.007c0-1.108.895-2.006 1.998-2.006 1.104 0 1.998.898 1.998 2.006a2.003 2.003 0 0 1-1.998 2.008Zm12.033 3.782c.288-.39.969-.694.969-.694l.002-1.039s-1.272.457-1.773 1.135c-.452.61-.65.771-1.04.771-.389 0-.586-.16-1.038-.771-.628-.85-1.03-1.176-1.84-1.176-.811 0-1.214.326-1.842 1.176-.452.61-.649.771-1.039.771-.39 0-.587-.16-1.039-.771-.628-.85-1.03-1.176-1.84-1.176s-1.213.326-1.842 1.176c-.451.61-.649.771-1.039.771-.39 0-.587-.16-1.038-.771-.629-.85-1.031-1.176-1.841-1.176s-1.213.326-1.841 1.176c-.285.385-.93.69-.93.69l-.009 1.043s1.24-.457 1.74-1.135c.452-.61.65-.771 1.04-.771s.587.16 1.038.771c.629.85 1.031 1.177 1.841 1.177s1.213-.327 1.841-1.177c.452-.61.65-.771 1.04-.771s.587.16 1.038.771c.629.85 1.031 1.177 1.841 1.177s1.213-.327 1.841-1.177c.452-.61.65-.771 1.04-.771.389 0 .586.16 1.038.771.628.85 1.03 1.177 1.84 1.177.811 0 1.214-.327 1.842-1.177ZM22 18.628s-.684.303-.974.696c-.628.85-1.03 1.176-1.841 1.176-.81 0-1.213-.327-1.841-1.176-.452-.611-.65-.772-1.039-.772-.39 0-.587.16-1.039.772-.628.85-1.03 1.176-1.84 1.176-.811 0-1.213-.327-1.842-1.176-.451-.611-.649-.772-1.039-.772-.39 0-.587.16-1.039.772-.628.85-1.03 1.176-1.84 1.176s-1.213-.327-1.842-1.176c-.451-.611-.649-.772-1.038-.772-.39 0-.588.16-1.04.772-.5.676-1.736 1.134-1.736 1.134L2 19.42s.655-.304.945-.696c.628-.85 1.03-1.176 1.84-1.176s1.213.327 1.842 1.176c.451.611.649.771 1.038.771.39 0 .588-.16 1.04-.77.628-.85 1.03-1.177 1.84-1.177s1.213.327 1.841 1.176c.452.611.65.771 1.04.771.389 0 .586-.16 1.038-.77.628-.85 1.03-1.177 1.841-1.177.81 0 1.213.327 1.841 1.176.452.611.65.771 1.039.771.39 0 .587-.16 1.039-.77.5-.677 1.77-1.135 1.77-1.135L22 18.628ZM4.497 10.524a.501.501 0 0 1 0 1.004H2.5a.502.502 0 0 1 0-1.004h1.997Zm1.476-3.037a.5.5 0 0 0 0-.706L4.56 5.361a.5.5 0 0 0-.71.707l1.414 1.42a.5.5 0 0 0 .71 0Zm6.369-.204a.5.5 0 0 0 .71.706l1.413-1.42a.5.5 0 0 0-.71-.706l-1.413 1.42Zm3.645 3.743a.502.502 0 0 0-.5-.502h-1.998a.502.502 0 0 0 0 1.004h1.998c.276 0 .5-.226.5-.502Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1139
 */

const IconSwingShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '16',
  viewBox: '0 0 19 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11 12h3V2.002h-3V12Zm-1 0V2.002H7V15.5a.5.5 0 0 1-1 0V14H1v1.5a.5.5 0 0 1-1 0V2.002a1 1 0 0 1 1-1h5L7 1l3 .002V.5a.5.5 0 0 1 1 0v.502h3V.5a.5.5 0 0 1 1 0v.502h3a1 1 0 0 1 1 1V15.5a.5.5 0 0 1-1 0V2.252a.25.25 0 0 0-.25-.25H15V12h.5c.276 0 .5.535.5 1.024 0 .49-.224.976-.5.976h-6c-.276 0-.5-.5-.5-1s.224-1 .5-1h.5Zm-9 1h5v-2H1v2Zm0-3h5V8H1v2Zm0-3h5V5H1v2Zm0-3h5V2.002H1.25a.25.25 0 0 0-.25.25V4Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1135
 */

const IconSwing = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13.5 16h3V6.002h-3V16Zm-1 0V6.002h-3V19.5a.5.5 0 0 1-1 0V18h-5v1.5a.5.5 0 0 1-1 0V6.002a1 1 0 0 1 1-1h5L9.5 5l3 .002V4.5a.5.5 0 0 1 1 0v.502h3V4.5a.5.5 0 0 1 1 0v.502h3a1 1 0 0 1 1 1V19.5a.5.5 0 0 1-1 0V6.252a.25.25 0 0 0-.25-.25H17.5V16h.5c.276 0 .5.535.5 1.024 0 .49-.224.976-.5.976h-6c-.276 0-.5-.5-.5-1s.224-1 .5-1h.5Zm-9 1h5v-2h-5v2Zm0-3h5v-2h-5v2Zm0-3h5V9h-5v2Zm0-3h5V6.002H3.75a.25.25 0 0 0-.25.25V8Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4496
 */

const IconTextBubbleFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M0 1.6A1.6 1.6 0 0 1 1.6 0h12.8A1.6 1.6 0 0 1 16 1.6v9.6a1.6 1.6 0 0 1-1.6 1.6h-3.981l-1.975 2.962a.533.533 0 0 1-.888 0L5.581 12.8H1.6A1.6 1.6 0 0 1 0 11.2V1.6Zm12 3.467H4V4h8v1.067Zm-1 3H5V7h6v1.067Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4363
 */

const IconTextBubbleShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm5.857 12.286.416-.278a.5.5 0 0 0-.416-.222v.5ZM8 15.5l-.416.277a.5.5 0 0 0 .832 0L8 15.5Zm2.143-3.214v-.5a.5.5 0 0 0-.416.222l.416.278Zm-4.702.277 2.143 3.214.832-.554-2.143-3.215-.832.555Zm2.975 3.214 2.143-3.214-.832-.555-2.143 3.215.832.554Zm1.727-2.991h4.286v-1h-4.286v1Zm4.286 0A1.57 1.57 0 0 0 16 11.214h-1a.57.57 0 0 1-.571.572v1ZM16 11.214V1.571h-1v9.643h1Zm0-9.643A1.57 1.57 0 0 0 14.429 0v1a.57.57 0 0 1 .571.571h1ZM14.429 0H1.57v1H14.43V0ZM1.57 0A1.57 1.57 0 0 0 0 1.571h1A.57.57 0 0 1 1.571 1V0ZM0 1.571v9.643h1V1.571H0Zm0 9.643a1.57 1.57 0 0 0 1.571 1.572v-1A.57.57 0 0 1 1 11.214H0Zm1.571 1.572h4.286v-1H1.571v1ZM5 8h6V7H5v1ZM4 5h8V4H4v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3573
 */

const IconTextBubbleFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M4 6.6A1.6 1.6 0 0 1 5.6 5h12.8A1.6 1.6 0 0 1 20 6.6v9.6a1.6 1.6 0 0 1-1.6 1.6h-3.981l-1.975 2.962a.533.533 0 0 1-.888 0L9.581 17.8H5.6A1.6 1.6 0 0 1 4 16.2V6.6Zm12 3.467H8V9h8v1.067Zm-1 3H9V12h6v1.067Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3505
 */

const IconTextBubble = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm9.857 17.286.416-.278a.5.5 0 0 0-.416-.222v.5ZM12 20.5l-.416.277a.5.5 0 0 0 .832 0L12 20.5Zm2.143-3.214v-.5a.5.5 0 0 0-.416.222l.416.278Zm-4.702.277 2.143 3.214.832-.554-2.143-3.215-.832.555Zm2.975 3.214 2.143-3.214-.832-.555-2.143 3.215.832.554Zm1.727-2.991h4.286v-1h-4.286v1Zm4.286 0A1.57 1.57 0 0 0 20 16.214h-1a.57.57 0 0 1-.571.572v1ZM20 16.214V6.571h-1v9.643h1Zm0-9.643A1.57 1.57 0 0 0 18.429 5v1a.57.57 0 0 1 .571.571h1ZM18.429 5H5.57v1H18.43V5ZM5.57 5A1.57 1.57 0 0 0 4 6.571h1A.57.57 0 0 1 5.571 6V5ZM4 6.571v9.643h1V6.571H4Zm0 9.643a1.57 1.57 0 0 0 1.571 1.572v-1A.57.57 0 0 1 5 16.214H4Zm1.571 1.572h4.286v-1H5.571v1ZM9 13h6v-1H9v1Zm-1-3h8V9H8v1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4136
 */

const IconThreeDotsHorizontalShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '4',
  viewBox: '0 0 16 4',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M1.806 2.58a.774.774 0 1 0 0-1.548.774.774 0 0 0 0 1.549Zm0 1.033a1.806 1.806 0 1 0 0-3.613 1.806 1.806 0 0 0 0 3.613ZM8 2.58a.774.774 0 1 0 0-1.549.774.774 0 0 0 0 1.549Zm0 1.032A1.806 1.806 0 1 0 8 0a1.806 1.806 0 0 0 0 3.613Zm6.968-1.807a.774.774 0 1 1-1.549 0 .774.774 0 0 1 1.549 0Zm1.032 0a1.806 1.806 0 1 1-3.613 0 1.806 1.806 0 0 1 3.613 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4146
 */

const IconThreeDotsVerticalShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '4',
  height: '16',
  viewBox: '0 0 4 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M1.032 1.806a.774.774 0 1 0 1.549 0 .774.774 0 0 0-1.549 0ZM0 1.806a1.806 1.806 0 1 0 3.613 0 1.806 1.806 0 0 0-3.613 0ZM1.032 8a.774.774 0 1 0 1.549 0 .774.774 0 0 0-1.549 0ZM0 8a1.806 1.806 0 1 0 3.613 0A1.806 1.806 0 0 0 0 8Zm1.806 6.968a.774.774 0 1 1 0-1.549.774.774 0 0 1 0 1.549Zm0 1.032a1.806 1.806 0 1 1 0-3.613 1.806 1.806 0 0 1 0 3.613Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1056
 */

const IconThreeDotsHorizontal = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6 12.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 1a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Zm6-1a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 1a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm1 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=801:1746
 */

const IconThreeDotsVertical = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M11.25 6a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Zm-1 0a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Zm1 6a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Zm-1 0a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm0 1a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=216:88
 */

const IconThumbsUpShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '21',
  viewBox: '0 0 20 21',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M14.079 2.59a.473.473 0 0 0 .009.072 13.8 13.8 0 0 1-.068 1.979.463.463 0 0 0-.014.083c-.165 1.981-.44 2.718-.502 2.865a.463.463 0 0 0-.085.269c0 .247.188.446.42.446h4.349c.537 0 .974.466.974 1.038 0 .571-.437 1.037-.973 1.037-.232 0-.42.2-.42.446a.444.444 0 0 0 .31.431c.406.13.691.539.691.994 0 .57-.436 1.036-.972 1.036a.398.398 0 0 0-.098.012.428.428 0 0 0-.324.314.45.45 0 0 0 .286.552c.412.127.7.537.7.996 0 .571-.436 1.036-.972 1.036-.232 0-.42.2-.42.446l.001.017a.445.445 0 0 0 .295.43c.409.136.683.534.683.991 0 .57-.436 1.036-.973 1.036a.401.401 0 0 0-.095.011c-.664.01-4.87.072-6.85 0-.744-.027-1.44-.734-2-1.302l-.004-.003a10.343 10.343 0 0 0-.466-.456v-5.66c0-.133-.01-.263-.03-.39 1.16-.852 3.5-3.948 4.043-6.297a.485.485 0 0 0 .01-.049c.152-.607.327-2.14.376-2.585a.468.468 0 0 0 .023-.101c.126-1.11.348-1.329.769-1.378.381-.046.668.021.87.205.362.328.434 1.001.457 1.48Zm-6.862 7.877c.818-.752 2.997-3.378 3.535-5.622a.465.465 0 0 1 .014-.077c.13-.474.312-2.027.372-2.586a.467.467 0 0 1 .024-.105c.084-.719.275-1.913 1.498-2.058.617-.073 1.124.065 1.506.413.572.517.705 1.357.745 1.989l.005.044c.077 1.106-.066 2.314-.073 2.364a.465.465 0 0 1-.009.052c-.107 1.255-.257 2.045-.386 2.531h3.762c.989.013 1.79.873 1.79 1.93a1.96 1.96 0 0 1-.842 1.629 2 2 0 0 1 .45 1.28c0 .69-.343 1.298-.858 1.639.282.344.45.793.45 1.27 0 .694-.345 1.303-.863 1.643a2 2 0 0 1 .45 1.277c0 1.027-.758 1.869-1.71 1.925a.398.398 0 0 1-.094.013l-.145.002c-.516.008-2.323.034-4.077.034-1.028 0-2.037-.01-2.759-.036-1.037-.037-1.88-.869-2.505-1.502-.206.88-.887 1.53-1.691 1.53h-4.05c-.968 0-1.756-.938-1.756-2.09v-6.25c0-1.151.788-2.088 1.756-2.088h4.05c.578 0 1.091.334 1.411.849Zm-5.461.043c-.506 0-.917.537-.917 1.197v6.25c0 .66.41 1.197.917 1.197h4.05c.505 0 .916-.537.916-1.197v-6.25c0-.66-.41-1.197-.916-1.197h-4.05Zm1.322 7.581a.33.33 0 0 1-.023-.037c-.525-.992-.672-1.513-.585-2.064.08-.506.58-.998 1.167-.909.27.042.51.194.674.428.04.059.076.12.105.185a.977.977 0 0 1 .958.16c.474.38.493 1.105.212 1.52-.312.46-.747.704-1.792 1.008a.628.628 0 0 1-.174.024.591.591 0 0 1-.267-.066.621.621 0 0 1-.275-.249Zm.656-.385a.31.31 0 0 0-.041.01c-.053.017-.07.022-.075.017a.258.258 0 0 0-.011-.005.641.641 0 0 1-.036-.066.34.34 0 0 0-.023-.04c-.45-.866-.509-1.207-.459-1.52.03-.19.25-.394.456-.36a.39.39 0 0 1 .261.166.435.435 0 0 1 .077.285.35.35 0 0 0 .08.307c.047.052.11.088.182.1.13.018.25-.046.314-.156a.386.386 0 0 1 .242-.138.384.384 0 0 1 .294.083c.17.135.186.44.081.595-.175.259-.446.453-1.342.722Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=216:89
 */

const IconThumbsUp = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M16.079 4.563a.473.473 0 0 0 .009.072 13.8 13.8 0 0 1-.068 1.98.463.463 0 0 0-.014.082c-.165 1.982-.44 2.718-.502 2.865a.463.463 0 0 0-.085.27c0 .246.188.445.42.445h4.349c.537 0 .974.466.974 1.038 0 .572-.437 1.037-.973 1.037-.232 0-.42.2-.42.446a.444.444 0 0 0 .31.431c.406.13.691.54.691.995 0 .57-.436 1.035-.972 1.035a.398.398 0 0 0-.098.012.428.428 0 0 0-.324.314.45.45 0 0 0 .286.553c.412.127.7.536.7.995 0 .571-.436 1.036-.972 1.036-.232 0-.42.2-.42.446l.001.017a.445.445 0 0 0 .295.43c.409.136.683.534.683.991 0 .571-.436 1.036-.973 1.036a.401.401 0 0 0-.095.011c-.664.01-4.87.072-6.85 0-.744-.027-1.44-.734-2-1.302l-.004-.003a10.348 10.348 0 0 0-.466-.456v-5.66c0-.132-.01-.263-.03-.389 1.16-.852 3.5-3.948 4.043-6.298a.485.485 0 0 0 .01-.048c.152-.608.327-2.142.376-2.585a.468.468 0 0 0 .023-.102c.126-1.11.348-1.329.769-1.378.381-.046.668.021.87.205.362.328.434 1.001.457 1.48ZM9.217 12.44c.818-.751 2.996-3.378 3.534-5.621a.465.465 0 0 1 .015-.078c.13-.474.312-2.027.372-2.585a.467.467 0 0 1 .024-.106c.084-.718.275-1.913 1.498-2.058.617-.073 1.124.065 1.506.413.572.518.705 1.357.745 1.99l.005.043c.077 1.106-.066 2.314-.073 2.364a.464.464 0 0 1-.009.053c-.107 1.254-.257 2.044-.386 2.53h3.762c.989.013 1.79.873 1.79 1.93a1.96 1.96 0 0 1-.842 1.63 2 2 0 0 1 .45 1.279c0 .69-.343 1.298-.858 1.639.282.344.45.793.45 1.27 0 .694-.345 1.303-.863 1.643.284.343.45.793.45 1.277 0 1.027-.758 1.869-1.71 1.925a.398.398 0 0 1-.094.013l-.145.002c-.517.008-2.323.034-4.077.034-1.028 0-2.037-.01-2.759-.036-1.037-.037-1.88-.869-2.505-1.502-.206.88-.887 1.53-1.691 1.53h-4.05c-.968 0-1.756-.938-1.756-2.09v-6.25c0-1.15.788-2.088 1.756-2.088h4.05c.578 0 1.091.334 1.411.849Zm-5.461.043c-.506 0-.917.537-.917 1.197v6.25c0 .66.41 1.197.917 1.197h4.05c.505 0 .916-.537.916-1.197v-6.25c0-.66-.41-1.197-.916-1.197h-4.05Zm1.322 7.581a.349.349 0 0 1-.023-.037c-.525-.992-.672-1.513-.585-2.064.08-.506.58-.998 1.167-.909.27.043.51.194.674.428.04.059.076.121.105.186a.972.972 0 0 1 .958.16c.474.378.493 1.105.212 1.519-.312.46-.747.704-1.792 1.008a.62.62 0 0 1-.174.024.591.591 0 0 1-.267-.066.621.621 0 0 1-.275-.248Zm.656-.385a.31.31 0 0 0-.041.01c-.053.017-.07.022-.075.017a.492.492 0 0 0-.011-.004.641.641 0 0 1-.036-.067.341.341 0 0 0-.023-.04c-.45-.866-.509-1.207-.459-1.52.03-.19.25-.394.456-.36a.39.39 0 0 1 .261.166.435.435 0 0 1 .077.285.35.35 0 0 0 .08.307c.047.052.11.089.182.1.13.018.25-.046.314-.156a.385.385 0 0 1 .242-.138.384.384 0 0 1 .294.083c.17.135.186.44.081.595-.175.259-.446.453-1.342.722Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1328
 */

const IconTimesThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm1.613.21.094.083L8 6.585 14.293.293a1 1 0 0 1 1.497 1.32l-.083.094L9.414 8l6.293 6.293a1 1 0 0 1-1.32 1.497l-.094-.083L8 9.414l-6.293 6.293a1 1 0 0 1-1.497-1.32l.083-.094L6.585 8 .293 1.707A1 1 0 0 1 1.51.14l.102.07Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1326
 */

const IconTimesThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm5.613 4.21.094.083L12 10.585l6.293-6.292a1 1 0 0 1 1.497 1.32l-.083.094L13.414 12l6.293 6.293a1 1 0 0 1-1.32 1.497l-.094-.083L12 13.414l-6.293 6.293a1 1 0 0 1-1.497-1.32l.083-.094L10.585 12 4.293 5.707A1 1 0 0 1 5.51 4.14l.102.07Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3532
 */

const IconTimesCircleThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12ZM12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM7.244 7.244c.3-.3.773-.323 1.1-.07l.079.07L12 10.822l3.577-3.578.079-.07a.833.833 0 0 1 1.1 1.249L13.178 12l3.578 3.577a.833.833 0 0 1-1.1 1.248l-.079-.07L12 13.18l-3.577 3.577-.079.07a.833.833 0 0 1-1.1-1.249L10.822 12 7.244 8.423a.833.833 0 0 1 0-1.179Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:650
 */

const IconTimesShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '14',
  viewBox: '0 0 14 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm.732.083.065.054L7 6.34 13.203.137a.467.467 0 0 1 .714.595l-.054.065L7.66 7l6.203 6.203a.466.466 0 0 1-.595.714l-.065-.054L7 7.66.797 13.863a.467.467 0 0 1-.714-.595l.054-.065L6.34 7 .137.797A.467.467 0 0 1 .66.042l.071.04Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1118
 */

const IconTimesSmallThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '10',
  height: '10',
  viewBox: '0 0 10 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M1.344.175a.833.833 0 0 0-1.1 1.248L3.821 5 .244 8.577a.833.833 0 0 0 1.1 1.248l.079-.07L5 6.18l3.577 3.577.079.07a.834.834 0 0 0 1.1-1.249L6.179 5l3.577-3.577a.833.833 0 0 0-1.1-1.248l-.079.07L5 3.82 1.423.244l-.079-.07Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1114
 */

const IconTimesSmallShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '11',
  height: '10',
  viewBox: '0 0 11 10',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M5.024 4.22 9.063.195a.552.552 0 0 1 .778 0 .544.544 0 0 1 0 .773L5.8 4.993 9.84 9.007a.544.544 0 0 1 0 .773.552.552 0 0 1-.778 0L5.025 5.768.939 9.84a.552.552 0 0 1-.778 0 .544.544 0 0 1 0-.773l4.086-4.072L.161.933a.544.544 0 0 1 0-.773.552.552 0 0 1 .778 0l4.085 4.06Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:648
 */

const IconTimes = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm5.732 5.083.065.054L12 11.34l6.203-6.203a.467.467 0 0 1 .714.595l-.054.065L12.66 12l6.203 6.203a.466.466 0 0 1-.595.714l-.065-.054L12 12.66l-6.203 6.203a.467.467 0 0 1-.714-.595l.054-.065L11.34 12 5.137 5.797a.467.467 0 0 1 .524-.755l.071.04Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=532:1708
 */

const IconTimesCircleThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12ZM12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM7.244 7.244c.3-.3.773-.323 1.1-.07l.079.07L12 10.822l3.577-3.578.079-.07a.833.833 0 0 1 1.1 1.249L13.178 12l3.578 3.577a.833.833 0 0 1-1.1 1.248l-.079-.07L12 13.18l-3.577 3.577-.079.07a.833.833 0 0 1-1.1-1.249L10.822 12 7.244 8.423a.833.833 0 0 1 0-1.179Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1115
 */

const IconTimesSmallThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.344 7.175a.833.833 0 0 0-1.1 1.248L10.822 12l-3.578 3.577a.833.833 0 0 0 1.1 1.248l.079-.07L12 13.18l3.577 3.577.079.07a.833.833 0 0 0 1.1-1.249L13.178 12l3.578-3.577a.833.833 0 0 0-1.1-1.248l-.079.07L12 10.821 8.423 7.244l-.079-.07Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1113
 */

const IconTimesSmall = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm12.024 11.22 4.039-4.025a.552.552 0 0 1 .778 0 .544.544 0 0 1 0 .773l-4.04 4.025 4.038 4.014a.544.544 0 0 1 0 .773.552.552 0 0 1-.778 0l-4.036-4.012-4.086 4.072a.552.552 0 0 1-.778 0 .544.544 0 0 1 0-.773l4.086-4.072-4.086-4.062a.544.544 0 0 1 0-.773.552.552 0 0 1 .778 0l4.085 4.06Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:972
 */

const IconTwitterFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10 20c5.525 0 10-4.475 10-10S15.525 0 10 0 0 4.475 0 10s4.475 10 10 10Zm4.606-11.772c0 3.51-2.39 7.562-6.763 7.562a6.13 6.13 0 0 1-3.632-1.202c.187.028.374.039.566.039 1.114 0 2.14-.425 2.953-1.136-1.04-.022-1.917-.788-2.218-1.846a2.136 2.136 0 0 0 1.075-.044c-1.09-.248-1.908-1.317-1.908-2.607v-.033c.32.199.685.32 1.074.33-.64-.473-1.06-1.289-1.06-2.21 0-.484.119-.942.321-1.333 1.173 1.61 2.923 2.668 4.9 2.778a2.709 2.709 0 0 1-.064-.606c0-1.466 1.064-2.657 2.376-2.657.685 0 1.3.32 1.735.838a4.52 4.52 0 0 0 1.508-.645 2.626 2.626 0 0 1-1.045 1.472c.483-.067.942-.21 1.366-.42a5.227 5.227 0 0 1-1.188 1.378c.004.11.004.226.004.342Z',
  fill: '#1DA1F3'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:969
 */

const IconTwitterFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 22c5.525 0 10-4.475 10-10S17.525 2 12 2 2 6.475 2 12s4.475 10 10 10Zm4.606-11.772c0 3.51-2.39 7.562-6.763 7.562a6.13 6.13 0 0 1-3.632-1.202c.187.028.374.039.566.039 1.114 0 2.14-.425 2.953-1.136-1.04-.022-1.917-.788-2.218-1.846a2.136 2.136 0 0 0 1.075-.044c-1.09-.248-1.908-1.317-1.908-2.607v-.033c.32.198.685.32 1.074.33-.64-.473-1.06-1.289-1.06-2.21 0-.484.119-.942.321-1.333 1.173 1.61 2.923 2.667 4.9 2.778a2.713 2.713 0 0 1-.064-.606c0-1.466 1.064-2.657 2.376-2.657.685 0 1.3.32 1.735.838a4.52 4.52 0 0 0 1.508-.645 2.626 2.626 0 0 1-1.045 1.472c.483-.067.942-.21 1.366-.42a5.227 5.227 0 0 1-1.188 1.378c.004.11.004.226.004.342Z',
  fill: '#1DA1F3'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2290:4368
 */

const IconUserFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M10 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM0 19a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7v1H0v-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2290:4373
 */

const IconUserFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM2 21a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7v1H2v-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2287:4321
 */

const IconUserThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M13.5 5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM15 5A5 5 0 1 1 5 5a5 5 0 0 1 10 0Zm3.5 14a5.5 5.5 0 0 0-5.5-5.5H7A5.5 5.5 0 0 0 1.5 19v1H0v-1a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7v1h-1.5v-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=270:1602
 */

const IconUserThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M15.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM17 7A5 5 0 1 1 7 7a5 5 0 0 1 10 0Zm3.5 14a5.5 5.5 0 0 0-5.5-5.5H9A5.5 5.5 0 0 0 3.5 21v1H2v-1a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7v1h-1.5v-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2287:4239
 */

const IconUserShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M14 5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm1 0A5 5 0 1 1 5 5a5 5 0 0 1 10 0Zm4 14a6 6 0 0 0-6-6H7a6 6 0 0 0-6 6v1H0v-1a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7v1h-1v-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:669
 */

const IconUser = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm1 0A5 5 0 1 1 7 7a5 5 0 0 1 10 0Zm4 14a6 6 0 0 0-6-6H9a6 6 0 0 0-6 6v1H2v-1a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7v1h-1v-1Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1169
 */

const IconVastuStarShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm10.277.223 1.7 7.8 7.8 1.7a.284.284 0 0 1 0 .554l-7.8 1.7-1.7 7.8a.284.284 0 0 1-.554 0l-1.7-7.8-7.8-1.7a.284.284 0 0 1 0-.554l7.8-1.7 1.7-7.8a.284.284 0 0 1 .554 0ZM8.875 8.875 3.713 10l5.162 1.125L10 16.287l1.125-5.162L16.287 10l-5.162-1.125L10 3.713 8.875 8.875Zm5.526-1.285-1.062-.223 1.164-1.813-1.859 1.194-.218-1.064 4.349-2.793a.284.284 0 0 1 .392.392L14.4 7.59Zm.004 4.826 2.762 4.3a.284.284 0 0 1-.392.393L12.5 14.364l.196-1.079 1.806 1.16-1.157-1.801 1.059-.228ZM3.34 17.11l4.19-2.691-.222-1.062-1.697 1.09 1.16-1.805-1.014-.298-2.81 4.374a.284.284 0 0 0 .393.392Zm2.272-9.677L2.95 3.283a.284.284 0 0 1 .392-.392l4.162 2.673-.22 1.064-1.67-1.074L6.675 7.21l-1.063.222Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1159
 */

const IconVastuStar = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'm12.277 2.223 1.7 7.8 7.8 1.7a.284.284 0 0 1 0 .554l-7.8 1.7-1.7 7.8a.284.284 0 0 1-.554 0l-1.7-7.8-7.8-1.7a.284.284 0 0 1 0-.554l7.8-1.7 1.7-7.8a.284.284 0 0 1 .554 0Zm-1.402 8.652L5.713 12l5.162 1.125L12 18.287l1.125-5.162L18.287 12l-5.162-1.125L12 5.713l-1.125 5.162Zm5.526-1.285-1.062-.223 1.164-1.813-1.859 1.194-.218-1.064 4.349-2.793a.284.284 0 0 1 .392.392L16.4 9.59Zm.004 4.826 2.762 4.3a.284.284 0 0 1-.392.393L14.5 16.364l.196-1.079 1.806 1.16-1.157-1.801 1.059-.228ZM5.34 19.11l4.19-2.691-.222-1.062-1.697 1.09 1.16-1.805-1.014-.298-2.81 4.374a.284.284 0 0 0 .393.392Zm2.272-9.677L4.95 5.283a.284.284 0 0 1 .392-.392l4.162 2.673-.22 1.064-1.67-1.074L8.675 9.21l-1.063.222Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2100:3975
 */

const IconWhatsappFilledShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8 0a8 8 0 0 0-6.595 12.53L.056 15.228a.533.533 0 0 0 .716.716l2.698-1.35A8 8 0 1 0 8 0Zm2.645 8.77c.181.074 1.148.593 1.344.7l.105.056c.139.074.232.123.27.192.047.085.033.484-.152.944-.184.459-1.02.878-1.388.897-.063.004-.116.014-.17.025-.26.053-.553.112-2.216-.613-1.854-.809-3.026-2.687-3.268-3.075a2.149 2.149 0 0 0-.041-.064l-.001-.002c-.1-.142-.776-1.114-.74-2.092.035-.919.507-1.383.724-1.597l.04-.04a.738.738 0 0 1 .544-.23c.069.003.137.01.203.016.063.007.124.013.18.015h.045c.113-.003.26-.007.394.35.05.132.122.328.198.535.158.426.333.9.364.968.046.102.075.22.003.35l-.029.054a1.146 1.146 0 0 1-.183.272l-.11.12c-.071.08-.142.161-.204.218-.104.096-.213.2-.103.404.11.203.487.872 1.062 1.423.62.592 1.168.853 1.445.985l.13.064c.196.108.313.096.435-.033s.523-.564.664-.758c.141-.195.274-.157.455-.083Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:660
 */

const IconWhatsappFilled = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M12 4a8 8 0 0 0-6.595 12.53l-1.349 2.698a.533.533 0 0 0 .716.716l2.698-1.35A8 8 0 1 0 12 4Zm2.645 8.77c.181.074 1.148.593 1.344.7l.105.056c.139.074.232.123.27.192.047.085.033.484-.152.944-.184.459-1.02.878-1.388.897-.063.004-.116.014-.17.025-.26.053-.553.112-2.216-.613-1.854-.809-3.026-2.687-3.268-3.075a2.156 2.156 0 0 0-.041-.064l-.001-.002c-.1-.142-.776-1.114-.74-2.092.035-.919.507-1.383.724-1.597l.04-.04a.738.738 0 0 1 .544-.23c.069.003.137.01.203.016.063.007.124.013.18.015h.045c.113-.003.26-.007.394.35.05.132.122.328.198.535.158.426.333.9.364.968.046.102.075.22.004.35l-.03.054a1.147 1.147 0 0 1-.183.272l-.11.12c-.071.08-.142.161-.204.218-.104.095-.213.2-.103.404.11.204.487.872 1.062 1.422.62.593 1.168.854 1.445.986l.13.064c.196.108.313.096.436-.033.121-.129.522-.564.663-.758.141-.195.274-.157.455-.083Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4382
 */

const IconWhatsappShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm2.001 12.5.45.224.138-.278-.186-.248-.402.301Zm1.5 1.498.301-.4-.248-.188-.278.14.225.448Zm-2.999 1.5-.449-.225a.502.502 0 0 0 .674.674l-.225-.45ZM4.787 4.787l-.279-.418a.502.502 0 0 0-.223.418h.502Zm6.426 6.426v.503a.502.502 0 0 0 .418-.224l-.418-.279ZM6.666 5.35l.495-.083-.495.083Zm.149.896-.495.082.495-.082Zm-.462 1.067.278.418-.278-.418Zm5.013 3.672.417.279-.417-.279Zm-.716-1.65.083-.496-.083.495Zm-.896-.15-.082.495.082-.495Zm-1.067.462-.418-.278.418.278ZM0 8c0 1.8.595 3.464 1.6 4.8l.803-.602A6.963 6.963 0 0 1 1.004 8H0Zm8-8a8 8 0 0 0-8 8h1.004A6.996 6.996 0 0 1 8 1.004V0Zm8 8a8 8 0 0 0-8-8v1.004A6.996 6.996 0 0 1 14.996 8H16Zm-8 8a8 8 0 0 0 8-8h-1.004A6.996 6.996 0 0 1 8 14.996V16Zm-4.8-1.6C4.535 15.405 6.2 16 8 16v-1.004a6.963 6.963 0 0 1-4.198-1.399L3.2 14.4ZM.726 15.947l2.998-1.5-.449-.898-2.998 1.5.449.898Zm.825-3.672L.053 15.273l.898.45 1.5-3-.899-.448Zm2.733-7.488v1.07h1.004v-1.07H4.285Zm5.857 6.929h1.071V10.71h-1.07v1.005ZM4.285 5.858a5.858 5.858 0 0 0 5.857 5.858V10.71A4.854 4.854 0 0 1 5.29 5.858H4.285Zm.78-.654.228-.152-.557-.835-.228.152.557.835Zm1.105.228.15.896.99-.165-.15-.896-.99.165Zm-.096 1.463-1.03.687.557.836 1.03-.687-.557-.836Zm.246-.567a.569.569 0 0 1-.246.567l.557.836c.515-.344.781-.957.68-1.568l-.991.165ZM5.293 5.052a.569.569 0 0 1 .877.38l.99-.165a1.573 1.573 0 0 0-2.424-1.05l.557.835Zm6.338 6.44.152-.228-.835-.557-.152.228.835.557Zm-.898-2.653-.896-.15-.165.991.896.15.165-.99Zm-2.464.53-.687 1.03.836.557.687-1.03-.836-.557Zm1.568-.68a1.573 1.573 0 0 0-1.568.68l.836.557a.569.569 0 0 1 .567-.246l.165-.99Zm1.946 2.575a1.573 1.573 0 0 0-1.05-2.425l-.165.99a.569.569 0 0 1 .38.877l.835.558Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3527
 */

const IconWhatsapp = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  d: 'm5.993 16.447.447.224.139-.277-.186-.247-.4.3Zm1.493 1.493.3-.4-.247-.185-.276.138.223.447ZM4.5 19.433l-.447-.223a.5.5 0 0 0 .67.67l-.223-.447ZM8.767 8.767l-.278-.416a.5.5 0 0 0-.222.416h.5Zm6.4 6.4v.5a.5.5 0 0 0 .416-.223l-.416-.277Zm-4.53-5.84.494-.082-.493.082Zm.15.893-.494.082.494-.082Zm-.46 1.063.277.416-.278-.416Zm4.991 3.656.416.278-.416-.278Zm-.712-1.643.082-.494-.082.494Zm-.892-.15-.083.494.083-.493Zm-1.063.461-.416-.277.416.277ZM4 11.967c0 1.793.593 3.449 1.593 4.78l.8-.6A6.934 6.934 0 0 1 5 11.967H4ZM11.967 4A7.967 7.967 0 0 0 4 11.967h1A6.967 6.967 0 0 1 11.967 5V4Zm7.966 7.967c0-4.4-3.567-7.967-7.966-7.967v1a6.967 6.967 0 0 1 6.966 6.967h1Zm-7.966 7.966c4.4 0 7.966-3.567 7.966-7.966h-1a6.967 6.967 0 0 1-6.966 6.966v1ZM7.186 18.34a7.934 7.934 0 0 0 4.78 1.593v-1a6.934 6.934 0 0 1-4.18-1.392l-.6.799Zm-2.462 1.54 2.986-1.493-.447-.894-2.987 1.493.448.895Zm.822-3.656L4.053 19.21l.894.447L6.44 16.67l-.894-.447Zm2.72-7.457v1.066h1V8.767h-1Zm5.834 6.9h1.067v-1H14.1v1ZM8.267 9.833a5.833 5.833 0 0 0 5.833 5.834v-1a4.833 4.833 0 0 1-4.833-4.834h-1Zm.777-.65.227-.152-.554-.832-.228.152.555.832Zm1.1.226.15.893.986-.165-.149-.892-.986.164Zm-.095 1.457-1.026.685.554.832 1.027-.684-.555-.832Zm.244-.564a.567.567 0 0 1-.244.565l.555.832c.513-.342.777-.953.676-1.562l-.987.165Zm-1.022-1.27a.567.567 0 0 1 .874.377l.986-.164A1.567 1.567 0 0 0 8.717 8.2l.554.832Zm6.312 6.412.151-.227-.832-.555-.151.227.832.555Zm-.895-2.642-.892-.149-.165.987.893.149.164-.987Zm-2.453.528-.684 1.026.832.555.684-1.027-.832-.554Zm1.56-.677a1.567 1.567 0 0 0-1.56.677l.832.554a.567.567 0 0 1 .564-.244l.165-.987Zm1.94 2.564a1.567 1.567 0 0 0-1.047-2.415l-.164.987a.567.567 0 0 1 .378.873l.832.555Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2805:3350
 */

const IconWorkerThickShape = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M6.593 4.62c0-1.056.417-1.801 1.02-2.297.195-.159.412-.295.646-.408v.798a.77.77 0 1 0 1.539 0v-1.17a4.314 4.314 0 0 1 .404.001v1.169a.77.77 0 0 0 1.539 0v-.784a3.2 3.2 0 0 1 .627.4c.605.497 1.022 1.242 1.022 2.29v.604a.77.77 0 0 0 .27.586 37.996 37.996 0 0 1-1.127.107c-.742.06-1.686.12-2.53.12-.846 0-1.757-.053-2.462-.108a43.947 43.947 0 0 1-1.1-.1l-.063-.007h-.006l-.054-.009a.77.77 0 0 0 .275-.589V4.62ZM5.49 5.74v-.003l-.002-.003.002.006Zm-.14-.175.006.004h.001a.054.054 0 0 0-.006-.004ZM5.045 7.1c.145.048.307.09.482.13.1 1.441.518 2.853 1.166 3.967.728 1.25 1.864 2.304 3.31 2.304 1.44 0 2.612-1.05 3.375-2.303.684-1.12 1.14-2.547 1.246-4.004.118-.03.228-.06.33-.094.163-.054.33-.122.48-.212.133-.08.337-.228.457-.48a.898.898 0 0 0 .094-.398v-.004a1.441 1.441 0 0 0-.585-1.197 1.683 1.683 0 0 0-.47-.246c-.016-1.484-.638-2.644-1.584-3.421C12.405.368 11.183 0 9.992 0 8.802-.002 7.58.362 6.638 1.134c-.948.778-1.569 1.94-1.584 3.431a1.672 1.672 0 0 0-.463.245 1.443 1.443 0 0 0-.58 1.195v.004c0 .181.054.317.094.4.121.251.326.399.46.48.148.089.316.156.479.21Zm5.226.476a30.59 30.59 0 0 0 2.784-.134c-.131 1.093-.492 2.139-.99 2.955-.65 1.066-1.414 1.566-2.061 1.566-.64 0-1.367-.485-1.981-1.54-.474-.814-.81-1.863-.932-2.966a31.23 31.23 0 0 0 2.634.12H10.27ZM14.64 5.57h-.002c.008-.005.01-.005.002 0Zm-7.801 6.833a.77.77 0 0 0-.921-.16L3.59 13.454l-1.094.475-.005.003c-.074.033-.125.047-.206.07a6.04 6.04 0 0 0-.227.069 1.699 1.699 0 0 0-.75.448c-.358.38-.565.871-.64 1.367l-.653 3.19A.77.77 0 0 0 .769 20H19.23a.769.769 0 0 0 .754-.924l-.653-3.187c-.172-1.187-1.135-1.674-1.842-1.965l-1.148-.471-2.263-1.207a.77.77 0 0 0-.927.157l-1.55 1.68c-1.037.881-2.432.785-3.28-.072l-1.483-1.608Zm-1.71 1.986-.85.443a.745.745 0 0 1-.048.023l-1.117.485a2.997 2.997 0 0 1-.344.125l-.123.036c-.04.012-.07.02-.114.035a.641.641 0 0 0-.103.04c-.11.117-.205.305-.24.55a.768.768 0 0 1-.007.048l-.47 2.288h3.416v-4.073Zm1.539 4.073h6.666v-3.989l-.631.685a.777.777 0 0 1-.06.057c-1.638 1.433-3.985 1.338-5.427-.135a.68.68 0 0 1-.016-.016l-.532-.577v3.975Zm8.205-4.05v4.05h3.416l-.47-2.288a.754.754 0 0 1-.009-.054.58.58 0 0 0-.21-.39c-.143-.127-.363-.246-.695-.383l-1.184-.486a.772.772 0 0 1-.069-.033l-.78-.415Z',
  fill: 'currentColor'
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2805:3351
 */

const IconWorkerThick = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}), /*#__PURE__*/React.createElement("path", {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M8.678 6.754c0-1.03.407-1.756.995-2.239.19-.155.401-.288.63-.397v.777a.75.75 0 0 0 1.5 0V3.754a4.22 4.22 0 0 1 .394.001v1.14a.75.75 0 0 0 1.5 0V4.13c.222.108.428.239.612.39.59.485.996 1.21.996 2.233v.589a.75.75 0 0 0 .264.571 35.457 35.457 0 0 1-1.1.104c-.722.06-1.643.118-2.466.118-.825 0-1.713-.053-2.4-.106a42.783 42.783 0 0 1-1.073-.098l-.061-.006h-.006l-.053-.009a.756.756 0 0 0 .268-.574v-.589ZM7.603 7.846l-.001-.003-.001-.002.002.005Zm-.136-.17.005.004h.001a.053.053 0 0 0-.006-.004Zm-.3 1.495c.142.047.3.089.47.127.098 1.406.506 2.782 1.138 3.868.71 1.22 1.817 2.247 3.228 2.247 1.403 0 2.545-1.025 3.29-2.245.667-1.094 1.111-2.484 1.215-3.905.114-.028.222-.059.321-.092.159-.052.322-.118.468-.206.13-.078.329-.222.446-.469a.875.875 0 0 0 .091-.387v-.004c.008-.47-.2-.89-.57-1.167a1.64 1.64 0 0 0-.459-.24c-.015-1.447-.621-2.578-1.543-3.336-.917-.753-2.109-1.11-3.27-1.112-1.16-.002-2.353.353-3.27 1.106-.924.758-1.53 1.892-1.544 3.345a1.63 1.63 0 0 0-.452.238 1.407 1.407 0 0 0-.566 1.166v.004c0 .176.053.31.093.39.118.245.317.389.447.467.146.087.31.153.468.205Zm5.097.465a29.819 29.819 0 0 0 2.714-.13c-.128 1.064-.48 2.084-.966 2.88-.634 1.04-1.378 1.527-2.01 1.527-.623 0-1.332-.473-1.93-1.502-.462-.793-.791-1.816-.909-2.892.754.07 1.632.11 2.568.117H12.264Zm4.259-1.955h-.002a.067.067 0 0 1 .002 0Zm-7.606 6.662a.75.75 0 0 0-.898-.157l-2.267 1.182-1.067.464-.005.002a1.356 1.356 0 0 1-.2.069 6.04 6.04 0 0 0-.222.067 1.657 1.657 0 0 0-.73.437c-.351.37-.553.85-.625 1.332l-.638 3.11A.75.75 0 0 0 3 21.75h18a.75.75 0 0 0 .735-.9l-.638-3.109c-.167-1.157-1.106-1.631-1.795-1.915l-1.12-.46-2.206-1.176a.75.75 0 0 0-.904.153l-1.511 1.637c-1.011.86-2.371.767-3.198-.069l-1.446-1.568ZM7.25 16.279l-.828.432a.767.767 0 0 1-.048.023l-1.09.473c-.123.055-.24.093-.334.121l-.12.036a3.45 3.45 0 0 0-.111.033.624.624 0 0 0-.101.04.977.977 0 0 0-.233.535.77.77 0 0 1-.008.047l-.458 2.231H7.25v-3.971Zm1.5 3.971h6.5v-3.888l-.616.667a.738.738 0 0 1-.057.056c-1.598 1.396-3.886 1.304-5.292-.132a.647.647 0 0 1-.016-.016l-.519-.563v3.876Zm8-3.948v3.948h3.33l-.457-2.23a.719.719 0 0 1-.009-.053.566.566 0 0 0-.204-.38c-.14-.125-.355-.24-.678-.373l-1.154-.475a.775.775 0 0 1-.068-.032l-.76-.405Z',
  fill: 'currentColor'
}));

var aCallable$1 = aCallable$3;
var toObject$3 = toObject$6;
var IndexedObject = indexedObject;
var lengthOfArrayLike$2 = lengthOfArrayLike$4;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable$1(callbackfn);
    var O = toObject$3(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike$2(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$2(true)
};

var fails$c = fails$j;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$c(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var classof$6 = classofRaw$1;
var global$6 = global$h;

var engineIsNode = classof$6(global$6.process) == 'process';

var $$4 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$4({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var wellKnownSymbol$d = wellKnownSymbol$f;

var TO_STRING_TAG$3 = wellKnownSymbol$d('toStringTag');
var test = {};

test[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$8 = isCallable$i;
var classofRaw = classofRaw$1;
var wellKnownSymbol$c = wellKnownSymbol$f;

var TO_STRING_TAG$2 = wellKnownSymbol$c('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$5 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$8(O.callee) ? 'Arguments' : result;
};

var classof$4 = classof$5;

var toString$7 = function (argument) {
  if (classof$4(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};

var anObject$9 = anObject$c;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$9(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var regexpStickyHelpers = {};

var fails$b = fails$j;
var global$5 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$5.RegExp;

regexpStickyHelpers.UNSUPPORTED_Y = fails$b(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

regexpStickyHelpers.BROKEN_CARET = fails$b(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var DESCRIPTORS$2 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var anObject$8 = anObject$c;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = DESCRIPTORS$2 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$8(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], Properties[key]);
  return O;
};

var getBuiltIn$2 = getBuiltIn$6;

var html$1 = getBuiltIn$2('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$7 = anObject$c;
var defineProperties = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$7(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

var fails$a = fails$j;
var global$4 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$4.RegExp;

var regexpUnsupportedDotAll = fails$a(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$9 = fails$j;
var global$3 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$3.RegExp;

var regexpUnsupportedNcg = fails$9(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var toString$6 = toString$7;
var regexpFlags = regexpFlags$1;
var stickyHelpers$2 = regexpStickyHelpers;
var shared = shared$4.exports;
var create$2 = objectCreate;
var getInternalState$1 = internalState.get;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$2 = stickyHelpers$2.UNSUPPORTED_Y || stickyHelpers$2.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$2 || UNSUPPORTED_DOT_ALL$1 || UNSUPPORTED_NCG$1;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$1(re);
    var str = toString$6(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = patchedExec.call(raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$2 && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = str.slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str.charAt(re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$2(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$3 = patchedExec;

var $$3 = _export;
var exec$1 = regexpExec$3;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$3({ target: 'RegExp', proto: true, forced: /./.exec !== exec$1 }, {
  exec: exec$1
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var redefine$4 = redefine$6.exports;
var regexpExec$2 = regexpExec$3;
var fails$8 = fails$j;
var wellKnownSymbol$b = wellKnownSymbol$f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$7;

var SPECIES$3 = wellKnownSymbol$b('species');
var RegExpPrototype$2 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$b(KEY);

  var DELEGATES_TO_SYMBOL = !fails$8(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$8(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$2 || $exec === RegExpPrototype$2.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine$4(String.prototype, KEY, methods[0]);
    redefine$4(RegExpPrototype$2, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$3(RegExpPrototype$2[SYMBOL], 'sham', true);
};

var isObject$2 = isObject$8;
var classof$3 = classofRaw$1;
var wellKnownSymbol$a = wellKnownSymbol$f;

var MATCH$1 = wellKnownSymbol$a('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$2(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$3(it) == 'RegExp');
};

var fails$7 = fails$j;
var isCallable$7 = isCallable$i;
var classof$2 = classof$5;
var getBuiltIn$1 = getBuiltIn$6;
var inspectSource = inspectSource$3;

var empty = [];
var construct = getBuiltIn$1('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = constructorRegExp.exec;
var INCORRECT_TO_STRING = !constructorRegExp.exec(function () { /* empty */ });

var isConstructorModern = function (argument) {
  if (!isCallable$7(argument)) return false;
  try {
    construct(Object, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable$7(argument)) return false;
  switch (classof$2(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec.call(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$2 = !construct || fails$7(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor$1 = isConstructor$2;
var tryToString = tryToString$2;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor$1(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};

var anObject$6 = anObject$c;
var aConstructor = aConstructor$1;
var wellKnownSymbol$9 = wellKnownSymbol$f;

var SPECIES$2 = wellKnownSymbol$9('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$6(O).constructor;
  var S;
  return C === undefined || (S = anObject$6(C)[SPECIES$2]) == undefined ? defaultConstructor : aConstructor(S);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$5;
var toString$5 = toString$7;
var requireObjectCoercible$4 = requireObjectCoercible$7;

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$5(requireObjectCoercible$4($this));
    var position = toIntegerOrInfinity$2(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$3 = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

var anObject$5 = anObject$c;
var isCallable$6 = isCallable$i;
var classof$1 = classofRaw$1;
var regexpExec$1 = regexpExec$3;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$6(exec)) {
    var result = exec.call(R, S);
    if (result !== null) anObject$5(result);
    return result;
  }
  if (classof$1(R) === 'RegExp') return regexpExec$1.call(R, S);
  throw TypeError('RegExp#exec called on incompatible receiver');
};

var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var isRegExp$1 = isRegexp;
var anObject$4 = anObject$c;
var requireObjectCoercible$3 = requireObjectCoercible$7;
var speciesConstructor = speciesConstructor$1;
var advanceStringIndex$2 = advanceStringIndex$3;
var toLength$2 = toLength$4;
var toString$4 = toString$7;
var getMethod$2 = getMethod$4;
var callRegExpExec = regexpExecAbstract;
var regexpExec = regexpExec$3;
var stickyHelpers$1 = regexpStickyHelpers;
var fails$6 = fails$j;

var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y;
var arrayPush = [].push;
var min$1 = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$6(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic$2('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString$4(requireObjectCoercible$3(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp$1(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible$3(this);
      var splitter = separator == undefined ? undefined : getMethod$2(separator, SPLIT);
      return splitter
        ? splitter.call(separator, O, limit)
        : internalSplit.call(toString$4(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject$4(this);
      var S = toString$4(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y$1 ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y$1 ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y$1 ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y$1 ? S.slice(q) : S);
        var e;
        if (
          z === null ||
          (e = min$1(toLength$2(splitter.lastIndex + (UNSUPPORTED_Y$1 ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex$2(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y$1);

var wellKnownSymbol$8 = wellKnownSymbol$f;
var create$1 = objectCreate;
var definePropertyModule$1 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$8('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule$1.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$5 = fails$j;

var correctPrototypeGetter = !fails$5(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$2 = hasOwnProperty_1;
var isCallable$5 = isCallable$i;
var toObject$2 = toObject$6;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject$2(O);
  if (hasOwn$2(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$5(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};

var fails$4 = fails$j;
var isCallable$4 = isCallable$i;
var getPrototypeOf$1 = objectGetPrototypeOf;
var redefine$3 = redefine$6.exports;
var wellKnownSymbol$7 = wellKnownSymbol$f;

var ITERATOR$2 = wellKnownSymbol$7('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$4(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$2].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$4(IteratorPrototype$2[ITERATOR$2])) {
  redefine$3(IteratorPrototype$2, ITERATOR$2, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$1 = objectDefineProperty.f;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$6 = wellKnownSymbol$f;

var TO_STRING_TAG$1 = wellKnownSymbol$6('toStringTag');

var setToStringTag$2 = function (it, TAG, STATIC) {
  if (it && !hasOwn$1(it = STATIC ? it : it.prototype, TO_STRING_TAG$1)) {
    defineProperty$1(it, TO_STRING_TAG$1, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$1 = setToStringTag$2;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isCallable$3 = isCallable$i;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument === 'object' || isCallable$3(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var anObject$3 = anObject$c;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$3(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$2 = _export;
var FunctionName = functionName;
var isCallable$2 = isCallable$i;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$7;
var redefine$2 = redefine$6.exports;
var wellKnownSymbol$5 = wellKnownSymbol$f;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$5('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$2(CurrentIteratorPrototype[ITERATOR$1])) {
          redefine$2(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$2 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return nativeIterator.call(this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$2({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    redefine$2(IterablePrototype, ITERATOR$1, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject = toIndexedObject$4;
var addToUnscopables = addToUnscopables$1;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineIterator = defineIterator$1;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$2 = global$h;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$7;
var wellKnownSymbol$4 = wellKnownSymbol$f;

var ITERATOR = wellKnownSymbol$4('iterator');
var TO_STRING_TAG = wellKnownSymbol$4('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty$1(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$2[COLLECTION_NAME] && global$2[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var requireObjectCoercible$2 = requireObjectCoercible$7;
var toString$3 = toString$7;
var whitespaces$1 = whitespaces$2;

var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$3(requireObjectCoercible$2($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var fails$3 = fails$j;
var whitespaces = whitespaces$2;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$3(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME$1 && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$1 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$1({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

class SpriteHelper {
  constructor() {
    this.defaultPath = 'pf-icons-sprite.svg';
    this.storageName = 'PF_ICONS_SPRITE_PATH';
    this.cookies = null;
  }

  getPath() {
    // If value is set in the globalThis, return this value
    const storedValue = globalThisGetValue(this.storageName);

    if (this.isValidPath(storedValue)) {
      return storedValue;
    } // If not, check the cookies


    const cookies = this.getCookies(); // If cookie is set, return value from cookie

    if (cookies && this.isValidPath(cookies[this.storageName])) {
      return cookies[this.storageName];
    } // If cookie is not set, return value from service


    return this.defaultPath;
  }

  getStorageKeyName() {
    return this.storageName;
  }

  setPath(newPath) {
    this.defaultPath = newPath;
  }

  getCookies() {
    if (this.cookies) {
      return this.cookies;
    }

    if (typeof document !== 'undefined') {
      // Parse cookie string
      const cookies = document.cookie.split(';').reduce((result, current) => {
        const [name, value] = current.split('=');

        if (name && value) {
          result[name.trim()] = decodeURIComponent(value.trim());
        }

        return result;
      }, {});
      this.cookies = cookies;
      return this.cookies;
    }

    return null;
  }

  isValidPath(path) {
    return path !== undefined && path !== null;
  }

}

const service = new SpriteHelper();
function SpriteHelperService() {
  return service;
}

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:873
 */

const IconSprite360ThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#360-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:860
 */

const IconSprite360Thick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#360-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1191
 */

const IconSprite360Shape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#360-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1187
 */

const IconSprite360$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#360`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1539
 */

const IconSpriteAppleFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#apple-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1534
 */

const IconSpriteAppleFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#apple-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2394:3443
 */

const IconSpriteAreaChartThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#area-chart-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2394:3427
 */

const IconSpriteAreaChartShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#area-chart-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2133:3728
 */

const IconSpriteAreaSizeThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#area-size-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2422:3440
 */

const IconSpriteAreaSizeShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#area-size-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2394:3444
 */

const IconSpriteAreaChartThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#area_chart-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2394:3439
 */

const IconSpriteAreaChart$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#area_chart`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=508:1711
 */

const IconSpriteAreaSizeThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#area_size-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1062
 */

const IconSpriteAreaSize$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#area_size`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=269:1611
 */

const IconSpriteArrowCircleClockwiseShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-circle-clockwise-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=800:1817
 */

const IconSpriteArrowCircleCounterclockwiseShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-circle-counterclockwise-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3106
 */

const IconSpriteArrowDownThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '13',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-down-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3102
 */

const IconSpriteArrowDownShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '12',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-down-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3096
 */

const IconSpriteArrowLeftThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-left-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3076
 */

const IconSpriteArrowLeftShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '12'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-left-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=704:7
 */

const IconSpriteArrowNarrowDownThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-narrow-down-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=704:17
 */

const IconSpriteArrowNarrowUpThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-narrow-up-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3098
 */

const IconSpriteArrowRightThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-right-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3085
 */

const IconSpriteArrowRightShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '12'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-right-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3104
 */

const IconSpriteArrowUpThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '13',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-up-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3100
 */

const IconSpriteArrowUpShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '12',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-up-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3531
 */

const IconSpriteArrowZigzagDownThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-zigzag-down-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3590
 */

const IconSpriteArrowZigzagDownRtlThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-zigzag-down-rtl-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3483
 */

const IconSpriteArrowZigzagDownRtlShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-zigzag-down-rtl-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2369:3329
 */

const IconSpriteArrowZigzagDownShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-zigzag-down-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3530
 */

const IconSpriteArrowZigzagUpThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-zigzag-up-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3604
 */

const IconSpriteArrowZigzagUpRtlThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-zigzag-up-rtl-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3455
 */

const IconSpriteArrowZigzagUpRtlShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-zigzag-up-rtl-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2369:3330
 */

const IconSpriteArrowZigzagUpShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow-zigzag-up-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=270:1582
 */

const IconSpriteArrowCircleClockwise$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_circle_clockwise`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=800:1818
 */

const IconSpriteArrowCircleCounterclockwise$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_circle_counterclockwise`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3119
 */

const IconSpriteArrowDownThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_down-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3115
 */

const IconSpriteArrowDown$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_down`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3116
 */

const IconSpriteArrowLeftThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_left-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3112
 */

const IconSpriteArrowLeft$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_left`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=704:10
 */

const IconSpriteArrowNarrowDownThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_narrow_down-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=704:19
 */

const IconSpriteArrowNarrowUpThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_narrow_up-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3117
 */

const IconSpriteArrowRightThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_right-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3113
 */

const IconSpriteArrowRight$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_right`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3118
 */

const IconSpriteArrowUpThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_up-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2129:3114
 */

const IconSpriteArrowUp$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_up`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1664:3510
 */

const IconSpriteArrowZigzagDownThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_zigzag_down-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1667:4101
 */

const IconSpriteArrowZigzagDown$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_zigzag_down`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3593
 */

const IconSpriteArrowZigzagDownRtlThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_zigzag_down_rtl-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3486
 */

const IconSpriteArrowZigzagDownRtl$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_zigzag_down_rtl`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1664:3453
 */

const IconSpriteArrowZigzagUpThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_zigzag_up-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1667:4097
 */

const IconSpriteArrowZigzagUp$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_zigzag_up`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3607
 */

const IconSpriteArrowZigzagUpRtlThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_zigzag_up_rtl-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3458
 */

const IconSpriteArrowZigzagUpRtl$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrow_zigzag_up_rtl`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=268:1640
 */

const IconSpriteArrowsCircleThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrows-circle-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:851
 */

const IconSpriteArrowsUpDownThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrows-up-down-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:857
 */

const IconSpriteArrowsUpDownShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrows-up-down-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=269:1583
 */

const IconSpriteArrowsCircleThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrows_circle-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:847
 */

const IconSpriteArrowsUpDownThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrows_up_down-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:852
 */

const IconSpriteArrowsUpDown$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#arrows_up_down`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:616
 */

const IconSpriteBalconyShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#balcony-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:613
 */

const IconSpriteBalcony$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#balcony`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1148
 */

const IconSpriteBarbecueShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#barbecue-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1144
 */

const IconSpriteBarbecue$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#barbecue`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=178:94
 */

const IconSpriteBathtubThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bathtub-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=178:96
 */

const IconSpriteBathtubThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bathtub-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1123
 */

const IconSpriteBathtubShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '12'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bathtub-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1119
 */

const IconSpriteBathtub$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bathtub`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1130
 */

const IconSpriteBeachBallShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#beach-ball-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1126
 */

const IconSpriteBeachBall$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#beach_ball`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:802
 */

const IconSpriteBedThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bed-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:799
 */

const IconSpriteBedThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bed-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:766
 */

const IconSpriteBedShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bed-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:762
 */

const IconSpriteBed$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bed`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=515:1742
 */

const IconSpriteBellShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bell-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3777
 */

const IconSpriteBellThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bell-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=515:1748
 */

const IconSpriteBellThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bell-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=515:1743
 */

const IconSpriteBell$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bell`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2771:6084
 */

const IconSpriteBookOpenThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#book-open-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:606
 */

const IconSpriteBookOpenShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#book-open-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2771:6089
 */

const IconSpriteBookOpenThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#book_open-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:603
 */

const IconSpriteBookOpen$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#book_open`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=181:34
 */

const IconSpriteBricksThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bricks-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=182:0
 */

const IconSpriteBricksThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bricks-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1073
 */

const IconSpriteBricksShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bricks-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1069
 */

const IconSpriteBricks$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bricks`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=414:0
 */

const IconSpriteBriefcaseThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#briefcase-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=414:6
 */

const IconSpriteBriefcaseThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#briefcase-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:599
 */

const IconSpriteBroomShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#broom-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:596
 */

const IconSpriteBroom$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#broom`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:699
 */

const IconSpriteBubblesShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bubbles-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:693
 */

const IconSpriteBubbles$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#bubbles`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:785
 */

const IconSpriteBuildingsAltThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#buildings-alt-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1092
 */

const IconSpriteBuildingsAltShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#buildings-alt-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1085
 */

const IconSpriteBuildingsShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#buildings-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2392:3386
 */

const IconSpriteBuildingsStarThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#buildings-star-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2392:3363
 */

const IconSpriteBuildingsStarShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#buildings-star-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1081
 */

const IconSpriteBuildings$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#buildings`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:782
 */

const IconSpriteBuildingsAltThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#buildings_alt-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1088
 */

const IconSpriteBuildingsAlt$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#buildings_alt`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2392:3401
 */

const IconSpriteBuildingsStarThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#buildings_star-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2392:3365
 */

const IconSpriteBuildingsStar$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#buildings_star`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1282
 */

const IconSpriteBurjKhalifaShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#burj-khalifa-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1278
 */

const IconSpriteBurjKhalifa$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#burj_khalifa`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1047
 */

const IconSpriteCalendarThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#calendar-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1043
 */

const IconSpriteCalendarThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#calendar-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1033
 */

const IconSpriteCalendarShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#calendar-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1027
 */

const IconSpriteCalendar$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#calendar`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=507:1727
 */

const IconSpriteCarClockThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '21'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#car-clock-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4299
 */

const IconSpriteCarClockShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#car-clock-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3390
 */

const IconSpriteCarEntranceShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#car-entrance-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=507:1736
 */

const IconSpriteCarClockThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#car_clock-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3374
 */

const IconSpriteCarClock$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#car_clock`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3391
 */

const IconSpriteCarEntrance$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#car_entrance`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2302:5121
 */

const IconSpriteCheckmarkThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '11'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#checkmark-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=703:1707
 */

const IconSpriteCheckmarkThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#checkmark-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2302:5120
 */

const IconSpriteCheckmarkShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#checkmark-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=703:1715
 */

const IconSpriteCheckmark$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#checkmark`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1319
 */

const IconSpriteChevronDownThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '9'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-down-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:668
 */

const IconSpriteChevronDownShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '8'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-down-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3375
 */

const IconSpriteChevronDownSmallFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '5'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-down-small-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3335
 */

const IconSpriteChevronDownSmallThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '8',
  height: '5'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-down-small-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4243
 */

const IconSpriteChevronDownSmallShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '7',
  height: '4'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-down-small-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1316
 */

const IconSpriteChevronLeftThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-left-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:641
 */

const IconSpriteChevronLeftShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '8',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-left-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3381
 */

const IconSpriteChevronLeftSmallFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '5',
  height: '9'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-left-small-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3359
 */

const IconSpriteChevronLeftSmallThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '5',
  height: '8'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-left-small-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4249
 */

const IconSpriteChevronLeftSmallShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '4',
  height: '7'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-left-small-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1322
 */

const IconSpriteChevronRightThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-right-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:647
 */

const IconSpriteChevronRightShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '8',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-right-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3386
 */

const IconSpriteChevronRightSmallFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '5',
  height: '9'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-right-small-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3353
 */

const IconSpriteChevronRightSmallThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '5',
  height: '8'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-right-small-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4257
 */

const IconSpriteChevronRightSmallShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '4',
  height: '7'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-right-small-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1325
 */

const IconSpriteChevronUpThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '9'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-up-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:644
 */

const IconSpriteChevronUpShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '8'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-up-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3367
 */

const IconSpriteChevronUpSmallFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '9',
  height: '5'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-up-small-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3346
 */

const IconSpriteChevronUpSmallThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '8',
  height: '5'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-up-small-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4265
 */

const IconSpriteChevronUpSmallShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '7',
  height: '4'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron-up-small-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1317
 */

const IconSpriteChevronDownThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_down-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:666
 */

const IconSpriteChevronDown$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_down`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3376
 */

const IconSpriteChevronDownSmallFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_down_small-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3336
 */

const IconSpriteChevronDownSmallThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_down_small-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3249
 */

const IconSpriteChevronDownSmall$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_down_small`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1314
 */

const IconSpriteChevronLeftThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_left-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:639
 */

const IconSpriteChevronLeft$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_left`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3382
 */

const IconSpriteChevronLeftSmallFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_left_small-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3360
 */

const IconSpriteChevronLeftSmallThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_left_small-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3250
 */

const IconSpriteChevronLeftSmall$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_left_small`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1320
 */

const IconSpriteChevronRightThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_right-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:645
 */

const IconSpriteChevronRight$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_right`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3388
 */

const IconSpriteChevronRightSmallFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_right_small-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3354
 */

const IconSpriteChevronRightSmallThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_right_small-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3251
 */

const IconSpriteChevronRightSmall$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_right_small`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1323
 */

const IconSpriteChevronUpThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_up-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:642
 */

const IconSpriteChevronUp$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_up`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3370
 */

const IconSpriteChevronUpSmallFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_up_small-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2820:3348
 */

const IconSpriteChevronUpSmallThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_up_small-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3252
 */

const IconSpriteChevronUpSmall$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#chevron_up_small`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:825
 */

const IconSpriteClockHistoryThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#clock-history-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4336
 */

const IconSpriteClockHistoryShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#clock-history-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:638
 */

const IconSpriteClockShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#clock-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:633
 */

const IconSpriteClock$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#clock`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:822
 */

const IconSpriteClockHistoryThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#clock_history-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3477
 */

const IconSpriteClockHistory$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#clock_history`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1248
 */

const IconSpriteClosetShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#closet-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1244
 */

const IconSpriteCloset$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#closet`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4472
 */

const IconSpriteCogFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#cog-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3572
 */

const IconSpriteCogFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#cog-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4316
 */

const IconSpriteCogShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#cog-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3448
 */

const IconSpriteCog$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#cog`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3536
 */

const IconSpriteCompassThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#compass-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3506
 */

const IconSpriteCompassThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#compass-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3533
 */

const IconSpriteCompassShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#compass-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3440
 */

const IconSpriteCompass$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#compass`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:729
 */

const IconSpriteConciergeShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#concierge-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:722
 */

const IconSpriteConcierge$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#concierge`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3363
 */

const IconSpriteCraneShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '21',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#crane-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=86:37
 */

const IconSpriteCrane$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#crane`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2732:3337
 */

const IconSpriteCrownFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#crown-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2726:3386
 */

const IconSpriteCrownFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#crown-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3412
 */

const IconSpriteCrownShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#crown-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3413
 */

const IconSpriteCrown$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#crown`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1209
 */

const IconSpriteCutleryAndDishShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#cutlery-and-dish-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1259
 */

const IconSpriteCutleryShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#cutlery-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1253
 */

const IconSpriteCutlery$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#cutlery`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1205
 */

const IconSpriteCutleryAndDish$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#cutlery_and_dish`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:821
 */

const IconSpriteDiamondThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#diamond-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:818
 */

const IconSpriteDiamondThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#diamond-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:753
 */

const IconSpriteDogFootprintShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#dog-footprint-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:749
 */

const IconSpriteDogFootprint$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#dog_footprint`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2298:4953
 */

const IconSpriteDownloadThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#download-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2298:4956
 */

const IconSpriteDownloadThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#download-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2298:4930
 */

const IconSpriteDownloadShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#download-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1433:1799
 */

const IconSpriteDownload$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#download`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:688
 */

const IconSpriteDumbbellShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#dumbbell-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:684
 */

const IconSpriteDumbbell$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#dumbbell`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2272:3515
 */

const IconSpriteEditSquareThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#edit-square-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=702:37
 */

const IconSpriteEditSquareShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#edit-square-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=700:1736
 */

const IconSpriteEditSquareThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#edit_square-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=700:1757
 */

const IconSpriteEditSquare$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#edit_square`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=88:1442
 */

const IconSpriteElectricPlugThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#electric-plug-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=89:12
 */

const IconSpriteElectricPlugDisabledThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#electric-plug-disabled-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=89:5
 */

const IconSpriteElectricPlugThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#electric_plug-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=89:31
 */

const IconSpriteElectricPlugDisabledThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#electric_plug_disabled-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2093:3948
 */

const IconSpriteEnvelopeFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#envelope-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1350
 */

const IconSpriteEnvelopeFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#envelope-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4369
 */

const IconSpriteEnvelopeShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#envelope-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3506
 */

const IconSpriteEnvelope$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#envelope`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3361
 */

const IconSpriteExtensionShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#extension-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3371
 */

const IconSpriteExtension$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#extension`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2255:3468
 */

const IconSpriteExternalLinkThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#external-link-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3562
 */

const IconSpriteExternalLinkRtlThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#external-link-rtl-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3439
 */

const IconSpriteExternalLinkRtlShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#external-link-rtl-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2255:3484
 */

const IconSpriteExternalLinkShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#external-link-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2255:3483
 */

const IconSpriteExternalLinkThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#external_link-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=270:1583
 */

const IconSpriteExternalLink$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#external_link`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3567
 */

const IconSpriteExternalLinkRtlThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#external_link_rtl-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3442
 */

const IconSpriteExternalLinkRtl$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#external_link_rtl`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3630
 */

const IconSpriteEyeThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#eye-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=256:27
 */

const IconSpriteEyeThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#eye-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3631
 */

const IconSpriteEyeClosedThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '11'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#eye-closed-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3609
 */

const IconSpriteEyeClosedShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#eye-closed-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3608
 */

const IconSpriteEyeShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#eye-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=750:1797
 */

const IconSpriteEye$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#eye`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=256:10
 */

const IconSpriteEyeClosedThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#eye_closed-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=750:1798
 */

const IconSpriteEyeClosed$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#eye_closed`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1543
 */

const IconSpriteFacebookFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#facebook-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1542
 */

const IconSpriteFacebookFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#facebook-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3670
 */

const IconSpriteFilterThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#filter-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=501:1737
 */

const IconSpriteFilterThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#filter-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:883
 */

const IconSpriteFilterClearThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '9'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#filter-clear-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:5064
 */

const IconSpriteFilterShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#filter-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=501:1717
 */

const IconSpriteFilter$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#filter`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:880
 */

const IconSpriteFilterClearThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#filter_clear-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2291:4398
 */

const IconSpriteFlagFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#flag-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2291:4409
 */

const IconSpriteFlagFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#flag-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2291:4401
 */

const IconSpriteFlagThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#flag-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2291:4408
 */

const IconSpriteFlagThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#flag-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:5219
 */

const IconSpriteFlagShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#flag-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1000
 */

const IconSpriteFlag$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#flag`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:810
 */

const IconSpriteFloorplanThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#floorplan-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:806
 */

const IconSpriteFloorplanThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#floorplan-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1556
 */

const IconSpriteFloorplanShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#floorplan-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:770
 */

const IconSpriteFloorplan$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#floorplan`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2299:5055
 */

const IconSpriteFullscreenThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#fullscreen-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2299:5068
 */

const IconSpriteFullscreenThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#fullscreen-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=195:15
 */

const IconSpriteFullscreenShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#fullscreen-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=195:28
 */

const IconSpriteFullscreen$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#fullscreen`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:814
 */

const IconSpriteFurnitureThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '11'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#furniture-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:811
 */

const IconSpriteFurnitureThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#furniture-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:531
 */

const IconSpriteFurnitureShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#furniture-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:527
 */

const IconSpriteFurniture$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#furniture`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1528
 */

const IconSpriteGoogleFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#google-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1526
 */

const IconSpriteGoogleFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#google-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=7:1477
 */

const IconSpriteGroupPeopleShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#group-people-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1170
 */

const IconSpriteGroupPeople$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#group_people`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1243
 */

const IconSpriteHangerShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#hanger-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1241
 */

const IconSpriteHanger$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#hanger`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1372
 */

const IconSpriteHeartFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#heart-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1370
 */

const IconSpriteHeartFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#heart-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2272:3487
 */

const IconSpriteHeartThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#heart-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1338
 */

const IconSpriteHeartThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#heart-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1361
 */

const IconSpriteHeartShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#heart-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1357
 */

const IconSpriteHeart$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#heart`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3474
 */

const IconSpriteHouseFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#house-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3475
 */

const IconSpriteHouseFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#house-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3462
 */

const IconSpriteHouseThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#house-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3463
 */

const IconSpriteHouseThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#house-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3410
 */

const IconSpriteHouseArrowShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#house-arrow-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3408
 */

const IconSpriteHousePercentageShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '23',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#house-percentage-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3452
 */

const IconSpriteHouseShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#house-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1675:3453
 */

const IconSpriteHouse$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#house`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3411
 */

const IconSpriteHouseArrow$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#house_arrow`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3409
 */

const IconSpriteHousePercentage$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#house_percentage`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2113:3090
 */

const IconSpriteInfoCircleFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#info-circle-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:999
 */

const IconSpriteInfoCircleShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#info-circle-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2113:3106
 */

const IconSpriteInfoCircleFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#info_circle-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:991
 */

const IconSpriteInfoCircle$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#info_circle`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1305
 */

const IconSpriteInternetSocketShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#internet-socket-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1292
 */

const IconSpriteInternetSocket$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#internet_socket`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=36:0
 */

const IconSpriteLayersShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#layers-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:775
 */

const IconSpriteLayers$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#layers`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3349
 */

const IconSpriteLiftShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#lift-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2961:3350
 */

const IconSpriteLift$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#lift`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3352
 */

const IconSpriteLighningFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#lighning-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3358
 */

const IconSpriteLighningThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#lighning-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3364
 */

const IconSpriteLighning$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#lighning`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3351
 */

const IconSpriteLightningFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '11',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#lightning-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3348
 */

const IconSpriteLightningThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '12',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#lightning-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2750:3345
 */

const IconSpriteLightningShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '11',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#lightning-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2296:4451
 */

const IconSpriteListFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#list-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2296:4452
 */

const IconSpriteListFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#list-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2295:4431
 */

const IconSpriteListThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#list-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=189:1508
 */

const IconSpriteListThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#list-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2295:4446
 */

const IconSpriteListShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#list-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2295:4447
 */

const IconSpriteList$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#list`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:843
 */

const IconSpriteLiveThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#live-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:839
 */

const IconSpriteLiveThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#live-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4461
 */

const IconSpriteLocationArrowFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#location-arrow-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:838
 */

const IconSpriteLocationArrowThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#location-arrow-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4285
 */

const IconSpriteLocationArrowShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#location-arrow-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:890
 */

const IconSpriteLocationGpsThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#location-gps-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3571
 */

const IconSpriteLocationArrowFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#location_arrow-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:834
 */

const IconSpriteLocationArrowThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#location_arrow-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3345
 */

const IconSpriteLocationArrow$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#location_arrow`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:886
 */

const IconSpriteLocationGpsThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#location_gps-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:712
 */

const IconSpriteLotusPlantShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#lotus-plant-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:708
 */

const IconSpriteLotusPlant$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#lotus_plant`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2093:3947
 */

const IconSpriteMagnifierFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#magnifier-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=724:1759
 */

const IconSpriteMagnifierFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#magnifier-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:895
 */

const IconSpriteMagnifierThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#magnifier-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:892
 */

const IconSpriteMagnifierThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#magnifier-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1106
 */

const IconSpriteMagnifierMinusShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#magnifier-minus-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1100
 */

const IconSpriteMagnifierPlusShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#magnifier-plus-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1112
 */

const IconSpriteMagnifierShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#magnifier-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1108
 */

const IconSpriteMagnifier$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#magnifier`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1102
 */

const IconSpriteMagnifierMinus$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#magnifier_minus`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1096
 */

const IconSpriteMagnifierPlus$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#magnifier_plus`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=275:510
 */

const IconSpriteMapPinFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#map-pin-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4110
 */

const IconSpriteMapPinThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#map-pin-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=271:1582
 */

const IconSpriteMapPinPlusThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#map-pin-plus-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1024
 */

const IconSpriteMapPinShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#map-pin-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=275:516
 */

const IconSpriteMapPinFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#map_pin-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=170:1670
 */

const IconSpriteMapPinThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#map_pin-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1020
 */

const IconSpriteMapPin$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#map_pin`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=271:1606
 */

const IconSpriteMapPinPlusThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#map_pin_plus-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2996:3343
 */

const IconSpriteMenuThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '12'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#menu-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2996:3344
 */

const IconSpriteMenuThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#menu-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2995:3331
 */

const IconSpriteMenuShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '11'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#menu-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2995:3339
 */

const IconSpriteMenu$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#menu`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1156
 */

const IconSpriteMezzanineShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '13'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#mezzanine-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1152
 */

const IconSpriteMezzanine$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#mezzanine`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1674:3437
 */

const IconSpriteMicrophoneFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '11',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#microphone-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1674:3440
 */

const IconSpriteMicrophoneFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#microphone-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1674:3421
 */

const IconSpriteMicrophoneShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '11',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#microphone-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=1674:3422
 */

const IconSpriteMicrophone$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#microphone`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1334
 */

const IconSpriteMinusThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '2'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#minus-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1332
 */

const IconSpriteMinusThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#minus-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:656
 */

const IconSpriteMinusShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '1'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#minus-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:654
 */

const IconSpriteMinus$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#minus`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:794
 */

const IconSpriteMoneyBillsThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '12'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#money-bills-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3403
 */

const IconSpriteMoneyBillsShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#money-bills-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:791
 */

const IconSpriteMoneyBillsThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#money_bills-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=86:155
 */

const IconSpriteMoneyBills$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#money_bills`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:738
 */

const IconSpriteMopShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#mop-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:730
 */

const IconSpriteMop$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#mop`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4210
 */

const IconSpriteMoreHorizontalThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '4'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#more-horizontal-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4216
 */

const IconSpriteMoreVerticalThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '4',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#more-vertical-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4214
 */

const IconSpriteMoreHorizontalThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#more_horizontal-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4220
 */

const IconSpriteMoreVerticalThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#more_vertical-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:623
 */

const IconSpritePalmTreeShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#palm-tree-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:620
 */

const IconSpritePalmTree$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#palm_tree`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:833
 */

const IconSpritePaperplaneThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#paperplane-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:832
 */

const IconSpritePaperplaneThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#paperplane-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:744
 */

const IconSpriteParkingSignShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#parking-sign-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:740
 */

const IconSpriteParkingSign$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#parking_sign`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2100:3968
 */

const IconSpritePhoneFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#phone-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:657
 */

const IconSpritePhoneFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#phone-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2100:3964
 */

const IconSpritePhoneShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '17',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#phone-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3478
 */

const IconSpritePhone$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#phone`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1201
 */

const IconSpritePhotoCameraShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#photo-camera-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1197
 */

const IconSpritePhotoCamera$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#photo_camera`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:988
 */

const IconSpritePinterestFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#pinterest-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1055
 */

const IconSpritePlayThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#play-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1049
 */

const IconSpritePlayThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#play-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2347:3574
 */

const IconSpritePlayShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#play-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1036
 */

const IconSpritePlay$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#play`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1331
 */

const IconSpritePlusThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#plus-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1329
 */

const IconSpritePlusThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#plus-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:653
 */

const IconSpritePlusShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#plus-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:651
 */

const IconSpritePlus$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#plus`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:680
 */

const IconSpritePoolLadderShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#pool-ladder-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:676
 */

const IconSpritePoolLadder$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#pool_ladder`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1219
 */

const IconSpriteReceptionistShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#receptionist-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1215
 */

const IconSpriteReceptionist$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#receptionist`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3484
 */

const IconSpriteRoadSizeThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#road-size-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3462
 */

const IconSpriteRoadSizeShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#road-size-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3488
 */

const IconSpriteRoadSizeThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#road_size-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2517:3466
 */

const IconSpriteRoadSize$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#road_size`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:594
 */

const IconSpriteRoomShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#room-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:591
 */

const IconSpriteRoom$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#room`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3892
 */

const IconSpriteShareThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1306
 */

const IconSpriteShareThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3891
 */

const IconSpriteShareAltThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share-alt-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3543
 */

const IconSpriteShareAltRtlThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share-alt-rtl-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3497
 */

const IconSpriteShareAltRtlShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share-alt-rtl-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3745
 */

const IconSpriteShareAltShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share-alt-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3752
 */

const IconSpriteShareShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1343
 */

const IconSpriteShare$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3947
 */

const IconSpriteShareAltThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share_alt-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2277:3849
 */

const IconSpriteShareAlt$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share_alt`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2371:3544
 */

const IconSpriteShareAltRtlThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share_alt_rtl-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3498
 */

const IconSpriteShareAltRtl$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#share_alt_rtl`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2097:3909
 */

const IconSpriteShieldCheckmarkFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#shield-checkmark-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2097:3931
 */

const IconSpriteShieldCheckmarkShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#shield-checkmark-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:719
 */

const IconSpriteShieldShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#shield-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:715
 */

const IconSpriteShield$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#shield`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2097:3908
 */

const IconSpriteShieldCheckmarkFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#shield_checkmark-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2097:3932
 */

const IconSpriteShieldCheckmark$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#shield_checkmark`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:612
 */

const IconSpriteSnowFlakeShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '19'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#snow-flake-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:609
 */

const IconSpriteSnowFlake$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#snow_flake`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:877
 */

const IconSpriteSortDownThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#sort-down-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:5080
 */

const IconSpriteSortDownShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#sort-down-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:5147
 */

const IconSpriteSortUpShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '15',
  height: '15'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#sort-up-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:874
 */

const IconSpriteSortDownThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#sort_down-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1006
 */

const IconSpriteSortDown$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#sort_down`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1013
 */

const IconSpriteSortUp$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#sort_up`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1232
 */

const IconSpriteSpiceShakersShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '18',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#spice-shakers-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1228
 */

const IconSpriteSpiceShakers$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#spice_shakers`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=705:5
 */

const IconSpriteStarFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#star-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=705:6
 */

const IconSpriteStarFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#star-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=702:34
 */

const IconSpriteStarThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#star-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=702:35
 */

const IconSpriteStarThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#star-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=702:27
 */

const IconSpriteStarShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#star-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2764:6040
 */

const IconSpriteStarTrophyFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '12',
  height: '18'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#star-trophy-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=702:28
 */

const IconSpriteStar$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#star`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2764:6045
 */

const IconSpriteStarTrophyFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#star_trophy-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1271
 */

const IconSpriteSunAndWaterShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '17'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#sun-and-water-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1265
 */

const IconSpriteSunAndWater$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#sun_and_water`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1139
 */

const IconSpriteSwingShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '19',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#swing-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1135
 */

const IconSpriteSwing$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#swing`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4496
 */

const IconSpriteTextBubbleFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#text-bubble-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4363
 */

const IconSpriteTextBubbleShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#text-bubble-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3573
 */

const IconSpriteTextBubbleFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#text_bubble-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3505
 */

const IconSpriteTextBubble$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#text_bubble`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4136
 */

const IconSpriteThreeDotsHorizontalShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '4'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#three-dots-horizontal-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2285:4146
 */

const IconSpriteThreeDotsVerticalShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '4',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#three-dots-vertical-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1056
 */

const IconSpriteThreeDotsHorizontal$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#three_dots_horizontal`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=801:1746
 */

const IconSpriteThreeDotsVertical$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#three_dots_vertical`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=216:88
 */

const IconSpriteThumbsUpShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '21'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#thumbs-up-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=216:89
 */

const IconSpriteThumbsUp$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#thumbs_up`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1328
 */

const IconSpriteTimesThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#times-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1326
 */

const IconSpriteTimesThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#times-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2370:3532
 */

const IconSpriteTimesCircleThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#times-circle-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:650
 */

const IconSpriteTimesShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '14',
  height: '14'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#times-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1118
 */

const IconSpriteTimesSmallThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '10',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#times-small-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1114
 */

const IconSpriteTimesSmallShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '11',
  height: '10'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#times-small-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:648
 */

const IconSpriteTimes$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#times`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=532:1708
 */

const IconSpriteTimesCircleThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#times_circle-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1115
 */

const IconSpriteTimesSmallThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#times_small-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1113
 */

const IconSpriteTimesSmall$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#times_small`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:972
 */

const IconSpriteTwitterFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#twitter-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:969
 */

const IconSpriteTwitterFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#twitter-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2290:4368
 */

const IconSpriteUserFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#user-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2290:4373
 */

const IconSpriteUserFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#user-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2287:4321
 */

const IconSpriteUserThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#user-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=270:1602
 */

const IconSpriteUserThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#user-thick`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2287:4239
 */

const IconSpriteUserShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#user-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:669
 */

const IconSpriteUser$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#user`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1169
 */

const IconSpriteVastuStarShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#vastu-star-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:1159
 */

const IconSpriteVastuStar$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#vastu_star`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2100:3975
 */

const IconSpriteWhatsappFilledShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#whatsapp-filled-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0:660
 */

const IconSpriteWhatsappFilled$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#whatsapp-filled`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2091:4382
 */

const IconSpriteWhatsappShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '16',
  height: '16'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#whatsapp-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2096:3527
 */

const IconSpriteWhatsapp$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#whatsapp`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2805:3350
 */

const IconSpriteWorkerThickShape$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '20',
  height: '20'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#worker-thick-shape`
}));

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=2805:3351
 */

const IconSpriteWorkerThick$1 = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  width: '24',
  height: '24'
}), /*#__PURE__*/React.createElement("use", {
  href: `${SpriteHelperService().getPath()}#worker-thick`
}));

var toObject$1 = toObject$6;

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$1(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var fails$2 = fails$j;
var anObject$2 = anObject$c;
var isCallable$1 = isCallable$i;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$5;
var toLength$1 = toLength$4;
var toString$2 = toString$7;
var requireObjectCoercible$1 = requireObjectCoercible$7;
var advanceStringIndex$1 = advanceStringIndex$3;
var getMethod$1 = getMethod$4;
var getSubstitution = getSubstitution$1;
var regExpExec$1 = regexpExecAbstract;
var wellKnownSymbol$3 = wellKnownSymbol$f;

var REPLACE = wellKnownSymbol$3('replace');
var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$2(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$1(this);
      var replacer = searchValue == undefined ? undefined : getMethod$1(searchValue, REPLACE);
      return replacer
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(toString$2(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$2(this);
      var S = toString$2(string);

      if (
        typeof replaceValue === 'string' &&
        replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 &&
        replaceValue.indexOf('$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$1(replaceValue);
      if (!functionalReplace) replaceValue = toString$2(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec$1(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = toString$2(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$1(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$2(result[0]);
        var position = max(min(toIntegerOrInfinity$1(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = toString$2(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var classof = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$2 = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};

var aCallable = aCallable$3;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aCallable(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var isArray$1 = isArray$2;
var lengthOfArrayLike$1 = lengthOfArrayLike$4;
var bind = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$1(element)) {
        elementLen = lengthOfArrayLike$1(element);
        targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$1;

var isArray = isArray$2;
var isConstructor = isConstructor$2;
var isObject$1 = isObject$8;
var wellKnownSymbol$2 = wellKnownSymbol$f;

var SPECIES$1 = wellKnownSymbol$2('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject$1(C)) {
      C = C[SPECIES$1];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var $ = _export;
var flattenIntoArray = flattenIntoArray_1;
var toObject = toObject$6;
var lengthOfArrayLike = lengthOfArrayLike$4;
var toIntegerOrInfinity = toIntegerOrInfinity$5;
var arraySpeciesCreate = arraySpeciesCreate$1;

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
    return A;
  }
});

var PROPER_FUNCTION_NAME = functionName.PROPER;
var redefine$1 = redefine$6.exports;
var anObject$1 = anObject$c;
var $toString = toString$7;
var fails$1 = fails$j;
var flags = regexpFlags$1;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$1(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine$1(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$1(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype$1) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$c;
var toLength = toLength$4;
var toString$1 = toString$7;
var requireObjectCoercible = requireObjectCoercible$7;
var getMethod = getMethod$4;
var advanceStringIndex = advanceStringIndex$3;
var regExpExec = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](toString$1(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString$1(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString$1(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var isCallable = isCallable$i;
var isObject = isObject$8;
var setPrototypeOf = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var getBuiltIn = getBuiltIn$6;
var definePropertyModule = objectDefineProperty;
var wellKnownSymbol$1 = wellKnownSymbol$f;
var DESCRIPTORS$1 = descriptors;

var SPECIES = wellKnownSymbol$1('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS$1 && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var DESCRIPTORS = descriptors;
var global$1 = global$h;
var isForced = isForced_1;
var inheritIfRequired = inheritIfRequired$1;
var createNonEnumerableProperty = createNonEnumerableProperty$7;
var defineProperty = objectDefineProperty.f;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var isRegExp = isRegexp;
var toString = toString$7;
var getFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var redefine = redefine$6.exports;
var fails = fails$j;
var hasOwn = hasOwnProperty_1;
var enforceInternalState = internalState.enforce;
var setSpecies = setSpecies$1;
var wellKnownSymbol = wellKnownSymbol$f;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global$1.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      result += chr + string.charAt(++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      chr = chr + string.charAt(++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (IS_NCG.test(string.slice(index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named.push([groupname, groupid]);
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || pattern instanceof RegExpWrapper) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags.call(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && flags.indexOf('s') > -1;
      if (dotAll) flags = flags.replace(/s/g, '');
    }

    rawFlags = flags;

    if (UNSUPPORTED_Y && 'sticky' in re1) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global$1, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var IconSprite360ThickShape = "360--thick-shape";
var IconSprite360Thick = "360--thick";
var IconSprite360Shape = "360-shape";
var IconSprite360 = "360";
var IconSpriteAppleFilledShape = "apple--filled-shape";
var IconSpriteAppleFilled = "apple--filled";
var IconSpriteAreaChartThickShape = "area-chart--thick-shape";
var IconSpriteAreaChartShape = "area-chart-shape";
var IconSpriteAreaSizeThickShape = "area-size--thick-shape";
var IconSpriteAreaSizeShape = "area-size-shape";
var IconSpriteAreaChartThick = "area_chart--thick";
var IconSpriteAreaChart = "area_chart";
var IconSpriteAreaSizeThick = "area_size--thick";
var IconSpriteAreaSize = "area_size";
var IconSpriteArrowCircleClockwiseShape = "arrow-circle-clockwise-shape";
var IconSpriteArrowCircleCounterclockwiseShape = "arrow-circle-counterclockwise-shape";
var IconSpriteArrowDownThickShape = "arrow-down--thick-shape";
var IconSpriteArrowDownShape = "arrow-down-shape";
var IconSpriteArrowLeftThickShape = "arrow-left--thick-shape";
var IconSpriteArrowLeftShape = "arrow-left-shape";
var IconSpriteArrowNarrowDownThickShape = "arrow-narrow-down--thick-shape";
var IconSpriteArrowNarrowUpThickShape = "arrow-narrow-up--thick-shape";
var IconSpriteArrowRightThickShape = "arrow-right--thick-shape";
var IconSpriteArrowRightShape = "arrow-right-shape";
var IconSpriteArrowUpThickShape = "arrow-up--thick-shape";
var IconSpriteArrowUpShape = "arrow-up-shape";
var IconSpriteArrowZigzagDownThickShape = "arrow-zigzag-down--thick-shape";
var IconSpriteArrowZigzagDownRtlThickShape = "arrow-zigzag-down-rtl--thick-shape";
var IconSpriteArrowZigzagDownRtlShape = "arrow-zigzag-down-rtl-shape";
var IconSpriteArrowZigzagDownShape = "arrow-zigzag-down-shape";
var IconSpriteArrowZigzagUpThickShape = "arrow-zigzag-up--thick-shape";
var IconSpriteArrowZigzagUpRtlThickShape = "arrow-zigzag-up-rtl--thick-shape";
var IconSpriteArrowZigzagUpRtlShape = "arrow-zigzag-up-rtl-shape";
var IconSpriteArrowZigzagUpShape = "arrow-zigzag-up-shape";
var IconSpriteArrowCircleClockwise = "arrow_circle_clockwise";
var IconSpriteArrowCircleCounterclockwise = "arrow_circle_counterclockwise";
var IconSpriteArrowDownThick = "arrow_down--thick";
var IconSpriteArrowDown = "arrow_down";
var IconSpriteArrowLeftThick = "arrow_left--thick";
var IconSpriteArrowLeft = "arrow_left";
var IconSpriteArrowNarrowDownThick = "arrow_narrow_down--thick";
var IconSpriteArrowNarrowUpThick = "arrow_narrow_up--thick";
var IconSpriteArrowRightThick = "arrow_right--thick";
var IconSpriteArrowRight = "arrow_right";
var IconSpriteArrowUpThick = "arrow_up--thick";
var IconSpriteArrowUp = "arrow_up";
var IconSpriteArrowZigzagDownThick = "arrow_zigzag_down--thick";
var IconSpriteArrowZigzagDown = "arrow_zigzag_down";
var IconSpriteArrowZigzagDownRtlThick = "arrow_zigzag_down_rtl--thick";
var IconSpriteArrowZigzagDownRtl = "arrow_zigzag_down_rtl";
var IconSpriteArrowZigzagUpThick = "arrow_zigzag_up--thick";
var IconSpriteArrowZigzagUp = "arrow_zigzag_up";
var IconSpriteArrowZigzagUpRtlThick = "arrow_zigzag_up_rtl--thick";
var IconSpriteArrowZigzagUpRtl = "arrow_zigzag_up_rtl";
var IconSpriteArrowsCircleThickShape = "arrows-circle--thick-shape";
var IconSpriteArrowsUpDownThickShape = "arrows-up-down--thick-shape";
var IconSpriteArrowsUpDownShape = "arrows-up-down-shape";
var IconSpriteArrowsCircleThick = "arrows_circle--thick";
var IconSpriteArrowsUpDownThick = "arrows_up_down--thick";
var IconSpriteArrowsUpDown = "arrows_up_down";
var IconSpriteBalconyShape = "balcony-shape";
var IconSpriteBalcony = "balcony";
var IconSpriteBarbecueShape = "barbecue-shape";
var IconSpriteBarbecue = "barbecue";
var IconSpriteBathtubThickShape = "bathtub--thick-shape";
var IconSpriteBathtubThick = "bathtub--thick";
var IconSpriteBathtubShape = "bathtub-shape";
var IconSpriteBathtub = "bathtub";
var IconSpriteBeachBallShape = "beach-ball-shape";
var IconSpriteBeachBall = "beach_ball";
var IconSpriteBedThickShape = "bed--thick-shape";
var IconSpriteBedThick = "bed--thick";
var IconSpriteBedShape = "bed-shape";
var IconSpriteBed = "bed";
var IconSpriteBellShape = "bell-shape";
var IconSpriteBellThickShape = "bell-thick-shape";
var IconSpriteBellThick = "bell-thick";
var IconSpriteBell = "bell";
var IconSpriteBookOpenThickShape = "book-open--thick-shape";
var IconSpriteBookOpenShape = "book-open-shape";
var IconSpriteBookOpenThick = "book_open--thick";
var IconSpriteBookOpen = "book_open";
var IconSpriteBricksThickShape = "bricks--thick-shape";
var IconSpriteBricksThick = "bricks--thick";
var IconSpriteBricksShape = "bricks-shape";
var IconSpriteBricks = "bricks";
var IconSpriteBriefcaseThickShape = "briefcase--thick-shape";
var IconSpriteBriefcaseThick = "briefcase--thick";
var IconSpriteBroomShape = "broom-shape";
var IconSpriteBroom = "broom";
var IconSpriteBubblesShape = "bubbles-shape";
var IconSpriteBubbles = "bubbles";
var IconSpriteBuildingsAltThickShape = "buildings-alt--thick-shape";
var IconSpriteBuildingsAltShape = "buildings-alt-shape";
var IconSpriteBuildingsShape = "buildings-shape";
var IconSpriteBuildingsStarThickShape = "buildings-star--thick-shape";
var IconSpriteBuildingsStarShape = "buildings-star-shape";
var IconSpriteBuildings = "buildings";
var IconSpriteBuildingsAltThick = "buildings_alt--thick";
var IconSpriteBuildingsAlt = "buildings_alt";
var IconSpriteBuildingsStarThick = "buildings_star--thick";
var IconSpriteBuildingsStar = "buildings_star";
var IconSpriteBurjKhalifaShape = "burj-khalifa-shape";
var IconSpriteBurjKhalifa = "burj_khalifa";
var IconSpriteCalendarThickShape = "calendar--thick-shape";
var IconSpriteCalendarThick = "calendar--thick";
var IconSpriteCalendarShape = "calendar-shape";
var IconSpriteCalendar = "calendar";
var IconSpriteCarClockThickShape = "car-clock--thick-shape";
var IconSpriteCarClockShape = "car-clock-shape";
var IconSpriteCarEntranceShape = "car-entrance-shape";
var IconSpriteCarClockThick = "car_clock--thick";
var IconSpriteCarClock = "car_clock";
var IconSpriteCarEntrance = "car_entrance";
var IconSpriteCheckmarkThickShape = "checkmark--thick-shape";
var IconSpriteCheckmarkThick = "checkmark--thick";
var IconSpriteCheckmarkShape = "checkmark-shape";
var IconSpriteCheckmark = "checkmark";
var IconSpriteChevronDownThickShape = "chevron-down--thick-shape";
var IconSpriteChevronDownShape = "chevron-down-shape";
var IconSpriteChevronDownSmallFilledShape = "chevron-down-small--filled-shape";
var IconSpriteChevronDownSmallThickShape = "chevron-down-small--thick-shape";
var IconSpriteChevronDownSmallShape = "chevron-down-small-shape";
var IconSpriteChevronLeftThickShape = "chevron-left--thick-shape";
var IconSpriteChevronLeftShape = "chevron-left-shape";
var IconSpriteChevronLeftSmallFilledShape = "chevron-left-small--filled-shape";
var IconSpriteChevronLeftSmallThickShape = "chevron-left-small--thick-shape";
var IconSpriteChevronLeftSmallShape = "chevron-left-small-shape";
var IconSpriteChevronRightThickShape = "chevron-right--thick-shape";
var IconSpriteChevronRightShape = "chevron-right-shape";
var IconSpriteChevronRightSmallFilledShape = "chevron-right-small--filled-shape";
var IconSpriteChevronRightSmallThickShape = "chevron-right-small--thick-shape";
var IconSpriteChevronRightSmallShape = "chevron-right-small-shape";
var IconSpriteChevronUpThickShape = "chevron-up--thick-shape";
var IconSpriteChevronUpShape = "chevron-up-shape";
var IconSpriteChevronUpSmallFilledShape = "chevron-up-small--filled-shape";
var IconSpriteChevronUpSmallThickShape = "chevron-up-small--thick-shape";
var IconSpriteChevronUpSmallShape = "chevron-up-small-shape";
var IconSpriteChevronDownThick = "chevron_down--thick";
var IconSpriteChevronDown = "chevron_down";
var IconSpriteChevronDownSmallFilled = "chevron_down_small--filled";
var IconSpriteChevronDownSmallThick = "chevron_down_small--thick";
var IconSpriteChevronDownSmall = "chevron_down_small";
var IconSpriteChevronLeftThick = "chevron_left--thick";
var IconSpriteChevronLeft = "chevron_left";
var IconSpriteChevronLeftSmallFilled = "chevron_left_small--filled";
var IconSpriteChevronLeftSmallThick = "chevron_left_small--thick";
var IconSpriteChevronLeftSmall = "chevron_left_small";
var IconSpriteChevronRightThick = "chevron_right--thick";
var IconSpriteChevronRight = "chevron_right";
var IconSpriteChevronRightSmallFilled = "chevron_right_small--filled";
var IconSpriteChevronRightSmallThick = "chevron_right_small--thick";
var IconSpriteChevronRightSmall = "chevron_right_small";
var IconSpriteChevronUpThick = "chevron_up--thick";
var IconSpriteChevronUp = "chevron_up";
var IconSpriteChevronUpSmallFilled = "chevron_up_small--filled";
var IconSpriteChevronUpSmallThick = "chevron_up_small--thick";
var IconSpriteChevronUpSmall = "chevron_up_small";
var IconSpriteClockHistoryThickShape = "clock-history--thick-shape";
var IconSpriteClockHistoryShape = "clock-history-shape";
var IconSpriteClockShape = "clock-shape";
var IconSpriteClock = "clock";
var IconSpriteClockHistoryThick = "clock_history--thick";
var IconSpriteClockHistory = "clock_history";
var IconSpriteClosetShape = "closet-shape";
var IconSpriteCloset = "closet";
var IconSpriteCogFilledShape = "cog--filled-shape";
var IconSpriteCogFilled = "cog--filled";
var IconSpriteCogShape = "cog-shape";
var IconSpriteCog = "cog";
var IconSpriteCompassThickShape = "compass--thick-shape";
var IconSpriteCompassThick = "compass--thick";
var IconSpriteCompassShape = "compass-shape";
var IconSpriteCompass = "compass";
var IconSpriteConciergeShape = "concierge-shape";
var IconSpriteConcierge = "concierge";
var IconSpriteCraneShape = "crane-shape";
var IconSpriteCrane = "crane";
var IconSpriteCrownFilledShape = "crown--filled-shape";
var IconSpriteCrownFilled = "crown--filled";
var IconSpriteCrownShape = "crown-shape";
var IconSpriteCrown = "crown";
var IconSpriteCutleryAndDishShape = "cutlery-and-dish-shape";
var IconSpriteCutleryShape = "cutlery-shape";
var IconSpriteCutlery = "cutlery";
var IconSpriteCutleryAndDish = "cutlery_and_dish";
var IconSpriteDiamondThickShape = "diamond--thick-shape";
var IconSpriteDiamondThick = "diamond--thick";
var IconSpriteDogFootprintShape = "dog-footprint-shape";
var IconSpriteDogFootprint = "dog_footprint";
var IconSpriteDownloadThickShape = "download--thick-shape";
var IconSpriteDownloadThick = "download--thick";
var IconSpriteDownloadShape = "download-shape";
var IconSpriteDownload = "download";
var IconSpriteDumbbellShape = "dumbbell-shape";
var IconSpriteDumbbell = "dumbbell";
var IconSpriteEditSquareThickShape = "edit-square--thick-shape";
var IconSpriteEditSquareShape = "edit-square-shape";
var IconSpriteEditSquareThick = "edit_square--thick";
var IconSpriteEditSquare = "edit_square";
var IconSpriteElectricPlugThickShape = "electric-plug--thick-shape";
var IconSpriteElectricPlugDisabledThickShape = "electric-plug-disabled--thick-shape";
var IconSpriteElectricPlugThick = "electric_plug--thick";
var IconSpriteElectricPlugDisabledThick = "electric_plug_disabled--thick";
var IconSpriteEnvelopeFilledShape = "envelope--filled-shape";
var IconSpriteEnvelopeFilled = "envelope--filled";
var IconSpriteEnvelopeShape = "envelope-shape";
var IconSpriteEnvelope = "envelope";
var IconSpriteExtensionShape = "extension-shape";
var IconSpriteExtension = "extension";
var IconSpriteExternalLinkThickShape = "external-link--thick-shape";
var IconSpriteExternalLinkRtlThickShape = "external-link-rtl--thick-shape";
var IconSpriteExternalLinkRtlShape = "external-link-rtl-shape";
var IconSpriteExternalLinkShape = "external-link-shape";
var IconSpriteExternalLinkThick = "external_link--thick";
var IconSpriteExternalLink = "external_link";
var IconSpriteExternalLinkRtlThick = "external_link_rtl--thick";
var IconSpriteExternalLinkRtl = "external_link_rtl";
var IconSpriteEyeThickShape = "eye--thick-shape";
var IconSpriteEyeThick = "eye--thick";
var IconSpriteEyeClosedThickShape = "eye-closed--thick-shape";
var IconSpriteEyeClosedShape = "eye-closed-shape";
var IconSpriteEyeShape = "eye-shape";
var IconSpriteEye = "eye";
var IconSpriteEyeClosedThick = "eye_closed--thick";
var IconSpriteEyeClosed = "eye_closed";
var IconSpriteFacebookFilledShape = "facebook--filled-shape";
var IconSpriteFacebookFilled = "facebook--filled";
var IconSpriteFilterThickShape = "filter--thick-shape";
var IconSpriteFilterThick = "filter--thick";
var IconSpriteFilterClearThickShape = "filter-clear--thick-shape";
var IconSpriteFilterShape = "filter-shape";
var IconSpriteFilter = "filter";
var IconSpriteFilterClearThick = "filter_clear--thick";
var IconSpriteFlagFilledShape = "flag--filled-shape";
var IconSpriteFlagFilled = "flag--filled";
var IconSpriteFlagThickShape = "flag--thick-shape";
var IconSpriteFlagThick = "flag--thick";
var IconSpriteFlagShape = "flag-shape";
var IconSpriteFlag = "flag";
var IconSpriteFloorplanThickShape = "floorplan--thick-shape";
var IconSpriteFloorplanThick = "floorplan--thick";
var IconSpriteFloorplanShape = "floorplan-shape";
var IconSpriteFloorplan = "floorplan";
var IconSpriteFullscreenThickShape = "fullscreen--thick-shape";
var IconSpriteFullscreenThick = "fullscreen--thick";
var IconSpriteFullscreenShape = "fullscreen-shape";
var IconSpriteFullscreen = "fullscreen";
var IconSpriteFurnitureThickShape = "furniture--thick-shape";
var IconSpriteFurnitureThick = "furniture--thick";
var IconSpriteFurnitureShape = "furniture-shape";
var IconSpriteFurniture = "furniture";
var IconSpriteGoogleFilledShape = "google--filled-shape";
var IconSpriteGoogleFilled = "google--filled";
var IconSpriteGroupPeopleShape = "group-people-shape";
var IconSpriteGroupPeople = "group_people";
var IconSpriteHangerShape = "hanger-shape";
var IconSpriteHanger = "hanger";
var IconSpriteHeartFilledShape = "heart--filled-shape";
var IconSpriteHeartFilled = "heart--filled";
var IconSpriteHeartThickShape = "heart--thick-shape";
var IconSpriteHeartThick = "heart--thick";
var IconSpriteHeartShape = "heart-shape";
var IconSpriteHeart = "heart";
var IconSpriteHouseFilledShape = "house--filled-shape";
var IconSpriteHouseFilled = "house--filled";
var IconSpriteHouseThickShape = "house--thick-shape";
var IconSpriteHouseThick = "house--thick";
var IconSpriteHouseArrowShape = "house-arrow-shape";
var IconSpriteHousePercentageShape = "house-percentage-shape";
var IconSpriteHouseShape = "house-shape";
var IconSpriteHouse = "house";
var IconSpriteHouseArrow = "house_arrow";
var IconSpriteHousePercentage = "house_percentage";
var IconSpriteInfoCircleFilledShape = "info-circle--filled-shape";
var IconSpriteInfoCircleShape = "info-circle-shape";
var IconSpriteInfoCircleFilled = "info_circle--filled";
var IconSpriteInfoCircle = "info_circle";
var IconSpriteInternetSocketShape = "internet-socket-shape";
var IconSpriteInternetSocket = "internet_socket";
var IconSpriteLayersShape = "layers-shape";
var IconSpriteLayers = "layers";
var IconSpriteLiftShape = "lift-shape";
var IconSpriteLift = "lift";
var IconSpriteLighningFilled = "lighning--filled";
var IconSpriteLighningThick = "lighning--thick";
var IconSpriteLighning = "lighning";
var IconSpriteLightningFilledShape = "lightning--filled-shape";
var IconSpriteLightningThickShape = "lightning--thick-shape";
var IconSpriteLightningShape = "lightning-shape";
var IconSpriteListFilledShape = "list--filled-shape";
var IconSpriteListFilled = "list--filled";
var IconSpriteListThickShape = "list--thick-shape";
var IconSpriteListThick = "list--thick";
var IconSpriteListShape = "list-shape";
var IconSpriteList = "list";
var IconSpriteLiveThickShape = "live--thick-shape";
var IconSpriteLiveThick = "live--thick";
var IconSpriteLocationArrowFilledShape = "location-arrow--filled-shape";
var IconSpriteLocationArrowThickShape = "location-arrow--thick-shape";
var IconSpriteLocationArrowShape = "location-arrow-shape";
var IconSpriteLocationGpsThickShape = "location-gps--thick-shape";
var IconSpriteLocationArrowFilled = "location_arrow--filled";
var IconSpriteLocationArrowThick = "location_arrow--thick";
var IconSpriteLocationArrow = "location_arrow";
var IconSpriteLocationGpsThick = "location_gps--thick";
var IconSpriteLotusPlantShape = "lotus-plant-shape";
var IconSpriteLotusPlant = "lotus_plant";
var IconSpriteMagnifierFilledShape = "magnifier--filled-shape";
var IconSpriteMagnifierFilled = "magnifier--filled";
var IconSpriteMagnifierThickShape = "magnifier--thick-shape";
var IconSpriteMagnifierThick = "magnifier--thick";
var IconSpriteMagnifierMinusShape = "magnifier-minus-shape";
var IconSpriteMagnifierPlusShape = "magnifier-plus-shape";
var IconSpriteMagnifierShape = "magnifier-shape";
var IconSpriteMagnifier = "magnifier";
var IconSpriteMagnifierMinus = "magnifier_minus";
var IconSpriteMagnifierPlus = "magnifier_plus";
var IconSpriteMapPinFilledShape = "map-pin--filled-shape";
var IconSpriteMapPinThickShape = "map-pin--thick-shape";
var IconSpriteMapPinPlusThickShape = "map-pin-plus--thick-shape";
var IconSpriteMapPinShape = "map-pin-shape";
var IconSpriteMapPinFilled = "map_pin--filled";
var IconSpriteMapPinThick = "map_pin--thick";
var IconSpriteMapPin = "map_pin";
var IconSpriteMapPinPlusThick = "map_pin_plus--thick";
var IconSpriteMenuThickShape = "menu--thick-shape";
var IconSpriteMenuThick = "menu--thick";
var IconSpriteMenuShape = "menu-shape";
var IconSpriteMenu = "menu";
var IconSpriteMezzanineShape = "mezzanine-shape";
var IconSpriteMezzanine = "mezzanine";
var IconSpriteMicrophoneFilledShape = "microphone--filled-shape";
var IconSpriteMicrophoneFilled = "microphone--filled";
var IconSpriteMicrophoneShape = "microphone-shape";
var IconSpriteMicrophone = "microphone";
var IconSpriteMinusThickShape = "minus--thick-shape";
var IconSpriteMinusThick = "minus--thick";
var IconSpriteMinusShape = "minus-shape";
var IconSpriteMinus = "minus";
var IconSpriteMoneyBillsThickShape = "money-bills--thick-shape";
var IconSpriteMoneyBillsShape = "money-bills-shape";
var IconSpriteMoneyBillsThick = "money_bills--thick";
var IconSpriteMoneyBills = "money_bills";
var IconSpriteMopShape = "mop-shape";
var IconSpriteMop = "mop";
var IconSpriteMoreHorizontalThickShape = "more-horizontal--thick-shape";
var IconSpriteMoreVerticalThickShape = "more-vertical--thick-shape";
var IconSpriteMoreHorizontalThick = "more_horizontal--thick";
var IconSpriteMoreVerticalThick = "more_vertical--thick";
var IconSpritePalmTreeShape = "palm-tree-shape";
var IconSpritePalmTree = "palm_tree";
var IconSpritePaperplaneThickShape = "paperplane--thick-shape";
var IconSpritePaperplaneThick = "paperplane--thick";
var IconSpriteParkingSignShape = "parking-sign-shape";
var IconSpriteParkingSign = "parking_sign";
var IconSpritePhoneFilledShape = "phone--filled-shape";
var IconSpritePhoneFilled = "phone--filled";
var IconSpritePhoneShape = "phone-shape";
var IconSpritePhone = "phone";
var IconSpritePhotoCameraShape = "photo-camera-shape";
var IconSpritePhotoCamera = "photo_camera";
var IconSpritePinterestFilled = "pinterest--filled";
var IconSpritePlayThickShape = "play--thick-shape";
var IconSpritePlayThick = "play--thick";
var IconSpritePlayShape = "play-shape";
var IconSpritePlay = "play";
var IconSpritePlusThickShape = "plus--thick-shape";
var IconSpritePlusThick = "plus--thick";
var IconSpritePlusShape = "plus-shape";
var IconSpritePlus = "plus";
var IconSpritePoolLadderShape = "pool-ladder-shape";
var IconSpritePoolLadder = "pool_ladder";
var IconSpriteReceptionistShape = "receptionist-shape";
var IconSpriteReceptionist = "receptionist";
var IconSpriteRoadSizeThickShape = "road-size--thick-shape";
var IconSpriteRoadSizeShape = "road-size-shape";
var IconSpriteRoadSizeThick = "road_size--thick";
var IconSpriteRoadSize = "road_size";
var IconSpriteRoomShape = "room-shape";
var IconSpriteRoom = "room";
var IconSpriteShareThickShape = "share--thick-shape";
var IconSpriteShareThick = "share--thick";
var IconSpriteShareAltThickShape = "share-alt--thick-shape";
var IconSpriteShareAltRtlThickShape = "share-alt-rtl--thick-shape";
var IconSpriteShareAltRtlShape = "share-alt-rtl-shape";
var IconSpriteShareAltShape = "share-alt-shape";
var IconSpriteShareShape = "share-shape";
var IconSpriteShare = "share";
var IconSpriteShareAltThick = "share_alt--thick";
var IconSpriteShareAlt = "share_alt";
var IconSpriteShareAltRtlThick = "share_alt_rtl--thick";
var IconSpriteShareAltRtl = "share_alt_rtl";
var IconSpriteShieldCheckmarkFilledShape = "shield-checkmark--filled-shape";
var IconSpriteShieldCheckmarkShape = "shield-checkmark-shape";
var IconSpriteShieldShape = "shield-shape";
var IconSpriteShield = "shield";
var IconSpriteShieldCheckmarkFilled = "shield_checkmark--filled";
var IconSpriteShieldCheckmark = "shield_checkmark";
var IconSpriteSnowFlakeShape = "snow-flake-shape";
var IconSpriteSnowFlake = "snow_flake";
var IconSpriteSortDownThickShape = "sort-down--thick-shape";
var IconSpriteSortDownShape = "sort-down-shape";
var IconSpriteSortUpShape = "sort-up-shape";
var IconSpriteSortDownThick = "sort_down--thick";
var IconSpriteSortDown = "sort_down";
var IconSpriteSortUp = "sort_up";
var IconSpriteSpiceShakersShape = "spice-shakers-shape";
var IconSpriteSpiceShakers = "spice_shakers";
var IconSpriteStarFilledShape = "star--filled-shape";
var IconSpriteStarFilled = "star--filled";
var IconSpriteStarThickShape = "star--thick-shape";
var IconSpriteStarThick = "star--thick";
var IconSpriteStarShape = "star-shape";
var IconSpriteStarTrophyFilledShape = "star-trophy--filled-shape";
var IconSpriteStar = "star";
var IconSpriteStarTrophyFilled = "star_trophy--filled";
var IconSpriteSunAndWaterShape = "sun-and-water-shape";
var IconSpriteSunAndWater = "sun_and_water";
var IconSpriteSwingShape = "swing-shape";
var IconSpriteSwing = "swing";
var IconSpriteTextBubbleFilledShape = "text-bubble--filled-shape";
var IconSpriteTextBubbleShape = "text-bubble-shape";
var IconSpriteTextBubbleFilled = "text_bubble--filled";
var IconSpriteTextBubble = "text_bubble";
var IconSpriteThreeDotsHorizontalShape = "three-dots-horizontal-shape";
var IconSpriteThreeDotsVerticalShape = "three-dots-vertical-shape";
var IconSpriteThreeDotsHorizontal = "three_dots_horizontal";
var IconSpriteThreeDotsVertical = "three_dots_vertical";
var IconSpriteThumbsUpShape = "thumbs-up-shape";
var IconSpriteThumbsUp = "thumbs_up";
var IconSpriteTimesThickShape = "times--thick-shape";
var IconSpriteTimesThick = "times--thick";
var IconSpriteTimesCircleThickShape = "times-circle--thick-shape";
var IconSpriteTimesShape = "times-shape";
var IconSpriteTimesSmallThickShape = "times-small--thick-shape";
var IconSpriteTimesSmallShape = "times-small-shape";
var IconSpriteTimes = "times";
var IconSpriteTimesCircleThick = "times_circle--thick";
var IconSpriteTimesSmallThick = "times_small--thick";
var IconSpriteTimesSmall = "times_small";
var IconSpriteTwitterFilledShape = "twitter--filled-shape";
var IconSpriteTwitterFilled = "twitter--filled";
var IconSpriteUserFilledShape = "user--filled-shape";
var IconSpriteUserFilled = "user--filled";
var IconSpriteUserThickShape = "user--thick-shape";
var IconSpriteUserThick = "user--thick";
var IconSpriteUserShape = "user-shape";
var IconSpriteUser = "user";
var IconSpriteVastuStarShape = "vastu-star-shape";
var IconSpriteVastuStar = "vastu_star";
var IconSpriteWhatsappFilledShape = "whatsapp--filled-shape";
var IconSpriteWhatsappFilled = "whatsapp--filled";
var IconSpriteWhatsappShape = "whatsapp-shape";
var IconSpriteWhatsapp = "whatsapp";
var IconSpriteWorkerThickShape = "worker--thick-shape";
var IconSpriteWorkerThick = "worker--thick";
var spriteMap = {
	IconSprite360ThickShape: IconSprite360ThickShape,
	IconSprite360Thick: IconSprite360Thick,
	IconSprite360Shape: IconSprite360Shape,
	IconSprite360: IconSprite360,
	IconSpriteAppleFilledShape: IconSpriteAppleFilledShape,
	IconSpriteAppleFilled: IconSpriteAppleFilled,
	IconSpriteAreaChartThickShape: IconSpriteAreaChartThickShape,
	IconSpriteAreaChartShape: IconSpriteAreaChartShape,
	IconSpriteAreaSizeThickShape: IconSpriteAreaSizeThickShape,
	IconSpriteAreaSizeShape: IconSpriteAreaSizeShape,
	IconSpriteAreaChartThick: IconSpriteAreaChartThick,
	IconSpriteAreaChart: IconSpriteAreaChart,
	IconSpriteAreaSizeThick: IconSpriteAreaSizeThick,
	IconSpriteAreaSize: IconSpriteAreaSize,
	IconSpriteArrowCircleClockwiseShape: IconSpriteArrowCircleClockwiseShape,
	IconSpriteArrowCircleCounterclockwiseShape: IconSpriteArrowCircleCounterclockwiseShape,
	IconSpriteArrowDownThickShape: IconSpriteArrowDownThickShape,
	IconSpriteArrowDownShape: IconSpriteArrowDownShape,
	IconSpriteArrowLeftThickShape: IconSpriteArrowLeftThickShape,
	IconSpriteArrowLeftShape: IconSpriteArrowLeftShape,
	IconSpriteArrowNarrowDownThickShape: IconSpriteArrowNarrowDownThickShape,
	IconSpriteArrowNarrowUpThickShape: IconSpriteArrowNarrowUpThickShape,
	IconSpriteArrowRightThickShape: IconSpriteArrowRightThickShape,
	IconSpriteArrowRightShape: IconSpriteArrowRightShape,
	IconSpriteArrowUpThickShape: IconSpriteArrowUpThickShape,
	IconSpriteArrowUpShape: IconSpriteArrowUpShape,
	IconSpriteArrowZigzagDownThickShape: IconSpriteArrowZigzagDownThickShape,
	IconSpriteArrowZigzagDownRtlThickShape: IconSpriteArrowZigzagDownRtlThickShape,
	IconSpriteArrowZigzagDownRtlShape: IconSpriteArrowZigzagDownRtlShape,
	IconSpriteArrowZigzagDownShape: IconSpriteArrowZigzagDownShape,
	IconSpriteArrowZigzagUpThickShape: IconSpriteArrowZigzagUpThickShape,
	IconSpriteArrowZigzagUpRtlThickShape: IconSpriteArrowZigzagUpRtlThickShape,
	IconSpriteArrowZigzagUpRtlShape: IconSpriteArrowZigzagUpRtlShape,
	IconSpriteArrowZigzagUpShape: IconSpriteArrowZigzagUpShape,
	IconSpriteArrowCircleClockwise: IconSpriteArrowCircleClockwise,
	IconSpriteArrowCircleCounterclockwise: IconSpriteArrowCircleCounterclockwise,
	IconSpriteArrowDownThick: IconSpriteArrowDownThick,
	IconSpriteArrowDown: IconSpriteArrowDown,
	IconSpriteArrowLeftThick: IconSpriteArrowLeftThick,
	IconSpriteArrowLeft: IconSpriteArrowLeft,
	IconSpriteArrowNarrowDownThick: IconSpriteArrowNarrowDownThick,
	IconSpriteArrowNarrowUpThick: IconSpriteArrowNarrowUpThick,
	IconSpriteArrowRightThick: IconSpriteArrowRightThick,
	IconSpriteArrowRight: IconSpriteArrowRight,
	IconSpriteArrowUpThick: IconSpriteArrowUpThick,
	IconSpriteArrowUp: IconSpriteArrowUp,
	IconSpriteArrowZigzagDownThick: IconSpriteArrowZigzagDownThick,
	IconSpriteArrowZigzagDown: IconSpriteArrowZigzagDown,
	IconSpriteArrowZigzagDownRtlThick: IconSpriteArrowZigzagDownRtlThick,
	IconSpriteArrowZigzagDownRtl: IconSpriteArrowZigzagDownRtl,
	IconSpriteArrowZigzagUpThick: IconSpriteArrowZigzagUpThick,
	IconSpriteArrowZigzagUp: IconSpriteArrowZigzagUp,
	IconSpriteArrowZigzagUpRtlThick: IconSpriteArrowZigzagUpRtlThick,
	IconSpriteArrowZigzagUpRtl: IconSpriteArrowZigzagUpRtl,
	IconSpriteArrowsCircleThickShape: IconSpriteArrowsCircleThickShape,
	IconSpriteArrowsUpDownThickShape: IconSpriteArrowsUpDownThickShape,
	IconSpriteArrowsUpDownShape: IconSpriteArrowsUpDownShape,
	IconSpriteArrowsCircleThick: IconSpriteArrowsCircleThick,
	IconSpriteArrowsUpDownThick: IconSpriteArrowsUpDownThick,
	IconSpriteArrowsUpDown: IconSpriteArrowsUpDown,
	IconSpriteBalconyShape: IconSpriteBalconyShape,
	IconSpriteBalcony: IconSpriteBalcony,
	IconSpriteBarbecueShape: IconSpriteBarbecueShape,
	IconSpriteBarbecue: IconSpriteBarbecue,
	IconSpriteBathtubThickShape: IconSpriteBathtubThickShape,
	IconSpriteBathtubThick: IconSpriteBathtubThick,
	IconSpriteBathtubShape: IconSpriteBathtubShape,
	IconSpriteBathtub: IconSpriteBathtub,
	IconSpriteBeachBallShape: IconSpriteBeachBallShape,
	IconSpriteBeachBall: IconSpriteBeachBall,
	IconSpriteBedThickShape: IconSpriteBedThickShape,
	IconSpriteBedThick: IconSpriteBedThick,
	IconSpriteBedShape: IconSpriteBedShape,
	IconSpriteBed: IconSpriteBed,
	IconSpriteBellShape: IconSpriteBellShape,
	IconSpriteBellThickShape: IconSpriteBellThickShape,
	IconSpriteBellThick: IconSpriteBellThick,
	IconSpriteBell: IconSpriteBell,
	IconSpriteBookOpenThickShape: IconSpriteBookOpenThickShape,
	IconSpriteBookOpenShape: IconSpriteBookOpenShape,
	IconSpriteBookOpenThick: IconSpriteBookOpenThick,
	IconSpriteBookOpen: IconSpriteBookOpen,
	IconSpriteBricksThickShape: IconSpriteBricksThickShape,
	IconSpriteBricksThick: IconSpriteBricksThick,
	IconSpriteBricksShape: IconSpriteBricksShape,
	IconSpriteBricks: IconSpriteBricks,
	IconSpriteBriefcaseThickShape: IconSpriteBriefcaseThickShape,
	IconSpriteBriefcaseThick: IconSpriteBriefcaseThick,
	IconSpriteBroomShape: IconSpriteBroomShape,
	IconSpriteBroom: IconSpriteBroom,
	IconSpriteBubblesShape: IconSpriteBubblesShape,
	IconSpriteBubbles: IconSpriteBubbles,
	IconSpriteBuildingsAltThickShape: IconSpriteBuildingsAltThickShape,
	IconSpriteBuildingsAltShape: IconSpriteBuildingsAltShape,
	IconSpriteBuildingsShape: IconSpriteBuildingsShape,
	IconSpriteBuildingsStarThickShape: IconSpriteBuildingsStarThickShape,
	IconSpriteBuildingsStarShape: IconSpriteBuildingsStarShape,
	IconSpriteBuildings: IconSpriteBuildings,
	IconSpriteBuildingsAltThick: IconSpriteBuildingsAltThick,
	IconSpriteBuildingsAlt: IconSpriteBuildingsAlt,
	IconSpriteBuildingsStarThick: IconSpriteBuildingsStarThick,
	IconSpriteBuildingsStar: IconSpriteBuildingsStar,
	IconSpriteBurjKhalifaShape: IconSpriteBurjKhalifaShape,
	IconSpriteBurjKhalifa: IconSpriteBurjKhalifa,
	IconSpriteCalendarThickShape: IconSpriteCalendarThickShape,
	IconSpriteCalendarThick: IconSpriteCalendarThick,
	IconSpriteCalendarShape: IconSpriteCalendarShape,
	IconSpriteCalendar: IconSpriteCalendar,
	IconSpriteCarClockThickShape: IconSpriteCarClockThickShape,
	IconSpriteCarClockShape: IconSpriteCarClockShape,
	IconSpriteCarEntranceShape: IconSpriteCarEntranceShape,
	IconSpriteCarClockThick: IconSpriteCarClockThick,
	IconSpriteCarClock: IconSpriteCarClock,
	IconSpriteCarEntrance: IconSpriteCarEntrance,
	IconSpriteCheckmarkThickShape: IconSpriteCheckmarkThickShape,
	IconSpriteCheckmarkThick: IconSpriteCheckmarkThick,
	IconSpriteCheckmarkShape: IconSpriteCheckmarkShape,
	IconSpriteCheckmark: IconSpriteCheckmark,
	IconSpriteChevronDownThickShape: IconSpriteChevronDownThickShape,
	IconSpriteChevronDownShape: IconSpriteChevronDownShape,
	IconSpriteChevronDownSmallFilledShape: IconSpriteChevronDownSmallFilledShape,
	IconSpriteChevronDownSmallThickShape: IconSpriteChevronDownSmallThickShape,
	IconSpriteChevronDownSmallShape: IconSpriteChevronDownSmallShape,
	IconSpriteChevronLeftThickShape: IconSpriteChevronLeftThickShape,
	IconSpriteChevronLeftShape: IconSpriteChevronLeftShape,
	IconSpriteChevronLeftSmallFilledShape: IconSpriteChevronLeftSmallFilledShape,
	IconSpriteChevronLeftSmallThickShape: IconSpriteChevronLeftSmallThickShape,
	IconSpriteChevronLeftSmallShape: IconSpriteChevronLeftSmallShape,
	IconSpriteChevronRightThickShape: IconSpriteChevronRightThickShape,
	IconSpriteChevronRightShape: IconSpriteChevronRightShape,
	IconSpriteChevronRightSmallFilledShape: IconSpriteChevronRightSmallFilledShape,
	IconSpriteChevronRightSmallThickShape: IconSpriteChevronRightSmallThickShape,
	IconSpriteChevronRightSmallShape: IconSpriteChevronRightSmallShape,
	IconSpriteChevronUpThickShape: IconSpriteChevronUpThickShape,
	IconSpriteChevronUpShape: IconSpriteChevronUpShape,
	IconSpriteChevronUpSmallFilledShape: IconSpriteChevronUpSmallFilledShape,
	IconSpriteChevronUpSmallThickShape: IconSpriteChevronUpSmallThickShape,
	IconSpriteChevronUpSmallShape: IconSpriteChevronUpSmallShape,
	IconSpriteChevronDownThick: IconSpriteChevronDownThick,
	IconSpriteChevronDown: IconSpriteChevronDown,
	IconSpriteChevronDownSmallFilled: IconSpriteChevronDownSmallFilled,
	IconSpriteChevronDownSmallThick: IconSpriteChevronDownSmallThick,
	IconSpriteChevronDownSmall: IconSpriteChevronDownSmall,
	IconSpriteChevronLeftThick: IconSpriteChevronLeftThick,
	IconSpriteChevronLeft: IconSpriteChevronLeft,
	IconSpriteChevronLeftSmallFilled: IconSpriteChevronLeftSmallFilled,
	IconSpriteChevronLeftSmallThick: IconSpriteChevronLeftSmallThick,
	IconSpriteChevronLeftSmall: IconSpriteChevronLeftSmall,
	IconSpriteChevronRightThick: IconSpriteChevronRightThick,
	IconSpriteChevronRight: IconSpriteChevronRight,
	IconSpriteChevronRightSmallFilled: IconSpriteChevronRightSmallFilled,
	IconSpriteChevronRightSmallThick: IconSpriteChevronRightSmallThick,
	IconSpriteChevronRightSmall: IconSpriteChevronRightSmall,
	IconSpriteChevronUpThick: IconSpriteChevronUpThick,
	IconSpriteChevronUp: IconSpriteChevronUp,
	IconSpriteChevronUpSmallFilled: IconSpriteChevronUpSmallFilled,
	IconSpriteChevronUpSmallThick: IconSpriteChevronUpSmallThick,
	IconSpriteChevronUpSmall: IconSpriteChevronUpSmall,
	IconSpriteClockHistoryThickShape: IconSpriteClockHistoryThickShape,
	IconSpriteClockHistoryShape: IconSpriteClockHistoryShape,
	IconSpriteClockShape: IconSpriteClockShape,
	IconSpriteClock: IconSpriteClock,
	IconSpriteClockHistoryThick: IconSpriteClockHistoryThick,
	IconSpriteClockHistory: IconSpriteClockHistory,
	IconSpriteClosetShape: IconSpriteClosetShape,
	IconSpriteCloset: IconSpriteCloset,
	IconSpriteCogFilledShape: IconSpriteCogFilledShape,
	IconSpriteCogFilled: IconSpriteCogFilled,
	IconSpriteCogShape: IconSpriteCogShape,
	IconSpriteCog: IconSpriteCog,
	IconSpriteCompassThickShape: IconSpriteCompassThickShape,
	IconSpriteCompassThick: IconSpriteCompassThick,
	IconSpriteCompassShape: IconSpriteCompassShape,
	IconSpriteCompass: IconSpriteCompass,
	IconSpriteConciergeShape: IconSpriteConciergeShape,
	IconSpriteConcierge: IconSpriteConcierge,
	IconSpriteCraneShape: IconSpriteCraneShape,
	IconSpriteCrane: IconSpriteCrane,
	IconSpriteCrownFilledShape: IconSpriteCrownFilledShape,
	IconSpriteCrownFilled: IconSpriteCrownFilled,
	IconSpriteCrownShape: IconSpriteCrownShape,
	IconSpriteCrown: IconSpriteCrown,
	IconSpriteCutleryAndDishShape: IconSpriteCutleryAndDishShape,
	IconSpriteCutleryShape: IconSpriteCutleryShape,
	IconSpriteCutlery: IconSpriteCutlery,
	IconSpriteCutleryAndDish: IconSpriteCutleryAndDish,
	IconSpriteDiamondThickShape: IconSpriteDiamondThickShape,
	IconSpriteDiamondThick: IconSpriteDiamondThick,
	IconSpriteDogFootprintShape: IconSpriteDogFootprintShape,
	IconSpriteDogFootprint: IconSpriteDogFootprint,
	IconSpriteDownloadThickShape: IconSpriteDownloadThickShape,
	IconSpriteDownloadThick: IconSpriteDownloadThick,
	IconSpriteDownloadShape: IconSpriteDownloadShape,
	IconSpriteDownload: IconSpriteDownload,
	IconSpriteDumbbellShape: IconSpriteDumbbellShape,
	IconSpriteDumbbell: IconSpriteDumbbell,
	IconSpriteEditSquareThickShape: IconSpriteEditSquareThickShape,
	IconSpriteEditSquareShape: IconSpriteEditSquareShape,
	IconSpriteEditSquareThick: IconSpriteEditSquareThick,
	IconSpriteEditSquare: IconSpriteEditSquare,
	IconSpriteElectricPlugThickShape: IconSpriteElectricPlugThickShape,
	IconSpriteElectricPlugDisabledThickShape: IconSpriteElectricPlugDisabledThickShape,
	IconSpriteElectricPlugThick: IconSpriteElectricPlugThick,
	IconSpriteElectricPlugDisabledThick: IconSpriteElectricPlugDisabledThick,
	IconSpriteEnvelopeFilledShape: IconSpriteEnvelopeFilledShape,
	IconSpriteEnvelopeFilled: IconSpriteEnvelopeFilled,
	IconSpriteEnvelopeShape: IconSpriteEnvelopeShape,
	IconSpriteEnvelope: IconSpriteEnvelope,
	IconSpriteExtensionShape: IconSpriteExtensionShape,
	IconSpriteExtension: IconSpriteExtension,
	IconSpriteExternalLinkThickShape: IconSpriteExternalLinkThickShape,
	IconSpriteExternalLinkRtlThickShape: IconSpriteExternalLinkRtlThickShape,
	IconSpriteExternalLinkRtlShape: IconSpriteExternalLinkRtlShape,
	IconSpriteExternalLinkShape: IconSpriteExternalLinkShape,
	IconSpriteExternalLinkThick: IconSpriteExternalLinkThick,
	IconSpriteExternalLink: IconSpriteExternalLink,
	IconSpriteExternalLinkRtlThick: IconSpriteExternalLinkRtlThick,
	IconSpriteExternalLinkRtl: IconSpriteExternalLinkRtl,
	IconSpriteEyeThickShape: IconSpriteEyeThickShape,
	IconSpriteEyeThick: IconSpriteEyeThick,
	IconSpriteEyeClosedThickShape: IconSpriteEyeClosedThickShape,
	IconSpriteEyeClosedShape: IconSpriteEyeClosedShape,
	IconSpriteEyeShape: IconSpriteEyeShape,
	IconSpriteEye: IconSpriteEye,
	IconSpriteEyeClosedThick: IconSpriteEyeClosedThick,
	IconSpriteEyeClosed: IconSpriteEyeClosed,
	IconSpriteFacebookFilledShape: IconSpriteFacebookFilledShape,
	IconSpriteFacebookFilled: IconSpriteFacebookFilled,
	IconSpriteFilterThickShape: IconSpriteFilterThickShape,
	IconSpriteFilterThick: IconSpriteFilterThick,
	IconSpriteFilterClearThickShape: IconSpriteFilterClearThickShape,
	IconSpriteFilterShape: IconSpriteFilterShape,
	IconSpriteFilter: IconSpriteFilter,
	IconSpriteFilterClearThick: IconSpriteFilterClearThick,
	IconSpriteFlagFilledShape: IconSpriteFlagFilledShape,
	IconSpriteFlagFilled: IconSpriteFlagFilled,
	IconSpriteFlagThickShape: IconSpriteFlagThickShape,
	IconSpriteFlagThick: IconSpriteFlagThick,
	IconSpriteFlagShape: IconSpriteFlagShape,
	IconSpriteFlag: IconSpriteFlag,
	IconSpriteFloorplanThickShape: IconSpriteFloorplanThickShape,
	IconSpriteFloorplanThick: IconSpriteFloorplanThick,
	IconSpriteFloorplanShape: IconSpriteFloorplanShape,
	IconSpriteFloorplan: IconSpriteFloorplan,
	IconSpriteFullscreenThickShape: IconSpriteFullscreenThickShape,
	IconSpriteFullscreenThick: IconSpriteFullscreenThick,
	IconSpriteFullscreenShape: IconSpriteFullscreenShape,
	IconSpriteFullscreen: IconSpriteFullscreen,
	IconSpriteFurnitureThickShape: IconSpriteFurnitureThickShape,
	IconSpriteFurnitureThick: IconSpriteFurnitureThick,
	IconSpriteFurnitureShape: IconSpriteFurnitureShape,
	IconSpriteFurniture: IconSpriteFurniture,
	IconSpriteGoogleFilledShape: IconSpriteGoogleFilledShape,
	IconSpriteGoogleFilled: IconSpriteGoogleFilled,
	IconSpriteGroupPeopleShape: IconSpriteGroupPeopleShape,
	IconSpriteGroupPeople: IconSpriteGroupPeople,
	IconSpriteHangerShape: IconSpriteHangerShape,
	IconSpriteHanger: IconSpriteHanger,
	IconSpriteHeartFilledShape: IconSpriteHeartFilledShape,
	IconSpriteHeartFilled: IconSpriteHeartFilled,
	IconSpriteHeartThickShape: IconSpriteHeartThickShape,
	IconSpriteHeartThick: IconSpriteHeartThick,
	IconSpriteHeartShape: IconSpriteHeartShape,
	IconSpriteHeart: IconSpriteHeart,
	IconSpriteHouseFilledShape: IconSpriteHouseFilledShape,
	IconSpriteHouseFilled: IconSpriteHouseFilled,
	IconSpriteHouseThickShape: IconSpriteHouseThickShape,
	IconSpriteHouseThick: IconSpriteHouseThick,
	IconSpriteHouseArrowShape: IconSpriteHouseArrowShape,
	IconSpriteHousePercentageShape: IconSpriteHousePercentageShape,
	IconSpriteHouseShape: IconSpriteHouseShape,
	IconSpriteHouse: IconSpriteHouse,
	IconSpriteHouseArrow: IconSpriteHouseArrow,
	IconSpriteHousePercentage: IconSpriteHousePercentage,
	IconSpriteInfoCircleFilledShape: IconSpriteInfoCircleFilledShape,
	IconSpriteInfoCircleShape: IconSpriteInfoCircleShape,
	IconSpriteInfoCircleFilled: IconSpriteInfoCircleFilled,
	IconSpriteInfoCircle: IconSpriteInfoCircle,
	IconSpriteInternetSocketShape: IconSpriteInternetSocketShape,
	IconSpriteInternetSocket: IconSpriteInternetSocket,
	IconSpriteLayersShape: IconSpriteLayersShape,
	IconSpriteLayers: IconSpriteLayers,
	IconSpriteLiftShape: IconSpriteLiftShape,
	IconSpriteLift: IconSpriteLift,
	IconSpriteLighningFilled: IconSpriteLighningFilled,
	IconSpriteLighningThick: IconSpriteLighningThick,
	IconSpriteLighning: IconSpriteLighning,
	IconSpriteLightningFilledShape: IconSpriteLightningFilledShape,
	IconSpriteLightningThickShape: IconSpriteLightningThickShape,
	IconSpriteLightningShape: IconSpriteLightningShape,
	IconSpriteListFilledShape: IconSpriteListFilledShape,
	IconSpriteListFilled: IconSpriteListFilled,
	IconSpriteListThickShape: IconSpriteListThickShape,
	IconSpriteListThick: IconSpriteListThick,
	IconSpriteListShape: IconSpriteListShape,
	IconSpriteList: IconSpriteList,
	IconSpriteLiveThickShape: IconSpriteLiveThickShape,
	IconSpriteLiveThick: IconSpriteLiveThick,
	IconSpriteLocationArrowFilledShape: IconSpriteLocationArrowFilledShape,
	IconSpriteLocationArrowThickShape: IconSpriteLocationArrowThickShape,
	IconSpriteLocationArrowShape: IconSpriteLocationArrowShape,
	IconSpriteLocationGpsThickShape: IconSpriteLocationGpsThickShape,
	IconSpriteLocationArrowFilled: IconSpriteLocationArrowFilled,
	IconSpriteLocationArrowThick: IconSpriteLocationArrowThick,
	IconSpriteLocationArrow: IconSpriteLocationArrow,
	IconSpriteLocationGpsThick: IconSpriteLocationGpsThick,
	IconSpriteLotusPlantShape: IconSpriteLotusPlantShape,
	IconSpriteLotusPlant: IconSpriteLotusPlant,
	IconSpriteMagnifierFilledShape: IconSpriteMagnifierFilledShape,
	IconSpriteMagnifierFilled: IconSpriteMagnifierFilled,
	IconSpriteMagnifierThickShape: IconSpriteMagnifierThickShape,
	IconSpriteMagnifierThick: IconSpriteMagnifierThick,
	IconSpriteMagnifierMinusShape: IconSpriteMagnifierMinusShape,
	IconSpriteMagnifierPlusShape: IconSpriteMagnifierPlusShape,
	IconSpriteMagnifierShape: IconSpriteMagnifierShape,
	IconSpriteMagnifier: IconSpriteMagnifier,
	IconSpriteMagnifierMinus: IconSpriteMagnifierMinus,
	IconSpriteMagnifierPlus: IconSpriteMagnifierPlus,
	IconSpriteMapPinFilledShape: IconSpriteMapPinFilledShape,
	IconSpriteMapPinThickShape: IconSpriteMapPinThickShape,
	IconSpriteMapPinPlusThickShape: IconSpriteMapPinPlusThickShape,
	IconSpriteMapPinShape: IconSpriteMapPinShape,
	IconSpriteMapPinFilled: IconSpriteMapPinFilled,
	IconSpriteMapPinThick: IconSpriteMapPinThick,
	IconSpriteMapPin: IconSpriteMapPin,
	IconSpriteMapPinPlusThick: IconSpriteMapPinPlusThick,
	IconSpriteMenuThickShape: IconSpriteMenuThickShape,
	IconSpriteMenuThick: IconSpriteMenuThick,
	IconSpriteMenuShape: IconSpriteMenuShape,
	IconSpriteMenu: IconSpriteMenu,
	IconSpriteMezzanineShape: IconSpriteMezzanineShape,
	IconSpriteMezzanine: IconSpriteMezzanine,
	IconSpriteMicrophoneFilledShape: IconSpriteMicrophoneFilledShape,
	IconSpriteMicrophoneFilled: IconSpriteMicrophoneFilled,
	IconSpriteMicrophoneShape: IconSpriteMicrophoneShape,
	IconSpriteMicrophone: IconSpriteMicrophone,
	IconSpriteMinusThickShape: IconSpriteMinusThickShape,
	IconSpriteMinusThick: IconSpriteMinusThick,
	IconSpriteMinusShape: IconSpriteMinusShape,
	IconSpriteMinus: IconSpriteMinus,
	IconSpriteMoneyBillsThickShape: IconSpriteMoneyBillsThickShape,
	IconSpriteMoneyBillsShape: IconSpriteMoneyBillsShape,
	IconSpriteMoneyBillsThick: IconSpriteMoneyBillsThick,
	IconSpriteMoneyBills: IconSpriteMoneyBills,
	IconSpriteMopShape: IconSpriteMopShape,
	IconSpriteMop: IconSpriteMop,
	IconSpriteMoreHorizontalThickShape: IconSpriteMoreHorizontalThickShape,
	IconSpriteMoreVerticalThickShape: IconSpriteMoreVerticalThickShape,
	IconSpriteMoreHorizontalThick: IconSpriteMoreHorizontalThick,
	IconSpriteMoreVerticalThick: IconSpriteMoreVerticalThick,
	IconSpritePalmTreeShape: IconSpritePalmTreeShape,
	IconSpritePalmTree: IconSpritePalmTree,
	IconSpritePaperplaneThickShape: IconSpritePaperplaneThickShape,
	IconSpritePaperplaneThick: IconSpritePaperplaneThick,
	IconSpriteParkingSignShape: IconSpriteParkingSignShape,
	IconSpriteParkingSign: IconSpriteParkingSign,
	IconSpritePhoneFilledShape: IconSpritePhoneFilledShape,
	IconSpritePhoneFilled: IconSpritePhoneFilled,
	IconSpritePhoneShape: IconSpritePhoneShape,
	IconSpritePhone: IconSpritePhone,
	IconSpritePhotoCameraShape: IconSpritePhotoCameraShape,
	IconSpritePhotoCamera: IconSpritePhotoCamera,
	IconSpritePinterestFilled: IconSpritePinterestFilled,
	IconSpritePlayThickShape: IconSpritePlayThickShape,
	IconSpritePlayThick: IconSpritePlayThick,
	IconSpritePlayShape: IconSpritePlayShape,
	IconSpritePlay: IconSpritePlay,
	IconSpritePlusThickShape: IconSpritePlusThickShape,
	IconSpritePlusThick: IconSpritePlusThick,
	IconSpritePlusShape: IconSpritePlusShape,
	IconSpritePlus: IconSpritePlus,
	IconSpritePoolLadderShape: IconSpritePoolLadderShape,
	IconSpritePoolLadder: IconSpritePoolLadder,
	IconSpriteReceptionistShape: IconSpriteReceptionistShape,
	IconSpriteReceptionist: IconSpriteReceptionist,
	IconSpriteRoadSizeThickShape: IconSpriteRoadSizeThickShape,
	IconSpriteRoadSizeShape: IconSpriteRoadSizeShape,
	IconSpriteRoadSizeThick: IconSpriteRoadSizeThick,
	IconSpriteRoadSize: IconSpriteRoadSize,
	IconSpriteRoomShape: IconSpriteRoomShape,
	IconSpriteRoom: IconSpriteRoom,
	IconSpriteShareThickShape: IconSpriteShareThickShape,
	IconSpriteShareThick: IconSpriteShareThick,
	IconSpriteShareAltThickShape: IconSpriteShareAltThickShape,
	IconSpriteShareAltRtlThickShape: IconSpriteShareAltRtlThickShape,
	IconSpriteShareAltRtlShape: IconSpriteShareAltRtlShape,
	IconSpriteShareAltShape: IconSpriteShareAltShape,
	IconSpriteShareShape: IconSpriteShareShape,
	IconSpriteShare: IconSpriteShare,
	IconSpriteShareAltThick: IconSpriteShareAltThick,
	IconSpriteShareAlt: IconSpriteShareAlt,
	IconSpriteShareAltRtlThick: IconSpriteShareAltRtlThick,
	IconSpriteShareAltRtl: IconSpriteShareAltRtl,
	IconSpriteShieldCheckmarkFilledShape: IconSpriteShieldCheckmarkFilledShape,
	IconSpriteShieldCheckmarkShape: IconSpriteShieldCheckmarkShape,
	IconSpriteShieldShape: IconSpriteShieldShape,
	IconSpriteShield: IconSpriteShield,
	IconSpriteShieldCheckmarkFilled: IconSpriteShieldCheckmarkFilled,
	IconSpriteShieldCheckmark: IconSpriteShieldCheckmark,
	IconSpriteSnowFlakeShape: IconSpriteSnowFlakeShape,
	IconSpriteSnowFlake: IconSpriteSnowFlake,
	IconSpriteSortDownThickShape: IconSpriteSortDownThickShape,
	IconSpriteSortDownShape: IconSpriteSortDownShape,
	IconSpriteSortUpShape: IconSpriteSortUpShape,
	IconSpriteSortDownThick: IconSpriteSortDownThick,
	IconSpriteSortDown: IconSpriteSortDown,
	IconSpriteSortUp: IconSpriteSortUp,
	IconSpriteSpiceShakersShape: IconSpriteSpiceShakersShape,
	IconSpriteSpiceShakers: IconSpriteSpiceShakers,
	IconSpriteStarFilledShape: IconSpriteStarFilledShape,
	IconSpriteStarFilled: IconSpriteStarFilled,
	IconSpriteStarThickShape: IconSpriteStarThickShape,
	IconSpriteStarThick: IconSpriteStarThick,
	IconSpriteStarShape: IconSpriteStarShape,
	IconSpriteStarTrophyFilledShape: IconSpriteStarTrophyFilledShape,
	IconSpriteStar: IconSpriteStar,
	IconSpriteStarTrophyFilled: IconSpriteStarTrophyFilled,
	IconSpriteSunAndWaterShape: IconSpriteSunAndWaterShape,
	IconSpriteSunAndWater: IconSpriteSunAndWater,
	IconSpriteSwingShape: IconSpriteSwingShape,
	IconSpriteSwing: IconSpriteSwing,
	IconSpriteTextBubbleFilledShape: IconSpriteTextBubbleFilledShape,
	IconSpriteTextBubbleShape: IconSpriteTextBubbleShape,
	IconSpriteTextBubbleFilled: IconSpriteTextBubbleFilled,
	IconSpriteTextBubble: IconSpriteTextBubble,
	IconSpriteThreeDotsHorizontalShape: IconSpriteThreeDotsHorizontalShape,
	IconSpriteThreeDotsVerticalShape: IconSpriteThreeDotsVerticalShape,
	IconSpriteThreeDotsHorizontal: IconSpriteThreeDotsHorizontal,
	IconSpriteThreeDotsVertical: IconSpriteThreeDotsVertical,
	IconSpriteThumbsUpShape: IconSpriteThumbsUpShape,
	IconSpriteThumbsUp: IconSpriteThumbsUp,
	IconSpriteTimesThickShape: IconSpriteTimesThickShape,
	IconSpriteTimesThick: IconSpriteTimesThick,
	IconSpriteTimesCircleThickShape: IconSpriteTimesCircleThickShape,
	IconSpriteTimesShape: IconSpriteTimesShape,
	IconSpriteTimesSmallThickShape: IconSpriteTimesSmallThickShape,
	IconSpriteTimesSmallShape: IconSpriteTimesSmallShape,
	IconSpriteTimes: IconSpriteTimes,
	IconSpriteTimesCircleThick: IconSpriteTimesCircleThick,
	IconSpriteTimesSmallThick: IconSpriteTimesSmallThick,
	IconSpriteTimesSmall: IconSpriteTimesSmall,
	IconSpriteTwitterFilledShape: IconSpriteTwitterFilledShape,
	IconSpriteTwitterFilled: IconSpriteTwitterFilled,
	IconSpriteUserFilledShape: IconSpriteUserFilledShape,
	IconSpriteUserFilled: IconSpriteUserFilled,
	IconSpriteUserThickShape: IconSpriteUserThickShape,
	IconSpriteUserThick: IconSpriteUserThick,
	IconSpriteUserShape: IconSpriteUserShape,
	IconSpriteUser: IconSpriteUser,
	IconSpriteVastuStarShape: IconSpriteVastuStarShape,
	IconSpriteVastuStar: IconSpriteVastuStar,
	IconSpriteWhatsappFilledShape: IconSpriteWhatsappFilledShape,
	IconSpriteWhatsappFilled: IconSpriteWhatsappFilled,
	IconSpriteWhatsappShape: IconSpriteWhatsappShape,
	IconSpriteWhatsapp: IconSpriteWhatsapp,
	IconSpriteWorkerThickShape: IconSpriteWorkerThickShape,
	IconSpriteWorkerThick: IconSpriteWorkerThick
};

const mapOfIndexes = Object.keys(spriteMap).reduce((result, current) => {
  result[spriteMap[current].replace('--', '-')] = current;
  return result;
}, {});
/**
 *
 * @param {Case} - Case to find matching keywords
 * @param  {boolean} verbose - Wheter or not to show descriptive logs
 * @description Finds and parses icons according to options
 */

function getIconsUsedByCase({
  dir,
  excludeDirectories,
  excludeExtensions,
  parserFunction,
  regex,
  stringToFind
}, verbose) {
  if (!stringToFind.length) {
    throw new Error('No string to find provided');
  }

  const options = ['-rnw', dir, ...stringToFind.map(item => ['-e', item]).flat(), ...excludeDirectories.map(item => ['--exclude-dir', item]).flat(), ...excludeExtensions.map(item => ['--exclude', `*.${item}`]).flat()];

  if (verbose) {
    // eslint-disable-next-line no-console
    console.log('grep command will be launched with the followig options:', options);
  }

  const filesImportingIcons = Array.from(new Set(spawnSync('grep', options).stdout.toString('utf8').split('\n').map(item => item.replace(/(.+?):(.+)/gm, '$1')).filter(item => item)));

  if (verbose) {
    // eslint-disable-next-line no-console
    console.log(`Files containing the keyword(s) [${stringToFind}] (${filesImportingIcons.length}):`, filesImportingIcons);
  }

  const iconsUsed = Array.from( // Filters repetitive icons
  new Set(filesImportingIcons.reduce((result, currentFile) => {
    const fileContent = readFileSync(currentFile, {
      encoding: 'utf-8',
      flag: 'r'
    }); // Use regex provided to find keywords

    if (regex.test(fileContent)) {
      // if found, parse contents with provided function
      result.push(...fileContent.match(regex).map(parserFunction));
    }

    return result;
  }, [])));
  return iconsUsed;
}
/**
 * @description returns list of icons used in the files in the folder
 */


function getIconsUsage({
  cases,
  verbose
}) {
  if (!cases.length) {
    throw new Error('No cases provided');
  }

  const iconsFound = Array.from(new Set(cases.map(item => getIconsUsedByCase(item, verbose)).flat()));

  if (verbose) {
    // eslint-disable-next-line no-console
    console.log(`List of sprite icons found (${iconsFound.length}):`, iconsFound);
  }

  return iconsFound;
}

function copySvgsToTempFolder(icons, dist) {
  const TEMP_FOLDER = `${__dirname}/temp`; // Create temp folder

  execSync(`mkdir ${TEMP_FOLDER}`); // Svg folder

  const svgFolder = resolve(__dirname, 'svg'); // Copy files from source directory

  icons.forEach(icon => {
    const source = `${svgFolder}/${spriteMap[icon]}.svg`;

    if (existsSync(source)) {
      execSync(`cp -R ${source} ${TEMP_FOLDER}/`);
    }
  }); // Generate svg sprite of used icons only

  execSync(`svg-sprite-generate -d ${TEMP_FOLDER}/ -o ${dist}/pf-icons-sprite.svg`); // Delete temp folder

  rmSync(TEMP_FOLDER, {
    recursive: true
  }); // eslint-disable-next-line no-console

  console.log(`New sprite file created: ${dist}/pf-icons-sprite.svg`);
} // eslint-disable-next-line @propertyfinder/rules/export-name-validation


const defaultCases = [{
  regex: new RegExp(/\W+(IconSprite.+?)[,|\W]/, 'gm'),
  excludeDirectories: ['dist', 'build'],
  excludeExtensions: [],
  dir: './src',
  stringToFind: ['@propertyfinder/icons'],
  parserFunction: word => word.replace(/\W/g, '')
}, {
  regex: new RegExp(/\.getPath\(\)}#(.+?)`/, 'gm'),
  excludeDirectories: ['dist', 'build'],
  excludeExtensions: [],
  dir: './src',
  stringToFind: ['getPath'],
  parserFunction: word => mapOfIndexes[word.replace(/(.+?)#(.+)/gm, '$2').replace('`', '')]
}];
/**
 * Get usage of sprite components in the project
 */

function getUsage({
  dist = './dist',
  verbose = false,
  cases = defaultCases
}) {
  const iconsUsed = getIconsUsage({
    verbose,
    cases: cases.map(item => Object.assign(Object.assign({}, item), {
      dir: resolve(process.cwd(), item.dir)
    }))
  });
  copySvgsToTempFolder(iconsUsed, resolve(process.cwd(), dist));
}

export { Icon360, Icon360Shape, Icon360Thick, Icon360ThickShape, IconAppleFilled, IconAppleFilledShape, IconAreaChart, IconAreaChartShape, IconAreaChartThick, IconAreaChartThickShape, IconAreaSize, IconAreaSizeShape, IconAreaSizeThick, IconAreaSizeThickShape, IconArrowCircleClockwise, IconArrowCircleClockwiseShape, IconArrowCircleCounterclockwise, IconArrowCircleCounterclockwiseShape, IconArrowDown, IconArrowDownShape, IconArrowDownThick, IconArrowDownThickShape, IconArrowLeft, IconArrowLeftShape, IconArrowLeftThick, IconArrowLeftThickShape, IconArrowNarrowDownThick, IconArrowNarrowDownThickShape, IconArrowNarrowUpThick, IconArrowNarrowUpThickShape, IconArrowRight, IconArrowRightShape, IconArrowRightThick, IconArrowRightThickShape, IconArrowUp, IconArrowUpShape, IconArrowUpThick, IconArrowUpThickShape, IconArrowZigzagDown, IconArrowZigzagDownRtl, IconArrowZigzagDownRtlShape, IconArrowZigzagDownRtlThick, IconArrowZigzagDownRtlThickShape, IconArrowZigzagDownShape, IconArrowZigzagDownThick, IconArrowZigzagDownThickShape, IconArrowZigzagUp, IconArrowZigzagUpRtl, IconArrowZigzagUpRtlShape, IconArrowZigzagUpRtlThick, IconArrowZigzagUpRtlThickShape, IconArrowZigzagUpShape, IconArrowZigzagUpThick, IconArrowZigzagUpThickShape, IconArrowsCircleThick, IconArrowsCircleThickShape, IconArrowsUpDown, IconArrowsUpDownShape, IconArrowsUpDownThick, IconArrowsUpDownThickShape, IconBalcony, IconBalconyShape, IconBarbecue, IconBarbecueShape, IconBathtub, IconBathtubShape, IconBathtubThick, IconBathtubThickShape, IconBeachBall, IconBeachBallShape, IconBed, IconBedShape, IconBedThick, IconBedThickShape, IconBell, IconBellShape, IconBellThick, IconBellThickShape, IconBookOpen, IconBookOpenShape, IconBookOpenThick, IconBookOpenThickShape, IconBricks, IconBricksShape, IconBricksThick, IconBricksThickShape, IconBriefcaseThick, IconBriefcaseThickShape, IconBroom, IconBroomShape, IconBubbles, IconBubblesShape, IconBuildings, IconBuildingsAlt, IconBuildingsAltShape, IconBuildingsAltThick, IconBuildingsAltThickShape, IconBuildingsShape, IconBuildingsStar, IconBuildingsStarShape, IconBuildingsStarThick, IconBuildingsStarThickShape, IconBurjKhalifa, IconBurjKhalifaShape, IconCalendar, IconCalendarShape, IconCalendarThick, IconCalendarThickShape, IconCarClock, IconCarClockShape, IconCarClockThick, IconCarClockThickShape, IconCarEntrance, IconCarEntranceShape, IconCheckmark, IconCheckmarkShape, IconCheckmarkThick, IconCheckmarkThickShape, IconChevronDown, IconChevronDownShape, IconChevronDownSmall, IconChevronDownSmallFilled, IconChevronDownSmallFilledShape, IconChevronDownSmallShape, IconChevronDownSmallThick, IconChevronDownSmallThickShape, IconChevronDownThick, IconChevronDownThickShape, IconChevronLeft, IconChevronLeftShape, IconChevronLeftSmall, IconChevronLeftSmallFilled, IconChevronLeftSmallFilledShape, IconChevronLeftSmallShape, IconChevronLeftSmallThick, IconChevronLeftSmallThickShape, IconChevronLeftThick, IconChevronLeftThickShape, IconChevronRight, IconChevronRightShape, IconChevronRightSmall, IconChevronRightSmallFilled, IconChevronRightSmallFilledShape, IconChevronRightSmallShape, IconChevronRightSmallThick, IconChevronRightSmallThickShape, IconChevronRightThick, IconChevronRightThickShape, IconChevronUp, IconChevronUpShape, IconChevronUpSmall, IconChevronUpSmallFilled, IconChevronUpSmallFilledShape, IconChevronUpSmallShape, IconChevronUpSmallThick, IconChevronUpSmallThickShape, IconChevronUpThick, IconChevronUpThickShape, IconClock, IconClockHistory, IconClockHistoryShape, IconClockHistoryThick, IconClockHistoryThickShape, IconClockShape, IconCloset, IconClosetShape, IconCog, IconCogFilled, IconCogFilledShape, IconCogShape, IconCompass, IconCompassShape, IconCompassThick, IconCompassThickShape, IconConcierge, IconConciergeShape, IconCrane, IconCraneShape, IconCrown, IconCrownFilled, IconCrownFilledShape, IconCrownShape, IconCutlery, IconCutleryAndDish, IconCutleryAndDishShape, IconCutleryShape, IconDiamondThick, IconDiamondThickShape, IconDogFootprint, IconDogFootprintShape, IconDownload, IconDownloadShape, IconDownloadThick, IconDownloadThickShape, IconDumbbell, IconDumbbellShape, IconEditSquare, IconEditSquareShape, IconEditSquareThick, IconEditSquareThickShape, IconElectricPlugDisabledThick, IconElectricPlugDisabledThickShape, IconElectricPlugThick, IconElectricPlugThickShape, IconEnvelope, IconEnvelopeFilled, IconEnvelopeFilledShape, IconEnvelopeShape, IconExtension, IconExtensionShape, IconExternalLink, IconExternalLinkRtl, IconExternalLinkRtlShape, IconExternalLinkRtlThick, IconExternalLinkRtlThickShape, IconExternalLinkShape, IconExternalLinkThick, IconExternalLinkThickShape, IconEye, IconEyeClosed, IconEyeClosedShape, IconEyeClosedThick, IconEyeClosedThickShape, IconEyeShape, IconEyeThick, IconEyeThickShape, IconFacebookFilled, IconFacebookFilledShape, IconFilter, IconFilterClearThick, IconFilterClearThickShape, IconFilterShape, IconFilterThick, IconFilterThickShape, IconFlag, IconFlagFilled, IconFlagFilledShape, IconFlagShape, IconFlagThick, IconFlagThickShape, IconFloorplan, IconFloorplanShape, IconFloorplanThick, IconFloorplanThickShape, IconFullscreen, IconFullscreenShape, IconFullscreenThick, IconFullscreenThickShape, IconFurniture, IconFurnitureShape, IconFurnitureThick, IconFurnitureThickShape, IconGoogleFilled, IconGoogleFilledShape, IconGroupPeople, IconGroupPeopleShape, IconHanger, IconHangerShape, IconHeart, IconHeartFilled, IconHeartFilledShape, IconHeartShape, IconHeartThick, IconHeartThickShape, IconHouse, IconHouseArrow, IconHouseArrowShape, IconHouseFilled, IconHouseFilledShape, IconHousePercentage, IconHousePercentageShape, IconHouseShape, IconHouseThick, IconHouseThickShape, IconInfoCircle, IconInfoCircleFilled, IconInfoCircleFilledShape, IconInfoCircleShape, IconInternetSocket, IconInternetSocketShape, IconLayers, IconLayersShape, IconLift, IconLiftShape, IconLighning, IconLighningFilled, IconLighningThick, IconLightningFilledShape, IconLightningShape, IconLightningThickShape, IconList, IconListFilled, IconListFilledShape, IconListShape, IconListThick, IconListThickShape, IconLiveThick, IconLiveThickShape, IconLocationArrow, IconLocationArrowFilled, IconLocationArrowFilledShape, IconLocationArrowShape, IconLocationArrowThick, IconLocationArrowThickShape, IconLocationGpsThick, IconLocationGpsThickShape, IconLotusPlant, IconLotusPlantShape, IconMagnifier, IconMagnifierFilled, IconMagnifierFilledShape, IconMagnifierMinus, IconMagnifierMinusShape, IconMagnifierPlus, IconMagnifierPlusShape, IconMagnifierShape, IconMagnifierThick, IconMagnifierThickShape, IconMapPin, IconMapPinFilled, IconMapPinFilledShape, IconMapPinPlusThick, IconMapPinPlusThickShape, IconMapPinShape, IconMapPinThick, IconMapPinThickShape, IconMenu, IconMenuShape, IconMenuThick, IconMenuThickShape, IconMezzanine, IconMezzanineShape, IconMicrophone, IconMicrophoneFilled, IconMicrophoneFilledShape, IconMicrophoneShape, IconMinus, IconMinusShape, IconMinusThick, IconMinusThickShape, IconMoneyBills, IconMoneyBillsShape, IconMoneyBillsThick, IconMoneyBillsThickShape, IconMop, IconMopShape, IconMoreHorizontalThick, IconMoreHorizontalThickShape, IconMoreVerticalThick, IconMoreVerticalThickShape, IconPalmTree, IconPalmTreeShape, IconPaperplaneThick, IconPaperplaneThickShape, IconParkingSign, IconParkingSignShape, IconPhone, IconPhoneFilled, IconPhoneFilledShape, IconPhoneShape, IconPhotoCamera, IconPhotoCameraShape, IconPinterestFilled, IconPlay, IconPlayShape, IconPlayThick, IconPlayThickShape, IconPlus, IconPlusShape, IconPlusThick, IconPlusThickShape, IconPoolLadder, IconPoolLadderShape, IconReceptionist, IconReceptionistShape, IconRoadSize, IconRoadSizeShape, IconRoadSizeThick, IconRoadSizeThickShape, IconRoom, IconRoomShape, IconShare, IconShareAlt, IconShareAltRtl, IconShareAltRtlShape, IconShareAltRtlThick, IconShareAltRtlThickShape, IconShareAltShape, IconShareAltThick, IconShareAltThickShape, IconShareShape, IconShareThick, IconShareThickShape, IconShield, IconShieldCheckmark, IconShieldCheckmarkFilled, IconShieldCheckmarkFilledShape, IconShieldCheckmarkShape, IconShieldShape, IconSnowFlake, IconSnowFlakeShape, IconSortDown, IconSortDownShape, IconSortDownThick, IconSortDownThickShape, IconSortUp, IconSortUpShape, IconSpiceShakers, IconSpiceShakersShape, IconSprite360$1 as IconSprite360, IconSprite360Shape$1 as IconSprite360Shape, IconSprite360Thick$1 as IconSprite360Thick, IconSprite360ThickShape$1 as IconSprite360ThickShape, IconSpriteAppleFilled$1 as IconSpriteAppleFilled, IconSpriteAppleFilledShape$1 as IconSpriteAppleFilledShape, IconSpriteAreaChart$1 as IconSpriteAreaChart, IconSpriteAreaChartShape$1 as IconSpriteAreaChartShape, IconSpriteAreaChartThick$1 as IconSpriteAreaChartThick, IconSpriteAreaChartThickShape$1 as IconSpriteAreaChartThickShape, IconSpriteAreaSize$1 as IconSpriteAreaSize, IconSpriteAreaSizeShape$1 as IconSpriteAreaSizeShape, IconSpriteAreaSizeThick$1 as IconSpriteAreaSizeThick, IconSpriteAreaSizeThickShape$1 as IconSpriteAreaSizeThickShape, IconSpriteArrowCircleClockwise$1 as IconSpriteArrowCircleClockwise, IconSpriteArrowCircleClockwiseShape$1 as IconSpriteArrowCircleClockwiseShape, IconSpriteArrowCircleCounterclockwise$1 as IconSpriteArrowCircleCounterclockwise, IconSpriteArrowCircleCounterclockwiseShape$1 as IconSpriteArrowCircleCounterclockwiseShape, IconSpriteArrowDown$1 as IconSpriteArrowDown, IconSpriteArrowDownShape$1 as IconSpriteArrowDownShape, IconSpriteArrowDownThick$1 as IconSpriteArrowDownThick, IconSpriteArrowDownThickShape$1 as IconSpriteArrowDownThickShape, IconSpriteArrowLeft$1 as IconSpriteArrowLeft, IconSpriteArrowLeftShape$1 as IconSpriteArrowLeftShape, IconSpriteArrowLeftThick$1 as IconSpriteArrowLeftThick, IconSpriteArrowLeftThickShape$1 as IconSpriteArrowLeftThickShape, IconSpriteArrowNarrowDownThick$1 as IconSpriteArrowNarrowDownThick, IconSpriteArrowNarrowDownThickShape$1 as IconSpriteArrowNarrowDownThickShape, IconSpriteArrowNarrowUpThick$1 as IconSpriteArrowNarrowUpThick, IconSpriteArrowNarrowUpThickShape$1 as IconSpriteArrowNarrowUpThickShape, IconSpriteArrowRight$1 as IconSpriteArrowRight, IconSpriteArrowRightShape$1 as IconSpriteArrowRightShape, IconSpriteArrowRightThick$1 as IconSpriteArrowRightThick, IconSpriteArrowRightThickShape$1 as IconSpriteArrowRightThickShape, IconSpriteArrowUp$1 as IconSpriteArrowUp, IconSpriteArrowUpShape$1 as IconSpriteArrowUpShape, IconSpriteArrowUpThick$1 as IconSpriteArrowUpThick, IconSpriteArrowUpThickShape$1 as IconSpriteArrowUpThickShape, IconSpriteArrowZigzagDown$1 as IconSpriteArrowZigzagDown, IconSpriteArrowZigzagDownRtl$1 as IconSpriteArrowZigzagDownRtl, IconSpriteArrowZigzagDownRtlShape$1 as IconSpriteArrowZigzagDownRtlShape, IconSpriteArrowZigzagDownRtlThick$1 as IconSpriteArrowZigzagDownRtlThick, IconSpriteArrowZigzagDownRtlThickShape$1 as IconSpriteArrowZigzagDownRtlThickShape, IconSpriteArrowZigzagDownShape$1 as IconSpriteArrowZigzagDownShape, IconSpriteArrowZigzagDownThick$1 as IconSpriteArrowZigzagDownThick, IconSpriteArrowZigzagDownThickShape$1 as IconSpriteArrowZigzagDownThickShape, IconSpriteArrowZigzagUp$1 as IconSpriteArrowZigzagUp, IconSpriteArrowZigzagUpRtl$1 as IconSpriteArrowZigzagUpRtl, IconSpriteArrowZigzagUpRtlShape$1 as IconSpriteArrowZigzagUpRtlShape, IconSpriteArrowZigzagUpRtlThick$1 as IconSpriteArrowZigzagUpRtlThick, IconSpriteArrowZigzagUpRtlThickShape$1 as IconSpriteArrowZigzagUpRtlThickShape, IconSpriteArrowZigzagUpShape$1 as IconSpriteArrowZigzagUpShape, IconSpriteArrowZigzagUpThick$1 as IconSpriteArrowZigzagUpThick, IconSpriteArrowZigzagUpThickShape$1 as IconSpriteArrowZigzagUpThickShape, IconSpriteArrowsCircleThick$1 as IconSpriteArrowsCircleThick, IconSpriteArrowsCircleThickShape$1 as IconSpriteArrowsCircleThickShape, IconSpriteArrowsUpDown$1 as IconSpriteArrowsUpDown, IconSpriteArrowsUpDownShape$1 as IconSpriteArrowsUpDownShape, IconSpriteArrowsUpDownThick$1 as IconSpriteArrowsUpDownThick, IconSpriteArrowsUpDownThickShape$1 as IconSpriteArrowsUpDownThickShape, IconSpriteBalcony$1 as IconSpriteBalcony, IconSpriteBalconyShape$1 as IconSpriteBalconyShape, IconSpriteBarbecue$1 as IconSpriteBarbecue, IconSpriteBarbecueShape$1 as IconSpriteBarbecueShape, IconSpriteBathtub$1 as IconSpriteBathtub, IconSpriteBathtubShape$1 as IconSpriteBathtubShape, IconSpriteBathtubThick$1 as IconSpriteBathtubThick, IconSpriteBathtubThickShape$1 as IconSpriteBathtubThickShape, IconSpriteBeachBall$1 as IconSpriteBeachBall, IconSpriteBeachBallShape$1 as IconSpriteBeachBallShape, IconSpriteBed$1 as IconSpriteBed, IconSpriteBedShape$1 as IconSpriteBedShape, IconSpriteBedThick$1 as IconSpriteBedThick, IconSpriteBedThickShape$1 as IconSpriteBedThickShape, IconSpriteBell$1 as IconSpriteBell, IconSpriteBellShape$1 as IconSpriteBellShape, IconSpriteBellThick$1 as IconSpriteBellThick, IconSpriteBellThickShape$1 as IconSpriteBellThickShape, IconSpriteBookOpen$1 as IconSpriteBookOpen, IconSpriteBookOpenShape$1 as IconSpriteBookOpenShape, IconSpriteBookOpenThick$1 as IconSpriteBookOpenThick, IconSpriteBookOpenThickShape$1 as IconSpriteBookOpenThickShape, IconSpriteBricks$1 as IconSpriteBricks, IconSpriteBricksShape$1 as IconSpriteBricksShape, IconSpriteBricksThick$1 as IconSpriteBricksThick, IconSpriteBricksThickShape$1 as IconSpriteBricksThickShape, IconSpriteBriefcaseThick$1 as IconSpriteBriefcaseThick, IconSpriteBriefcaseThickShape$1 as IconSpriteBriefcaseThickShape, IconSpriteBroom$1 as IconSpriteBroom, IconSpriteBroomShape$1 as IconSpriteBroomShape, IconSpriteBubbles$1 as IconSpriteBubbles, IconSpriteBubblesShape$1 as IconSpriteBubblesShape, IconSpriteBuildings$1 as IconSpriteBuildings, IconSpriteBuildingsAlt$1 as IconSpriteBuildingsAlt, IconSpriteBuildingsAltShape$1 as IconSpriteBuildingsAltShape, IconSpriteBuildingsAltThick$1 as IconSpriteBuildingsAltThick, IconSpriteBuildingsAltThickShape$1 as IconSpriteBuildingsAltThickShape, IconSpriteBuildingsShape$1 as IconSpriteBuildingsShape, IconSpriteBuildingsStar$1 as IconSpriteBuildingsStar, IconSpriteBuildingsStarShape$1 as IconSpriteBuildingsStarShape, IconSpriteBuildingsStarThick$1 as IconSpriteBuildingsStarThick, IconSpriteBuildingsStarThickShape$1 as IconSpriteBuildingsStarThickShape, IconSpriteBurjKhalifa$1 as IconSpriteBurjKhalifa, IconSpriteBurjKhalifaShape$1 as IconSpriteBurjKhalifaShape, IconSpriteCalendar$1 as IconSpriteCalendar, IconSpriteCalendarShape$1 as IconSpriteCalendarShape, IconSpriteCalendarThick$1 as IconSpriteCalendarThick, IconSpriteCalendarThickShape$1 as IconSpriteCalendarThickShape, IconSpriteCarClock$1 as IconSpriteCarClock, IconSpriteCarClockShape$1 as IconSpriteCarClockShape, IconSpriteCarClockThick$1 as IconSpriteCarClockThick, IconSpriteCarClockThickShape$1 as IconSpriteCarClockThickShape, IconSpriteCarEntrance$1 as IconSpriteCarEntrance, IconSpriteCarEntranceShape$1 as IconSpriteCarEntranceShape, IconSpriteCheckmark$1 as IconSpriteCheckmark, IconSpriteCheckmarkShape$1 as IconSpriteCheckmarkShape, IconSpriteCheckmarkThick$1 as IconSpriteCheckmarkThick, IconSpriteCheckmarkThickShape$1 as IconSpriteCheckmarkThickShape, IconSpriteChevronDown$1 as IconSpriteChevronDown, IconSpriteChevronDownShape$1 as IconSpriteChevronDownShape, IconSpriteChevronDownSmall$1 as IconSpriteChevronDownSmall, IconSpriteChevronDownSmallFilled$1 as IconSpriteChevronDownSmallFilled, IconSpriteChevronDownSmallFilledShape$1 as IconSpriteChevronDownSmallFilledShape, IconSpriteChevronDownSmallShape$1 as IconSpriteChevronDownSmallShape, IconSpriteChevronDownSmallThick$1 as IconSpriteChevronDownSmallThick, IconSpriteChevronDownSmallThickShape$1 as IconSpriteChevronDownSmallThickShape, IconSpriteChevronDownThick$1 as IconSpriteChevronDownThick, IconSpriteChevronDownThickShape$1 as IconSpriteChevronDownThickShape, IconSpriteChevronLeft$1 as IconSpriteChevronLeft, IconSpriteChevronLeftShape$1 as IconSpriteChevronLeftShape, IconSpriteChevronLeftSmall$1 as IconSpriteChevronLeftSmall, IconSpriteChevronLeftSmallFilled$1 as IconSpriteChevronLeftSmallFilled, IconSpriteChevronLeftSmallFilledShape$1 as IconSpriteChevronLeftSmallFilledShape, IconSpriteChevronLeftSmallShape$1 as IconSpriteChevronLeftSmallShape, IconSpriteChevronLeftSmallThick$1 as IconSpriteChevronLeftSmallThick, IconSpriteChevronLeftSmallThickShape$1 as IconSpriteChevronLeftSmallThickShape, IconSpriteChevronLeftThick$1 as IconSpriteChevronLeftThick, IconSpriteChevronLeftThickShape$1 as IconSpriteChevronLeftThickShape, IconSpriteChevronRight$1 as IconSpriteChevronRight, IconSpriteChevronRightShape$1 as IconSpriteChevronRightShape, IconSpriteChevronRightSmall$1 as IconSpriteChevronRightSmall, IconSpriteChevronRightSmallFilled$1 as IconSpriteChevronRightSmallFilled, IconSpriteChevronRightSmallFilledShape$1 as IconSpriteChevronRightSmallFilledShape, IconSpriteChevronRightSmallShape$1 as IconSpriteChevronRightSmallShape, IconSpriteChevronRightSmallThick$1 as IconSpriteChevronRightSmallThick, IconSpriteChevronRightSmallThickShape$1 as IconSpriteChevronRightSmallThickShape, IconSpriteChevronRightThick$1 as IconSpriteChevronRightThick, IconSpriteChevronRightThickShape$1 as IconSpriteChevronRightThickShape, IconSpriteChevronUp$1 as IconSpriteChevronUp, IconSpriteChevronUpShape$1 as IconSpriteChevronUpShape, IconSpriteChevronUpSmall$1 as IconSpriteChevronUpSmall, IconSpriteChevronUpSmallFilled$1 as IconSpriteChevronUpSmallFilled, IconSpriteChevronUpSmallFilledShape$1 as IconSpriteChevronUpSmallFilledShape, IconSpriteChevronUpSmallShape$1 as IconSpriteChevronUpSmallShape, IconSpriteChevronUpSmallThick$1 as IconSpriteChevronUpSmallThick, IconSpriteChevronUpSmallThickShape$1 as IconSpriteChevronUpSmallThickShape, IconSpriteChevronUpThick$1 as IconSpriteChevronUpThick, IconSpriteChevronUpThickShape$1 as IconSpriteChevronUpThickShape, IconSpriteClock$1 as IconSpriteClock, IconSpriteClockHistory$1 as IconSpriteClockHistory, IconSpriteClockHistoryShape$1 as IconSpriteClockHistoryShape, IconSpriteClockHistoryThick$1 as IconSpriteClockHistoryThick, IconSpriteClockHistoryThickShape$1 as IconSpriteClockHistoryThickShape, IconSpriteClockShape$1 as IconSpriteClockShape, IconSpriteCloset$1 as IconSpriteCloset, IconSpriteClosetShape$1 as IconSpriteClosetShape, IconSpriteCog$1 as IconSpriteCog, IconSpriteCogFilled$1 as IconSpriteCogFilled, IconSpriteCogFilledShape$1 as IconSpriteCogFilledShape, IconSpriteCogShape$1 as IconSpriteCogShape, IconSpriteCompass$1 as IconSpriteCompass, IconSpriteCompassShape$1 as IconSpriteCompassShape, IconSpriteCompassThick$1 as IconSpriteCompassThick, IconSpriteCompassThickShape$1 as IconSpriteCompassThickShape, IconSpriteConcierge$1 as IconSpriteConcierge, IconSpriteConciergeShape$1 as IconSpriteConciergeShape, IconSpriteCrane$1 as IconSpriteCrane, IconSpriteCraneShape$1 as IconSpriteCraneShape, IconSpriteCrown$1 as IconSpriteCrown, IconSpriteCrownFilled$1 as IconSpriteCrownFilled, IconSpriteCrownFilledShape$1 as IconSpriteCrownFilledShape, IconSpriteCrownShape$1 as IconSpriteCrownShape, IconSpriteCutlery$1 as IconSpriteCutlery, IconSpriteCutleryAndDish$1 as IconSpriteCutleryAndDish, IconSpriteCutleryAndDishShape$1 as IconSpriteCutleryAndDishShape, IconSpriteCutleryShape$1 as IconSpriteCutleryShape, IconSpriteDiamondThick$1 as IconSpriteDiamondThick, IconSpriteDiamondThickShape$1 as IconSpriteDiamondThickShape, IconSpriteDogFootprint$1 as IconSpriteDogFootprint, IconSpriteDogFootprintShape$1 as IconSpriteDogFootprintShape, IconSpriteDownload$1 as IconSpriteDownload, IconSpriteDownloadShape$1 as IconSpriteDownloadShape, IconSpriteDownloadThick$1 as IconSpriteDownloadThick, IconSpriteDownloadThickShape$1 as IconSpriteDownloadThickShape, IconSpriteDumbbell$1 as IconSpriteDumbbell, IconSpriteDumbbellShape$1 as IconSpriteDumbbellShape, IconSpriteEditSquare$1 as IconSpriteEditSquare, IconSpriteEditSquareShape$1 as IconSpriteEditSquareShape, IconSpriteEditSquareThick$1 as IconSpriteEditSquareThick, IconSpriteEditSquareThickShape$1 as IconSpriteEditSquareThickShape, IconSpriteElectricPlugDisabledThick$1 as IconSpriteElectricPlugDisabledThick, IconSpriteElectricPlugDisabledThickShape$1 as IconSpriteElectricPlugDisabledThickShape, IconSpriteElectricPlugThick$1 as IconSpriteElectricPlugThick, IconSpriteElectricPlugThickShape$1 as IconSpriteElectricPlugThickShape, IconSpriteEnvelope$1 as IconSpriteEnvelope, IconSpriteEnvelopeFilled$1 as IconSpriteEnvelopeFilled, IconSpriteEnvelopeFilledShape$1 as IconSpriteEnvelopeFilledShape, IconSpriteEnvelopeShape$1 as IconSpriteEnvelopeShape, IconSpriteExtension$1 as IconSpriteExtension, IconSpriteExtensionShape$1 as IconSpriteExtensionShape, IconSpriteExternalLink$1 as IconSpriteExternalLink, IconSpriteExternalLinkRtl$1 as IconSpriteExternalLinkRtl, IconSpriteExternalLinkRtlShape$1 as IconSpriteExternalLinkRtlShape, IconSpriteExternalLinkRtlThick$1 as IconSpriteExternalLinkRtlThick, IconSpriteExternalLinkRtlThickShape$1 as IconSpriteExternalLinkRtlThickShape, IconSpriteExternalLinkShape$1 as IconSpriteExternalLinkShape, IconSpriteExternalLinkThick$1 as IconSpriteExternalLinkThick, IconSpriteExternalLinkThickShape$1 as IconSpriteExternalLinkThickShape, IconSpriteEye$1 as IconSpriteEye, IconSpriteEyeClosed$1 as IconSpriteEyeClosed, IconSpriteEyeClosedShape$1 as IconSpriteEyeClosedShape, IconSpriteEyeClosedThick$1 as IconSpriteEyeClosedThick, IconSpriteEyeClosedThickShape$1 as IconSpriteEyeClosedThickShape, IconSpriteEyeShape$1 as IconSpriteEyeShape, IconSpriteEyeThick$1 as IconSpriteEyeThick, IconSpriteEyeThickShape$1 as IconSpriteEyeThickShape, IconSpriteFacebookFilled$1 as IconSpriteFacebookFilled, IconSpriteFacebookFilledShape$1 as IconSpriteFacebookFilledShape, IconSpriteFilter$1 as IconSpriteFilter, IconSpriteFilterClearThick$1 as IconSpriteFilterClearThick, IconSpriteFilterClearThickShape$1 as IconSpriteFilterClearThickShape, IconSpriteFilterShape$1 as IconSpriteFilterShape, IconSpriteFilterThick$1 as IconSpriteFilterThick, IconSpriteFilterThickShape$1 as IconSpriteFilterThickShape, IconSpriteFlag$1 as IconSpriteFlag, IconSpriteFlagFilled$1 as IconSpriteFlagFilled, IconSpriteFlagFilledShape$1 as IconSpriteFlagFilledShape, IconSpriteFlagShape$1 as IconSpriteFlagShape, IconSpriteFlagThick$1 as IconSpriteFlagThick, IconSpriteFlagThickShape$1 as IconSpriteFlagThickShape, IconSpriteFloorplan$1 as IconSpriteFloorplan, IconSpriteFloorplanShape$1 as IconSpriteFloorplanShape, IconSpriteFloorplanThick$1 as IconSpriteFloorplanThick, IconSpriteFloorplanThickShape$1 as IconSpriteFloorplanThickShape, IconSpriteFullscreen$1 as IconSpriteFullscreen, IconSpriteFullscreenShape$1 as IconSpriteFullscreenShape, IconSpriteFullscreenThick$1 as IconSpriteFullscreenThick, IconSpriteFullscreenThickShape$1 as IconSpriteFullscreenThickShape, IconSpriteFurniture$1 as IconSpriteFurniture, IconSpriteFurnitureShape$1 as IconSpriteFurnitureShape, IconSpriteFurnitureThick$1 as IconSpriteFurnitureThick, IconSpriteFurnitureThickShape$1 as IconSpriteFurnitureThickShape, IconSpriteGoogleFilled$1 as IconSpriteGoogleFilled, IconSpriteGoogleFilledShape$1 as IconSpriteGoogleFilledShape, IconSpriteGroupPeople$1 as IconSpriteGroupPeople, IconSpriteGroupPeopleShape$1 as IconSpriteGroupPeopleShape, IconSpriteHanger$1 as IconSpriteHanger, IconSpriteHangerShape$1 as IconSpriteHangerShape, IconSpriteHeart$1 as IconSpriteHeart, IconSpriteHeartFilled$1 as IconSpriteHeartFilled, IconSpriteHeartFilledShape$1 as IconSpriteHeartFilledShape, IconSpriteHeartShape$1 as IconSpriteHeartShape, IconSpriteHeartThick$1 as IconSpriteHeartThick, IconSpriteHeartThickShape$1 as IconSpriteHeartThickShape, IconSpriteHouse$1 as IconSpriteHouse, IconSpriteHouseArrow$1 as IconSpriteHouseArrow, IconSpriteHouseArrowShape$1 as IconSpriteHouseArrowShape, IconSpriteHouseFilled$1 as IconSpriteHouseFilled, IconSpriteHouseFilledShape$1 as IconSpriteHouseFilledShape, IconSpriteHousePercentage$1 as IconSpriteHousePercentage, IconSpriteHousePercentageShape$1 as IconSpriteHousePercentageShape, IconSpriteHouseShape$1 as IconSpriteHouseShape, IconSpriteHouseThick$1 as IconSpriteHouseThick, IconSpriteHouseThickShape$1 as IconSpriteHouseThickShape, IconSpriteInfoCircle$1 as IconSpriteInfoCircle, IconSpriteInfoCircleFilled$1 as IconSpriteInfoCircleFilled, IconSpriteInfoCircleFilledShape$1 as IconSpriteInfoCircleFilledShape, IconSpriteInfoCircleShape$1 as IconSpriteInfoCircleShape, IconSpriteInternetSocket$1 as IconSpriteInternetSocket, IconSpriteInternetSocketShape$1 as IconSpriteInternetSocketShape, IconSpriteLayers$1 as IconSpriteLayers, IconSpriteLayersShape$1 as IconSpriteLayersShape, IconSpriteLift$1 as IconSpriteLift, IconSpriteLiftShape$1 as IconSpriteLiftShape, IconSpriteLighning$1 as IconSpriteLighning, IconSpriteLighningFilled$1 as IconSpriteLighningFilled, IconSpriteLighningThick$1 as IconSpriteLighningThick, IconSpriteLightningFilledShape$1 as IconSpriteLightningFilledShape, IconSpriteLightningShape$1 as IconSpriteLightningShape, IconSpriteLightningThickShape$1 as IconSpriteLightningThickShape, IconSpriteList$1 as IconSpriteList, IconSpriteListFilled$1 as IconSpriteListFilled, IconSpriteListFilledShape$1 as IconSpriteListFilledShape, IconSpriteListShape$1 as IconSpriteListShape, IconSpriteListThick$1 as IconSpriteListThick, IconSpriteListThickShape$1 as IconSpriteListThickShape, IconSpriteLiveThick$1 as IconSpriteLiveThick, IconSpriteLiveThickShape$1 as IconSpriteLiveThickShape, IconSpriteLocationArrow$1 as IconSpriteLocationArrow, IconSpriteLocationArrowFilled$1 as IconSpriteLocationArrowFilled, IconSpriteLocationArrowFilledShape$1 as IconSpriteLocationArrowFilledShape, IconSpriteLocationArrowShape$1 as IconSpriteLocationArrowShape, IconSpriteLocationArrowThick$1 as IconSpriteLocationArrowThick, IconSpriteLocationArrowThickShape$1 as IconSpriteLocationArrowThickShape, IconSpriteLocationGpsThick$1 as IconSpriteLocationGpsThick, IconSpriteLocationGpsThickShape$1 as IconSpriteLocationGpsThickShape, IconSpriteLotusPlant$1 as IconSpriteLotusPlant, IconSpriteLotusPlantShape$1 as IconSpriteLotusPlantShape, IconSpriteMagnifier$1 as IconSpriteMagnifier, IconSpriteMagnifierFilled$1 as IconSpriteMagnifierFilled, IconSpriteMagnifierFilledShape$1 as IconSpriteMagnifierFilledShape, IconSpriteMagnifierMinus$1 as IconSpriteMagnifierMinus, IconSpriteMagnifierMinusShape$1 as IconSpriteMagnifierMinusShape, IconSpriteMagnifierPlus$1 as IconSpriteMagnifierPlus, IconSpriteMagnifierPlusShape$1 as IconSpriteMagnifierPlusShape, IconSpriteMagnifierShape$1 as IconSpriteMagnifierShape, IconSpriteMagnifierThick$1 as IconSpriteMagnifierThick, IconSpriteMagnifierThickShape$1 as IconSpriteMagnifierThickShape, IconSpriteMapPin$1 as IconSpriteMapPin, IconSpriteMapPinFilled$1 as IconSpriteMapPinFilled, IconSpriteMapPinFilledShape$1 as IconSpriteMapPinFilledShape, IconSpriteMapPinPlusThick$1 as IconSpriteMapPinPlusThick, IconSpriteMapPinPlusThickShape$1 as IconSpriteMapPinPlusThickShape, IconSpriteMapPinShape$1 as IconSpriteMapPinShape, IconSpriteMapPinThick$1 as IconSpriteMapPinThick, IconSpriteMapPinThickShape$1 as IconSpriteMapPinThickShape, IconSpriteMenu$1 as IconSpriteMenu, IconSpriteMenuShape$1 as IconSpriteMenuShape, IconSpriteMenuThick$1 as IconSpriteMenuThick, IconSpriteMenuThickShape$1 as IconSpriteMenuThickShape, IconSpriteMezzanine$1 as IconSpriteMezzanine, IconSpriteMezzanineShape$1 as IconSpriteMezzanineShape, IconSpriteMicrophone$1 as IconSpriteMicrophone, IconSpriteMicrophoneFilled$1 as IconSpriteMicrophoneFilled, IconSpriteMicrophoneFilledShape$1 as IconSpriteMicrophoneFilledShape, IconSpriteMicrophoneShape$1 as IconSpriteMicrophoneShape, IconSpriteMinus$1 as IconSpriteMinus, IconSpriteMinusShape$1 as IconSpriteMinusShape, IconSpriteMinusThick$1 as IconSpriteMinusThick, IconSpriteMinusThickShape$1 as IconSpriteMinusThickShape, IconSpriteMoneyBills$1 as IconSpriteMoneyBills, IconSpriteMoneyBillsShape$1 as IconSpriteMoneyBillsShape, IconSpriteMoneyBillsThick$1 as IconSpriteMoneyBillsThick, IconSpriteMoneyBillsThickShape$1 as IconSpriteMoneyBillsThickShape, IconSpriteMop$1 as IconSpriteMop, IconSpriteMopShape$1 as IconSpriteMopShape, IconSpriteMoreHorizontalThick$1 as IconSpriteMoreHorizontalThick, IconSpriteMoreHorizontalThickShape$1 as IconSpriteMoreHorizontalThickShape, IconSpriteMoreVerticalThick$1 as IconSpriteMoreVerticalThick, IconSpriteMoreVerticalThickShape$1 as IconSpriteMoreVerticalThickShape, IconSpritePalmTree$1 as IconSpritePalmTree, IconSpritePalmTreeShape$1 as IconSpritePalmTreeShape, IconSpritePaperplaneThick$1 as IconSpritePaperplaneThick, IconSpritePaperplaneThickShape$1 as IconSpritePaperplaneThickShape, IconSpriteParkingSign$1 as IconSpriteParkingSign, IconSpriteParkingSignShape$1 as IconSpriteParkingSignShape, IconSpritePhone$1 as IconSpritePhone, IconSpritePhoneFilled$1 as IconSpritePhoneFilled, IconSpritePhoneFilledShape$1 as IconSpritePhoneFilledShape, IconSpritePhoneShape$1 as IconSpritePhoneShape, IconSpritePhotoCamera$1 as IconSpritePhotoCamera, IconSpritePhotoCameraShape$1 as IconSpritePhotoCameraShape, IconSpritePinterestFilled$1 as IconSpritePinterestFilled, IconSpritePlay$1 as IconSpritePlay, IconSpritePlayShape$1 as IconSpritePlayShape, IconSpritePlayThick$1 as IconSpritePlayThick, IconSpritePlayThickShape$1 as IconSpritePlayThickShape, IconSpritePlus$1 as IconSpritePlus, IconSpritePlusShape$1 as IconSpritePlusShape, IconSpritePlusThick$1 as IconSpritePlusThick, IconSpritePlusThickShape$1 as IconSpritePlusThickShape, IconSpritePoolLadder$1 as IconSpritePoolLadder, IconSpritePoolLadderShape$1 as IconSpritePoolLadderShape, IconSpriteReceptionist$1 as IconSpriteReceptionist, IconSpriteReceptionistShape$1 as IconSpriteReceptionistShape, IconSpriteRoadSize$1 as IconSpriteRoadSize, IconSpriteRoadSizeShape$1 as IconSpriteRoadSizeShape, IconSpriteRoadSizeThick$1 as IconSpriteRoadSizeThick, IconSpriteRoadSizeThickShape$1 as IconSpriteRoadSizeThickShape, IconSpriteRoom$1 as IconSpriteRoom, IconSpriteRoomShape$1 as IconSpriteRoomShape, IconSpriteShare$1 as IconSpriteShare, IconSpriteShareAlt$1 as IconSpriteShareAlt, IconSpriteShareAltRtl$1 as IconSpriteShareAltRtl, IconSpriteShareAltRtlShape$1 as IconSpriteShareAltRtlShape, IconSpriteShareAltRtlThick$1 as IconSpriteShareAltRtlThick, IconSpriteShareAltRtlThickShape$1 as IconSpriteShareAltRtlThickShape, IconSpriteShareAltShape$1 as IconSpriteShareAltShape, IconSpriteShareAltThick$1 as IconSpriteShareAltThick, IconSpriteShareAltThickShape$1 as IconSpriteShareAltThickShape, IconSpriteShareShape$1 as IconSpriteShareShape, IconSpriteShareThick$1 as IconSpriteShareThick, IconSpriteShareThickShape$1 as IconSpriteShareThickShape, IconSpriteShield$1 as IconSpriteShield, IconSpriteShieldCheckmark$1 as IconSpriteShieldCheckmark, IconSpriteShieldCheckmarkFilled$1 as IconSpriteShieldCheckmarkFilled, IconSpriteShieldCheckmarkFilledShape$1 as IconSpriteShieldCheckmarkFilledShape, IconSpriteShieldCheckmarkShape$1 as IconSpriteShieldCheckmarkShape, IconSpriteShieldShape$1 as IconSpriteShieldShape, IconSpriteSnowFlake$1 as IconSpriteSnowFlake, IconSpriteSnowFlakeShape$1 as IconSpriteSnowFlakeShape, IconSpriteSortDown$1 as IconSpriteSortDown, IconSpriteSortDownShape$1 as IconSpriteSortDownShape, IconSpriteSortDownThick$1 as IconSpriteSortDownThick, IconSpriteSortDownThickShape$1 as IconSpriteSortDownThickShape, IconSpriteSortUp$1 as IconSpriteSortUp, IconSpriteSortUpShape$1 as IconSpriteSortUpShape, IconSpriteSpiceShakers$1 as IconSpriteSpiceShakers, IconSpriteSpiceShakersShape$1 as IconSpriteSpiceShakersShape, IconSpriteStar$1 as IconSpriteStar, IconSpriteStarFilled$1 as IconSpriteStarFilled, IconSpriteStarFilledShape$1 as IconSpriteStarFilledShape, IconSpriteStarShape$1 as IconSpriteStarShape, IconSpriteStarThick$1 as IconSpriteStarThick, IconSpriteStarThickShape$1 as IconSpriteStarThickShape, IconSpriteStarTrophyFilled$1 as IconSpriteStarTrophyFilled, IconSpriteStarTrophyFilledShape$1 as IconSpriteStarTrophyFilledShape, IconSpriteSunAndWater$1 as IconSpriteSunAndWater, IconSpriteSunAndWaterShape$1 as IconSpriteSunAndWaterShape, IconSpriteSwing$1 as IconSpriteSwing, IconSpriteSwingShape$1 as IconSpriteSwingShape, IconSpriteTextBubble$1 as IconSpriteTextBubble, IconSpriteTextBubbleFilled$1 as IconSpriteTextBubbleFilled, IconSpriteTextBubbleFilledShape$1 as IconSpriteTextBubbleFilledShape, IconSpriteTextBubbleShape$1 as IconSpriteTextBubbleShape, IconSpriteThreeDotsHorizontal$1 as IconSpriteThreeDotsHorizontal, IconSpriteThreeDotsHorizontalShape$1 as IconSpriteThreeDotsHorizontalShape, IconSpriteThreeDotsVertical$1 as IconSpriteThreeDotsVertical, IconSpriteThreeDotsVerticalShape$1 as IconSpriteThreeDotsVerticalShape, IconSpriteThumbsUp$1 as IconSpriteThumbsUp, IconSpriteThumbsUpShape$1 as IconSpriteThumbsUpShape, IconSpriteTimes$1 as IconSpriteTimes, IconSpriteTimesCircleThick$1 as IconSpriteTimesCircleThick, IconSpriteTimesCircleThickShape$1 as IconSpriteTimesCircleThickShape, IconSpriteTimesShape$1 as IconSpriteTimesShape, IconSpriteTimesSmall$1 as IconSpriteTimesSmall, IconSpriteTimesSmallShape$1 as IconSpriteTimesSmallShape, IconSpriteTimesSmallThick$1 as IconSpriteTimesSmallThick, IconSpriteTimesSmallThickShape$1 as IconSpriteTimesSmallThickShape, IconSpriteTimesThick$1 as IconSpriteTimesThick, IconSpriteTimesThickShape$1 as IconSpriteTimesThickShape, IconSpriteTwitterFilled$1 as IconSpriteTwitterFilled, IconSpriteTwitterFilledShape$1 as IconSpriteTwitterFilledShape, IconSpriteUser$1 as IconSpriteUser, IconSpriteUserFilled$1 as IconSpriteUserFilled, IconSpriteUserFilledShape$1 as IconSpriteUserFilledShape, IconSpriteUserShape$1 as IconSpriteUserShape, IconSpriteUserThick$1 as IconSpriteUserThick, IconSpriteUserThickShape$1 as IconSpriteUserThickShape, IconSpriteVastuStar$1 as IconSpriteVastuStar, IconSpriteVastuStarShape$1 as IconSpriteVastuStarShape, IconSpriteWhatsapp$1 as IconSpriteWhatsapp, IconSpriteWhatsappFilled$1 as IconSpriteWhatsappFilled, IconSpriteWhatsappFilledShape$1 as IconSpriteWhatsappFilledShape, IconSpriteWhatsappShape$1 as IconSpriteWhatsappShape, IconSpriteWorkerThick$1 as IconSpriteWorkerThick, IconSpriteWorkerThickShape$1 as IconSpriteWorkerThickShape, IconStar, IconStarFilled, IconStarFilledShape, IconStarShape, IconStarThick, IconStarThickShape, IconStarTrophyFilled, IconStarTrophyFilledShape, IconSunAndWater, IconSunAndWaterShape, IconSwing, IconSwingShape, IconTextBubble, IconTextBubbleFilled, IconTextBubbleFilledShape, IconTextBubbleShape, IconThreeDotsHorizontal, IconThreeDotsHorizontalShape, IconThreeDotsVertical, IconThreeDotsVerticalShape, IconThumbsUp, IconThumbsUpShape, IconTimes, IconTimesCircleThick, IconTimesCircleThickShape, IconTimesShape, IconTimesSmall, IconTimesSmallShape, IconTimesSmallThick, IconTimesSmallThickShape, IconTimesThick, IconTimesThickShape, IconTwitterFilled, IconTwitterFilledShape, IconUser, IconUserFilled, IconUserFilledShape, IconUserShape, IconUserThick, IconUserThickShape, IconVastuStar, IconVastuStarShape, IconWhatsapp, IconWhatsappFilled, IconWhatsappFilledShape, IconWhatsappShape, IconWorkerThick, IconWorkerThickShape, SpriteHelperService, defaultCases, getUsage };
